import _slicedToArray from "D:\\loc\\loc-app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import _toConsumableArray from "D:\\loc\\loc-app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/toConsumableArray";
import _get from "D:\\loc\\loc-app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/get";
import _defineProperty from "D:\\loc\\loc-app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";
import _assertThisInitialized from "D:\\loc\\loc-app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/assertThisInitialized";
import _wrapNativeSuper from "D:\\loc\\loc-app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/wrapNativeSuper";
import _possibleConstructorReturn from "D:\\loc\\loc-app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "D:\\loc\\loc-app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "D:\\loc\\loc-app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import _classCallCheck from "D:\\loc\\loc-app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "D:\\loc\\loc-app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
var _Gi;
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e7) { throw _e7; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e8) { didErr = true; err = _e8; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var er = Object.defineProperty,
  tr = Object.defineProperties;
var ir = Object.getOwnPropertyDescriptors;
var Be = Object.getOwnPropertySymbols;
var oi = Object.prototype.hasOwnProperty,
  ci = Object.prototype.propertyIsEnumerable;
var di = function di(a, e, t) {
    return e in a ? er(a, e, {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: t
    }) : a[e] = t;
  },
  v = function v(a, e) {
    for (var t in e || (e = {})) oi.call(e, t) && di(a, t, e[t]);
    if (Be) {
      var _iterator = _createForOfIteratorHelper(Be(e)),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var t = _step.value;
          ci.call(e, t) && di(a, t, e[t]);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
    return a;
  },
  L = function L(a, e) {
    return tr(a, ir(e));
  };
var kt = function kt(a, e) {
  var t = {};
  for (var i in a) oi.call(a, i) && e.indexOf(i) < 0 && (t[i] = a[i]);
  if (a != null && Be) {
    var _iterator2 = _createForOfIteratorHelper(Be(a)),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var i = _step2.value;
        e.indexOf(i) < 0 && ci.call(a, i) && (t[i] = a[i]);
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }
  return t;
};
var rr = function rr(a, e) {
  return function () {
    return e || a((e = {
      exports: {}
    }).exports, e), e.exports;
  };
};
var c = function c(a, e, t) {
  return new Promise(function (i, r) {
    var s = function s(l) {
        try {
          d(t.next(l));
        } catch (h) {
          r(h);
        }
      },
      n = function n(l) {
        try {
          d(t.throw(l));
        } catch (h) {
          r(h);
        }
      },
      d = function d(l) {
        return l.done ? i(l.value) : Promise.resolve(l.value).then(s, n);
      };
    d((t = t.apply(a, e)).next());
  });
};
var Si = rr(function (ms, lr) {
  lr.exports = {
    name: "@100mslive/hms-video",
    version: "0.7.4",
    license: "MIT",
    main: "dist/index.cjs.js",
    typings: "dist/index.d.ts",
    module: "dist/index.js",
    files: ["dist", "src"],
    engines: {
      node: ">=10"
    },
    exports: {
      ".": {
        require: "./dist/index.cjs.js",
        import: "./dist/index.js",
        default: "./dist/index.js"
      }
    },
    scripts: {
      prestart: "rm -rf dist && yarn types:build",
      start: 'concurrently "yarn dev" "yarn types"',
      dev: "node ../../scripts/dev",
      "build:only": "node ../../scripts/build",
      build: "yarn build:only && yarn types:build",
      types: "tsc -w",
      "types:build": "tsc -p tsconfig.json",
      test: "jest --maxWorkers=1",
      lint: "eslint -c ../../.eslintrc .",
      "lint:fix": "yarn lint --fix",
      prepare: "yarn build",
      size: "size-limit",
      analyze: "size-limit --why",
      format: "prettier --write src/**/*.ts"
    },
    author: "100ms <tech-common@100ms.live>",
    devDependencies: {
      "@types/sdp-transform": "^2.4.4",
      "@types/ua-parser-js": "^0.7.36",
      "@types/uuid": "^8.3.0",
      "jest-canvas-mock": "^2.3.1",
      tslib: "^2.2.0"
    },
    dependencies: {
      eventemitter2: "^6.4.7",
      "sdp-transform": "^2.14.1",
      "ua-parser-js": "^1.0.1",
      uuid: "^8.3.2",
      "webrtc-adapter": "^8.0.0"
    },
    gitHead: "36f8d865f05deffecd7a64fb7f3aba1070561584"
  };
});
import Xi from "webrtc-adapter";
import { UAParser as sr } from "ua-parser-js";
import { v4 as ar } from "uuid";
var te = /*#__PURE__*/function () {
  function te(e) {
    _classCallCheck(this, te);
    this.key = e;
    this.storage = null;
  }
  _createClass(te, [{
    key: "getStorage",
    value: function getStorage() {
      return X && !this.storage && (li(), this.storage = window.localStorage), this.storage;
    }
  }, {
    key: "get",
    value: function get() {
      var i;
      var e = (i = this.getStorage()) == null ? void 0 : i.getItem(this.key);
      return e ? JSON.parse(e) : void 0;
    }
  }, {
    key: "set",
    value: function set(e) {
      var i;
      var t = JSON.stringify(e);
      (i = this.getStorage()) == null || i.setItem(this.key, t);
    }
  }, {
    key: "clear",
    value: function clear() {
      var e;
      (e = this.getStorage()) == null || e.removeItem(this.key);
    }
  }]);
  return te;
}();
var pe = new sr(),
  mi,
  me = typeof window == "undefined" && !((mi = pe.getBrowser().name) == null ? void 0 : mi.toLowerCase().includes("electron")),
  X = typeof window != "undefined",
  W;
(function (i) {
  i.PROD = "prod", i.QA = "qa", i.DEV = "dev";
})(W || (W = {}));
var nr = function nr() {
    return !me;
  },
  $r = nr(),
  ui = function ui() {
    return pe.getDevice().type === "mobile";
  },
  hi = function hi() {
    var a,
      e = new te("hms-analytics-deviceId"),
      t = e.get();
    return t ? a = t : (a = ar(), e.set(a)), a;
  },
  pi = function pi() {
    return typeof document != "undefined" && document.hidden;
  },
  yt = function yt() {
    var a;
    return ((a = pe.getOS().name) == null ? void 0 : a.toLowerCase()) === "ios";
  };
var gi = /*#__PURE__*/function () {
    function gi() {
      _classCallCheck(this, gi);
      this.valuesMap = new Map();
    }
    _createClass(gi, [{
      key: "getItem",
      value: function getItem(e) {
        return this.valuesMap.has(e) ? String(this.valuesMap.get(e)) : null;
      }
    }, {
      key: "setItem",
      value: function setItem(e, t) {
        this.valuesMap.set(e, t);
      }
    }, {
      key: "removeItem",
      value: function removeItem(e) {
        this.valuesMap.delete(e);
      }
    }, {
      key: "clear",
      value: function clear() {
        this.valuesMap.clear();
      }
    }, {
      key: "key",
      value: function key(e) {
        if (arguments.length === 0) throw new TypeError("Failed to execute 'key' on 'Storage': 1 argument required, but only 0 present.");
        return Array.from(this.valuesMap.keys())[e];
      }
    }, {
      key: "length",
      get: function get() {
        return this.valuesMap.size;
      }
    }]);
    return gi;
  }(),
  li = function li() {
    X && !localStorage && (window.localStorage = new gi());
  };
var U;
(function (l) {
  l[l.VERBOSE = 0] = "VERBOSE", l[l.DEBUG = 1] = "DEBUG", l[l.INFO = 2] = "INFO", l[l.WARN = 3] = "WARN", l[l.TIME = 4] = "TIME", l[l.TIMEEND = 5] = "TIMEEND", l[l.ERROR = 6] = "ERROR", l[l.NONE = 7] = "NONE";
})(U || (U = {}));
var or = typeof window != "undefined" && typeof window.expect != "undefined",
  o = /*#__PURE__*/function () {
    function o() {
      _classCallCheck(this, o);
    }
    _createClass(o, null, [{
      key: "v",
      value: function v(e) {
        for (var _len = arguments.length, t = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          t[_key - 1] = arguments[_key];
        }
        this.log.apply(this, [0, e].concat(t));
      }
    }, {
      key: "d",
      value: function d(e) {
        for (var _len2 = arguments.length, t = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
          t[_key2 - 1] = arguments[_key2];
        }
        this.log.apply(this, [1, e].concat(t));
      }
    }, {
      key: "i",
      value: function i(e) {
        for (var _len3 = arguments.length, t = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
          t[_key3 - 1] = arguments[_key3];
        }
        this.log.apply(this, [2, e].concat(t));
      }
    }, {
      key: "w",
      value: function w(e) {
        for (var _len4 = arguments.length, t = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
          t[_key4 - 1] = arguments[_key4];
        }
        this.log.apply(this, [3, e].concat(t));
      }
    }, {
      key: "e",
      value: function e(_e2) {
        for (var _len5 = arguments.length, t = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
          t[_key5 - 1] = arguments[_key5];
        }
        this.log.apply(this, [6, _e2].concat(t));
      }
    }, {
      key: "time",
      value: function time(e) {
        this.log(4, "[HMSPerformanceTiming]", e);
      }
    }, {
      key: "timeEnd",
      value: function timeEnd(e) {
        this.log(5, "[HMSPerformanceTiming]", e, e);
      }
    }, {
      key: "cleanUp",
      value: function cleanUp() {
        performance.clearMarks(), performance.clearMeasures();
      }
    }, {
      key: "log",
      value: function log(e, t) {
        for (var _len6 = arguments.length, i = new Array(_len6 > 2 ? _len6 - 2 : 0), _key6 = 2; _key6 < _len6; _key6++) {
          i[_key6 - 2] = arguments[_key6];
        }
        if (!(this.level.valueOf() > e.valueOf())) switch (e) {
          case 0:
            {
              var _console;
              (_console = console).log.apply(_console, [t].concat(i));
              break;
            }
          case 1:
            {
              var _console2;
              (_console2 = console).debug.apply(_console2, [t].concat(i));
              break;
            }
          case 2:
            {
              var _console3;
              (_console3 = console).info.apply(_console3, [t].concat(i));
              break;
            }
          case 3:
            {
              var _console4;
              (_console4 = console).warn.apply(_console4, [t].concat(i));
              break;
            }
          case 6:
            {
              var _console5;
              (_console5 = console).error.apply(_console5, [t].concat(i));
              break;
            }
          case 4:
            {
              performance.mark(i[0]);
              break;
            }
          case 5:
            {
              var r = i[0];
              try {
                var s = performance.measure(r, r);
                this.log(1, t, r, s == null ? void 0 : s.duration), performance.clearMarks(r), performance.clearMeasures(r);
              } catch (s) {
                this.log(1, t, r, s);
              }
              break;
            }
        }
      }
    }]);
    return o;
  }();
o.level = or ? 7 : 0;
var Ee = /*#__PURE__*/function () {
  function Ee(_ref) {
    var e = _ref.sender,
      t = _ref.message,
      _ref$type = _ref.type,
      i = _ref$type === void 0 ? "chat" : _ref$type,
      r = _ref.recipientPeer,
      s = _ref.recipientRoles,
      n = _ref.time;
    _classCallCheck(this, Ee);
    this.sender = e, this.message = t, this.type = i, this.recipientPeer = r, this.recipientRoles = s, this.time = n;
  }
  _createClass(Ee, [{
    key: "toSignalParams",
    value: function toSignalParams() {
      var r, s;
      var e = (r = this.recipientRoles) == null ? void 0 : r.map(function (n) {
          return n.name;
        }),
        t = (s = this.recipientPeer) == null ? void 0 : s.peerId,
        i = {
          info: {
            message: this.message,
            type: this.type
          }
        };
      return (e == null ? void 0 : e.length) && (i.roles = e), t && (i.peer_id = t), i;
    }
  }, {
    key: "toString",
    value: function toString() {
      var e;
      return "{\n      sender: ".concat(this.sender, ";\n      recipientPeer: ").concat(this.recipientPeer, ";\n      recipientRoles: ").concat((e = this.recipientRoles) == null ? void 0 : e.map(function (t) {
        return t.name;
      }), ";\n      message: ").concat(this.message, ";\n      time: ").concat(this.time, ";\n      type: ").concat(this.type, ";\n    }");
    }
  }]);
  return Ee;
}();
var Ge = /*#__PURE__*/function () {
  function Ge(e, t) {
    _classCallCheck(this, Ge);
    this.id = e;
    this.store = t;
    this.recording = {
      server: {
        running: !1
      },
      browser: {
        running: !1
      },
      hls: {
        running: !1
      }
    };
    this.rtmp = {
      running: !1
    };
    this.hls = {
      running: !1,
      variants: []
    };
  }
  _createClass(Ge, [{
    key: "localPeer",
    get: function get() {
      return this.store.getLocalPeer();
    }
  }, {
    key: "peers",
    get: function get() {
      return this.store.getPeers();
    }
  }]);
  return Ge;
}();
var oe = /*#__PURE__*/function () {
  function oe(_ref2) {
    var e = _ref2.peerId,
      t = _ref2.name,
      i = _ref2.isLocal,
      r = _ref2.customerUserId,
      s = _ref2.metadata,
      n = _ref2.role,
      d = _ref2.joinedAt;
    _classCallCheck(this, oe);
    this.customerUserId = "";
    this.metadata = "";
    this.auxiliaryTracks = [];
    this.name = t, this.peerId = e, this.isLocal = i, this.customerUserId = r, this.metadata = s, this.joinedAt = d, n && (this.role = n);
  }
  _createClass(oe, [{
    key: "updateRole",
    value: function updateRole(e) {
      this.role = e;
    }
  }, {
    key: "updateName",
    value: function updateName(e) {
      this.name = e;
    }
  }, {
    key: "updateMetadata",
    value: function updateMetadata(e) {
      this.metadata = e;
    }
  }, {
    key: "toString",
    value: function toString() {
      var e, t, i;
      return "{\n      name: ".concat(this.name, ";\n      role: ").concat((e = this.role) == null ? void 0 : e.name, ";\n      peerId: ").concat(this.peerId, ";\n      customerUserId: ").concat(this.customerUserId, ";\n      ").concat(this.audioTrack ? "audioTrack: ".concat((t = this.audioTrack) == null ? void 0 : t.trackId, ";") : "", "\n      ").concat(this.videoTrack ? "videoTrack: ".concat((i = this.videoTrack) == null ? void 0 : i.trackId, ";") : "", "\n    }");
    }
  }]);
  return oe;
}();
import { v4 as cr } from "uuid";
var He = function He() {
  _classCallCheck(this, He);
};
He.makePeerId = function () {
  return cr();
};
var Ve = /*#__PURE__*/function (_oe) {
  _inherits(Ve, _oe);
  function Ve(e) {
    var _this;
    _classCallCheck(this, Ve);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(Ve).call(this, L(v({}, e), {
      peerId: He.makePeerId(),
      isLocal: !0
    })));
    _this.isLocal = !0;
    _this.auxiliaryTracks = [];
    _this.asRole = e.asRole;
    return _this;
  }
  _createClass(Ve, [{
    key: "isInPreview",
    value: function isInPreview() {
      return !!this.asRole;
    }
  }, {
    key: "toString",
    value: function toString() {
      var e, t, i;
      return "{\n      name: ".concat(this.name, ";\n      role: ").concat((e = this.role) == null ? void 0 : e.name, ";\n      peerId: ").concat(this.peerId, ";\n      customerUserId: ").concat(this.customerUserId, ";\n      ").concat(this.asRole ? "asRole: ".concat(this.asRole.name, ";") : "", "\n      ").concat(this.audioTrack ? "audioTrack: ".concat((t = this.audioTrack) == null ? void 0 : t.trackId, ";") : "", "\n      ").concat(this.videoTrack ? "videoTrack: ".concat((i = this.videoTrack) == null ? void 0 : i.trackId, ";") : "", "\n    }");
    }
  }]);
  return Ve;
}(oe);
var $e = /*#__PURE__*/function (_oe2) {
  _inherits($e, _oe2);
  function $e(e) {
    var _this2;
    _classCallCheck(this, $e);
    _this2 = _possibleConstructorReturn(this, _getPrototypeOf($e).call(this, L(v({}, e), {
      isLocal: !1
    })));
    _this2.isLocal = !1;
    _this2.auxiliaryTracks = [];
    _this2.fromRoomState = !1;
    _this2.fromRoomState = !!e.fromRoomState;
    return _this2;
  }
  return $e;
}(oe);
import { v4 as kr } from "uuid";
import { v4 as ur } from "uuid";
var ie;
(function (i) {
  i.CUSTOM = "CUSTOM", i.LOCAL = "LOCAL", i.HMS = "HMS";
})(ie || (ie = {}));
function dr() {
  if (X && window) {
    var a = window.location.hostname;
    return a === "localhost" || a === "127.0.0.1" ? ie.LOCAL : a.includes("app.100ms.live") ? ie.HMS : ie.CUSTOM;
  }
  return ie.CUSTOM;
}
var ke = dr();
var vi = Si().version;
function Le() {
  var a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : W.PROD;
  var e = arguments.length > 1 ? arguments[1] : undefined;
  var t = "web",
    i = ke !== ie.LOCAL && a === W.PROD ? "prod" : "debug";
  if (me) return Ti({
    os: "web_nodejs",
    os_version: process.version,
    sdk: t,
    sdk_version: vi,
    env: i,
    domain: ke,
    framework: "node",
    framework_version: process.version,
    framework_sdk_version: e == null ? void 0 : e.sdkVersion
  });
  var r = pe.getOS(),
    s = pe.getDevice(),
    n = pe.getBrowser(),
    d = Mt("web_".concat(r.name)),
    l = r.version || "",
    h = Mt("".concat(n.name, "_").concat(n.version)),
    u = h;
  return s.type && (u = "".concat(Mt("".concat(s.vendor, "_").concat(s.type)), "/").concat(h)), Ti({
    os: d,
    os_version: l,
    sdk: t,
    sdk_version: vi,
    device_model: u,
    env: i,
    domain: ke,
    framework: e == null ? void 0 : e.type,
    framework_version: e == null ? void 0 : e.version,
    framework_sdk_version: e == null ? void 0 : e.sdkVersion
  });
}
function Mt(a) {
  return a.replace(/ /g, "_");
}
var Ti = function Ti(a) {
  var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ",";
  return Object.keys(a).filter(function (t) {
    return !!a[t];
  }).map(function (t) {
    return "".concat(t, ":").concat(a[t]);
  }).join(e);
};
var x = /*#__PURE__*/function () {
  function x(_ref3) {
    var e = _ref3.name,
      t = _ref3.level,
      i = _ref3.properties,
      r = _ref3.includesPII,
      s = _ref3.timestamp;
    _classCallCheck(this, x);
    this.metadata = {
      peer: {},
      userAgent: Le()
    };
    this.name = e, this.level = t, this.includesPII = r || !1, this.properties = i || {}, this.timestamp = s || new Date().getTime(), this.event_id = ur(), this.device_id = hi();
  }
  _createClass(x, [{
    key: "toSignalParams",
    value: function toSignalParams() {
      return {
        name: this.name,
        info: L(v({}, this.properties), {
          timestamp: this.timestamp,
          domain: ke
        }),
        timestamp: new Date().getTime()
      };
    }
  }]);
  return x;
}();
var We;
(function (r) {
  r[r.VERBOSE = 0] = "VERBOSE", r[r.INFO = 1] = "INFO", r[r.ERROR = 2] = "ERROR", r[r.OFF = 3] = "OFF";
})(We || (We = {}));
var _;
(function (r) {
  r[r.VERBOSE = 0] = "VERBOSE", r[r.INFO = 1] = "INFO", r[r.ERROR = 2] = "ERROR", r[r.OFF = 3] = "OFF";
})(_ || (_ = {}));
var T = /*#__PURE__*/function (_Error) {
  _inherits(T, _Error);
  function T(e, t, i, r, s) {
    var _this3;
    var n = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : !1;
    _classCallCheck(this, T);
    _this3 = _possibleConstructorReturn(this, _getPrototypeOf(T).call(this, r));
    _this3.code = e;
    _this3.name = t;
    _this3.message = r;
    _this3.description = s;
    _this3.isTerminal = n;
    Object.setPrototypeOf(_assertThisInitialized(_assertThisInitialized(_this3)), T.prototype), _this3.action = i.toString();
    return _this3;
  }
  _createClass(T, [{
    key: "toAnalyticsProperties",
    value: function toAnalyticsProperties() {
      return {
        error_name: this.name,
        error_code: this.code,
        error_message: this.message,
        error_description: this.description,
        action: this.action,
        is_terminal: this.isTerminal
      };
    }
  }, {
    key: "addNativeError",
    value: function addNativeError(e) {
      this.nativeError = e;
    }
  }, {
    key: "toString",
    value: function toString() {
      var e;
      return "{\n      code: ".concat(this.code, ";\n      name: ").concat(this.name, ";\n      action: ").concat(this.action, ";\n      message: ").concat(this.message, ";\n      description: ").concat(this.description, ";\n      isTerminal: ").concat(this.isTerminal, ";\n      nativeError: ").concat((e = this.nativeError) == null ? void 0 : e.message, ";\n    }");
    }
  }]);
  return T;
}(_wrapNativeSuper(Error));
var H = /*#__PURE__*/function () {
  function H() {
    _classCallCheck(this, H);
  }
  _createClass(H, null, [{
    key: "connect",
    value: function connect(e, t) {
      var _L;
      var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : new Date();
      var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : new Date();
      var s = arguments.length > 4 ? arguments[4] : undefined;
      var n = this.eventNameFor("connect", e === void 0),
        d = e ? _.ERROR : _.INFO,
        l = this.getPropertiesWithError(L(v({}, t), (_L = {}, _defineProperty(_L, this.KEY_REQUESTED_AT, i == null ? void 0 : i.getTime()), _defineProperty(_L, this.KEY_RESPONDED_AT, r == null ? void 0 : r.getTime()), _defineProperty(_L, "endpoint", s), _L)), e);
      return new x({
        name: n,
        level: d,
        properties: l
      });
    }
  }, {
    key: "disconnect",
    value: function disconnect(e, t) {
      var i = "disconnected",
        r = e ? _.ERROR : _.INFO,
        s = this.getPropertiesWithError(t, e);
      return new x({
        name: i,
        level: r,
        properties: s
      });
    }
  }, {
    key: "preview",
    value: function preview(i) {
      var r = i,
        e = r.error,
        t = kt(r, ["error"]);
      var s = this.eventNameFor("preview", e === void 0),
        n = e ? _.ERROR : _.INFO,
        d = this.getPropertiesWithError(t, e);
      return new x({
        name: s,
        level: n,
        properties: d
      });
    }
  }, {
    key: "join",
    value: function join(i) {
      var r = i,
        e = r.error,
        t = kt(r, ["error"]);
      var s = this.eventNameFor("join", e === void 0),
        n = e ? _.ERROR : _.INFO,
        d = this.getPropertiesWithError(L(v({}, t), {
          is_preview_called: !!t.is_preview_called
        }), e);
      return new x({
        name: s,
        level: n,
        properties: d
      });
    }
  }, {
    key: "publish",
    value: function publish(_ref4) {
      var e = _ref4.devices,
        t = _ref4.settings,
        i = _ref4.error;
      var r = this.eventNameFor("publish", i === void 0),
        s = i ? _.ERROR : _.INFO,
        n = this.getPropertiesWithError({
          devices: e,
          audio: t == null ? void 0 : t.audio,
          video: t == null ? void 0 : t.video
        }, i);
      return new x({
        name: r,
        level: s,
        properties: n
      });
    }
  }, {
    key: "subscribeFail",
    value: function subscribeFail(e) {
      var t = this.eventNameFor("subscribe", !1),
        i = _.ERROR,
        r = this.getErrorProperties(e);
      return new x({
        name: t,
        level: i,
        properties: r
      });
    }
  }, {
    key: "leave",
    value: function leave() {
      return new x({
        name: "leave",
        level: _.INFO
      });
    }
  }, {
    key: "autoplayError",
    value: function autoplayError() {
      return new x({
        name: "autoplayError",
        level: _.ERROR
      });
    }
  }, {
    key: "audioPlaybackError",
    value: function audioPlaybackError(e) {
      return new x({
        name: "audioPlaybackError",
        level: _.ERROR,
        properties: this.getErrorProperties(e)
      });
    }
  }, {
    key: "deviceChange",
    value: function deviceChange(_ref5) {
      var e = _ref5.selection,
        t = _ref5.type,
        i = _ref5.devices,
        r = _ref5.error;
      var s = this.eventNameFor(r ? "publish" : "device.".concat(t), r === void 0),
        n = r ? _.ERROR : _.INFO,
        d = this.getPropertiesWithError({
          selection: e,
          devices: i
        }, r);
      return new x({
        name: s,
        level: n,
        properties: d
      });
    }
  }, {
    key: "performance",
    value: function performance(e) {
      var t = "perf.stats",
        i = _.INFO,
        r = e.toAnalyticsProperties();
      return new x({
        name: t,
        level: i,
        properties: r
      });
    }
  }, {
    key: "rtcStats",
    value: function rtcStats(e) {
      var t = "rtc.stats",
        i = _.INFO,
        r = e.toAnalyticsProperties();
      return new x({
        name: t,
        level: i,
        properties: r
      });
    }
  }, {
    key: "degradationStats",
    value: function degradationStats(e, t) {
      var i = "video.degradation.stats",
        r = _.INFO,
        s = {
          degradedAt: e.degradedAt,
          trackId: e.trackId
        };
      if (!t && e.degradedAt instanceof Date) {
        var n = new Date(),
          d = n.valueOf() - e.degradedAt.valueOf();
        s = L(v({}, s), {
          duration: d,
          restoredAt: n
        });
      }
      return new x({
        name: i,
        level: r,
        properties: s
      });
    }
  }, {
    key: "audioDetectionFail",
    value: function audioDetectionFail(e, t) {
      var i = this.getPropertiesWithError({
          device: t
        }, e),
        r = _.ERROR,
        s = "audiopresence.failed";
      return new x({
        name: s,
        level: r,
        properties: i
      });
    }
  }, {
    key: "previewNetworkQuality",
    value: function previewNetworkQuality(e) {
      return new x({
        name: "perf.networkquality.preview",
        level: e.error ? _.ERROR : _.INFO,
        properties: e
      });
    }
  }, {
    key: "eventNameFor",
    value: function eventNameFor(e, t) {
      return "".concat(e, ".").concat(t ? "success" : "failed");
    }
  }, {
    key: "getPropertiesWithError",
    value: function getPropertiesWithError(e, t) {
      var i = this.getErrorProperties(t);
      return e = v(v({}, i), e), e;
    }
  }, {
    key: "getErrorProperties",
    value: function getErrorProperties(e) {
      return e ? e instanceof T ? e.toAnalyticsProperties() : {
        error_name: e.name,
        error_message: e.message,
        error_description: e.cause
      } : {};
    }
  }]);
  return H;
}();
H.KEY_REQUESTED_AT = "requested_at", H.KEY_RESPONDED_AT = "responded_at";
var M;
(function (u) {
  u.INIT = "init_response_time", u.WEBSOCKET_CONNECT = "ws_connect_time", u.ON_POLICY_CHANGE = "on_policy_change_time", u.LOCAL_AUDIO_TRACK = "local_audio_track_time", u.LOCAL_VIDEO_TRACK = "local_video_track_time", u.JOIN = "join_time", u.PREVIEW = "preview_time", u.PEER_LIST = "peer_list_time", u.ROOM_STATE = "room_state_time", u.JOIN_RESPONSE = "join_response_time";
})(M || (M = {}));
var hr = [M.INIT, M.WEBSOCKET_CONNECT, M.ON_POLICY_CHANGE, M.LOCAL_AUDIO_TRACK, M.LOCAL_VIDEO_TRACK, M.PEER_LIST, M.ROOM_STATE],
  At = /*#__PURE__*/function () {
    function At() {
      _classCallCheck(this, At);
      this.eventPerformanceMeasures = {};
    }
    _createClass(At, [{
      key: "start",
      value: function start(e) {
        performance.mark(e);
      }
    }, {
      key: "end",
      value: function end(e) {
        var t;
        try {
          this.eventPerformanceMeasures[e] = performance.measure(e, e), o.d("[HMSPerformanceTiming]", e, (t = this.eventPerformanceMeasures[e]) == null ? void 0 : t.duration);
        } catch (i) {
          o.w("[AnalyticsTimer]", "Error in measuring performance for event ".concat(e), {
            error: i
          });
        }
      }
    }, {
      key: "getTimeTaken",
      value: function getTimeTaken(e) {
        var t;
        return (t = this.eventPerformanceMeasures[e]) == null ? void 0 : t.duration;
      }
    }, {
      key: "getTimes",
      value: function getTimes() {
        var _this4 = this;
        for (var _len7 = arguments.length, e = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
          e[_key7] = arguments[_key7];
        }
        return [].concat(hr, e).reduce(function (t, i) {
          return L(v({}, t), _defineProperty({}, i, _this4.getTimeTaken(i)));
        }, {});
      }
    }, {
      key: "cleanUp",
      value: function cleanUp() {
        this.eventPerformanceMeasures = {};
      }
    }]);
    return At;
  }();
var f = {
  WebSocketConnectionErrors: {
    FAILED_TO_CONNECT: 1e3,
    WEBSOCKET_CONNECTION_LOST: 1003,
    ABNORMAL_CLOSE: 1006
  },
  InitAPIErrors: {
    SERVER_ERRORS: 2e3,
    INIT_CONFIG_NOT_AVAILABLE: 2002,
    ENDPOINT_UNREACHABLE: 2003,
    INVALID_TOKEN_FORMAT: 2004
  },
  TracksErrors: {
    GENERIC_TRACK: 3e3,
    CANT_ACCESS_CAPTURE_DEVICE: 3001,
    DEVICE_NOT_AVAILABLE: 3002,
    DEVICE_IN_USE: 3003,
    DEVICE_LOST_MIDWAY: 3008,
    NOTHING_TO_RETURN: 3005,
    INVALID_VIDEO_SETTINGS: 3006,
    CODEC_CHANGE_NOT_PERMITTED: 3007,
    AUTOPLAY_ERROR: 3008,
    OVER_CONSTRAINED: 3009,
    NO_AUDIO_DETECTED: 3010,
    SYSTEM_DENIED_PERMISSION: 3011,
    CURRENT_TAB_NOT_SHARED: 3012,
    AUDIO_PLAYBACK_ERROR: 3013
  },
  WebrtcErrors: {
    CREATE_OFFER_FAILED: 4001,
    CREATE_ANSWER_FAILED: 4002,
    SET_LOCAL_DESCRIPTION_FAILED: 4003,
    SET_REMOTE_DESCRIPTION_FAILED: 4004,
    ICE_FAILURE: 4005,
    ICE_DISCONNECTED: 4006
  },
  WebsocketMethodErrors: {
    SERVER_ERRORS: 5e3,
    ALREADY_JOINED: 5001,
    CANNOT_JOIN_PREVIEW_IN_PROGRESS: 5002
  },
  GenericErrors: {
    NOT_CONNECTED: 6e3,
    SIGNALLING: 6001,
    UNKNOWN: 6002,
    NOT_READY: 6003,
    JSON_PARSING_FAILED: 6004,
    TRACK_METADATA_MISSING: 6005,
    RTC_TRACK_MISSING: 6006,
    PEER_METADATA_MISSING: 6007,
    INVALID_ROLE: 6008,
    PREVIEW_IN_PROGRESS: 6009,
    MISSING_MEDIADEVICES: 6010,
    MISSING_RTCPEERCONNECTION: 6011
  },
  PlaylistErrors: {
    NO_ENTRY_TO_PLAY: 8001,
    NO_ENTRY_IS_PLAYING: 8002
  }
};
var p;
(function (I) {
  I.NONE = "NONE", I.TRACK = "TRACK", I.INIT = "INIT", I.PUBLISH = "PUBLISH", I.UNPUBLISH = "UNPUBLISH", I.JOIN = "JOIN", I.SUBSCRIBE = "SUBSCRIBE", I.DATA_CHANNEL_SEND = "DATA_CHANNEL_SEND", I.RESTART_ICE = "RESTART_ICE", I.VIDEO_PLUGINS = "VIDEO_PLUGINS", I.AUDIO_PLUGINS = "AUDIO_PLUGINS", I.AUTOPLAY = "AUTOPLAY", I.RECONNECT_SIGNAL = "RECONNECT_SIGNAL", I.VALIDATION = "VALIDATION", I.PLAYLIST = "PLAYLIST", I.PREVIEW = "PREVIEW";
})(p || (p = {}));
var m = {
  WebSocketConnectionErrors: {
    FailedToConnect: function FailedToConnect(a) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
      return new T(f.WebSocketConnectionErrors.FAILED_TO_CONNECT, "WebsocketFailedToConnect", a, "[WS]: ".concat(e), "[WS]: ".concat(e));
    },
    WebSocketConnectionLost: function WebSocketConnectionLost(a) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
      return new T(f.WebSocketConnectionErrors.WEBSOCKET_CONNECTION_LOST, "WebSocketConnectionLost", a, "Network connection lost ", e);
    },
    AbnormalClose: function AbnormalClose(a) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
      return new T(f.WebSocketConnectionErrors.ABNORMAL_CLOSE, "WebSocketAbnormalClose", a, "Websocket closed abnormally", e);
    }
  },
  InitAPIErrors: {
    ServerErrors: function ServerErrors(a, e) {
      var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
      return new T(a, "ServerErrors", e, "[INIT]: Server error ".concat(t), t, !0);
    },
    EndpointUnreachable: function EndpointUnreachable(a) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
      return new T(f.InitAPIErrors.ENDPOINT_UNREACHABLE, "EndpointUnreachable", a, "Endpoint is not reachable - ".concat(e), e);
    },
    InvalidTokenFormat: function InvalidTokenFormat(a) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
      return new T(f.InitAPIErrors.INVALID_TOKEN_FORMAT, "InvalidTokenFormat", a, "Token is not in proper JWT format - ".concat(e), e, !0);
    },
    InitConfigNotAvailable: function InitConfigNotAvailable(a) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
      return new T(f.InitAPIErrors.INIT_CONFIG_NOT_AVAILABLE, "InitError", a, "[INIT]: ".concat(e), "[INIT]: ".concat(e));
    }
  },
  TracksErrors: {
    GenericTrack: function GenericTrack(a) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
      return new T(f.TracksErrors.GENERIC_TRACK, "GenericTrack", a, "[TRACK]: ".concat(e), "[TRACK]: ".concat(e));
    },
    CantAccessCaptureDevice: function CantAccessCaptureDevice(a, e) {
      var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
      return new T(f.TracksErrors.CANT_ACCESS_CAPTURE_DEVICE, "CantAccessCaptureDevice", a, "User denied permission to access capture device - ".concat(e), t);
    },
    DeviceNotAvailable: function DeviceNotAvailable(a, e) {
      var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
      return new T(f.TracksErrors.DEVICE_NOT_AVAILABLE, "DeviceNotAvailable", a, "[TRACK]: Capture device is no longer available - ".concat(e), t);
    },
    DeviceInUse: function DeviceInUse(a, e) {
      var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
      return new T(f.TracksErrors.DEVICE_IN_USE, "DeviceInUse", a, "[TRACK]: Capture device is in use by another application - ".concat(e), t);
    },
    DeviceLostMidway: function DeviceLostMidway(a, e) {
      var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
      return new T(f.TracksErrors.DEVICE_LOST_MIDWAY, "DeviceLostMidway", a, "Lost access to capture device midway - ".concat(e), t);
    },
    NothingToReturn: function NothingToReturn(a) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
      var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "There is no media to return. Please select either video or audio or both.";
      return new T(f.TracksErrors.NOTHING_TO_RETURN, "NothingToReturn", a, t, e);
    },
    InvalidVideoSettings: function InvalidVideoSettings(a) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
      return new T(f.TracksErrors.INVALID_VIDEO_SETTINGS, "InvalidVideoSettings", a, "Cannot enable simulcast when no video settings are provided", e);
    },
    AutoplayBlocked: function AutoplayBlocked(a) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
      return new T(f.TracksErrors.AUTOPLAY_ERROR, "AutoplayBlocked", a, "Autoplay blocked because the user didn't interact with the document first", e);
    },
    CodecChangeNotPermitted: function CodecChangeNotPermitted(a) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
      return new T(f.TracksErrors.CODEC_CHANGE_NOT_PERMITTED, "CodecChangeNotPermitted", a, "Codec can't be changed mid call.", e);
    },
    OverConstrained: function OverConstrained(a, e) {
      var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
      return new T(f.TracksErrors.OVER_CONSTRAINED, "OverConstrained", a, "[TRACK]: Requested constraints cannot be satisfied with the device hardware - ".concat(e), t);
    },
    NoAudioDetected: function NoAudioDetected(a) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "Please check the mic or use another audio input";
      return new T(f.TracksErrors.NO_AUDIO_DETECTED, "NoAudioDetected", a, "No audio input detected from microphone", e);
    },
    SystemDeniedPermission: function SystemDeniedPermission(a, e) {
      var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
      return new T(f.TracksErrors.SYSTEM_DENIED_PERMISSION, "SystemDeniedPermission", a, "Operating System denied permission to access capture device - ".concat(e), t);
    },
    CurrentTabNotShared: function CurrentTabNotShared() {
      return new T(f.TracksErrors.CURRENT_TAB_NOT_SHARED, "CurrentTabNotShared", p.TRACK, "The app requires you to share the current tab", "You must screen share the current tab in order to proceed");
    },
    AudioPlaybackError: function AudioPlaybackError(a) {
      return new T(f.TracksErrors.AUDIO_PLAYBACK_ERROR, "Audio playback error", p.TRACK, a, a);
    }
  },
  WebrtcErrors: {
    CreateOfferFailed: function CreateOfferFailed(a) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
      return new T(f.WebrtcErrors.CREATE_OFFER_FAILED, "CreateOfferFailed", a, "[".concat(a.toString(), "]: Failed to create offer. "), e);
    },
    CreateAnswerFailed: function CreateAnswerFailed(a) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
      return new T(f.WebrtcErrors.CREATE_ANSWER_FAILED, "CreateAnswerFailed", a, "[".concat(a.toString(), "]: Failed to create answer. "), e);
    },
    SetLocalDescriptionFailed: function SetLocalDescriptionFailed(a) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
      return new T(f.WebrtcErrors.SET_LOCAL_DESCRIPTION_FAILED, "SetLocalDescriptionFailed", a, "[".concat(a.toString(), "]: Failed to set offer. "), e);
    },
    SetRemoteDescriptionFailed: function SetRemoteDescriptionFailed(a) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
      return new T(f.WebrtcErrors.SET_REMOTE_DESCRIPTION_FAILED, "SetRemoteDescriptionFailed", a, "[".concat(a.toString(), "]: Failed to set answer. "), e, !0);
    },
    ICEFailure: function ICEFailure(a) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
      return new T(f.WebrtcErrors.ICE_FAILURE, "ICEFailure", a, "[".concat(a.toString(), "]: Ice connection state FAILED"), e);
    },
    ICEDisconnected: function ICEDisconnected(a) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
      return new T(f.WebrtcErrors.ICE_DISCONNECTED, "ICEDisconnected", a, "[".concat(a.toString(), "]: Ice connection state DISCONNECTED"), e);
    }
  },
  WebsocketMethodErrors: {
    ServerErrors: function ServerErrors(a, e, t) {
      return new T(a, "ServerErrors", e, t, t, !0);
    },
    AlreadyJoined: function AlreadyJoined(a) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
      return new T(f.WebsocketMethodErrors.ALREADY_JOINED, "AlreadyJoined", a, "[JOIN]: You have already joined this room.", e);
    },
    CannotJoinPreviewInProgress: function CannotJoinPreviewInProgress(a) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
      return new T(f.WebsocketMethodErrors.CANNOT_JOIN_PREVIEW_IN_PROGRESS, "CannotJoinPreviewInProgress", a, "[JOIN]: Cannot join if preview is in progress", e);
    }
  },
  GenericErrors: {
    NotConnected: function NotConnected(a) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
      return new T(f.GenericErrors.NOT_CONNECTED, "NotConnected", a, "Client is not connected", e);
    },
    Signalling: function Signalling(a, e) {
      return new T(f.GenericErrors.SIGNALLING, "Signalling", a, "Unknown signalling error: ".concat(a.toString(), " ").concat(e, " "), e);
    },
    Unknown: function Unknown(a, e) {
      return new T(f.GenericErrors.UNKNOWN, "Unknown", a, "Unknown exception: ".concat(e), e);
    },
    NotReady: function NotReady(a) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
      return new T(f.GenericErrors.NOT_READY, "NotReady", a, e, e);
    },
    JsonParsingFailed: function JsonParsingFailed(a, e) {
      var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
      return new T(f.GenericErrors.JSON_PARSING_FAILED, "JsonParsingFailed", a, "Failed to parse JSON message - ".concat(e), t);
    },
    TrackMetadataMissing: function TrackMetadataMissing(a) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
      return new T(f.GenericErrors.TRACK_METADATA_MISSING, "TrackMetadataMissing", a, "Track Metadata Missing", e);
    },
    RTCTrackMissing: function RTCTrackMissing(a) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
      return new T(f.GenericErrors.RTC_TRACK_MISSING, "RTCTrackMissing", a, "RTC Track missing", e);
    },
    PeerMetadataMissing: function PeerMetadataMissing(a) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
      return new T(f.GenericErrors.PEER_METADATA_MISSING, "PeerMetadataMissing", a, "Peer Metadata Missing", e);
    },
    ValidationFailed: function ValidationFailed(a, e) {
      return new T(f.GenericErrors.INVALID_ROLE, "ValidationFailed", p.VALIDATION, a, e ? JSON.stringify(e) : "");
    },
    InvalidRole: function InvalidRole(a, e) {
      return new T(f.GenericErrors.INVALID_ROLE, "InvalidRole", a, "Invalid role. Join with valid role", e, !0);
    },
    PreviewAlreadyInProgress: function PreviewAlreadyInProgress(a) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
      return new T(f.GenericErrors.PREVIEW_IN_PROGRESS, "PreviewAlreadyInProgress", a, "[Preview]: Cannot join if preview is in progress", e);
    },
    MissingMediaDevices: function MissingMediaDevices() {
      return new T(f.GenericErrors.MISSING_MEDIADEVICES, "MissingMediaDevices", p.JOIN, "navigator.mediaDevices is undefined. 100ms SDK won't work on this website as WebRTC is not supported on HTTP endpoints(missing navigator.mediaDevices). Please ensure you're using the SDK either on localhost or a valid HTTPS endpoint.", "", !0);
    },
    MissingRTCPeerConnection: function MissingRTCPeerConnection() {
      return new T(f.GenericErrors.MISSING_RTCPEERCONNECTION, "MissingRTCPeerConnection", p.JOIN, "RTCPeerConnection which is a core requirement for WebRTC call was not found, this could be due to an unsupported browser or browser extensions blocking WebRTC", "", !0);
    }
  },
  MediaPluginErrors: {
    PlatformNotSupported: function PlatformNotSupported(a) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
      return new T(7001, "PlatformNotSupported", a, "Check HMS Docs to see the list of supported platforms", e);
    },
    InitFailed: function InitFailed(a) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
      return new T(7002, "InitFailed", a, "Plugin init failed", e);
    },
    ProcessingFailed: function ProcessingFailed(a) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
      return new T(7003, "ProcessingFailed", a, "Plugin processing failed", e);
    },
    AddAlreadyInProgress: function AddAlreadyInProgress(a) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
      return new T(7004, "AddAlreadyInProgress", a, "Plugin add already in progress", e);
    },
    DeviceNotSupported: function DeviceNotSupported(a) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
      return new T(7005, "DeviceNotSupported", a, "Check HMS Docs to see the list of supported devices", e);
    }
  },
  PlaylistErrors: {
    NoEntryToPlay: function NoEntryToPlay(a, e) {
      return new T(f.PlaylistErrors.NO_ENTRY_TO_PLAY, "NoEntryToPlay", a, "Reached end of playlist", e);
    },
    NoEntryPlaying: function NoEntryPlaying(a, e) {
      return new T(f.PlaylistErrors.NO_ENTRY_IS_PLAYING, "NoEntryIsPlaying", a, "No entry is playing at this time", e);
    }
  }
};
import fi from "webrtc-adapter";
var K;
(function (s) {
  s.UNKNOWN = "unknown(video or audio)", s.AUDIO = "audio", s.VIDEO = "video", s.AV = "audio, video", s.SCREEN = "screen";
})(K || (K = {}));
function pr(a, e) {
  var t = a.toLowerCase();
  return t.includes("device not found") ? m.TracksErrors.DeviceNotAvailable(p.TRACK, e, a) : t.includes("permission denied") ? m.TracksErrors.CantAccessCaptureDevice(p.TRACK, e, a) : m.TracksErrors.GenericTrack(p.TRACK, a);
}
function mr(a) {
  var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
  if (fi.browserDetails.browser === "chrome" && a.name === "NotAllowedError" && a.message.includes("denied by system")) return m.TracksErrors.SystemDeniedPermission(p.TRACK, e, a.message);
  if (fi.browserDetails.browser === "firefox" && a.name === "NotFoundError") {
    var i = m.TracksErrors.SystemDeniedPermission(p.TRACK, e, a.message);
    return i.description = "Capture device is either blocked at Operating System level or not available - ".concat(e), i;
  }
  switch (a.name) {
    case "OverconstrainedError":
      return m.TracksErrors.OverConstrained(p.TRACK, e, a.constraint);
    case "NotAllowedError":
      return m.TracksErrors.CantAccessCaptureDevice(p.TRACK, e, a.message);
    case "NotFoundError":
      return m.TracksErrors.DeviceNotAvailable(p.TRACK, e, a.message);
    case "NotReadableError":
      return m.TracksErrors.DeviceInUse(p.TRACK, e, a.message);
    case "TypeError":
      return m.TracksErrors.NothingToReturn(p.TRACK, a.message);
    default:
      return pr(a.message, e);
  }
}
function ee(a, e) {
  var t = mr(a, e);
  return t.addNativeError(a), t;
}
var ce;
(function (s) {
  s.RECORDING_STATE_UPDATED = "RECORDING_STATE_UPDATED", s.BROWSER_RECORDING_STATE_UPDATED = "BROWSER_RECORDING_STATE_UPDATED", s.SERVER_RECORDING_STATE_UPDATED = "SERVER_RECORDING_STATE_UPDATED", s.RTMP_STREAMING_STATE_UPDATED = "RTMP_STREAMING_STATE_UPDATED", s.HLS_STREAMING_STATE_UPDATED = "HLS_STREAMING_STATE_UPDATED";
})(ce || (ce = {}));
var q;
(function (g) {
  g[g.PEER_JOINED = 0] = "PEER_JOINED", g[g.PEER_LEFT = 1] = "PEER_LEFT", g[g.AUDIO_TOGGLED = 2] = "AUDIO_TOGGLED", g[g.VIDEO_TOGGLED = 3] = "VIDEO_TOGGLED", g[g.BECAME_DOMINANT_SPEAKER = 4] = "BECAME_DOMINANT_SPEAKER", g[g.RESIGNED_DOMINANT_SPEAKER = 5] = "RESIGNED_DOMINANT_SPEAKER", g[g.STARTED_SPEAKING = 6] = "STARTED_SPEAKING", g[g.STOPPED_SPEAKING = 7] = "STOPPED_SPEAKING", g[g.ROLE_UPDATED = 8] = "ROLE_UPDATED", g[g.PEER_LIST = 9] = "PEER_LIST", g[g.NAME_UPDATED = 10] = "NAME_UPDATED", g[g.METADATA_UPDATED = 11] = "METADATA_UPDATED";
})(q || (q = {}));
var D;
(function (d) {
  d[d.TRACK_ADDED = 0] = "TRACK_ADDED", d[d.TRACK_REMOVED = 1] = "TRACK_REMOVED", d[d.TRACK_MUTED = 2] = "TRACK_MUTED", d[d.TRACK_UNMUTED = 3] = "TRACK_UNMUTED", d[d.TRACK_DESCRIPTION_CHANGED = 4] = "TRACK_DESCRIPTION_CHANGED", d[d.TRACK_DEGRADED = 5] = "TRACK_DEGRADED", d[d.TRACK_RESTORED = 6] = "TRACK_RESTORED";
})(D || (D = {}));
var j;
(function (r) {
  r.NONE = "none", r.LOW = "low", r.MEDIUM = "medium", r.HIGH = "high";
})(j || (j = {}));
var Pt = {
  f: j.HIGH,
  h: j.MEDIUM,
  q: j.LOW
};
var Ke;
(function (i) {
  i.VP8 = "vp8", i.VP9 = "vp9", i.H264 = "h264";
})(Ke || (Ke = {}));
var qe;
(function (e) {
  e.OPUS = "opus";
})(qe || (qe = {}));
var Ei;
(function (i) {
  i.videoInput = "videoInput", i.audioInput = "audioInput", i.audioOutput = "audioOutput";
})(Ei || (Ei = {}));
var b;
(function (t) {
  t.audio = "audio", t.video = "video";
})(b || (b = {}));
var z = /*#__PURE__*/function () {
    function z() {
      _classCallCheck(this, z);
      this._volume = 1;
      this._codec = qe.OPUS;
      this._maxBitrate = 32;
      this._deviceId = "default";
      this._advanced = [{
        googEchoCancellation: {
          exact: !0
        }
      }, {
        googExperimentalEchoCancellation: {
          exact: !0
        }
      }, {
        autoGainControl: {
          exact: !0
        }
      }, {
        noiseSuppression: {
          exact: !0
        }
      }, {
        googHighpassFilter: {
          exact: !0
        }
      }, {
        googAudioMirroring: {
          exact: !0
        }
      }];
    }
    _createClass(z, [{
      key: "volume",
      value: function volume(e) {
        if (!(0 <= e && e <= 1)) throw Error("volume can only be in range [0.0, 1.0]");
        return this._volume = e, this;
      }
    }, {
      key: "codec",
      value: function codec(e) {
        return this._codec = e, this;
      }
    }, {
      key: "maxBitrate",
      value: function maxBitrate(e) {
        if (e && e <= 0) throw Error("maxBitrate should be >= 1");
        return this._maxBitrate = e, this;
      }
    }, {
      key: "deviceId",
      value: function deviceId(e) {
        return this._deviceId = e, this;
      }
    }, {
      key: "advanced",
      value: function advanced(e) {
        return this._advanced = e, this;
      }
    }, {
      key: "build",
      value: function build() {
        return new ye(this._volume, this._codec, this._maxBitrate, this._deviceId, this._advanced);
      }
    }]);
    return z;
  }(),
  ye = /*#__PURE__*/function () {
    function ye(e, t, i, r, s) {
      _classCallCheck(this, ye);
      this.volume = e, this.codec = t, this.maxBitrate = i, this.deviceId = r, this.advanced = s;
    }
    _createClass(ye, [{
      key: "toConstraints",
      value: function toConstraints() {
        return {
          deviceId: this.deviceId,
          advanced: this.advanced
        };
      }
    }, {
      key: "toAnalyticsProperties",
      value: function toAnalyticsProperties() {
        return {
          audio_bitrate: this.maxBitrate,
          audio_codec: this.codec
        };
      }
    }]);
    return ye;
  }();
var J = /*#__PURE__*/function () {
    function J() {
      _classCallCheck(this, J);
      this._width = 320;
      this._height = 180;
      this._codec = Ke.VP8;
      this._maxFramerate = 30;
      this._maxBitrate = 150;
      this._advanced = [];
    }
    _createClass(J, [{
      key: "setWidth",
      value: function setWidth(e) {
        return this._width = e, this;
      }
    }, {
      key: "setHeight",
      value: function setHeight(e) {
        return this._height = e, this;
      }
    }, {
      key: "codec",
      value: function codec(e) {
        return this._codec = e, this;
      }
    }, {
      key: "maxFramerate",
      value: function maxFramerate(e) {
        if (e && e <= 0) throw Error("maxFramerate should be >= 1");
        return this._maxFramerate = e, this;
      }
    }, {
      key: "maxBitrate",
      value: function maxBitrate(e) {
        var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
        if (typeof e == "number" && e <= 0) throw Error("maxBitrate should be >= 1");
        return this._maxBitrate = e, !this._maxBitrate && t && (this._maxBitrate = 15e4), this;
      }
    }, {
      key: "deviceId",
      value: function deviceId(e) {
        return this._deviceId = e, this;
      }
    }, {
      key: "advanced",
      value: function advanced(e) {
        return this._advanced = e, this;
      }
    }, {
      key: "build",
      value: function build() {
        return new Me(this._width, this._height, this._codec, this._maxFramerate, this._deviceId, this._advanced, this._maxBitrate);
      }
    }]);
    return J;
  }(),
  Me = /*#__PURE__*/function () {
    function Me(e, t, i, r, s, n, d) {
      _classCallCheck(this, Me);
      this.width = e, this.height = t, this.codec = i, this.maxFramerate = r, this.maxBitrate = d, this.deviceId = s, this.advanced = n;
    }
    _createClass(Me, [{
      key: "toConstraints",
      value: function toConstraints(e) {
        var t = "ideal";
        return e && (t = "max"), {
          width: _defineProperty({}, t, this.width),
          height: _defineProperty({}, t, this.height),
          frameRate: this.maxFramerate,
          deviceId: this.deviceId
        };
      }
    }, {
      key: "toAnalyticsProperties",
      value: function toAnalyticsProperties() {
        return {
          width: this.width,
          height: this.height,
          video_bitrate: this.maxBitrate,
          framerate: this.maxFramerate,
          video_codec: this.codec
        };
      }
    }]);
    return Me;
  }();
var je = /*#__PURE__*/function () {
    function je() {
      _classCallCheck(this, je);
      this._video = new J().build();
      this._audio = new z().build();
      this._screen = new J().build();
      this._simulcast = !1;
    }
    _createClass(je, [{
      key: "video",
      value: function video(e) {
        return this._video = e, this;
      }
    }, {
      key: "audio",
      value: function audio(e) {
        return this._audio = e, this;
      }
    }, {
      key: "screen",
      value: function screen(e) {
        return this._screen = e, this;
      }
    }, {
      key: "simulcast",
      value: function simulcast(e) {
        return this._simulcast = e, this;
      }
    }, {
      key: "build",
      value: function build() {
        if (this._audio === null && this._video === null) throw m.TracksErrors.NothingToReturn(p.TRACK);
        if (this._video === null && this._simulcast) throw m.TracksErrors.InvalidVideoSettings(p.TRACK, "Cannot enable simulcast when no video settings are provided");
        return new _e(this._video, this._audio, this._simulcast, this._screen || void 0);
      }
    }]);
    return je;
  }(),
  _e = /*#__PURE__*/function () {
    function _e(e, t, i) {
      var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
      _classCallCheck(this, _e);
      this.video = e, this.audio = t, this.simulcast = i, this.screen = r;
    }
    _createClass(_e, [{
      key: "toAnalyticsProperties",
      value: function toAnalyticsProperties() {
        var e = {
          audio_enabled: this.audio !== null,
          video_enabled: this.video !== null
        };
        return this.audio && (e = v(v({}, this.audio.toAnalyticsProperties()), e)), this.video && (e = v(v({}, this.video.toAnalyticsProperties()), e)), e;
      }
    }]);
    return _e;
  }();
var Ae = function Ae(e) {
  _classCallCheck(this, Ae);
  this.tracks = new Array();
  this.nativeStream = e, this.id = e.id;
};
var Je = function Je(a) {
  return a ? "{\n    trackId: ".concat(a.id, ";\n    kind: ").concat(a.kind, ";\n    enabled: ").concat(a.enabled, ";\n    muted: ").concat(a.muted, ";\n    readyState: ").concat(a.readyState, ";\n  }") : "";
};
var ge = /*#__PURE__*/function () {
  function ge(e, t, i) {
    _classCallCheck(this, ge);
    this.logIdentifier = "";
    this.stream = e, this.nativeTrack = t, this.source = i;
  }
  _createClass(ge, [{
    key: "getMediaTrackSettings",
    value: function getMediaTrackSettings() {
      return this.nativeTrack.getSettings();
    }
  }, {
    key: "setEnabled",
    value: function setEnabled(e) {
      return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              this.nativeTrack.enabled = e;
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "setSdpTrackId",
    value: function setSdpTrackId(e) {
      this.sdpTrackId = e;
    }
  }, {
    key: "setFirstTrackId",
    value: function setFirstTrackId(e) {
      this.firstTrackId = e;
    }
  }, {
    key: "cleanup",
    value: function cleanup() {
      var e;
      o.d("[HMSTrack]", "Stopping track", this.toString()), (e = this.nativeTrack) == null || e.stop();
    }
  }, {
    key: "toString",
    value: function toString() {
      return "{\n      streamId: ".concat(this.stream.id, ";\n      peerId: ").concat(this.peerId, ";\n      trackId: ").concat(this.trackId, ";\n      logIdentifier: ").concat(this.logIdentifier, ";\n      source: ").concat(this.source, ";\n      enabled: ").concat(this.enabled, ";\n      nativeTrack: ").concat(Je(this.nativeTrack), ";\n    }");
    }
  }, {
    key: "enabled",
    get: function get() {
      return this.nativeTrack.enabled;
    }
  }, {
    key: "trackId",
    get: function get() {
      return this.firstTrackId || this.sdpTrackId || this.nativeTrack.id;
    }
  }]);
  return ge;
}();
var F;
(function (t) {
  t.AUDIO = "audio", t.VIDEO = "video";
})(F || (F = {}));
var Pe = /*#__PURE__*/function (_Ae) {
  _inherits(Pe, _Ae);
  function Pe(e, t) {
    var _this5;
    _classCallCheck(this, Pe);
    _this5 = _possibleConstructorReturn(this, _getPrototypeOf(Pe).call(this, e));
    _this5.audio = !0;
    _this5.video = j.NONE;
    _this5.connection = t;
    return _this5;
  }
  _createClass(Pe, [{
    key: "setAudio",
    value: function setAudio(e, t, i) {
      return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.t0 = this.audio !== e;
              if (!_context2.t0) {
                _context2.next = 6;
                break;
              }
              this.audio = e;
              o.d("[Remote stream] ".concat(i || "", " ").concat(this.id), "subscribing audio - ".concat(this.audio));
              _context2.next = 6;
              return this.connection.sendOverApiDataChannelWithResponse({
                params: {
                  subscribed: this.audio,
                  track_id: t
                },
                method: "prefer-audio-track-state"
              });
            case 6:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
    }
  }, {
    key: "setVideoLayerLocally",
    value: function setVideoLayerLocally(e, t, i) {
      this.video = e, o.d("[Remote stream] ".concat(t, " - ").concat(this.id), "source: ".concat(i, " Setting layer field to - ").concat(e));
    }
  }, {
    key: "setVideoLayer",
    value: function setVideoLayer(e, t, i, r) {
      return this.setVideoLayerLocally(e, i, r), o.d("[Remote stream] ".concat(i, " - ").concat(this.id), "request ".concat(e, " layer")), this.connection.sendOverApiDataChannelWithResponse({
        params: {
          max_spatial_layer: this.video,
          track_id: t
        },
        method: "prefer-video-track-state"
      });
    }
  }, {
    key: "getSimulcastLayer",
    value: function getSimulcastLayer() {
      return this.video;
    }
  }, {
    key: "getVideoLayer",
    value: function getVideoLayer() {
      return this.video;
    }
  }, {
    key: "isAudioSubscribed",
    value: function isAudioSubscribed() {
      return this.audio;
    }
  }]);
  return Pe;
}(Ae);
var De = /*#__PURE__*/function (_ge) {
  _inherits(De, _ge);
  function De(e, t, i) {
    var _this6;
    _classCallCheck(this, De);
    _this6 = _possibleConstructorReturn(this, _getPrototypeOf(De).call(this, e, t, i));
    _this6.type = F.AUDIO;
    _this6.audioElement = null;
    if (t.kind !== "audio") throw new Error("Expected 'track' kind = 'audio'");
    return _this6;
  }
  _createClass(De, [{
    key: "getVolume",
    value: function getVolume() {
      return this.audioElement ? this.audioElement.volume * 100 : null;
    }
  }, {
    key: "setVolume",
    value: function setVolume(e) {
      return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (!(e < 0 || e > 100)) {
                _context3.next = 2;
                break;
              }
              throw Error("Please pass a valid number between 0-100");
            case 2:
              _context3.next = 4;
              return this.subscribeToAudio(e === 0 ? !1 : this.enabled);
            case 4:
              this.audioElement && (this.audioElement.volume = e / 100);
            case 5:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
    }
  }, {
    key: "setAudioElement",
    value: function setAudioElement(e) {
      this.audioElement = e;
    }
  }, {
    key: "getAudioElement",
    value: function getAudioElement() {
      return this.audioElement;
    }
  }, {
    key: "getOutputDevice",
    value: function getOutputDevice() {
      return this.outputDevice;
    }
  }, {
    key: "cleanup",
    value: function cleanup() {
      _get(_getPrototypeOf(De.prototype), "cleanup", this).call(this), this.audioElement && (this.audioElement.srcObject = null, this.audioElement.remove(), this.audioElement = null);
    }
  }, {
    key: "setOutputDevice",
    value: function setOutputDevice(e) {
      return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var t;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              if (this.audioElement) {
                _context4.next = 3;
                break;
              }
              o.d("audio-track", "no audio element to set output");
              return _context4.abrupt("return");
            case 3:
              _context4.prev = 3;
              _context4.t0 = typeof this.audioElement.setSinkId == "function";
              if (!_context4.t0) {
                _context4.next = 9;
                break;
              }
              _context4.next = 8;
              return (t = this.audioElement) == null ? void 0 : t.setSinkId(e.deviceId);
            case 8:
              this.outputDevice = e;
            case 9:
              _context4.next = 14;
              break;
            case 11:
              _context4.prev = 11;
              _context4.t1 = _context4["catch"](3);
              o.d("audio-track", _context4.t1);
            case 14:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this, [[3, 11]]);
      }));
    }
  }, {
    key: "subscribeToAudio",
    value: function subscribeToAudio(e) {
      return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.t0 = this.stream instanceof Pe;
              if (!_context5.t0) {
                _context5.next = 4;
                break;
              }
              _context5.next = 4;
              return this.stream.setAudio(e, this.trackId, this.logIdentifier);
            case 4:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
    }
  }]);
  return De;
}(ge);
var ki = /*#__PURE__*/function () {
    function ki() {
      _classCallCheck(this, ki);
      this.storage = new te("hms-device-selection");
      this.remember = !1;
      this.TAG = "[HMSDeviceStorage]";
    }
    _createClass(ki, [{
      key: "setDevices",
      value: function setDevices(e) {
        this.devices = e;
      }
    }, {
      key: "rememberDevices",
      value: function rememberDevices(e) {
        this.remember = e;
      }
    }, {
      key: "updateSelection",
      value: function updateSelection(e, _ref6) {
        var _this7 = this;
        var t = _ref6.deviceId,
          i = _ref6.groupId;
        if (!this.devices || !this.remember) return;
        var r = this.devices[e].find(function (n) {
          return _this7.isSame({
            deviceId: t,
            groupId: i
          }, n);
        });
        if (!r) {
          o.w(this.TAG, "Could not find device with deviceId: ".concat(t, ", groupId: ").concat(i));
          return;
        }
        var s = this.storage.get() || {};
        s[e] = r, this.storage.set(s);
      }
    }, {
      key: "getSelection",
      value: function getSelection() {
        if (!!this.remember) return this.storage.get();
      }
    }, {
      key: "cleanup",
      value: function cleanup() {
        this.remember = !1, this.devices = void 0;
      }
    }, {
      key: "isSame",
      value: function isSame(e, t) {
        return e.deviceId === t.deviceId && (e.groupId === t.groupId || !e.groupId);
      }
    }]);
    return ki;
  }(),
  Q = new ki();
var It;
(function (t) {
  t.TRANSFORM = "TRANSFORM", t.ANALYZE = "ANALYZE";
})(It || (It = {}));
var re;
(function (t) {
  t.PLATFORM_NOT_SUPPORTED = "PLATFORM_NOT_SUPPORTED", t.DEVICE_NOT_SUPPORTED = "DEVICE_NOT_SUPPORTED";
})(re || (re = {}));
var de = /*#__PURE__*/function () {
  function de() {
    _classCallCheck(this, de);
  }
  _createClass(de, null, [{
    key: "failure",
    value: function failure(e, t) {
      var i = "mediaPlugin.failed",
        r = _.ERROR,
        s = v({
          plugin_name: e
        }, t.toAnalyticsProperties());
      return new x({
        name: i,
        level: r,
        properties: s
      });
    }
  }, {
    key: "audioPluginFailure",
    value: function audioPluginFailure(e, t, i) {
      var r = "mediaPlugin.failed",
        s = _.ERROR,
        n = v({
          plugin_name: e,
          sampleRate: t
        }, i.toAnalyticsProperties());
      return new x({
        name: r,
        level: s,
        properties: n
      });
    }
  }, {
    key: "audioPluginStats",
    value: function audioPluginStats(_ref7) {
      var e = _ref7.pluginName,
        t = _ref7.duration,
        i = _ref7.loadTime,
        r = _ref7.sampleRate;
      var s = "mediaPlugin.stats",
        n = _.INFO,
        d = {
          plugin_name: e,
          duration: t,
          load_time: i,
          sampleRate: r
        };
      return new x({
        name: s,
        level: n,
        properties: d
      });
    }
  }, {
    key: "stats",
    value: function stats(_ref8) {
      var e = _ref8.pluginName,
        t = _ref8.duration,
        i = _ref8.loadTime,
        r = _ref8.avgPreProcessingTime,
        s = _ref8.avgProcessingTime,
        n = _ref8.inputFrameRate,
        d = _ref8.pluginFrameRate;
      var l = "mediaPlugin.stats",
        h = _.INFO,
        u = {
          plugin_name: e,
          duration: t,
          load_time: i,
          avg_preprocessing_time: r,
          avg_processing_time: s,
          input_frame_rate: n,
          plugin_frame_rate: d
        };
      return new x({
        name: l,
        level: h,
        properties: u
      });
    }
  }]);
  return de;
}();
var bt = /*#__PURE__*/function () {
  function bt(e) {
    _classCallCheck(this, bt);
    this.eventBus = e;
    this.TAG = "[AudioPluginsAnalytics]";
    this.initTime = {}, this.addedTimestamps = {}, this.pluginAdded = {}, this.pluginSampleRate = {};
  }
  _createClass(bt, [{
    key: "added",
    value: function added(e, t) {
      this.pluginAdded[e] = !0, this.addedTimestamps[e] = Date.now(), this.initTime[e] = 0, this.pluginSampleRate[e] = t;
    }
  }, {
    key: "removed",
    value: function removed(e) {
      if (this.pluginAdded[e]) {
        var t = {
          pluginName: e,
          duration: Math.floor((Date.now() - this.addedTimestamps[e]) / 1e3),
          loadTime: this.initTime[e],
          sampleRate: this.pluginSampleRate[e]
        };
        this.eventBus.analytics.publish(de.audioPluginStats(t)), this.clean(e);
      }
    }
  }, {
    key: "failure",
    value: function failure(e, t) {
      this.pluginAdded[e] && (this.eventBus.analytics.publish(de.audioPluginFailure(e, this.pluginSampleRate[e], t)), this.clean(e));
    }
  }, {
    key: "initWithTime",
    value: function initWithTime(e, t) {
      return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var i, s;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              if (!this.initTime[e]) {
                _context6.next = 3;
                break;
              }
              o.i(this.TAG, "Plugin Already loaded ".concat(e, ", time it took: ").concat(this.initTime[e]));
              return _context6.abrupt("return");
            case 3:
              _context6.prev = 3;
              _context6.next = 6;
              return this.timeInMs(t);
            case 6:
              i = _context6.sent;
              o.i(this.TAG, "Time taken for Plugin ".concat(e, " initialization : ").concat(i));
              _context6.next = 14;
              break;
            case 10:
              _context6.prev = 10;
              _context6.t0 = _context6["catch"](3);
              s = m.MediaPluginErrors.InitFailed(p.AUDIO_PLUGINS, "failed during initialization of plugin".concat(_context6.t0.message || _context6.t0));
              throw o.e(this.TAG, s), this.failure(e, s), s;
            case 14:
              i && (this.initTime[e] = i);
            case 15:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this, [[3, 10]]);
      }));
    }
  }, {
    key: "timeInMs",
    value: function timeInMs(e) {
      return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        var t;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              t = Date.now();
              _context7.next = 3;
              return e();
            case 3:
              return _context7.abrupt("return", Math.floor(Date.now() - t));
            case 4:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }));
    }
  }, {
    key: "clean",
    value: function clean(e) {
      delete this.addedTimestamps[e], delete this.initTime[e], delete this.pluginAdded[e], delete this.pluginSampleRate[e];
    }
  }]);
  return bt;
}();
var gr = 48e3,
  Sr = function Sr() {
    return navigator.userAgent.indexOf("Firefox") !== -1;
  },
  Qe = /*#__PURE__*/function () {
    function Qe(e, t) {
      _classCallCheck(this, Qe);
      this.TAG = "[AudioPluginsManager]";
      this.pluginAddInProgress = !1;
      this.hmsTrack = e, this.pluginsMap = new Map(), this.analytics = new bt(t), this.createAudioContext();
    }
    _createClass(Qe, [{
      key: "getPlugins",
      value: function getPlugins() {
        return Array.from(this.pluginsMap.keys());
      }
    }, {
      key: "addPlugin",
      value: function addPlugin(e) {
        return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
          var i, t, r;
          return _regeneratorRuntime().wrap(function _callee8$(_context8) {
            while (1) switch (_context8.prev = _context8.next) {
              case 0:
                t = (i = e.getName) == null ? void 0 : i.call(e);
                if (t) {
                  _context8.next = 4;
                  break;
                }
                o.w("no name provided by the plugin");
                return _context8.abrupt("return");
              case 4:
                if (!this.pluginAddInProgress) {
                  _context8.next = 7;
                  break;
                }
                r = m.MediaPluginErrors.AddAlreadyInProgress(p.AUDIO_PLUGINS, "Add Plugin is already in Progress");
                throw this.analytics.added(t, this.audioContext.sampleRate), this.analytics.failure(t, r), o.w("can't add another plugin when previous add is in progress"), r;
              case 7:
                this.pluginAddInProgress = !0;
                _context8.prev = 8;
                _context8.next = 11;
                return this.addPluginInternal(e);
              case 11:
                _context8.prev = 11;
                this.pluginAddInProgress = !1;
                return _context8.finish(11);
              case 14:
              case "end":
                return _context8.stop();
            }
          }, _callee8, this, [[8,, 11, 14]]);
        }));
      }
    }, {
      key: "addPluginInternal",
      value: function addPluginInternal(e) {
        return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
          var _this8 = this;
          var i, t;
          return _regeneratorRuntime().wrap(function _callee10$(_context10) {
            while (1) switch (_context10.prev = _context10.next) {
              case 0:
                t = (i = e.getName) == null ? void 0 : i.call(e);
                if (!this.pluginsMap.get(t)) {
                  _context10.next = 4;
                  break;
                }
                o.w(this.TAG, "plugin - ".concat(t, " already added."));
                return _context10.abrupt("return");
              case 4:
                _context10.next = 6;
                return this.validateAndThrow(t, e);
              case 6:
                _context10.prev = 6;
                if (!(this.pluginsMap.size === 0)) {
                  _context10.next = 12;
                  break;
                }
                _context10.next = 10;
                return this.initAudioNodes();
              case 10:
                _context10.next = 13;
                break;
              case 12:
                this.prevAudioNode && this.prevAudioNode.disconnect();
              case 13:
                this.analytics.added(t, this.audioContext.sampleRate);
                _context10.next = 16;
                return this.analytics.initWithTime(t, function () {
                  return c(_this8, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
                    return _regeneratorRuntime().wrap(function _callee9$(_context9) {
                      while (1) switch (_context9.prev = _context9.next) {
                        case 0:
                          return _context9.abrupt("return", e.init());
                        case 1:
                        case "end":
                          return _context9.stop();
                      }
                    }, _callee9);
                  }));
                });
              case 16:
                this.pluginsMap.set(t, e);
                _context10.next = 19;
                return this.processPlugin(e);
              case 19:
                _context10.next = 21;
                return this.connectToDestination();
              case 21:
                _context10.next = 26;
                break;
              case 23:
                _context10.prev = 23;
                _context10.t0 = _context10["catch"](6);
                throw o.e(this.TAG, "failed to add plugin", _context10.t0), _context10.t0;
              case 26:
              case "end":
                return _context10.stop();
            }
          }, _callee10, this, [[6, 23]]);
        }));
      }
    }, {
      key: "validatePlugin",
      value: function validatePlugin(e) {
        return e.checkSupport(this.audioContext);
      }
    }, {
      key: "validateAndThrow",
      value: function validateAndThrow(e, t) {
        return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
          var i, r, _r2;
          return _regeneratorRuntime().wrap(function _callee11$(_context11) {
            while (1) switch (_context11.prev = _context11.next) {
              case 0:
                i = this.validatePlugin(t);
                if (!i.isSupported) {
                  _context11.next = 5;
                  break;
                }
                o.i(this.TAG, "plugin is supported,- ".concat(t.getName()));
                _context11.next = 19;
                break;
              case 5:
                if (!(this.analytics.added(e, this.audioContext.sampleRate), i.errType === re.PLATFORM_NOT_SUPPORTED)) {
                  _context11.next = 13;
                  break;
                }
                r = m.MediaPluginErrors.PlatformNotSupported(p.AUDIO_PLUGINS, "platform not supported, see docs");
                this.analytics.failure(e, r);
                _context11.next = 10;
                return this.cleanup();
              case 10:
                throw r;
              case 13:
                if (!(i.errType === re.DEVICE_NOT_SUPPORTED)) {
                  _context11.next = 19;
                  break;
                }
                _r2 = m.MediaPluginErrors.DeviceNotSupported(p.AUDIO_PLUGINS, "audio device not supported, see docs");
                this.analytics.failure(e, _r2);
                _context11.next = 18;
                return this.cleanup();
              case 18:
                throw _r2;
              case 19:
              case "end":
                return _context11.stop();
            }
          }, _callee11, this);
        }));
      }
    }, {
      key: "removePlugin",
      value: function removePlugin(e) {
        return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee12() {
          return _regeneratorRuntime().wrap(function _callee12$(_context12) {
            while (1) switch (_context12.prev = _context12.next) {
              case 0:
                _context12.next = 2;
                return this.removePluginInternal(e);
              case 2:
                if (!(this.pluginsMap.size === 0)) {
                  _context12.next = 10;
                  break;
                }
                _context12.next = 5;
                return this.cleanup();
              case 5:
                o.i(this.TAG, "No plugins left, stopping plugins loop");
                _context12.next = 8;
                return this.hmsTrack.setProcessedTrack(void 0);
              case 8:
                _context12.next = 12;
                break;
              case 10:
                _context12.next = 12;
                return this.reprocessPlugins();
              case 12:
              case "end":
                return _context12.stop();
            }
          }, _callee12, this);
        }));
      }
    }, {
      key: "cleanup",
      value: function cleanup() {
        return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee13() {
          var e, t, i, _iterator3, _step3, r;
          return _regeneratorRuntime().wrap(function _callee13$(_context13) {
            while (1) switch (_context13.prev = _context13.next) {
              case 0:
                _iterator3 = _createForOfIteratorHelper(this.pluginsMap.values());
                _context13.prev = 1;
                _iterator3.s();
              case 3:
                if ((_step3 = _iterator3.n()).done) {
                  _context13.next = 9;
                  break;
                }
                r = _step3.value;
                _context13.next = 7;
                return this.removePluginInternal(r);
              case 7:
                _context13.next = 3;
                break;
              case 9:
                _context13.next = 14;
                break;
              case 11:
                _context13.prev = 11;
                _context13.t0 = _context13["catch"](1);
                _iterator3.e(_context13.t0);
              case 14:
                _context13.prev = 14;
                _iterator3.f();
                return _context13.finish(14);
              case 17:
                _context13.next = 19;
                return this.hmsTrack.setProcessedTrack(void 0);
              case 19:
                (e = this.sourceNode) == null || e.disconnect();
                (t = this.prevAudioNode) == null || t.disconnect();
                (i = this.outputTrack) == null || i.stop();
                this.sourceNode = void 0;
                this.destinationNode = void 0;
                this.prevAudioNode = void 0;
                this.outputTrack = void 0;
              case 26:
              case "end":
                return _context13.stop();
            }
          }, _callee13, this, [[1, 11, 14, 17]]);
        }));
      }
    }, {
      key: "closeContext",
      value: function closeContext() {
        return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee14() {
          var e;
          return _regeneratorRuntime().wrap(function _callee14$(_context14) {
            while (1) switch (_context14.prev = _context14.next) {
              case 0:
                (e = this.audioContext) == null || e.close(), this.audioContext = void 0;
              case 1:
              case "end":
                return _context14.stop();
            }
          }, _callee14, this);
        }));
      }
    }, {
      key: "reprocessPlugins",
      value: function reprocessPlugins() {
        return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee15() {
          var e, _i2, _e3, t;
          return _regeneratorRuntime().wrap(function _callee15$(_context15) {
            while (1) switch (_context15.prev = _context15.next) {
              case 0:
                if (!(this.pluginsMap.size === 0 || !this.sourceNode)) {
                  _context15.next = 2;
                  break;
                }
                return _context15.abrupt("return");
              case 2:
                e = Array.from(this.pluginsMap.values());
                _context15.next = 5;
                return this.cleanup();
              case 5:
                _context15.next = 7;
                return this.initAudioNodes();
              case 7:
                _i2 = 0, _e3 = e;
              case 8:
                if (!(_i2 < _e3.length)) {
                  _context15.next = 15;
                  break;
                }
                t = _e3[_i2];
                _context15.next = 12;
                return this.addPlugin(t);
              case 12:
                _i2++;
                _context15.next = 8;
                break;
              case 15:
              case "end":
                return _context15.stop();
            }
          }, _callee15, this);
        }));
      }
    }, {
      key: "initAudioNodes",
      value: function initAudioNodes() {
        return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee16() {
          var e;
          return _regeneratorRuntime().wrap(function _callee16$(_context16) {
            while (1) switch (_context16.prev = _context16.next) {
              case 0:
                if (!this.audioContext) {
                  _context16.next = 12;
                  break;
                }
                if (!this.sourceNode) {
                  e = new MediaStream([this.hmsTrack.nativeTrack]);
                  this.sourceNode = this.audioContext.createMediaStreamSource(e);
                }
                if (this.destinationNode) {
                  _context16.next = 12;
                  break;
                }
                this.destinationNode = this.audioContext.createMediaStreamDestination(), this.outputTrack = this.destinationNode.stream.getAudioTracks()[0];
                _context16.prev = 4;
                _context16.next = 7;
                return this.hmsTrack.setProcessedTrack(this.outputTrack);
              case 7:
                _context16.next = 12;
                break;
              case 9:
                _context16.prev = 9;
                _context16.t0 = _context16["catch"](4);
                throw o.e(this.TAG, "error in setting processed track", _context16.t0), _context16.t0;
              case 12:
              case "end":
                return _context16.stop();
            }
          }, _callee16, this, [[4, 9]]);
        }));
      }
    }, {
      key: "processPlugin",
      value: function processPlugin(e) {
        return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee17() {
          var t, i;
          return _regeneratorRuntime().wrap(function _callee17$(_context17) {
            while (1) switch (_context17.prev = _context17.next) {
              case 0:
                _context17.prev = 0;
                _context17.next = 3;
                return e.processAudioTrack(this.audioContext, this.prevAudioNode || this.sourceNode);
              case 3:
                t = _context17.sent;
                this.prevAudioNode && this.prevAudioNode.connect(t), this.prevAudioNode = t;
                _context17.next = 13;
                break;
              case 7:
                _context17.prev = 7;
                _context17.t0 = _context17["catch"](0);
                i = e.getName();
                o.e(this.TAG, "error in processing plugin ".concat(i), _context17.t0);
                _context17.next = 13;
                return this.removePluginInternal(e);
              case 13:
              case "end":
                return _context17.stop();
            }
          }, _callee17, this, [[0, 7]]);
        }));
      }
    }, {
      key: "connectToDestination",
      value: function connectToDestination() {
        return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee18() {
          return _regeneratorRuntime().wrap(function _callee18$(_context18) {
            while (1) switch (_context18.prev = _context18.next) {
              case 0:
                try {
                  this.prevAudioNode && this.destinationNode && this.prevAudioNode.context === this.destinationNode.context && this.prevAudioNode.connect(this.destinationNode);
                } catch (e) {
                  o.e(this.TAG, "error in connecting to destination node", e);
                }
              case 1:
              case "end":
                return _context18.stop();
            }
          }, _callee18, this);
        }));
      }
    }, {
      key: "removePluginInternal",
      value: function removePluginInternal(e) {
        return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee19() {
          var i, t;
          return _regeneratorRuntime().wrap(function _callee19$(_context19) {
            while (1) switch (_context19.prev = _context19.next) {
              case 0:
                t = (i = e.getName) == null ? void 0 : i.call(e);
                if (this.pluginsMap.get(t)) {
                  _context19.next = 4;
                  break;
                }
                o.w(this.TAG, "plugin - ".concat(t, " not found to remove."));
                return _context19.abrupt("return");
              case 4:
                o.i(this.TAG, "removing plugin ".concat(t)), this.pluginsMap.delete(t), e.stop(), this.analytics.removed(t);
              case 5:
              case "end":
                return _context19.stop();
            }
          }, _callee19, this);
        }));
      }
    }, {
      key: "createAudioContext",
      value: function createAudioContext() {
        this.audioContext || (Sr() ? this.audioContext = new AudioContext() : this.audioContext = new AudioContext({
          sampleRate: gr
        }));
      }
    }]);
    return Qe;
  }();
function Ye(a) {
  return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee20() {
    return _regeneratorRuntime().wrap(function _callee20$(_context20) {
      while (1) switch (_context20.prev = _context20.next) {
        case 0:
          _context20.prev = 0;
          _context20.next = 3;
          return navigator.mediaDevices.getUserMedia({
            audio: a ? a.toConstraints() : !1
          });
        case 3:
          return _context20.abrupt("return", _context20.sent.getAudioTracks()[0]);
        case 6:
          _context20.prev = 6;
          _context20.t0 = _context20["catch"](0);
          throw ee(_context20.t0, K.AUDIO);
        case 9:
        case "end":
          return _context20.stop();
      }
    }, _callee20, null, [[0, 6]]);
  }));
}
function ze(a) {
  return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee21() {
    return _regeneratorRuntime().wrap(function _callee21$(_context21) {
      while (1) switch (_context21.prev = _context21.next) {
        case 0:
          _context21.prev = 0;
          _context21.next = 3;
          return navigator.mediaDevices.getUserMedia({
            video: a ? a.toConstraints() : !1
          });
        case 3:
          return _context21.abrupt("return", _context21.sent.getVideoTracks()[0]);
        case 6:
          _context21.prev = 6;
          _context21.t0 = _context21["catch"](0);
          throw ee(_context21.t0, K.VIDEO);
        case 9:
        case "end":
          return _context21.stop();
      }
    }, _callee21, null, [[0, 6]]);
  }));
}
function Ze(a) {
  return "canvas" in a || a.label === "MediaStreamAudioDestinationNode" || a.label === "";
}
function yi(a) {
  return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee22() {
    return _regeneratorRuntime().wrap(function _callee22$(_context22) {
      while (1) switch (_context22.prev = _context22.next) {
        case 0:
          _context22.prev = 0;
          _context22.next = 3;
          return navigator.mediaDevices.getUserMedia(a);
        case 3:
          return _context22.abrupt("return", _context22.sent);
        case 6:
          _context22.prev = 6;
          _context22.t0 = _context22["catch"](0);
          throw ee(_context22.t0, K.AV);
        case 9:
        case "end":
          return _context22.stop();
      }
    }, _callee22, null, [[0, 6]]);
  }));
}
function pn(a) {
  return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee23() {
    return _regeneratorRuntime().wrap(function _callee23$(_context23) {
      while (1) switch (_context23.prev = _context23.next) {
        case 0:
          _context23.prev = 0;
          _context23.next = 3;
          return navigator.mediaDevices.getDisplayMedia({
            video: a,
            audio: !1
          });
        case 3:
          return _context23.abrupt("return", _context23.sent);
        case 6:
          _context23.prev = 6;
          _context23.t0 = _context23["catch"](0);
          throw ee(_context23.t0, K.SCREEN);
        case 9:
        case "end":
          return _context23.stop();
      }
    }, _callee23, null, [[0, 6]]);
  }));
}
function mn() {
  return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee24() {
    var a, e;
    return _regeneratorRuntime().wrap(function _callee24$(_context24) {
      while (1) switch (_context24.prev = _context24.next) {
        case 0:
          _context24.prev = 0;
          _context24.next = 3;
          return navigator.mediaDevices.enumerateDevices();
        case 3:
          a = _context24.sent;
          e = {
            audioinput: [],
            audiooutput: [],
            videoinput: []
          };
          return _context24.abrupt("return", (a.forEach(function (t) {
            return e[t.kind].push(t);
          }), e));
        case 8:
          _context24.prev = 8;
          _context24.t0 = _context24["catch"](0);
          throw ee(_context24.t0, K.AV);
        case 11:
        case "end":
          return _context24.stop();
      }
    }, _callee24, null, [[0, 8]]);
  }));
}
var le = {
  audioContext: null,
  getAudioContext: function getAudioContext() {
    return this.audioContext || (this.audioContext = new AudioContext()), this.audioContext;
  },
  resumeContext: function resumeContext() {
    return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee25() {
      return _regeneratorRuntime().wrap(function _callee25$(_context25) {
        while (1) switch (_context25.prev = _context25.next) {
          case 0:
            _context25.prev = 0;
            _context25.next = 3;
            return this.getAudioContext().resume();
          case 3:
            return _context25.abrupt("return", _context25.sent);
          case 6:
            _context25.prev = 6;
            _context25.t0 = _context25["catch"](0);
            o.e("AudioContext", _context25.t0);
          case 9:
          case "end":
            return _context25.stop();
        }
      }, _callee25, this, [[0, 6]]);
    }));
  }
};
var Se = /*#__PURE__*/function () {
  function Se() {
    var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1 / 0;
    _classCallCheck(this, Se);
    this.capacity = e;
    this.storage = [];
  }
  _createClass(Se, [{
    key: "size",
    value: function size() {
      return this.storage.length;
    }
  }, {
    key: "toList",
    value: function toList() {
      return this.storage.slice(0);
    }
  }, {
    key: "enqueue",
    value: function enqueue(e) {
      this.size() === this.capacity && this.dequeue(), this.storage.push(e);
    }
  }, {
    key: "dequeue",
    value: function dequeue() {
      return this.storage.shift();
    }
  }, {
    key: "aggregate",
    value: function aggregate(e) {
      return e(this.storage);
    }
  }]);
  return Se;
}();
function $(a) {
  if (a < 0) throw Error("`ms` should be a positive integer");
  return new Promise(function (e) {
    return setTimeout(e, a);
  });
}
function Mi(a) {
  var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 300;
  var t;
  return function () {
    for (var _len8 = arguments.length, i = new Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
      i[_key8] = arguments[_key8];
    }
    clearTimeout(t), t = void 0;
    var r = this;
    t = setTimeout(function () {
      a.apply(r, i);
    }, e);
  };
}
var vr = 35,
  Tr = 5,
  Ct = /*#__PURE__*/function () {
    function Ct(e, t, i) {
      var _this9 = this;
      _classCallCheck(this, Ct);
      this.track = e;
      this.audioLevelEvent = t;
      this.silenceEvent = i;
      this.TAG = "[TrackAudioLevelMonitor]";
      this.audioLevel = 0;
      this.isMonitored = !1;
      this.interval = 100;
      this.historyInterval = 700;
      this.history = new Se(this.historyInterval / this.interval);
      this.detectSilence = function () {
        return c(_this9, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee26() {
          var e, t, i;
          return _regeneratorRuntime().wrap(function _callee26$(_context26) {
            while (1) switch (_context26.prev = _context26.next) {
              case 0:
                e = 20, t = 50, i = 0;
              case 1:
                if (!this.isMonitored) {
                  _context26.next = 14;
                  break;
                }
                if (!this.track.enabled) {
                  _context26.next = 10;
                  break;
                }
                if (!this.isSilentThisInstant()) {
                  _context26.next = 9;
                  break;
                }
                if (!(i++, i > t)) {
                  _context26.next = 7;
                  break;
                }
                this.silenceEvent.publish({
                  track: this.track
                });
                return _context26.abrupt("break", 14);
              case 7:
                _context26.next = 10;
                break;
              case 9:
                return _context26.abrupt("break", 14);
              case 10:
                _context26.next = 12;
                return $(e);
              case 12:
                _context26.next = 1;
                break;
              case 14:
              case "end":
                return _context26.stop();
            }
          }, _callee26, this);
        }));
      };
      try {
        var r = new MediaStream([this.track.nativeTrack]);
        this.analyserNode = this.createAnalyserNodeForStream(r);
      } catch (r) {
        o.w(this.TAG, "Unable to initialize AudioContext", r);
      }
    }
    _createClass(Ct, [{
      key: "start",
      value: function start() {
        var _this10 = this;
        this.stop(), this.isMonitored = !0, o.d(this.TAG, "Starting track Monitor", "".concat(this.track)), this.loop().then(function () {
          return o.d(_this10.TAG, "Stopping track Monitor", "".concat(_this10.track));
        });
      }
    }, {
      key: "stop",
      value: function stop() {
        if (!this.analyserNode) {
          o.d(this.TAG, "AudioContext not initialized");
          return;
        }
        this.sendAudioLevel(0), this.isMonitored = !1;
      }
    }, {
      key: "loop",
      value: function loop() {
        return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee27() {
          return _regeneratorRuntime().wrap(function _callee27$(_context27) {
            while (1) switch (_context27.prev = _context27.next) {
              case 0:
                if (!this.isMonitored) {
                  _context27.next = 6;
                  break;
                }
                this.sendAudioLevel(this.getMaxAudioLevelOverPeriod());
                _context27.next = 4;
                return $(this.interval);
              case 4:
                _context27.next = 0;
                break;
              case 6:
              case "end":
                return _context27.stop();
            }
          }, _callee27, this);
        }));
      }
    }, {
      key: "sendAudioLevel",
      value: function sendAudioLevel() {
        var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        if (e = e > vr ? e : 0, Math.abs(this.audioLevel - e) > Tr) {
          this.audioLevel = e;
          var i = {
            track: this.track,
            audioLevel: this.audioLevel
          };
          this.audioLevelEvent.publish(i);
        }
      }
    }, {
      key: "getMaxAudioLevelOverPeriod",
      value: function getMaxAudioLevelOverPeriod() {
        if (!this.analyserNode) {
          o.d(this.TAG, "AudioContext not initialized");
          return;
        }
        var e = this.calculateAudioLevel();
        return e !== void 0 && this.history.enqueue(e), this.history.aggregate(function (t) {
          return Math.max.apply(Math, _toConsumableArray(t));
        });
      }
    }, {
      key: "calculateAudioLevel",
      value: function calculateAudioLevel() {
        if (!this.analyserNode) {
          o.d(this.TAG, "AudioContext not initialized");
          return;
        }
        var e = new Uint8Array(this.analyserNode.fftSize);
        this.analyserNode.getByteTimeDomainData(e);
        var t = .009,
          i = t;
        var _iterator4 = _createForOfIteratorHelper(e),
          _step4;
        try {
          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
            var n = _step4.value;
            i = Math.max(i, (n - 128) / 128);
          }
        } catch (err) {
          _iterator4.e(err);
        } finally {
          _iterator4.f();
        }
        var r = (Math.log(t) - Math.log(i)) / Math.log(t);
        return Math.ceil(Math.min(Math.max(r * 100, 0), 100));
      }
    }, {
      key: "isSilentThisInstant",
      value: function isSilentThisInstant() {
        if (!this.analyserNode) {
          o.d(this.TAG, "AudioContext not initialized");
          return;
        }
        var e = new Uint8Array(this.analyserNode.fftSize);
        return this.analyserNode.getByteTimeDomainData(e), !e.some(function (t) {
          return t !== 128 && t !== 0;
        });
      }
    }, {
      key: "createAnalyserNodeForStream",
      value: function createAnalyserNodeForStream(e) {
        var t = le.getAudioContext(),
          i = t.createAnalyser();
        return t.createMediaStreamSource(e).connect(i), i;
      }
    }]);
    return Ct;
  }();
function Ai(a, e) {
  return function (i) {
    return i in a && a[i] !== e[i];
  };
}
var Ie = /*#__PURE__*/function (_De) {
  _inherits(Ie, _De);
  function Ie(e, t, i, r) {
    var _this11;
    var s = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : new z().build();
    _classCallCheck(this, Ie);
    _this11 = _possibleConstructorReturn(this, _getPrototypeOf(Ie).call(this, e, t, i));
    _this11.eventBus = r;
    _this11.TAG = "[HMSLocalAudioTrack]";
    _this11.isPublished = !1;
    _this11.handleVisibilityChange = function () {
      return c(_assertThisInitialized(_assertThisInitialized(_this11)), null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee28() {
        return _regeneratorRuntime().wrap(function _callee28$(_context28) {
          while (1) switch (_context28.prev = _context28.next) {
            case 0:
              _context28.t0 = document.visibilityState === "visible";
              if (!_context28.t0) {
                _context28.next = 4;
                break;
              }
              _context28.next = 4;
              return this.replaceTrackWith(this.settings);
            case 4:
            case "end":
              return _context28.stop();
          }
        }, _callee28, this);
      }));
    };
    _this11.handleSettingsChange = function (e) {
      return c(_assertThisInitialized(_assertThisInitialized(_this11)), null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee29() {
        var t, i;
        return _regeneratorRuntime().wrap(function _callee29$(_context29) {
          while (1) switch (_context29.prev = _context29.next) {
            case 0:
              t = this.stream, i = Ai(e, this.settings);
              _context29.t0 = i("maxBitrate") && e.maxBitrate;
              if (!_context29.t0) {
                _context29.next = 5;
                break;
              }
              _context29.next = 5;
              return t.setMaxBitrateAndFramerate(this);
            case 5:
              _context29.t1 = i("advanced");
              if (!_context29.t1) {
                _context29.next = 9;
                break;
              }
              _context29.next = 9;
              return this.replaceTrackWith(e);
            case 9:
            case "end":
              return _context29.stop();
          }
        }, _callee29, this);
      }));
    };
    _this11.handleDeviceChange = function (e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
      return c(_assertThisInitialized(_assertThisInitialized(_this11)), null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee30() {
        return _regeneratorRuntime().wrap(function _callee30$(_context30) {
          while (1) switch (_context30.prev = _context30.next) {
            case 0:
              _context30.t0 = Ai(e, this.settings)("deviceId");
              if (!_context30.t0) {
                _context30.next = 5;
                break;
              }
              _context30.next = 4;
              return this.replaceTrackWith(e);
            case 4:
              t || Q.updateSelection("audioInput", {
                deviceId: e.deviceId,
                groupId: this.nativeTrack.getSettings().groupId
              });
            case 5:
            case "end":
              return _context30.stop();
          }
        }, _callee30, this);
      }));
    };
    e.tracks.push(_assertThisInitialized(_assertThisInitialized(_this11))), _this11.settings = s, s.deviceId !== t.getSettings().deviceId && !Ze(t) && (_this11.settings = _this11.buildNewSettings({
      deviceId: t.getSettings().deviceId
    })), _this11.pluginsManager = new Qe(_assertThisInitialized(_assertThisInitialized(_this11)), r), _this11.setFirstTrackId(t.id), yt() && X && document.addEventListener("visibilitychange", _this11.handleVisibilityChange);
    return _this11;
  }
  _createClass(Ie, [{
    key: "replaceTrackWith",
    value: function replaceTrackWith(e) {
      return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee31() {
        var t, i, r, s;
        return _regeneratorRuntime().wrap(function _callee31$(_context31) {
          while (1) switch (_context31.prev = _context31.next) {
            case 0:
              t = this.nativeTrack;
              i = Boolean(this.audioLevelMonitor);
              _context31.next = 4;
              return Ye(e);
            case 4:
              r = _context31.sent;
              t == null || t.stop(), r.enabled = this.enabled, o.d(this.TAG, "replaceTrack, Previous track stopped", t, "newTrack", r);
              s = this.stream;
              _context31.next = 9;
              return s.replaceSenderTrack(t, this.processedTrack || r);
            case 9:
              _context31.next = 11;
              return s.replaceStreamTrack(t, r);
            case 11:
              this.nativeTrack = r;
              i && this.initAudioLevelMonitor();
              _context31.prev = 13;
              _context31.next = 16;
              return this.pluginsManager.reprocessPlugins();
            case 16:
              _context31.next = 21;
              break;
            case 18:
              _context31.prev = 18;
              _context31.t0 = _context31["catch"](13);
              this.eventBus.audioPluginFailed.publish(_context31.t0);
            case 21:
            case "end":
              return _context31.stop();
          }
        }, _callee31, this, [[13, 18]]);
      }));
    }
  }, {
    key: "setEnabled",
    value: function setEnabled(e) {
      var _this12 = this;
      var t = function t(i) {
        return _get(_getPrototypeOf(Ie.prototype), i, _this12);
      };
      return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee32() {
        return _regeneratorRuntime().wrap(function _callee32$(_context32) {
          while (1) switch (_context32.prev = _context32.next) {
            case 0:
              _context32.t0 = e !== this.enabled;
              if (!_context32.t0) {
                _context32.next = 11;
                break;
              }
              _context32.t1 = e && Ze(this.nativeTrack);
              if (!_context32.t1) {
                _context32.next = 6;
                break;
              }
              _context32.next = 6;
              return this.replaceTrackWith(this.settings);
            case 6:
              _context32.next = 8;
              return t("setEnabled").call(this, e);
            case 8:
              e && (this.settings = this.buildNewSettings({
                deviceId: this.nativeTrack.getSettings().deviceId
              }));
              this.eventBus.localAudioEnabled.publish({
                enabled: e,
                track: this
              });
              this.stream.trackUpdate(this);
            case 11:
            case "end":
              return _context32.stop();
          }
        }, _callee32, this);
      }));
    }
  }, {
    key: "isPublishedTrackId",
    value: function isPublishedTrackId(e) {
      return this.publishedTrackId === e;
    }
  }, {
    key: "setSettings",
    value: function setSettings(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
      return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee33() {
        var i;
        return _regeneratorRuntime().wrap(function _callee33$(_context33) {
          while (1) switch (_context33.prev = _context33.next) {
            case 0:
              i = this.buildNewSettings(e);
              if (!Ze(this.nativeTrack)) {
                _context33.next = 4;
                break;
              }
              this.settings = i;
              return _context33.abrupt("return");
            case 4:
              _context33.next = 6;
              return this.handleDeviceChange(i, t);
            case 6:
              _context33.next = 8;
              return this.handleSettingsChange(i);
            case 8:
              this.settings = i;
            case 9:
            case "end":
              return _context33.stop();
          }
        }, _callee33, this);
      }));
    }
  }, {
    key: "getPlugins",
    value: function getPlugins() {
      return this.pluginsManager.getPlugins();
    }
  }, {
    key: "addPlugin",
    value: function addPlugin(e) {
      return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee34() {
        return _regeneratorRuntime().wrap(function _callee34$(_context34) {
          while (1) switch (_context34.prev = _context34.next) {
            case 0:
              return _context34.abrupt("return", this.pluginsManager.addPlugin(e));
            case 1:
            case "end":
              return _context34.stop();
          }
        }, _callee34, this);
      }));
    }
  }, {
    key: "removePlugin",
    value: function removePlugin(e) {
      return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee35() {
        return _regeneratorRuntime().wrap(function _callee35$(_context35) {
          while (1) switch (_context35.prev = _context35.next) {
            case 0:
              return _context35.abrupt("return", this.pluginsManager.removePlugin(e));
            case 1:
            case "end":
              return _context35.stop();
          }
        }, _callee35, this);
      }));
    }
  }, {
    key: "validatePlugin",
    value: function validatePlugin(e) {
      return this.pluginsManager.validatePlugin(e);
    }
  }, {
    key: "setProcessedTrack",
    value: function setProcessedTrack(e) {
      return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee36() {
        return _regeneratorRuntime().wrap(function _callee36$(_context36) {
          while (1) switch (_context36.prev = _context36.next) {
            case 0:
              if (e) {
                _context36.next = 7;
                break;
              }
              _context36.t0 = this.processedTrack;
              if (!_context36.t0) {
                _context36.next = 5;
                break;
              }
              _context36.next = 5;
              return this.stream.replaceSenderTrack(this.processedTrack, this.nativeTrack);
            case 5:
              this.processedTrack = void 0;
              return _context36.abrupt("return");
            case 7:
              _context36.t1 = e !== this.processedTrack;
              if (!_context36.t1) {
                _context36.next = 17;
                break;
              }
              if (!this.processedTrack) {
                _context36.next = 14;
                break;
              }
              _context36.next = 12;
              return this.stream.replaceSenderTrack(this.processedTrack, e);
            case 12:
              _context36.next = 16;
              break;
            case 14:
              _context36.next = 16;
              return this.stream.replaceSenderTrack(this.nativeTrack, e);
            case 16:
              this.processedTrack = e;
            case 17:
            case "end":
              return _context36.stop();
          }
        }, _callee36, this);
      }));
    }
  }, {
    key: "initAudioLevelMonitor",
    value: function initAudioLevelMonitor() {
      this.audioLevelMonitor && this.destroyAudioLevelMonitor(), o.d(this.TAG, "Monitor Audio Level for", this, this.getMediaTrackSettings().deviceId), this.audioLevelMonitor = new Ct(this, this.eventBus.trackAudioLevelUpdate, this.eventBus.localAudioSilence), this.audioLevelMonitor.start(), this.audioLevelMonitor.detectSilence();
    }
  }, {
    key: "destroyAudioLevelMonitor",
    value: function destroyAudioLevelMonitor() {
      var e;
      (e = this.audioLevelMonitor) == null || e.stop(), this.audioLevelMonitor = void 0;
    }
  }, {
    key: "cleanup",
    value: function cleanup() {
      var _this13 = this;
      var e = function e(t) {
        return _get(_getPrototypeOf(Ie.prototype), t, _this13);
      };
      return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee37() {
        var i;
        return _regeneratorRuntime().wrap(function _callee37$(_context37) {
          while (1) switch (_context37.prev = _context37.next) {
            case 0:
              e("cleanup").call(this);
              _context37.next = 3;
              return this.pluginsManager.cleanup();
            case 3:
              _context37.next = 5;
              return this.pluginsManager.closeContext();
            case 5:
              (i = this.processedTrack) == null || i.stop();
              this.isPublished = !1;
              this.destroyAudioLevelMonitor();
              yt() && X && document.removeEventListener("visibilitychange", this.handleVisibilityChange);
            case 9:
            case "end":
              return _context37.stop();
          }
        }, _callee37, this);
      }));
    }
  }, {
    key: "getTrackIDBeingSent",
    value: function getTrackIDBeingSent() {
      return this.processedTrack ? this.processedTrack.id : this.nativeTrack.id;
    }
  }, {
    key: "getTrackBeingSent",
    value: function getTrackBeingSent() {
      return this.processedTrack || this.nativeTrack;
    }
  }, {
    key: "buildNewSettings",
    value: function buildNewSettings(e) {
      var _v = v(v({}, this.settings), e),
        t = _v.volume,
        i = _v.codec,
        r = _v.maxBitrate,
        s = _v.deviceId,
        n = _v.advanced;
      return new ye(t, i, r, s, n);
    }
  }]);
  return Ie;
}(De);
var Rt = /*#__PURE__*/function (_De2) {
  _inherits(Rt, _De2);
  function Rt() {
    _classCallCheck(this, Rt);
    return _possibleConstructorReturn(this, _getPrototypeOf(Rt).apply(this, arguments));
  }
  _createClass(Rt, [{
    key: "setEnabled",
    value: function setEnabled(e) {
      var _this14 = this;
      var t = function t(i) {
        return _get(_getPrototypeOf(Rt.prototype), i, _this14);
      };
      return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee38() {
        return _regeneratorRuntime().wrap(function _callee38$(_context38) {
          while (1) switch (_context38.prev = _context38.next) {
            case 0:
              _context38.t0 = e !== this.enabled;
              if (!_context38.t0) {
                _context38.next = 6;
                break;
              }
              _context38.next = 4;
              return t("setEnabled").call(this, e);
            case 4:
              _context38.next = 6;
              return this.subscribeToAudio(e);
            case 6:
            case "end":
              return _context38.stop();
          }
        }, _callee38, this);
      }));
    }
  }]);
  return Rt;
}(De);
var Ne = /*#__PURE__*/function (_ge2) {
  _inherits(Ne, _ge2);
  function Ne(e, t, i) {
    var _this15;
    _classCallCheck(this, Ne);
    _this15 = _possibleConstructorReturn(this, _getPrototypeOf(Ne).call(this, e, t, i));
    _this15.type = F.VIDEO;
    _this15.sinkCount = 0;
    if (t.kind !== "video") throw new Error("Expected 'track' kind = 'video'");
    return _this15;
  }
  _createClass(Ne, [{
    key: "hasSinks",
    value: function hasSinks() {
      return this.sinkCount > 0;
    }
  }, {
    key: "addSink",
    value: function addSink(e) {
      this.addSinkInternal(e, this.nativeTrack);
    }
  }, {
    key: "removeSink",
    value: function removeSink(e) {
      e.srcObject !== null && (e.srcObject = null, this.sinkCount > 0 && this.sinkCount--);
    }
  }, {
    key: "addSinkInternal",
    value: function addSinkInternal(e, t) {
      var r;
      var i = e.srcObject;
      i !== null && i instanceof MediaStream && ((r = i.getVideoTracks()[0]) == null ? void 0 : r.id) === t.id || (e.srcObject = new MediaStream([t]), this.sinkCount++);
    }
  }]);
  return Ne;
}(ge);
var be;
(function (t) {
  t.TRANSFORM = "TRANSFORM", t.ANALYZE = "ANALYZE";
})(be || (be = {}));
var Oe;
(function (t) {
  t["2D"] = "2d", t.WEBGL = "webgl", t.WEBGL2 = "webgl2";
})(Oe || (Oe = {}));
var Xe = /*#__PURE__*/function () {
  function Xe() {
    _classCallCheck(this, Xe);
    this.total = 0;
    this.count = 0;
  }
  _createClass(Xe, [{
    key: "add",
    value: function add(e) {
      this.count++, this.total += e;
    }
  }, {
    key: "getAvg",
    value: function getAvg() {
      return Math.floor(this.total / this.count);
    }
  }, {
    key: "reset",
    value: function reset() {
      this.total = 0, this.count = 0;
    }
  }]);
  return Xe;
}();
var wt = /*#__PURE__*/function () {
  function wt(e) {
    _classCallCheck(this, wt);
    this.eventBus = e;
    this.TAG = "[VideoPluginsAnalytics]";
    this.initTime = {}, this.preProcessingAvgs = new Xe(), this.addedTimestamps = {}, this.processingAvgs = {}, this.pluginAdded = {}, this.pluginInputFrameRate = {}, this.pluginFrameRate = {};
  }
  _createClass(wt, [{
    key: "added",
    value: function added(e, t, i) {
      this.pluginAdded[e] = !0, this.addedTimestamps[e] = Date.now(), this.initTime[e] = 0, this.processingAvgs[e] = new Xe(), this.pluginInputFrameRate[e] = t, this.pluginFrameRate[e] = i || t;
    }
  }, {
    key: "removed",
    value: function removed(e) {
      var t;
      if (this.pluginAdded[e]) {
        var i = {
          pluginName: e,
          duration: Math.floor((Date.now() - this.addedTimestamps[e]) / 1e3),
          loadTime: this.initTime[e],
          avgPreProcessingTime: this.preProcessingAvgs.getAvg(),
          avgProcessingTime: (t = this.processingAvgs[e]) == null ? void 0 : t.getAvg(),
          inputFrameRate: this.pluginInputFrameRate[e],
          pluginFrameRate: this.pluginFrameRate[e]
        };
        this.eventBus.analytics.publish(de.stats(i)), this.clean(e);
      }
    }
  }, {
    key: "failure",
    value: function failure(e, t) {
      this.pluginAdded[e] && (this.eventBus.analytics.publish(de.failure(e, t)), this.clean(e));
    }
  }, {
    key: "initWithTime",
    value: function initWithTime(e, t) {
      return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee39() {
        var i, s;
        return _regeneratorRuntime().wrap(function _callee39$(_context39) {
          while (1) switch (_context39.prev = _context39.next) {
            case 0:
              if (!this.initTime[e]) {
                _context39.next = 3;
                break;
              }
              o.i(this.TAG, "Plugin Already loaded ".concat(e, ", time it took: ").concat(this.initTime[e]));
              return _context39.abrupt("return");
            case 3:
              _context39.prev = 3;
              _context39.next = 6;
              return this.timeInMs(t);
            case 6:
              i = _context39.sent;
              o.i(this.TAG, "Time taken for Plugin ".concat(e, " initialization : ").concat(i));
              _context39.next = 14;
              break;
            case 10:
              _context39.prev = 10;
              _context39.t0 = _context39["catch"](3);
              s = m.MediaPluginErrors.InitFailed(p.VIDEO_PLUGINS, "failed during initialization of plugin".concat(_context39.t0.message || _context39.t0));
              throw o.e(this.TAG, s), this.failure(e, s), s;
            case 14:
              i && (this.initTime[e] = i);
            case 15:
            case "end":
              return _context39.stop();
          }
        }, _callee39, this, [[3, 10]]);
      }));
    }
  }, {
    key: "preProcessWithTime",
    value: function preProcessWithTime(e) {
      return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee40() {
        var t;
        return _regeneratorRuntime().wrap(function _callee40$(_context40) {
          while (1) switch (_context40.prev = _context40.next) {
            case 0:
              _context40.next = 2;
              return this.timeInMs(e);
            case 2:
              t = _context40.sent;
              this.preProcessingAvgs.add(t);
            case 4:
            case "end":
              return _context40.stop();
          }
        }, _callee40, this);
      }));
    }
  }, {
    key: "processWithTime",
    value: function processWithTime(e, t) {
      return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee41() {
        var r, i, n;
        return _regeneratorRuntime().wrap(function _callee41$(_context41) {
          while (1) switch (_context41.prev = _context41.next) {
            case 0:
              _context41.prev = 0;
              _context41.next = 3;
              return this.timeInMs(t);
            case 3:
              i = _context41.sent;
              _context41.next = 10;
              break;
            case 6:
              _context41.prev = 6;
              _context41.t0 = _context41["catch"](0);
              n = m.MediaPluginErrors.ProcessingFailed(p.VIDEO_PLUGINS, "Failed during processing of plugin".concat(_context41.t0.message || _context41.t0));
              throw o.e(this.TAG, n), this.failure(e, n), n;
            case 10:
              i && ((r = this.processingAvgs[e]) == null || r.add(i));
            case 11:
            case "end":
              return _context41.stop();
          }
        }, _callee41, this, [[0, 6]]);
      }));
    }
  }, {
    key: "timeInMs",
    value: function timeInMs(e) {
      return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee42() {
        var t;
        return _regeneratorRuntime().wrap(function _callee42$(_context42) {
          while (1) switch (_context42.prev = _context42.next) {
            case 0:
              t = Date.now();
              _context42.next = 3;
              return e();
            case 3:
              return _context42.abrupt("return", Math.floor(Date.now() - t));
            case 4:
            case "end":
              return _context42.stop();
          }
        }, _callee42);
      }));
    }
  }, {
    key: "clean",
    value: function clean(e) {
      delete this.addedTimestamps[e], delete this.initTime[e], delete this.processingAvgs[e], delete this.pluginAdded[e], delete this.pluginInputFrameRate[e], delete this.pluginFrameRate[e];
    }
  }]);
  return wt;
}();
var Pi = 24,
  fr = 320,
  Er = 240,
  et = /*#__PURE__*/function () {
    function et(e, t) {
      _classCallCheck(this, et);
      this.TAG = "[VideoPluginsManager]";
      this.pluginsLoopRunning = !1;
      this.pluginsLoopState = "paused";
      this.pluginAddInProgress = !1;
      this.hmsTrack = e, this.pluginsMap = new Map(), this.pluginNumFramesToSkip = {}, this.pluginNumFramesSkipped = {}, this.analytics = new wt(t), this.canvases = new Array();
    }
    _createClass(et, [{
      key: "getPlugins",
      value: function getPlugins() {
        return Array.from(this.pluginsMap.keys());
      }
    }, {
      key: "addPlugin",
      value: function addPlugin(e, t) {
        return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee43() {
          var i, r, s;
          return _regeneratorRuntime().wrap(function _callee43$(_context43) {
            while (1) switch (_context43.prev = _context43.next) {
              case 0:
                if (!this.pluginAddInProgress) {
                  _context43.next = 7;
                  break;
                }
                r = (i = e.getName) == null ? void 0 : i.call(e);
                if (!(!r || r === "")) {
                  _context43.next = 5;
                  break;
                }
                o.w("no name provided by the plugin");
                return _context43.abrupt("return");
              case 5:
                s = m.MediaPluginErrors.AddAlreadyInProgress(p.VIDEO_PLUGINS, "Add Plugin is already in Progress");
                throw this.analytics.failure(r, s), o.w("can't add another plugin when previous add is in progress"), s;
              case 7:
                this.pluginAddInProgress = !0;
                _context43.prev = 8;
                _context43.next = 11;
                return this.addPluginInternal(e, t);
              case 11:
                _context43.prev = 11;
                this.pluginAddInProgress = !1;
                return _context43.finish(11);
              case 14:
              case "end":
                return _context43.stop();
            }
          }, _callee43, this, [[8,, 11, 14]]);
        }));
      }
    }, {
      key: "addPluginInternal",
      value: function addPluginInternal(e, t) {
        return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee45() {
          var _this16 = this;
          var n, d, i, r, s, l;
          return _regeneratorRuntime().wrap(function _callee45$(_context45) {
            while (1) switch (_context45.prev = _context45.next) {
              case 0:
                i = (n = e.getName) == null ? void 0 : n.call(e);
                if (!(!i || i === "")) {
                  _context45.next = 4;
                  break;
                }
                o.w("no name provided by the plugin");
                return _context45.abrupt("return");
              case 4:
                if (!this.pluginsMap.has(i)) {
                  _context45.next = 7;
                  break;
                }
                o.w(this.TAG, "plugin - ".concat(e.getName(), " already added."));
                return _context45.abrupt("return");
              case 7:
                r = this.hmsTrack.getMediaTrackSettings().frameRate || Pi, s = 0;
                t && t > 0 ? (o.i(this.TAG, "adding plugin ".concat(e.getName(), " with framerate ").concat(t)), t < r && (s = Math.ceil(r / t) - 1), this.analytics.added(i, r, t)) : (o.i(this.TAG, "adding plugin ".concat(e.getName())), this.analytics.added(i, r)), o.i(this.TAG, "numFrames to skip processing", s), this.pluginNumFramesToSkip[i] = s, this.pluginNumFramesSkipped[i] = s, this.validateAndThrow(i, e);
                _context45.prev = 9;
                _context45.next = 12;
                return this.analytics.initWithTime(i, function () {
                  return c(_this16, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee44() {
                    return _regeneratorRuntime().wrap(function _callee44$(_context44) {
                      while (1) switch (_context44.prev = _context44.next) {
                        case 0:
                          _context44.next = 2;
                          return e.init();
                        case 2:
                          return _context44.abrupt("return", _context44.sent);
                        case 3:
                        case "end":
                          return _context44.stop();
                      }
                    }, _callee44);
                  }));
                });
              case 12:
                this.pluginsMap.set(i, e);
                if (!(this.pluginsMap.size + 1 > this.canvases.length)) {
                  _context45.next = 15;
                  break;
                }
                for (l = this.canvases.length; l <= this.pluginsMap.size; l++) this.canvases[l] = document.createElement("canvas");
              case 15:
                _context45.next = 17;
                return this.startPluginsLoop((d = e.getContextType) == null ? void 0 : d.call(e));
              case 17:
                _context45.next = 25;
                break;
              case 19:
                _context45.prev = 19;
                _context45.t0 = _context45["catch"](9);
                o.e(this.TAG, "failed to add plugin", _context45.t0);
                _context45.next = 24;
                return this.removePlugin(e);
              case 24:
                throw _context45.t0;
              case 25:
              case "end":
                return _context45.stop();
            }
          }, _callee45, this, [[9, 19]]);
        }));
      }
    }, {
      key: "validatePlugin",
      value: function validatePlugin(e) {
        return e.checkSupport();
      }
    }, {
      key: "validateAndThrow",
      value: function validateAndThrow(e, t) {
        var i = this.validatePlugin(t);
        if (i.isSupported) o.i(this.TAG, "plugin is supported,- ".concat(t.getName()));else {
          var r;
          switch (i.errType) {
            case re.PLATFORM_NOT_SUPPORTED:
              throw r = m.MediaPluginErrors.PlatformNotSupported(p.VIDEO_PLUGINS, "platform not supported, see docs"), this.analytics.failure(e, r), r;
            case re.DEVICE_NOT_SUPPORTED:
              throw r = m.MediaPluginErrors.DeviceNotSupported(p.VIDEO_PLUGINS, "video device not supported, see docs"), this.analytics.failure(e, r), r;
          }
        }
      }
    }, {
      key: "removePlugin",
      value: function removePlugin(e) {
        return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee46() {
          var t;
          return _regeneratorRuntime().wrap(function _callee46$(_context46) {
            while (1) switch (_context46.prev = _context46.next) {
              case 0:
                t = e.getName();
                if (this.pluginsMap.get(t)) {
                  _context46.next = 4;
                  break;
                }
                o.w(this.TAG, "plugin - ".concat(t, " not found to remove."));
                return _context46.abrupt("return");
              case 4:
                o.i(this.TAG, "removing plugin ".concat(t));
                this.removePluginEntry(t);
                _context46.t0 = this.pluginsMap.size === 0;
                if (!_context46.t0) {
                  _context46.next = 11;
                  break;
                }
                o.i(this.TAG, "No plugins left, stopping plugins loop");
                _context46.next = 11;
                return this.stopPluginsLoop();
              case 11:
                e.stop();
                this.analytics.removed(t);
              case 13:
              case "end":
                return _context46.stop();
            }
          }, _callee46, this);
        }));
      }
    }, {
      key: "removePluginEntry",
      value: function removePluginEntry(e) {
        this.pluginsMap.delete(e), this.pluginNumFramesToSkip[e] && delete this.pluginNumFramesToSkip[e], this.pluginNumFramesSkipped[e] && delete this.pluginNumFramesSkipped[e];
      }
    }, {
      key: "waitForRestart",
      value: function waitForRestart() {
        return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee47() {
          return _regeneratorRuntime().wrap(function _callee47$(_context47) {
            while (1) switch (_context47.prev = _context47.next) {
              case 0:
                if (!this.pluginsLoopRunning || this.pluginsLoopState === "running") {
                  _context47.next = 6;
                  break;
                }
              case 1:
                if (!(this.pluginsLoopState === "paused")) {
                  _context47.next = 6;
                  break;
                }
                _context47.next = 4;
                return $(100);
              case 4:
                _context47.next = 1;
                break;
              case 6:
              case "end":
                return _context47.stop();
            }
          }, _callee47, this);
        }));
      }
    }, {
      key: "cleanup",
      value: function cleanup() {
        return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee48() {
          var e, _iterator5, _step5, t;
          return _regeneratorRuntime().wrap(function _callee48$(_context48) {
            while (1) switch (_context48.prev = _context48.next) {
              case 0:
                _iterator5 = _createForOfIteratorHelper(this.pluginsMap.values());
                _context48.prev = 1;
                _iterator5.s();
              case 3:
                if ((_step5 = _iterator5.n()).done) {
                  _context48.next = 9;
                  break;
                }
                t = _step5.value;
                _context48.next = 7;
                return this.removePlugin(t);
              case 7:
                _context48.next = 3;
                break;
              case 9:
                _context48.next = 14;
                break;
              case 11:
                _context48.prev = 11;
                _context48.t0 = _context48["catch"](1);
                _iterator5.e(_context48.t0);
              case 14:
                _context48.prev = 14;
                _iterator5.f();
                return _context48.finish(14);
              case 17:
                (e = this.outputTrack) == null || e.stop();
              case 18:
              case "end":
                return _context48.stop();
            }
          }, _callee48, this, [[1, 11, 14, 17]]);
        }));
      }
    }, {
      key: "initElementsAndStream",
      value: function initElementsAndStream(e) {
        this.inputCanvas || (this.inputCanvas = document.createElement("canvas")), this.outputCanvas = document.createElement("canvas"), this.inputVideo || (this.inputVideo = document.createElement("video")), this.inputCanvas.getContext("2d"), this.outputCanvas.getContext(e || Oe["2D"]);
        var t = this.outputCanvas.captureStream();
        this.outputTrack = t.getVideoTracks()[0];
      }
    }, {
      key: "startPluginsLoop",
      value: function startPluginsLoop(e) {
        return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee49() {
          var _this17 = this;
          return _regeneratorRuntime().wrap(function _callee49$(_context49) {
            while (1) switch (_context49.prev = _context49.next) {
              case 0:
                if (this.pluginsLoopRunning) {
                  _context49.next = 11;
                  break;
                }
                this.initElementsAndStream(e), this.pluginsLoopRunning = !0;
                _context49.prev = 2;
                _context49.next = 5;
                return this.hmsTrack.setProcessedTrack(this.outputTrack);
              case 5:
                _context49.next = 10;
                break;
              case 7:
                _context49.prev = 7;
                _context49.t0 = _context49["catch"](2);
                throw this.pluginsLoopRunning = !1, o.e(this.TAG, "error in setting processed track", _context49.t0), _context49.t0;
              case 10:
                this.pluginsLoop().then(function () {
                  o.d(_this17.TAG, "processLoop stopped");
                });
              case 11:
              case "end":
                return _context49.stop();
            }
          }, _callee49, this, [[2, 7]]);
        }));
      }
    }, {
      key: "stopPluginsLoop",
      value: function stopPluginsLoop() {
        return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee50() {
          var e;
          return _regeneratorRuntime().wrap(function _callee50$(_context50) {
            while (1) switch (_context50.prev = _context50.next) {
              case 0:
                this.pluginsLoopRunning = !1;
                _context50.next = 3;
                return this.hmsTrack.setProcessedTrack(void 0);
              case 3:
                this.resetCanvases();
                (e = this.outputTrack) == null || e.stop();
                this.inputVideo && (this.inputVideo.srcObject = null, this.inputVideo = void 0);
              case 6:
              case "end":
                return _context50.stop();
            }
          }, _callee50, this);
        }));
      }
    }, {
      key: "pluginsLoop",
      value: function pluginsLoop() {
        return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee52() {
          var _this18 = this;
          var e, t, i, r;
          return _regeneratorRuntime().wrap(function _callee52$(_context52) {
            while (1) switch (_context52.prev = _context52.next) {
              case 0:
                if (!this.pluginsLoopRunning) {
                  _context52.next = 27;
                  break;
                }
                e = this.hmsTrack.getMediaTrackSettings().frameRate || Pi, t = Math.floor(1e3 / e);
                if (!(!this.hmsTrack.enabled || this.hmsTrack.nativeTrack.readyState === "ended")) {
                  _context52.next = 8;
                  break;
                }
                this.pluginsLoopState === "running" && this.resetCanvases();
                this.pluginsLoopState = "paused";
                _context52.next = 7;
                return $(t);
              case 7:
                return _context52.abrupt("continue", 25);
              case 8:
                i = 0;
                _context52.prev = 9;
                _context52.next = 12;
                return this.analytics.preProcessWithTime(function () {
                  return c(_this18, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee51() {
                    return _regeneratorRuntime().wrap(function _callee51$(_context51) {
                      while (1) switch (_context51.prev = _context51.next) {
                        case 0:
                          _context51.next = 2;
                          return this.doPreProcessing();
                        case 2:
                          return _context51.abrupt("return", _context51.sent);
                        case 3:
                        case "end":
                          return _context51.stop();
                      }
                    }, _callee51, this);
                  }));
                });
              case 12:
                r = Date.now();
                _context52.next = 15;
                return this.processFramesThroughPlugins();
              case 15:
                i = Math.floor(Date.now() - r);
                i > t && (i = t);
                _context52.next = 22;
                break;
              case 19:
                _context52.prev = 19;
                _context52.t0 = _context52["catch"](9);
                o.e(this.TAG, "error in plugins loop", _context52.t0);
              case 22:
                this.pluginsLoopState = "running";
                _context52.next = 25;
                return $(t - i);
              case 25:
                _context52.next = 0;
                break;
              case 27:
              case "end":
                return _context52.stop();
            }
          }, _callee52, this, [[9, 19]]);
        }));
      }
    }, {
      key: "doPreProcessing",
      value: function doPreProcessing() {
        return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee53() {
          return _regeneratorRuntime().wrap(function _callee53$(_context53) {
            while (1) switch (_context53.prev = _context53.next) {
              case 0:
                _context53.next = 2;
                return this.addTrackToVideo();
              case 2:
                _context53.next = 4;
                return this.updateInputCanvas();
              case 4:
              case "end":
                return _context53.stop();
            }
          }, _callee53, this);
        }));
      }
    }, {
      key: "processFramesThroughPlugins",
      value: function processFramesThroughPlugins() {
        return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee58() {
          var _this19 = this;
          var e, _iterator6, _step6, _loop;
          return _regeneratorRuntime().wrap(function _callee58$(_context59) {
            while (1) switch (_context59.prev = _context59.next) {
              case 0:
                this.canvases[0] = this.inputCanvas;
                e = 0;
                _iterator6 = _createForOfIteratorHelper(this.pluginsMap.values());
                _context59.prev = 3;
                _loop = /*#__PURE__*/_regeneratorRuntime().mark(function _loop() {
                  var t, i, r, s, n, d;
                  return _regeneratorRuntime().wrap(function _loop$(_context58) {
                    while (1) switch (_context58.prev = _context58.next) {
                      case 0:
                        t = _step6.value;
                        i = t.getName();
                        if (!t) {
                          _context58.next = 39;
                          break;
                        }
                        _context58.prev = 3;
                        r = _this19.checkIfSkipRequired(i);
                        if (!(t.getPluginType() === be.TRANSFORM)) {
                          _context58.next = 27;
                          break;
                        }
                        s = function s(n, d) {
                          return c(_this19, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee54() {
                            return _regeneratorRuntime().wrap(function _callee54$(_context54) {
                              while (1) switch (_context54.prev = _context54.next) {
                                case 0:
                                  _context54.prev = 0;
                                  _context54.next = 3;
                                  return t.processVideoFrame(n, d, r);
                                case 3:
                                  _context54.next = 8;
                                  break;
                                case 5:
                                  _context54.prev = 5;
                                  _context54.t0 = _context54["catch"](0);
                                  o.e(this.TAG, "error in processing plugin ".concat(i), _context54.t0);
                                case 8:
                                case "end":
                                  return _context54.stop();
                              }
                            }, _callee54, this, [[0, 5]]);
                          }));
                        };
                        if (!r) {
                          _context58.next = 17;
                          break;
                        }
                        if (!(e === _this19.pluginsMap.size - 1)) {
                          _context58.next = 13;
                          break;
                        }
                        _context58.next = 11;
                        return s(_this19.canvases[e], _this19.outputCanvas);
                      case 11:
                        _context58.next = 15;
                        break;
                      case 13:
                        _context58.next = 15;
                        return s(_this19.canvases[e], _this19.canvases[e + 1]);
                      case 15:
                        _context58.next = 25;
                        break;
                      case 17:
                        n = _this19.canvases[e], d = _this19.canvases[e + 1];
                        if (!(e === _this19.pluginsMap.size - 1)) {
                          _context58.next = 23;
                          break;
                        }
                        _context58.next = 21;
                        return _this19.analytics.processWithTime(i, function () {
                          return c(_this19, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee55() {
                            return _regeneratorRuntime().wrap(function _callee55$(_context55) {
                              while (1) switch (_context55.prev = _context55.next) {
                                case 0:
                                  return _context55.abrupt("return", s(n, this.outputCanvas));
                                case 1:
                                case "end":
                                  return _context55.stop();
                              }
                            }, _callee55, this);
                          }));
                        });
                      case 21:
                        _context58.next = 25;
                        break;
                      case 23:
                        _context58.next = 25;
                        return _this19.analytics.processWithTime(i, function () {
                          return c(_this19, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee56() {
                            return _regeneratorRuntime().wrap(function _callee56$(_context56) {
                              while (1) switch (_context56.prev = _context56.next) {
                                case 0:
                                  return _context56.abrupt("return", s(n, d));
                                case 1:
                                case "end":
                                  return _context56.stop();
                              }
                            }, _callee56);
                          }));
                        });
                      case 25:
                        _context58.next = 31;
                        break;
                      case 27:
                        _context58.t0 = t.getPluginType() === be.ANALYZE && !r;
                        if (!_context58.t0) {
                          _context58.next = 31;
                          break;
                        }
                        _context58.next = 31;
                        return _this19.analytics.processWithTime(i, function () {
                          return c(_this19, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee57() {
                            return _regeneratorRuntime().wrap(function _callee57$(_context57) {
                              while (1) switch (_context57.prev = _context57.next) {
                                case 0:
                                  _context57.next = 2;
                                  return t.processVideoFrame(this.inputCanvas);
                                case 2:
                                  return _context57.abrupt("return", _context57.sent);
                                case 3:
                                case "end":
                                  return _context57.stop();
                              }
                            }, _callee57, this);
                          }));
                        });
                      case 31:
                        _context58.next = 38;
                        break;
                      case 33:
                        _context58.prev = 33;
                        _context58.t1 = _context58["catch"](3);
                        o.e(_this19.TAG, "error in processing plugin ".concat(i), _context58.t1);
                        _context58.next = 38;
                        return _this19.removePlugin(t);
                      case 38:
                        e++;
                      case 39:
                      case "end":
                        return _context58.stop();
                    }
                  }, _loop, null, [[3, 33]]);
                });
                _iterator6.s();
              case 6:
                if ((_step6 = _iterator6.n()).done) {
                  _context59.next = 10;
                  break;
                }
                return _context59.delegateYield(_loop(), "t0", 8);
              case 8:
                _context59.next = 6;
                break;
              case 10:
                _context59.next = 15;
                break;
              case 12:
                _context59.prev = 12;
                _context59.t1 = _context59["catch"](3);
                _iterator6.e(_context59.t1);
              case 15:
                _context59.prev = 15;
                _iterator6.f();
                return _context59.finish(15);
              case 18:
              case "end":
                return _context59.stop();
            }
          }, _callee58, this, [[3, 12, 15, 18]]);
        }));
      }
    }, {
      key: "addTrackToVideo",
      value: function addTrackToVideo() {
        return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee59() {
          var t, e;
          return _regeneratorRuntime().wrap(function _callee59$(_context60) {
            while (1) switch (_context60.prev = _context60.next) {
              case 0:
                if (this.inputVideo) {
                  _context60.next = 2;
                  break;
                }
                return _context60.abrupt("return");
              case 2:
                e = this.inputVideo.srcObject;
                _context60.t0 = e !== null && e instanceof MediaStream && ((t = e.getVideoTracks()[0]) == null ? void 0 : t.id) === this.hmsTrack.nativeTrack.id;
                if (_context60.t0) {
                  _context60.next = 11;
                  break;
                }
                this.inputVideo.pause();
                this.inputVideo.srcObject = new MediaStream([this.hmsTrack.nativeTrack]);
                this.inputVideo.muted = !0;
                this.inputVideo.playsInline = !0;
                _context60.next = 11;
                return this.inputVideo.play();
              case 11:
              case "end":
                return _context60.stop();
            }
          }, _callee59, this);
        }));
      }
    }, {
      key: "updateInputCanvas",
      value: function updateInputCanvas() {
        return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee60() {
          var _this$hmsTrack$getMed, _this$hmsTrack$getMed2, e, _this$hmsTrack$getMed3, t;
          return _regeneratorRuntime().wrap(function _callee60$(_context61) {
            while (1) switch (_context61.prev = _context61.next) {
              case 0:
                if (!(!this.inputCanvas || !this.inputVideo)) {
                  _context61.next = 2;
                  break;
                }
                return _context61.abrupt("return");
              case 2:
                _this$hmsTrack$getMed = this.hmsTrack.getMediaTrackSettings(), _this$hmsTrack$getMed2 = _this$hmsTrack$getMed.width, e = _this$hmsTrack$getMed2 === void 0 ? fr : _this$hmsTrack$getMed2, _this$hmsTrack$getMed3 = _this$hmsTrack$getMed.height, t = _this$hmsTrack$getMed3 === void 0 ? Er : _this$hmsTrack$getMed3;
                this.inputCanvas.height !== t && (this.inputCanvas.height = t), this.inputCanvas.width !== e && (this.inputCanvas.width = e), this.inputCanvas.getContext("2d").drawImage(this.inputVideo, 0, 0, e, t);
              case 4:
              case "end":
                return _context61.stop();
            }
          }, _callee60, this);
        }));
      }
    }, {
      key: "resetCanvases",
      value: function resetCanvases() {
        if (!this.outputCanvas || !this.inputCanvas) return;
        var e = this.inputCanvas.getContext("2d");
        e && (e.fillStyle = "rgb(0, 0, 0)", e.fillRect(0, 0, this.outputCanvas.width, this.outputCanvas.height)), this.canvases = [];
      }
    }, {
      key: "checkIfSkipRequired",
      value: function checkIfSkipRequired(e) {
        var t = !1;
        return this.pluginNumFramesSkipped[e] < this.pluginNumFramesToSkip[e] ? (this.pluginNumFramesSkipped[e]++, t = !0) : (t = !1, this.pluginNumFramesSkipped[e] = 0), t;
      }
    }]);
    return et;
  }();
function Ii(a, e) {
  return function (i) {
    return i in a && a[i] !== e[i];
  };
}
var Z = /*#__PURE__*/function (_Ne) {
  _inherits(Z, _Ne);
  function Z(e, t, i, r) {
    var _this20;
    var s = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : new J().build();
    _classCallCheck(this, Z);
    _this20 = _possibleConstructorReturn(this, _getPrototypeOf(Z).call(this, e, t, i));
    _this20.eventBus = r;
    _this20._layerDefinitions = [];
    _this20.TAG = "[HMSLocalVideoTrack]";
    _this20.isCurrentTab = !1;
    _this20.isPublished = !1;
    _this20.buildNewSettings = function (e) {
      var _v2 = v(v({}, _this20.settings), e),
        t = _v2.width,
        i = _v2.height,
        r = _v2.codec,
        s = _v2.maxFramerate,
        n = _v2.maxBitrate,
        d = _v2.deviceId,
        l = _v2.advanced;
      return new Me(t, i, r, s, d, l, n);
    };
    _this20.handleSettingsChange = function (e) {
      return c(_assertThisInitialized(_assertThisInitialized(_this20)), null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee61() {
        var t, i;
        return _regeneratorRuntime().wrap(function _callee61$(_context62) {
          while (1) switch (_context62.prev = _context62.next) {
            case 0:
              t = this.stream, i = Ii(e, this.settings);
              _context62.t0 = i("maxBitrate") && e.maxBitrate;
              if (!_context62.t0) {
                _context62.next = 5;
                break;
              }
              _context62.next = 5;
              return t.setMaxBitrateAndFramerate(this);
            case 5:
              _context62.t1 = i("width") || i("height") || i("advanced");
              if (!_context62.t1) {
                _context62.next = 9;
                break;
              }
              _context62.next = 9;
              return this.nativeTrack.applyConstraints(e.toConstraints());
            case 9:
            case "end":
              return _context62.stop();
          }
        }, _callee61, this);
      }));
    };
    _this20.handleDeviceChange = function (e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
      return c(_assertThisInitialized(_assertThisInitialized(_this20)), null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee62() {
        var _r3;
        return _regeneratorRuntime().wrap(function _callee62$(_context63) {
          while (1) switch (_context63.prev = _context63.next) {
            case 0:
              if (!(Ii(e, this.settings)("deviceId") && this.source === "regular")) {
                _context63.next = 9;
                break;
              }
              if (!this.enabled) {
                _context63.next = 8;
                break;
              }
              _context63.next = 4;
              return this.replaceTrackWith(e);
            case 4:
              _r3 = _context63.sent;
              _context63.next = 7;
              return this.replaceSender(_r3, this.enabled);
            case 7:
              this.nativeTrack = _r3;
            case 8:
              t || Q.updateSelection("videoInput", {
                deviceId: e.deviceId,
                groupId: this.nativeTrack.getSettings().groupId
              });
            case 9:
            case "end":
              return _context63.stop();
          }
        }, _callee62, this);
      }));
    };
    e.tracks.push(_assertThisInitialized(_assertThisInitialized(_this20))), _this20.settings = s, s.deviceId !== t.getSettings().deviceId && t.enabled && (_this20.settings = _this20.buildNewSettings({
      deviceId: t.getSettings().deviceId
    })), _this20.pluginsManager = new et(_assertThisInitialized(_assertThisInitialized(_this20)), r), _this20.setFirstTrackId(_this20.trackId);
    return _this20;
  }
  _createClass(Z, [{
    key: "setSimulcastDefinitons",
    value: function setSimulcastDefinitons(e) {
      this._layerDefinitions = e;
    }
  }, {
    key: "getSimulcastDefinitions",
    value: function getSimulcastDefinitions() {
      return this._layerDefinitions;
    }
  }, {
    key: "setEnabled",
    value: function setEnabled(e) {
      var _this21 = this;
      var t = function t(i) {
        return _get(_getPrototypeOf(Z.prototype), i, _this21);
      };
      return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee63() {
        var r, s;
        return _regeneratorRuntime().wrap(function _callee63$(_context64) {
          while (1) switch (_context64.prev = _context64.next) {
            case 0:
              if (!(e !== this.enabled)) {
                _context64.next = 24;
                break;
              }
              if (!(this.source === "regular")) {
                _context64.next = 20;
                break;
              }
              if (!e) {
                _context64.next = 8;
                break;
              }
              _context64.next = 5;
              return this.replaceTrackWith(this.settings);
            case 5:
              s = _context64.sent;
              _context64.next = 11;
              break;
            case 8:
              _context64.next = 10;
              return this.replaceTrackWithBlank();
            case 10:
              s = _context64.sent;
            case 11:
              _context64.next = 13;
              return this.replaceSender(s, e);
            case 13:
              (r = this.nativeTrack) == null || r.stop();
              this.nativeTrack = s;
              _context64.t0 = e;
              if (!_context64.t0) {
                _context64.next = 20;
                break;
              }
              _context64.next = 19;
              return this.pluginsManager.waitForRestart();
            case 19:
              this.settings = this.buildNewSettings({
                deviceId: s.getSettings().deviceId
              });
            case 20:
              _context64.next = 22;
              return t("setEnabled").call(this, e);
            case 22:
              this.eventBus.localVideoEnabled.publish({
                enabled: e,
                track: this
              });
              this.stream.trackUpdate(this);
            case 24:
            case "end":
              return _context64.stop();
          }
        }, _callee63, this);
      }));
    }
  }, {
    key: "isPublishedTrackId",
    value: function isPublishedTrackId(e) {
      return this.publishedTrackId === e;
    }
  }, {
    key: "addSink",
    value: function addSink(e) {
      this.addSinkInternal(e, this.processedTrack || this.nativeTrack);
    }
  }, {
    key: "setSettings",
    value: function setSettings(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
      return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee64() {
        var i;
        return _regeneratorRuntime().wrap(function _callee64$(_context65) {
          while (1) switch (_context65.prev = _context65.next) {
            case 0:
              i = this.buildNewSettings(e);
              _context65.next = 3;
              return this.handleDeviceChange(i, t);
            case 3:
              if (this.enabled) {
                _context65.next = 6;
                break;
              }
              this.settings = i;
              return _context65.abrupt("return");
            case 6:
              _context65.next = 8;
              return this.handleSettingsChange(i);
            case 8:
              this.settings = i;
            case 9:
            case "end":
              return _context65.stop();
          }
        }, _callee64, this);
      }));
    }
  }, {
    key: "getPlugins",
    value: function getPlugins() {
      return this.pluginsManager.getPlugins();
    }
  }, {
    key: "addPlugin",
    value: function addPlugin(e, t) {
      return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee65() {
        return _regeneratorRuntime().wrap(function _callee65$(_context66) {
          while (1) switch (_context66.prev = _context66.next) {
            case 0:
              return _context66.abrupt("return", this.pluginsManager.addPlugin(e, t));
            case 1:
            case "end":
              return _context66.stop();
          }
        }, _callee65, this);
      }));
    }
  }, {
    key: "removePlugin",
    value: function removePlugin(e) {
      return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee66() {
        return _regeneratorRuntime().wrap(function _callee66$(_context67) {
          while (1) switch (_context67.prev = _context67.next) {
            case 0:
              return _context67.abrupt("return", this.pluginsManager.removePlugin(e));
            case 1:
            case "end":
              return _context67.stop();
          }
        }, _callee66, this);
      }));
    }
  }, {
    key: "validatePlugin",
    value: function validatePlugin(e) {
      return this.pluginsManager.validatePlugin(e);
    }
  }, {
    key: "cleanup",
    value: function cleanup() {
      var _this22 = this;
      var e = function e(t) {
        return _get(_getPrototypeOf(Z.prototype), t, _this22);
      };
      return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee67() {
        var i;
        return _regeneratorRuntime().wrap(function _callee67$(_context68) {
          while (1) switch (_context68.prev = _context68.next) {
            case 0:
              e("cleanup").call(this);
              _context68.next = 3;
              return this.pluginsManager.cleanup();
            case 3:
              (i = this.processedTrack) == null || i.stop();
              this.isPublished = !1;
            case 5:
            case "end":
              return _context68.stop();
          }
        }, _callee67, this);
      }));
    }
  }, {
    key: "cropTo",
    value: function cropTo(e) {
      return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee68() {
        return _regeneratorRuntime().wrap(function _callee68$(_context69) {
          while (1) switch (_context69.prev = _context69.next) {
            case 0:
              if (!(!!e && this.source === "screen")) {
                _context69.next = 11;
                break;
              }
              _context69.prev = 1;
              _context69.t0 = this.nativeTrack.cropTo;
              if (!_context69.t0) {
                _context69.next = 6;
                break;
              }
              _context69.next = 6;
              return this.nativeTrack.cropTo(e);
            case 6:
              _context69.next = 11;
              break;
            case 8:
              _context69.prev = 8;
              _context69.t1 = _context69["catch"](1);
              throw o.e(this.TAG, "failed to crop screenshare capture - ", _context69.t1), m.TracksErrors.GenericTrack(p.TRACK, "failed to crop screenshare capture");
            case 11:
            case "end":
              return _context69.stop();
          }
        }, _callee68, this, [[1, 8]]);
      }));
    }
  }, {
    key: "getCaptureHandle",
    value: function getCaptureHandle() {
      if (this.nativeTrack.getCaptureHandle) return this.nativeTrack.getCaptureHandle();
    }
  }, {
    key: "setProcessedTrack",
    value: function setProcessedTrack(e) {
      return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee69() {
        return _regeneratorRuntime().wrap(function _callee69$(_context70) {
          while (1) switch (_context70.prev = _context70.next) {
            case 0:
              if (this.nativeTrack.enabled) {
                _context70.next = 3;
                break;
              }
              this.processedTrack = e;
              return _context70.abrupt("return");
            case 3:
              if (e) {
                _context70.next = 10;
                break;
              }
              _context70.t0 = this.processedTrack;
              if (!_context70.t0) {
                _context70.next = 8;
                break;
              }
              _context70.next = 8;
              return this.stream.replaceSenderTrack(this.processedTrack, this.nativeTrack);
            case 8:
              this.processedTrack = void 0;
              return _context70.abrupt("return");
            case 10:
              _context70.t1 = e !== this.processedTrack;
              if (!_context70.t1) {
                _context70.next = 20;
                break;
              }
              if (!this.processedTrack) {
                _context70.next = 17;
                break;
              }
              _context70.next = 15;
              return this.stream.replaceSenderTrack(this.processedTrack, e);
            case 15:
              _context70.next = 19;
              break;
            case 17:
              _context70.next = 19;
              return this.stream.replaceSenderTrack(this.nativeTrack, e);
            case 19:
              this.processedTrack = e;
            case 20:
            case "end":
              return _context70.stop();
          }
        }, _callee69, this);
      }));
    }
  }, {
    key: "getTrackIDBeingSent",
    value: function getTrackIDBeingSent() {
      return this.getTrackBeingSent().id;
    }
  }, {
    key: "getTrackBeingSent",
    value: function getTrackBeingSent() {
      return this.enabled ? this.processedTrack || this.nativeTrack : this.nativeTrack;
    }
  }, {
    key: "replaceTrackWith",
    value: function replaceTrackWith(e) {
      return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee70() {
        var t, i;
        return _regeneratorRuntime().wrap(function _callee70$(_context71) {
          while (1) switch (_context71.prev = _context71.next) {
            case 0:
              t = this.nativeTrack;
              _context71.next = 3;
              return ze(e);
            case 3:
              i = _context71.sent;
              return _context71.abrupt("return", (t == null || t.stop(), o.d(this.TAG, "replaceTrack, Previous track stopped", t, "newTrack", i), this.settings.deviceId === "default" && (this.settings = this.buildNewSettings({
                deviceId: this.nativeTrack.getSettings().deviceId
              })), i));
            case 5:
            case "end":
              return _context71.stop();
          }
        }, _callee70, this);
      }));
    }
  }, {
    key: "replaceTrackWithBlank",
    value: function replaceTrackWithBlank() {
      return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee71() {
        var e, t;
        return _regeneratorRuntime().wrap(function _callee71$(_context72) {
          while (1) switch (_context72.prev = _context72.next) {
            case 0:
              e = this.nativeTrack, t = ue.getEmptyVideoTrack(e);
              return _context72.abrupt("return", (e == null || e.stop(), o.d(this.TAG, "replaceTrackWithBlank, Previous track stopped", e, "newTrack", t), t));
            case 2:
            case "end":
              return _context72.stop();
          }
        }, _callee71, this);
      }));
    }
  }, {
    key: "replaceSender",
    value: function replaceSender(e, t) {
      return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee72() {
        var i;
        return _regeneratorRuntime().wrap(function _callee72$(_context73) {
          while (1) switch (_context73.prev = _context73.next) {
            case 0:
              i = this.stream;
              if (!t) {
                _context73.next = 6;
                break;
              }
              _context73.next = 4;
              return i.replaceSenderTrack(this.nativeTrack, this.processedTrack || e);
            case 4:
              _context73.next = 8;
              break;
            case 6:
              _context73.next = 8;
              return i.replaceSenderTrack(this.processedTrack || this.nativeTrack, e);
            case 8:
              _context73.next = 10;
              return i.replaceStreamTrack(this.nativeTrack, e);
            case 10:
            case "end":
              return _context73.stop();
          }
        }, _callee72, this);
      }));
    }
  }]);
  return Z;
}(Ne);
var Ce = "renegotiation-callback-id",
  tt = "ion-sfu",
  it = 100,
  xe = 5,
  bi = 60,
  Ci = 12e3,
  Ri = 1e3,
  wi = 5,
  Re = "SUBSCRIBE_ICE_CONNECTION_CALLBACK_ID",
  Hi = 6e4,
  Ht = 5e3,
  Li = 1e3,
  _i = !1,
  Di = "https://event.100ms.live/v2/client/report",
  Ni = "https://event-nonprod.100ms.live/v2/client/report",
  Oi = 100,
  V = {
    DEVICE_CHANGE: "device-change",
    LOCAL_AUDIO_ENABLED: "local-audio-enabled",
    LOCAL_VIDEO_ENABLED: "local-video-enabled",
    STATS_UPDATE: "stats-update",
    RTC_STATS_UPDATE: "rtc-stats-update",
    TRACK_DEGRADED: "track-degraded",
    TRACK_RESTORED: "track-restored",
    TRACK_AUDIO_LEVEL_UPDATE: "track-audio-level-update",
    LOCAL_AUDIO_SILENCE: "local-audio-silence",
    ANALYTICS: "analytics",
    AUDIO_PLUGIN_FAILED: "audio-plugin-failed",
    POLICY_CHANGE: "policy-change",
    LOCAL_ROLE_UPDATE: "local-role-update",
    AUDIO_TRACK_UPDATE: "audio-track-update",
    AUDIO_TRACK_ADDED: "audio-track-added",
    AUDIO_TRACK_REMOVED: "audio-track-removed",
    AUTOPLAY_ERROR: "autoplay-error",
    LEAVE: "leave"
  };
var ve = /*#__PURE__*/function (_Ne2) {
    _inherits(ve, _Ne2);
    function ve() {
      var _this23;
      _classCallCheck(this, ve);
      _this23 = _possibleConstructorReturn(this, _getPrototypeOf(ve).apply(this, arguments));
      _this23._degraded = !1;
      _this23._degradedAt = null;
      _this23._layerDefinitions = [];
      _this23.history = new xi();
      _this23.preferredLayer = j.HIGH;
      return _this23;
    }
    _createClass(ve, [{
      key: "setEnabled",
      value: function setEnabled(e) {
        var _this24 = this;
        var t = function t(i) {
          return _get(_getPrototypeOf(ve.prototype), i, _this24);
        };
        return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee73() {
          return _regeneratorRuntime().wrap(function _callee73$(_context74) {
            while (1) switch (_context74.prev = _context74.next) {
              case 0:
                _context74.t0 = e !== this.enabled;
                if (!_context74.t0) {
                  _context74.next = 4;
                  break;
                }
                _context74.next = 4;
                return t("setEnabled").call(this, e);
              case 4:
              case "end":
                return _context74.stop();
            }
          }, _callee73, this);
        }));
      }
    }, {
      key: "setPreferredLayer",
      value: function setPreferredLayer(e) {
        return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee74() {
          return _regeneratorRuntime().wrap(function _callee74$(_context75) {
            while (1) switch (_context75.prev = _context75.next) {
              case 0:
                if (!(e === j.NONE)) {
                  _context75.next = 3;
                  break;
                }
                o.w("layer ".concat(j.NONE, " will be ignored"));
                return _context75.abrupt("return");
              case 3:
                if (!(this.preferredLayer = e, !!this.shouldSendVideoLayer(e, "preferLayer"))) {
                  _context75.next = 10;
                  break;
                }
                if (this.hasSinks()) {
                  _context75.next = 7;
                  break;
                }
                o.d("[Remote Track] ".concat(this.logIdentifier), "Track does not have any sink, saving ".concat(e, ", source=").concat(this.source));
                return _context75.abrupt("return");
              case 7:
                _context75.next = 9;
                return this.requestLayer(e, "preferLayer");
              case 9:
                this.pushInHistory("uiPreferLayer-".concat(e));
              case 10:
              case "end":
                return _context75.stop();
            }
          }, _callee74, this);
        }));
      }
    }, {
      key: "getSimulcastLayer",
      value: function getSimulcastLayer() {
        return this.stream.getSimulcastLayer();
      }
    }, {
      key: "getLayer",
      value: function getLayer() {
        return this.stream.getVideoLayer();
      }
    }, {
      key: "getPreferredLayer",
      value: function getPreferredLayer() {
        return this.preferredLayer;
      }
    }, {
      key: "addSink",
      value: function addSink(e) {
        var _this25 = this;
        var t = function t(i) {
          return _get(_getPrototypeOf(ve.prototype), i, _this25);
        };
        return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee75() {
          return _regeneratorRuntime().wrap(function _callee75$(_context76) {
            while (1) switch (_context76.prev = _context76.next) {
              case 0:
                t("addSink").call(this, e);
                _context76.next = 3;
                return this.updateLayer("addSink");
              case 3:
                this.pushInHistory("uiSetLayer-high");
              case 4:
              case "end":
                return _context76.stop();
            }
          }, _callee75, this);
        }));
      }
    }, {
      key: "removeSink",
      value: function removeSink(e) {
        var _this26 = this;
        var t = function t(i) {
          return _get(_getPrototypeOf(ve.prototype), i, _this26);
        };
        return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee76() {
          return _regeneratorRuntime().wrap(function _callee76$(_context77) {
            while (1) switch (_context77.prev = _context77.next) {
              case 0:
                t("removeSink").call(this, e);
                _context77.next = 3;
                return this.updateLayer("removeSink");
              case 3:
                this._degraded = !1;
                this.pushInHistory("uiSetLayer-none");
              case 5:
              case "end":
                return _context77.stop();
            }
          }, _callee76, this);
        }));
      }
    }, {
      key: "getSimulcastDefinitions",
      value: function getSimulcastDefinitions() {
        return _toConsumableArray(this._layerDefinitions);
      }
    }, {
      key: "setSimulcastDefinitons",
      value: function setSimulcastDefinitons(e) {
        this._layerDefinitions = e;
      }
    }, {
      key: "setLayerFromServer",
      value: function setLayerFromServer(e) {
        this._degraded = (e.publisher_degraded || e.subscriber_degraded) && e.current_layer === j.NONE, this._degradedAt = this._degraded ? new Date() : this._degradedAt;
        var t = e.current_layer;
        return o.d("[Remote Track] ".concat(this.logIdentifier, " ").concat(this.stream.id, " - layer update from sfu"), "currLayer=".concat(e.current_layer, ", preferredLayer=").concat(e.expected_layer), "sub_degraded=".concat(e.subscriber_degraded), "pub_degraded=".concat(e.publisher_degraded), "isDegraded=".concat(this._degraded)), this.stream.setVideoLayerLocally(t, this.logIdentifier, "setLayerFromServer"), this.pushInHistory("sfuLayerUpdate-".concat(t)), this._degraded;
      }
    }, {
      key: "setDegradedFromSdk",
      value: function setDegradedFromSdk(e) {
        this._degraded = e, this._degradedAt = e ? new Date() : this._degradedAt, this.updateLayer("sdkDegradation"), this.pushInHistory(e ? "sdkDegraded-none" : "sdkRecovered-high");
      }
    }, {
      key: "updateLayer",
      value: function updateLayer(e) {
        return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee77() {
          var t;
          return _regeneratorRuntime().wrap(function _callee77$(_context78) {
            while (1) switch (_context78.prev = _context78.next) {
              case 0:
                t = this.degraded || !this.hasSinks() ? j.NONE : this.preferredLayer;
                _context78.t0 = !this.shouldSendVideoLayer(t, e);
                if (_context78.t0) {
                  _context78.next = 5;
                  break;
                }
                _context78.next = 5;
                return this.requestLayer(t, e);
              case 5:
              case "end":
                return _context78.stop();
            }
          }, _callee77, this);
        }));
      }
    }, {
      key: "pushInHistory",
      value: function pushInHistory(e) {
        _i && this.history.push({
          name: e,
          layer: this.getLayer(),
          degraded: this.degraded
        });
      }
    }, {
      key: "requestLayer",
      value: function requestLayer(e, t) {
        return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee78() {
          var _i3;
          return _regeneratorRuntime().wrap(function _callee78$(_context79) {
            while (1) switch (_context79.prev = _context79.next) {
              case 0:
                _context79.prev = 0;
                _context79.next = 3;
                return this.stream.setVideoLayer(e, this.trackId, this.logIdentifier, t);
              case 3:
                _i3 = _context79.sent;
                return _context79.abrupt("return", (o.d("[Remote Track] ".concat(this.logIdentifier), "Requested layer ".concat(e, ", source=").concat(this.source)), _i3));
              case 7:
                _context79.prev = 7;
                _context79.t0 = _context79["catch"](0);
                throw o.d("[Remote Track] ".concat(this.logIdentifier), "Failed to set layer ".concat(e, ", source=").concat(this.source, ", ").concat(_context79.t0.message)), _context79.t0;
              case 10:
              case "end":
                return _context79.stop();
            }
          }, _callee78, this, [[0, 7]]);
        }));
      }
    }, {
      key: "shouldSendVideoLayer",
      value: function shouldSendVideoLayer(e, t) {
        var i = this.getLayer();
        return this.degraded && e === j.NONE ? !0 : i === e ? (o.d("[Remote Track] ".concat(this.logIdentifier), "Not sending update, already on layer ".concat(e, ", source=").concat(t)), !1) : !0;
      }
    }, {
      key: "degraded",
      get: function get() {
        return this._degraded;
      }
    }, {
      key: "degradedAt",
      get: function get() {
        return this._degradedAt;
      }
    }]);
    return ve;
  }(Ne),
  xi = /*#__PURE__*/function () {
    function xi() {
      _classCallCheck(this, xi);
      this.history = [];
    }
    _createClass(xi, [{
      key: "push",
      value: function push(e) {
        e.time = new Date().toISOString().split("T")[1], this.history.push(e);
      }
    }]);
    return xi;
  }();
var Te = /*#__PURE__*/function (_Ae2) {
  _inherits(Te, _Ae2);
  function Te() {
    var _this27;
    _classCallCheck(this, Te);
    _this27 = _possibleConstructorReturn(this, _getPrototypeOf(Te).apply(this, arguments));
    _this27.TAG = "[HMSLocalStream]";
    _this27.connection = null;
    return _this27;
  }
  _createClass(Te, [{
    key: "setConnection",
    value: function setConnection(e) {
      this.connection = e;
    }
  }, {
    key: "addTransceiver",
    value: function addTransceiver(e, t) {
      var i = [];
      if (e instanceof Z) if (t.length > 0) o.v(this.TAG, "Simulcast enabled with layers", t), i.push.apply(i, _toConsumableArray(t));else {
        var s = {
          active: this.nativeStream.active
        };
        e.settings.maxBitrate && !me && (s.maxBitrate = e.settings.maxBitrate), i.push(s);
      }
      var r = this.connection.addTransceiver(e.getTrackBeingSent(), {
        streams: [this.nativeStream],
        direction: "sendonly",
        sendEncodings: i
      });
      return this.setPreferredCodec(r, e.nativeTrack.kind), r;
    }
  }, {
    key: "setMaxBitrateAndFramerate",
    value: function setMaxBitrateAndFramerate(e) {
      return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee79() {
        var t;
        return _regeneratorRuntime().wrap(function _callee79$(_context80) {
          while (1) switch (_context80.prev = _context80.next) {
            case 0:
              _context80.next = 2;
              return (t = this.connection) == null ? void 0 : t.setMaxBitrateAndFramerate(e);
            case 2:
            case "end":
              return _context80.stop();
          }
        }, _callee79, this);
      }));
    }
  }, {
    key: "setPreferredCodec",
    value: function setPreferredCodec(e, t) {}
  }, {
    key: "replaceTrack",
    value: function replaceTrack(e, t) {
      return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee80() {
        return _regeneratorRuntime().wrap(function _callee80$(_context81) {
          while (1) switch (_context81.prev = _context81.next) {
            case 0:
              _context81.next = 2;
              return this.replaceSenderTrack(e, t);
            case 2:
              e.stop();
              this.replaceStreamTrack(e, t);
            case 4:
            case "end":
              return _context81.stop();
          }
        }, _callee80, this);
      }));
    }
  }, {
    key: "replaceStreamTrack",
    value: function replaceStreamTrack(e, t) {
      this.nativeStream.addTrack(t), this.nativeStream.removeTrack(e);
    }
  }, {
    key: "replaceSenderTrack",
    value: function replaceSenderTrack(e, t) {
      return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee81() {
        var r, i;
        return _regeneratorRuntime().wrap(function _callee81$(_context82) {
          while (1) switch (_context82.prev = _context82.next) {
            case 0:
              i = (r = this.connection) == null ? void 0 : r.getSenders().find(function (s) {
                return s.track && s.track.id === e.id;
              });
              if (!(i === void 0)) {
                _context82.next = 4;
                break;
              }
              o.w(this.TAG, "No sender found for trackId=".concat(e.id));
              return _context82.abrupt("return");
            case 4:
              _context82.next = 6;
              return i.replaceTrack(t);
            case 6:
            case "end":
              return _context82.stop();
          }
        }, _callee81, this);
      }));
    }
  }, {
    key: "removeSender",
    value: function removeSender(e) {
      var _this28 = this;
      var i;
      var t = 0;
      (i = this.connection) == null || i.getSenders().forEach(function (r) {
        var s, n;
        if (((s = r.track) == null ? void 0 : s.id) === e.trackId || ((n = r.track) == null ? void 0 : n.id) === e.getTrackIDBeingSent()) {
          _this28.connection.removeTrack(r), t += 1;
          var d = _this28.tracks.indexOf(e);
          d !== -1 ? _this28.tracks.splice(d, 1) : o.e(_this28.TAG, "Cannot find ".concat(e.trackId, " in locally stored tracks"));
        }
      }), t !== 1 && o.e(this.TAG, "Removed ".concat(t, " sender's, expected to remove 1"));
    }
  }, {
    key: "hasSender",
    value: function hasSender(e) {
      var t;
      return !!((t = this.connection) == null ? void 0 : t.getSenders().find(function (i) {
        var r, s;
        return ((r = i.track) == null ? void 0 : r.id) === e.trackId || ((s = i.track) == null ? void 0 : s.id) === e.getTrackIDBeingSent();
      }));
    }
  }, {
    key: "trackUpdate",
    value: function trackUpdate(e) {
      var t;
      (t = this.connection) == null || t.trackUpdate(e);
    }
  }]);
  return Te;
}(Ae);
var Fi = {
    isAudioMuted: !1,
    isVideoMuted: !1,
    audioInputDeviceId: "default",
    audioOutputDeviceId: "default",
    videoDeviceId: "default"
  },
  Fe,
  ue = /*#__PURE__*/function () {
    function ue(e, t, i, r, s) {
      _classCallCheck(this, ue);
      this.store = e;
      this.observer = t;
      this.deviceManager = i;
      this.eventBus = r;
      this.analyticsTimer = s;
      this.TAG = "[LocalTrackManager]";
      this.setScreenCaptureHandleConfig();
    }
    _createClass(ue, [{
      key: "getTracksToPublish",
      value: function getTracksToPublish(e) {
        return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee82() {
          var t, i, r, s, _yield$this$updateCur, n, d, l, h, u, S;
          return _regeneratorRuntime().wrap(function _callee82$(_context83) {
            while (1) switch (_context83.prev = _context83.next) {
              case 0:
                t = this.getAVTrackSettings(e);
                if (t) {
                  _context83.next = 3;
                  break;
                }
                return _context83.abrupt("return", []);
              case 3:
                i = !!t.audio;
                r = !!t.video;
                s = [];
                _context83.next = 8;
                return this.updateCurrentLocalTrackSettings(t);
              case 8:
                _yield$this$updateCur = _context83.sent;
                n = _yield$this$updateCur.videoTrack;
                d = _yield$this$updateCur.audioTrack;
                l = (n == null ? void 0 : n.stream) || (d == null ? void 0 : d.stream);
                h = Boolean(n && this.store.getTrackById(n.trackId));
                u = Boolean(d && this.store.getTrackById(d.trackId));
                if (!(h && u)) {
                  _context83.next = 16;
                  break;
                }
                return _context83.abrupt("return", []);
              case 16:
                S = {
                  audio: i && !d && (e.isAudioMuted ? "empty" : !0),
                  video: r && !n && (e.isVideoMuted ? "empty" : !0)
                };
                this.analyticsTimer.start(M.LOCAL_AUDIO_TRACK), this.analyticsTimer.start(M.LOCAL_VIDEO_TRACK);
                _context83.prev = 18;
                o.d(this.TAG, "Init Local Tracks", {
                  fetchTrackOptions: S
                });
                _context83.next = 22;
                return this.getLocalTracks(S, t, l);
              case 22:
                s = _context83.sent;
                _context83.next = 30;
                break;
              case 25:
                _context83.prev = 25;
                _context83.t0 = _context83["catch"](18);
                _context83.next = 29;
                return this.retryGetLocalTracks(_context83.t0, t, S, l);
              case 29:
                s = _context83.sent;
              case 30:
                return _context83.abrupt("return", (this.analyticsTimer.end(M.LOCAL_AUDIO_TRACK), this.analyticsTimer.end(M.LOCAL_VIDEO_TRACK), n && r && !h && s.push(n), d && i && !u && s.push(d), s));
              case 31:
              case "end":
                return _context83.stop();
            }
          }, _callee82, this, [[18, 25]]);
        }));
      }
    }, {
      key: "getLocalTracks",
      value: function getLocalTracks() {
        return c(this, arguments, function () {
          var _this29 = this;
          var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
            audio: !0,
            video: !0
          };
          var t = arguments.length > 1 ? arguments[1] : undefined;
          var i = arguments.length > 2 ? arguments[2] : undefined;
          return /*#__PURE__*/_regeneratorRuntime().mark(function _callee83() {
            var _r4;
            return _regeneratorRuntime().wrap(function _callee83$(_context84) {
              while (1) switch (_context84.prev = _context84.next) {
                case 0:
                  _context84.prev = 0;
                  _context84.next = 3;
                  return _this29.getNativeLocalTracks(e, t);
                case 3:
                  _r4 = _context84.sent;
                  return _context84.abrupt("return", _this29.createHMSLocalTracks(_r4, t, i));
                case 7:
                  _context84.prev = 7;
                  _context84.t0 = _context84["catch"](0);
                  throw _this29.eventBus.analytics.publish(H.publish({
                    devices: _this29.deviceManager.getDevices(),
                    error: _context84.t0,
                    settings: t
                  })), _context84.t0;
                case 10:
                case "end":
                  return _context84.stop();
              }
            }, _callee83, null, [[0, 7]]);
          })();
        });
      }
    }, {
      key: "getNativeLocalTracks",
      value: function getNativeLocalTracks() {
        return c(this, arguments, function () {
          var _this30 = this;
          var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
            audio: !1,
            video: !1
          };
          var t = arguments.length > 1 ? arguments[1] : undefined;
          return /*#__PURE__*/_regeneratorRuntime().mark(function _callee84() {
            var i, r;
            return _regeneratorRuntime().wrap(function _callee84$(_context85) {
              while (1) switch (_context85.prev = _context85.next) {
                case 0:
                  i = new _e(e.video === !0 ? t.video : null, e.audio === !0 ? t.audio : null, t.simulcast), r = [];
                  _context85.t0 = i.audio || i.video;
                  if (!_context85.t0) {
                    _context85.next = 11;
                    break;
                  }
                  _context85.t1 = r.push;
                  _context85.t2 = r;
                  _context85.t3 = _toConsumableArray;
                  _context85.next = 8;
                  return _this30.getAVTracks(i);
                case 8:
                  _context85.t4 = _context85.sent;
                  _context85.t5 = (0, _context85.t3)(_context85.t4);
                  _context85.t1.apply.call(_context85.t1, _context85.t2, _context85.t5);
                case 11:
                  r.push.apply(r, _toConsumableArray(_this30.getEmptyTracks(e)));
                  return _context85.abrupt("return", r);
                case 13:
                case "end":
                  return _context85.stop();
              }
            }, _callee84);
          })();
        });
      }
    }, {
      key: "getLocalScreen",
      value: function getLocalScreen(e) {
        return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee85() {
          var S, t, i, r, g, s, E, n, d, l, h, _g, u, _g2;
          return _regeneratorRuntime().wrap(function _callee85$(_context86) {
            while (1) switch (_context86.prev = _context86.next) {
              case 0:
                _context86.next = 2;
                return this.getOrDefaultScreenshareConfig(e);
              case 2:
                t = _context86.sent;
                i = this.getScreenshareSettings(t.videoOnly);
                r = {
                  video: L(v({}, i == null ? void 0 : i.video.toConstraints(!0)), {
                    displaySurface: t.displaySurface
                  }),
                  preferCurrentTab: t.preferCurrentTab,
                  selfBrowserSurface: t.selfBrowserSurface,
                  surfaceSwitching: t.surfaceSwitching,
                  systemAudio: t.systemAudio
                };
                if (i == null ? void 0 : i.audio) {
                  g = (S = i == null ? void 0 : i.audio) == null ? void 0 : S.toConstraints();
                  delete g.advanced, r.audio = L(v({}, g), {
                    autoGainControl: !1,
                    noiseSuppression: !1,
                    googAutoGainControl: !1,
                    echoCancellation: !1
                  });
                }
                _context86.prev = 6;
                o.d("retrieving screenshare with ", {
                  config: t
                }, {
                  constraints: r
                });
                _context86.next = 10;
                return navigator.mediaDevices.getDisplayMedia(r);
              case 10:
                s = _context86.sent;
                _context86.next = 18;
                break;
              case 13:
                _context86.prev = 13;
                _context86.t0 = _context86["catch"](6);
                o.w(this.TAG, "error in getting screenshare - ", _context86.t0);
                E = ee(_context86.t0, K.SCREEN);
                throw this.eventBus.analytics.publish(H.publish({
                  error: E,
                  devices: this.deviceManager.getDevices(),
                  settings: new _e(i == null ? void 0 : i.video, i == null ? void 0 : i.audio, !1)
                })), E;
              case 18:
                n = [], d = new Te(s), l = s.getVideoTracks()[0], h = new Z(d, l, "screen", this.eventBus, i == null ? void 0 : i.video);
                h.setSimulcastDefinitons(this.store.getSimulcastDefinitionsForPeer(this.store.getLocalPeer(), "screen"));
                _context86.prev = 20;
                _g = this.validateCurrentTabCapture(h, t.forceCurrentTab);
                h.isCurrentTab = _g;
                _context86.next = 25;
                return h.cropTo(t.cropTarget);
              case 25:
                _context86.next = 30;
                break;
              case 27:
                _context86.prev = 27;
                _context86.t1 = _context86["catch"](20);
                throw s.getTracks().forEach(function (E) {
                  return E.stop();
                }), _context86.t1;
              case 30:
                n.push(h);
                u = s.getAudioTracks()[0];
                if (u) {
                  _g2 = new Ie(d, u, "screen", this.eventBus, i == null ? void 0 : i.audio);
                  n.push(_g2);
                }
                return _context86.abrupt("return", (o.v(this.TAG, "getLocalScreen", n), n));
              case 34:
              case "end":
                return _context86.stop();
            }
          }, _callee85, this, [[6, 13], [20, 27]]);
        }));
      }
    }, {
      key: "setScreenCaptureHandleConfig",
      value: function setScreenCaptureHandleConfig(e) {
        var t;
        !((t = navigator.mediaDevices) == null ? void 0 : t.setCaptureHandleConfig) || this.isInIframe() || (e = e || {}, Object.assign(e, {
          handle: kr(),
          exposeOrigin: !1,
          permittedOrigins: [window.location.origin]
        }), o.d("setting capture handle - ", e.handle), navigator.mediaDevices.setCaptureHandleConfig(e), this.captureHandleIdentifier = e.handle);
      }
    }, {
      key: "validateCurrentTabCapture",
      value: function validateCurrentTabCapture(e, t) {
        var i = e.getCaptureHandle(),
          r = !!(this.captureHandleIdentifier && (i == null ? void 0 : i.handle) === this.captureHandleIdentifier);
        if (t && !r) throw o.e(this.TAG, "current tab was not shared with forceCurrentTab as true"), m.TracksErrors.CurrentTabNotShared();
        return r;
      }
    }, {
      key: "requestPermissions",
      value: function requestPermissions() {
        return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee86() {
          return _regeneratorRuntime().wrap(function _callee86$(_context87) {
            while (1) switch (_context87.prev = _context87.next) {
              case 0:
                _context87.prev = 0;
                _context87.next = 3;
                return navigator.mediaDevices.getUserMedia({
                  audio: !0,
                  video: !0
                });
              case 3:
                _context87.sent.getTracks().forEach(function (t) {
                  return t.stop();
                });
                _context87.next = 9;
                break;
              case 6:
                _context87.prev = 6;
                _context87.t0 = _context87["catch"](0);
                o.e(this.TAG, _context87.t0);
              case 9:
              case "end":
                return _context87.stop();
            }
          }, _callee86, this, [[0, 6]]);
        }));
      }
    }, {
      key: "getAVTracks",
      value: function getAVTracks(e) {
        return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee87() {
          var _t2, _i4, _r5, s;
          return _regeneratorRuntime().wrap(function _callee87$(_context88) {
            while (1) switch (_context88.prev = _context88.next) {
              case 0:
                _context88.prev = 0;
                _context88.next = 3;
                return navigator.mediaDevices.getUserMedia({
                  audio: e.audio ? e.audio.toConstraints() : !1,
                  video: e.video ? e.video.toConstraints() : !1
                });
              case 3:
                _t2 = _context88.sent;
                return _context88.abrupt("return", _t2.getVideoTracks().concat(_t2.getAudioTracks()));
              case 7:
                _context88.prev = 7;
                _context88.t0 = _context88["catch"](0);
                _context88.next = 11;
                return this.deviceManager.init();
              case 11:
                _i4 = !!(!this.deviceManager.hasWebcamPermission && e.video), _r5 = !!(!this.deviceManager.hasMicrophonePermission && e.audio), s = this.getErrorType(_i4, _r5);
                throw ee(_context88.t0, s);
              case 13:
              case "end":
                return _context88.stop();
            }
          }, _callee87, this, [[0, 7]]);
        }));
      }
    }, {
      key: "getAVTrackSettings",
      value: function getAVTrackSettings(e) {
        var t = this.getAudioSettings(e),
          i = this.getVideoSettings(e);
        return !t && !i ? null : new je().video(i).audio(t).build();
      }
    }, {
      key: "isInIframe",
      value: function isInIframe() {
        try {
          return window.self !== window.top;
        } catch (e) {
          return !0;
        }
      }
    }, {
      key: "retryGetLocalTracks",
      value: function retryGetLocalTracks(e, t, i, r) {
        return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee88() {
          var s, n, d, l, u, S, g;
          return _regeneratorRuntime().wrap(function _callee88$(_context89) {
            while (1) switch (_context89.prev = _context89.next) {
              case 0:
                if (!(e instanceof T && e.action === p.TRACK)) {
                  _context89.next = 37;
                  break;
                }
                this.observer.onFailure(e);
                s = e.code === f.TracksErrors.OVER_CONSTRAINED, n = e.message.includes("audio"), d = e.message.includes("video");
                if (!s) {
                  _context89.next = 19;
                  break;
                }
                l = new je().video(new Me()).audio(new ye()).build();
                o.w(this.TAG, "Fetch AV Tracks failed with overconstrained error", {
                  fetchTrackOptions: i
                }, {
                  error: e
                });
                _context89.prev = 6;
                _context89.next = 9;
                return this.getLocalTracks(i, l, r);
              case 9:
                return _context89.abrupt("return", _context89.sent);
              case 12:
                _context89.prev = 12;
                _context89.t0 = _context89["catch"](6);
                u = _context89.t0 instanceof T ? _context89.t0.nativeError : _context89.t0, S = _context89.t0;
                if ((u == null ? void 0 : u.name) === "OverconstrainedError") {
                  g = m.TracksErrors.GenericTrack(p.TRACK, "Overconstrained error after dropping all constraints");
                  g.addNativeError(u), S = g;
                }
                _context89.next = 18;
                return this.retryGetLocalTracks(S, t, i, r);
              case 18:
                return _context89.abrupt("return", _context89.sent);
              case 19:
                i.audio = n ? "empty" : i.audio, i.video = d ? "empty" : i.video, o.w(this.TAG, "Fetch AV Tracks failed", {
                  fetchTrackOptions: i
                }, e);
                _context89.prev = 20;
                _context89.next = 23;
                return this.getLocalTracks(i, t, r);
              case 23:
                return _context89.abrupt("return", _context89.sent);
              case 26:
                _context89.prev = 26;
                _context89.t1 = _context89["catch"](20);
                o.w(this.TAG, "Fetch empty tacks failed", _context89.t1);
                i.audio = i.audio && "empty";
                i.video = i.video && "empty";
                this.observer.onFailure(_context89.t1);
                _context89.next = 34;
                return this.getLocalTracks(i, t, r);
              case 34:
                return _context89.abrupt("return", _context89.sent);
              case 35:
                _context89.next = 38;
                break;
              case 37:
                return _context89.abrupt("return", (o.w(this.TAG, "Fetch AV Tracks failed - unknown exception", e), this.observer.onFailure(e), []));
              case 38:
              case "end":
                return _context89.stop();
            }
          }, _callee88, this, [[6, 12], [20, 26]]);
        }));
      }
    }, {
      key: "getErrorType",
      value: function getErrorType(e, t) {
        return e && t ? K.AV : e ? K.VIDEO : t ? K.AUDIO : K.UNKNOWN;
      }
    }, {
      key: "getEmptyTracks",
      value: function getEmptyTracks(e) {
        var t = [];
        return e.audio === "empty" && t.push(ue.getEmptyAudioTrack()), e.video === "empty" && t.push(ue.getEmptyVideoTrack()), t;
      }
    }, {
      key: "updateCurrentLocalTrackSettings",
      value: function updateCurrentLocalTrackSettings(e) {
        return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee89() {
          var t, i, r;
          return _regeneratorRuntime().wrap(function _callee89$(_context90) {
            while (1) switch (_context90.prev = _context90.next) {
              case 0:
                t = this.store.getLocalPeerTracks(), i = t.find(function (s) {
                  return s.type === F.VIDEO && s.source === "regular";
                }), r = t.find(function (s) {
                  return s.type === F.AUDIO && s.source === "regular";
                });
                _context90.t0 = e == null ? void 0 : e.video;
                if (!_context90.t0) {
                  _context90.next = 5;
                  break;
                }
                _context90.next = 5;
                return i == null ? void 0 : i.setSettings(e.video);
              case 5:
                _context90.t1 = e == null ? void 0 : e.audio;
                if (!_context90.t1) {
                  _context90.next = 9;
                  break;
                }
                _context90.next = 9;
                return r == null ? void 0 : r.setSettings(e.audio);
              case 9:
                return _context90.abrupt("return", {
                  videoTrack: i,
                  audioTrack: r
                });
              case 10:
              case "end":
                return _context90.stop();
            }
          }, _callee89, this);
        }));
      }
    }, {
      key: "getAudioSettings",
      value: function getAudioSettings(e) {
        var n;
        var t = this.store.getPublishParams();
        if (!t || !((n = t.allowed) == null ? void 0 : n.includes("audio"))) return null;
        var i = this.store.getLocalPeer(),
          r = i == null ? void 0 : i.audioTrack,
          s = (r == null ? void 0 : r.settings.deviceId) || e.audioInputDeviceId;
        return new z().codec(t.audio.codec).maxBitrate(t.audio.bitRate).deviceId(s || Fi.audioInputDeviceId).build();
      }
    }, {
      key: "getVideoSettings",
      value: function getVideoSettings(e) {
        var d;
        var t = this.store.getPublishParams();
        if (!t || !((d = t.allowed) == null ? void 0 : d.includes("video"))) return null;
        var i = this.store.getLocalPeer(),
          r = i == null ? void 0 : i.videoTrack,
          s = (r == null ? void 0 : r.settings.deviceId) || e.videoDeviceId,
          n = t.video;
        return new J().codec(n.codec).maxBitrate(n.bitRate).maxFramerate(n.frameRate).setWidth(n.width).setHeight(n.height).deviceId(s || Fi.videoDeviceId).build();
      }
    }, {
      key: "getScreenshareSettings",
      value: function getScreenshareSettings() {
        var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
        var r;
        var t = this.store.getPublishParams();
        if (!t || !((r = t.allowed) == null ? void 0 : r.includes("screen"))) return null;
        var i = t.screen;
        return {
          video: new J().maxBitrate(i.bitRate, !1).codec(i.codec).maxFramerate(i.frameRate).setWidth(i.width).setHeight(i.height).build(),
          audio: e ? void 0 : new z().build()
        };
      }
    }, {
      key: "getOrDefaultScreenshareConfig",
      value: function getOrDefaultScreenshareConfig(e) {
        return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee90() {
          var i, t;
          return _regeneratorRuntime().wrap(function _callee90$(_context91) {
            while (1) switch (_context91.prev = _context91.next) {
              case 0:
                t = Object.assign({
                  videoOnly: !1,
                  audioOnly: !1,
                  forceCurrentTab: !1,
                  preferCurrentTab: !1,
                  selfBrowserSurface: "exclude",
                  surfaceSwitching: "include",
                  systemAudio: "exclude",
                  displaySurface: "monitor"
                }, e || {});
                t.forceCurrentTab && (t.videoOnly = !0, t.preferCurrentTab = !0, t.selfBrowserSurface = "include", t.surfaceSwitching = "exclude");
                t.preferCurrentTab && (t.selfBrowserSurface = "include", t.displaySurface = void 0);
                _context91.t0 = t.cropElement && ((i = window.CropTarget) == null ? void 0 : i.fromElement);
                if (!_context91.t0) {
                  _context91.next = 8;
                  break;
                }
                _context91.next = 7;
                return window.CropTarget.fromElement(t.cropElement);
              case 7:
                t.cropTarget = _context91.sent;
              case 8:
                return _context91.abrupt("return", t);
              case 9:
              case "end":
                return _context91.stop();
            }
          }, _callee90);
        }));
      }
    }, {
      key: "createHMSLocalTracks",
      value: function createHMSLocalTracks(e, t, i) {
        var r = e.find(function (d) {
            return d.kind === "video";
          }),
          s = e.find(function (d) {
            return d.kind === "audio";
          });
        i ? e.forEach(function (d) {
          return i == null ? void 0 : i.nativeStream.addTrack(d);
        }) : i = new Te(new MediaStream(e));
        var n = [];
        if (s && (t == null ? void 0 : t.audio)) {
          var d = new Ie(i, s, "regular", this.eventBus, t.audio);
          n.push(d);
        }
        if (r && (t == null ? void 0 : t.video)) {
          var _d = new Z(i, r, "regular", this.eventBus, t.video);
          _d.setSimulcastDefinitons(this.store.getSimulcastDefinitionsForPeer(this.store.getLocalPeer(), "regular")), n.push(_d);
        }
        return n;
      }
    }], [{
      key: "getEmptyVideoTrack",
      value: function getEmptyVideoTrack(e) {
        var l, h, u;
        var t = ((l = e == null ? void 0 : e.getSettings()) == null ? void 0 : l.width) || 320,
          i = ((h = e == null ? void 0 : e.getSettings()) == null ? void 0 : h.height) || 240,
          r = 10;
        Fe || (Fe = Object.assign(document.createElement("canvas"), {
          width: t,
          height: i
        }), (u = Fe.getContext("2d")) == null || u.fillRect(0, 0, t, i));
        var n = Fe.captureStream(r).getVideoTracks()[0],
          d = setInterval(function () {
            if (n.readyState === "ended") {
              clearInterval(d);
              return;
            }
            var S = Fe.getContext("2d");
            if (S) {
              var E = S.getImageData(0, 0, 1, 1).data[0] === 0 ? 1 : 0;
              S.fillStyle = "rgb(".concat(E, ", 0, 0)"), S.fillRect(0, 0, 1, 1);
            }
          }, 1e3 / r);
        return n.onended = function () {
          clearInterval(d);
        }, n.enabled = !1, n;
      }
    }, {
      key: "getEmptyAudioTrack",
      value: function getEmptyAudioTrack() {
        var e = le.getAudioContext(),
          t = e.createOscillator(),
          i = e.createMediaStreamDestination();
        t.connect(i), t.start();
        var r = i.stream.getAudioTracks()[0];
        return r.enabled = !1, r;
      }
    }]);
    return ue;
  }();
var Lt = /*#__PURE__*/function () {
  function Lt(e, t) {
    var _this31 = this;
    _classCallCheck(this, Lt);
    this.eventBus = e;
    this.listener = t;
    this.TAG = "[NetworkTestManager]";
    this.controller = new AbortController();
    this.start = function (e) {
      return c(_this31, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee92() {
        var _this32 = this;
        var h, t, i, r, s, n, d, l, S, g;
        return _regeneratorRuntime().wrap(function _callee92$(_context93) {
          while (1) switch (_context93.prev = _context93.next) {
            case 0:
              if (e) {
                _context93.next = 2;
                break;
              }
              return _context93.abrupt("return");
            case 2:
              t = e.url, i = e.timeout, r = e.scoreMap, s = this.controller.signal, n = Date.now(), d = 0, l = $(i).then(function () {
                _this32.controller.abort();
              });
              _context93.prev = 3;
              _context93.next = 6;
              return fetch("".concat(t, "?").concat(Date.now()), {
                signal: s
              });
            case 6:
              _context93.t0 = h = _context93.sent.body;
              if (!(_context93.t0 == null)) {
                _context93.next = 11;
                break;
              }
              _context93.t1 = void 0;
              _context93.next = 12;
              break;
            case 11:
              _context93.t1 = h.getReader();
            case 12:
              S = _context93.t1;
              if (S) {
                _context93.next = 15;
                break;
              }
              throw Error("unable to process request");
            case 15:
              g = function g() {
                return c(_this32, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee91() {
                  var E, _yield$S$read, N, O;
                  return _regeneratorRuntime().wrap(function _callee91$(_context92) {
                    while (1) switch (_context92.prev = _context92.next) {
                      case 0:
                        if (!S) {
                          _context92.next = 17;
                          break;
                        }
                        _context92.prev = 1;
                        E = !1;
                      case 3:
                        if (E) {
                          _context92.next = 12;
                          break;
                        }
                        _context92.next = 6;
                        return S.read();
                      case 6:
                        _yield$S$read = _context92.sent;
                        N = _yield$S$read.value;
                        O = _yield$S$read.done;
                        E = O, N && (d += N.byteLength, this.sendScore({
                          scoreMap: r,
                          downloadedSize: d,
                          startTime: n
                        }));
                      case 10:
                        _context92.next = 3;
                        break;
                      case 12:
                        _context92.next = 17;
                        break;
                      case 14:
                        _context92.prev = 14;
                        _context92.t0 = _context92["catch"](1);
                        _context92.t0.name !== "AbortError" && o.e(this.TAG, _context92.t0);
                      case 17:
                      case "end":
                        return _context92.stop();
                    }
                  }, _callee91, this, [[1, 14]]);
                }));
              };
              return _context93.abrupt("return", Promise.race([g(), l]).then(function () {
                _this32.sendScore({
                  scoreMap: r,
                  downloadedSize: d,
                  startTime: n,
                  finished: !0
                });
              }).catch(function (E) {
                o.e(_this32.TAG, E), _this32.updateScoreToListener(0), _this32.eventBus.analytics.publish(H.previewNetworkQuality({
                  error: E.message
                }));
              }));
            case 19:
              _context93.prev = 19;
              _context93.t2 = _context93["catch"](3);
              _context93.t2.name !== "AbortError" ? (o.e(this.TAG, _context93.t2), this.updateScoreToListener(0), this.eventBus.analytics.publish(H.previewNetworkQuality({
                error: _context93.t2.message
              }))) : o.d(this.TAG, _context93.t2);
            case 22:
            case "end":
              return _context93.stop();
          }
        }, _callee92, this, [[3, 19]]);
      }));
    };
    this.stop = function () {
      _this31.controller.signal.aborted || _this31.controller.abort();
    };
    this.sendScore = function (_ref9) {
      var e = _ref9.scoreMap,
        t = _ref9.downloadedSize,
        i = _ref9.startTime,
        _ref9$finished = _ref9.finished,
        r = _ref9$finished === void 0 ? !1 : _ref9$finished;
      var s = (Date.now() - i) / 1e3,
        d = t / 1024 / s * 8,
        l = -1;
      for (var h in e) {
        var u = e[h];
        d >= u.low && (!u.high || d <= u.high) && (l = Number(h));
      }
      _this31.updateScoreToListener(l), r && _this31.eventBus.analytics.publish(H.previewNetworkQuality({
        score: l,
        downLink: d.toFixed(2)
      }));
    };
  }
  _createClass(Lt, [{
    key: "updateScoreToListener",
    value: function updateScoreToListener(e) {
      var t, i;
      e !== this.score && (this.score = e, (i = (t = this.listener) == null ? void 0 : t.onNetworkQuality) == null || i.call(t, e));
    }
  }]);
  return Lt;
}();
var rt = /*#__PURE__*/function () {
  function rt(e, t, i, r, s) {
    var _this33 = this;
    _classCallCheck(this, rt);
    this.store = e;
    this.transport = t;
    this.publish = i;
    this.removeAuxiliaryTrack = r;
    this.listener = s;
    this.handleLocalPeerRoleUpdate = function (i) {
      return c(_this33, [i], function (_ref10) {
        var _this34 = this;
        var e = _ref10.oldRole,
          t = _ref10.newRole;
        return /*#__PURE__*/_regeneratorRuntime().mark(function _callee93() {
          var s, r;
          return _regeneratorRuntime().wrap(function _callee93$(_context94) {
            while (1) switch (_context94.prev = _context94.next) {
              case 0:
                r = _this34.store.getLocalPeer();
                _context94.t0 = !r;
                if (_context94.t0) {
                  _context94.next = 6;
                  break;
                }
                _context94.next = 5;
                return _this34.diffRolesAndPublishTracks({
                  oldRole: e,
                  newRole: t
                });
              case 5:
                (s = _this34.listener) == null || s.onPeerUpdate(q.ROLE_UPDATED, r);
              case 6:
              case "end":
                return _context94.stop();
            }
          }, _callee93);
        })();
      });
    };
    this.diffRolesAndPublishTracks = function (i) {
      return c(_this33, [i], function (_ref11) {
        var _this35 = this;
        var e = _ref11.oldRole,
          t = _ref11.newRole;
        return /*#__PURE__*/_regeneratorRuntime().mark(function _callee94() {
          var g, E, N, O, I, r, s, n, d, l, h, u, S;
          return _regeneratorRuntime().wrap(function _callee94$(_context95) {
            while (1) switch (_context95.prev = _context95.next) {
              case 0:
                r = new Set(e.publishParams.allowed), s = new Set(t.publishParams.allowed), n = _this35.removeTrack(r, s, "video"), d = _this35.hasSimulcastDifference((g = e.publishParams.simulcast) == null ? void 0 : g.video, (E = t.publishParams.simulcast) == null ? void 0 : E.video), l = _this35.removeTrack(r, s, "audio"), h = _this35.removeTrack(r, s, "screen"), u = _this35.hasSimulcastDifference((N = e.publishParams.simulcast) == null ? void 0 : N.screen, (O = t.publishParams.simulcast) == null ? void 0 : O.screen);
                _context95.next = 3;
                return _this35.removeAudioTrack(l);
              case 3:
                _context95.next = 5;
                return _this35.removeVideoTracks(n || d);
              case 5:
                _context95.next = 7;
                return _this35.removeScreenTracks(h || u);
              case 7:
                S = ((I = _this35.store.getConfig()) == null ? void 0 : I.settings) || {
                  isAudioMuted: !0,
                  isVideoMuted: !0,
                  audioInputDeviceId: "default",
                  videoDeviceId: "default",
                  audioOutputDeviceId: "default"
                };
                _context95.next = 10;
                return _this35.publish(L(v({}, S), {
                  isAudioMuted: !0,
                  isVideoMuted: !0
                }));
              case 10:
              case "end":
                return _context95.stop();
            }
          }, _callee94);
        })();
      });
    };
  }
  _createClass(rt, [{
    key: "removeVideoTracks",
    value: function removeVideoTracks(e) {
      return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee95() {
        var i, t;
        return _regeneratorRuntime().wrap(function _callee95$(_context96) {
          while (1) switch (_context96.prev = _context96.next) {
            case 0:
              if (e) {
                _context96.next = 2;
                break;
              }
              return _context96.abrupt("return");
            case 2:
              t = this.store.getLocalPeer();
              _context96.t0 = t == null ? void 0 : t.videoTrack;
              if (!_context96.t0) {
                _context96.next = 14;
                break;
              }
              if (!t.videoTrack.isPublished) {
                _context96.next = 10;
                break;
              }
              _context96.next = 8;
              return this.transport.unpublish([t.videoTrack]);
            case 8:
              _context96.next = 12;
              break;
            case 10:
              _context96.next = 12;
              return t.videoTrack.cleanup();
            case 12:
              (i = this.listener) == null || i.onTrackUpdate(D.TRACK_REMOVED, t.videoTrack, t);
              t.videoTrack = void 0;
            case 14:
              _context96.next = 16;
              return this.removeAuxTracks(function (r) {
                return r.source !== "screen" && r.type === "video";
              });
            case 16:
            case "end":
              return _context96.stop();
          }
        }, _callee95, this);
      }));
    }
  }, {
    key: "removeAudioTrack",
    value: function removeAudioTrack(e) {
      return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee96() {
        var i, t;
        return _regeneratorRuntime().wrap(function _callee96$(_context97) {
          while (1) switch (_context97.prev = _context97.next) {
            case 0:
              if (e) {
                _context97.next = 2;
                break;
              }
              return _context97.abrupt("return");
            case 2:
              t = this.store.getLocalPeer();
              _context97.t0 = t == null ? void 0 : t.audioTrack;
              if (!_context97.t0) {
                _context97.next = 14;
                break;
              }
              if (!t.audioTrack.isPublished) {
                _context97.next = 10;
                break;
              }
              _context97.next = 8;
              return this.transport.unpublish([t.audioTrack]);
            case 8:
              _context97.next = 12;
              break;
            case 10:
              _context97.next = 12;
              return t.audioTrack.cleanup();
            case 12:
              (i = this.listener) == null || i.onTrackUpdate(D.TRACK_REMOVED, t.audioTrack, t);
              t.audioTrack = void 0;
            case 14:
              _context97.next = 16;
              return this.removeAuxTracks(function (r) {
                return r.source !== "screen" && r.type === "audio";
              });
            case 16:
            case "end":
              return _context97.stop();
          }
        }, _callee96, this);
      }));
    }
  }, {
    key: "removeScreenTracks",
    value: function removeScreenTracks(e) {
      return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee97() {
        return _regeneratorRuntime().wrap(function _callee97$(_context98) {
          while (1) switch (_context98.prev = _context98.next) {
            case 0:
              _context98.t0 = !e;
              if (_context98.t0) {
                _context98.next = 4;
                break;
              }
              _context98.next = 4;
              return this.removeAuxTracks(function (t) {
                return t.source === "screen";
              });
            case 4:
            case "end":
              return _context98.stop();
          }
        }, _callee97, this);
      }));
    }
  }, {
    key: "removeAuxTracks",
    value: function removeAuxTracks(e) {
      return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee98() {
        var t, _i5, _iterator7, _step7, _r6;
        return _regeneratorRuntime().wrap(function _callee98$(_context99) {
          while (1) switch (_context99.prev = _context99.next) {
            case 0:
              t = this.store.getLocalPeer();
              if (!(t == null ? void 0 : t.auxiliaryTracks)) {
                _context99.next = 22;
                break;
              }
              _i5 = _toConsumableArray(t.auxiliaryTracks);
              _iterator7 = _createForOfIteratorHelper(_i5);
              _context99.prev = 4;
              _iterator7.s();
            case 6:
              if ((_step7 = _iterator7.n()).done) {
                _context99.next = 14;
                break;
              }
              _r6 = _step7.value;
              _context99.t0 = e(_r6);
              if (!_context99.t0) {
                _context99.next = 12;
                break;
              }
              _context99.next = 12;
              return this.removeAuxiliaryTrack(_r6.trackId);
            case 12:
              _context99.next = 6;
              break;
            case 14:
              _context99.next = 19;
              break;
            case 16:
              _context99.prev = 16;
              _context99.t1 = _context99["catch"](4);
              _iterator7.e(_context99.t1);
            case 19:
              _context99.prev = 19;
              _iterator7.f();
              return _context99.finish(19);
            case 22:
            case "end":
              return _context99.stop();
          }
        }, _callee98, this, [[4, 16, 19, 22]]);
      }));
    }
  }, {
    key: "removeTrack",
    value: function removeTrack(e, t, i) {
      return e.has(i) && !t.has(i);
    }
  }, {
    key: "hasSimulcastDifference",
    value: function hasSimulcastDifference(e, t) {
      var i, r;
      return !e && !t ? !1 : ((i = e == null ? void 0 : e.layers) == null ? void 0 : i.length) !== ((r = t == null ? void 0 : t.layers) == null ? void 0 : r.length);
    }
  }]);
  return rt;
}();
var Ui = /*#__PURE__*/function () {
    function Ui() {
      _classCallCheck(this, Ui);
      this.TAG = "[HTTPAnalyticsTransport]";
      this.failedEvents = new te("client-events");
      this.isConnected = !0;
      this.env = null;
      this.websocketURL = "";
    }
    _createClass(Ui, [{
      key: "setEnv",
      value: function setEnv(e) {
        this.env = e, this.flushFailedEvents();
      }
    }, {
      key: "setWebsocketEndpoint",
      value: function setWebsocketEndpoint(e) {
        this.websocketURL = e;
      }
    }, {
      key: "sendEvent",
      value: function sendEvent(e) {
        var _this36 = this;
        if (!this.env || !this.websocketURL) {
          this.addEventToStorage(e);
          return;
        }
        var t = {
            event: e.name,
            payload: e.properties,
            event_id: String(e.timestamp),
            peer: e.metadata.peer,
            timestamp: e.timestamp,
            device_id: e.device_id,
            cluster: {
              websocket_url: this.websocketURL
            }
          },
          i = this.env === W.PROD ? Di : Ni;
        fetch(i, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer ".concat(e.metadata.token),
            user_agent_v2: e.metadata.userAgent
          },
          body: JSON.stringify(t)
        }).then(function (r) {
          if (r.status === 401) {
            _this36.removeFromStorage(e);
            return;
          }
          if (r.status !== 200) throw Error(r.statusText);
          _this36.removeFromStorage(e);
        }).catch(function (r) {
          o.v(_this36.TAG, "Failed to send event", r, e), _this36.addEventToStorage(e);
        });
      }
    }, {
      key: "flushFailedEvents",
      value: function flushFailedEvents() {
        var _this37 = this;
        var e = this.failedEvents.get();
        e == null || e.forEach(function (t) {
          return _this37.sendEvent(t);
        });
      }
    }, {
      key: "addEventToStorage",
      value: function addEventToStorage(e) {
        var t = this.failedEvents.get() || [];
        t.find(function (i) {
          return i.timestamp === e.timestamp;
        }) || (t.length === Oi && t.shift(), t.push(e), this.failedEvents.set(t));
      }
    }, {
      key: "removeFromStorage",
      value: function removeFromStorage(e) {
        var t = this.failedEvents.get() || [],
          i = t.findIndex(function (r) {
            return r.timestamp === e.timestamp;
          });
        i > -1 && (t.splice(i, 1), this.failedEvents.set(t));
      }
    }]);
    return Ui;
  }(),
  se = new Ui();
var st = /*#__PURE__*/function () {
  function st() {
    _classCallCheck(this, st);
    this.knownRoles = {};
    this.peers = {};
    this.tracks = {};
    this.peerTrackStates = {};
    this.speakers = [];
    this.roleDetailsArrived = !1;
    this.env = W.PROD;
    this.simulcastEnabled = !1;
    this.userAgent = Le(this.env);
  }
  _createClass(st, [{
    key: "getConfig",
    value: function getConfig() {
      return this.config;
    }
  }, {
    key: "setSimulcastEnabled",
    value: function setSimulcastEnabled(e) {
      this.simulcastEnabled = e;
    }
  }, {
    key: "getEnv",
    value: function getEnv() {
      return this.env;
    }
  }, {
    key: "getPublishParams",
    value: function getPublishParams() {
      var e = this.getLocalPeer(),
        t = (e == null ? void 0 : e.asRole) || (e == null ? void 0 : e.role);
      return t == null ? void 0 : t.publishParams;
    }
  }, {
    key: "getRoom",
    value: function getRoom() {
      return this.room;
    }
  }, {
    key: "getPolicyForRole",
    value: function getPolicyForRole(e) {
      return this.knownRoles[e];
    }
  }, {
    key: "getKnownRoles",
    value: function getKnownRoles() {
      return this.knownRoles;
    }
  }, {
    key: "getLocalPeer",
    value: function getLocalPeer() {
      if (this.localPeerId && this.peers[this.localPeerId]) return this.peers[this.localPeerId];
    }
  }, {
    key: "getRemotePeers",
    value: function getRemotePeers() {
      return Object.values(this.peers).filter(function (e) {
        return !e.isLocal;
      });
    }
  }, {
    key: "getPeers",
    value: function getPeers() {
      return Object.values(this.peers);
    }
  }, {
    key: "getPeerById",
    value: function getPeerById(e) {
      if (this.peers[e]) return this.peers[e];
    }
  }, {
    key: "getTracksMap",
    value: function getTracksMap() {
      return this.tracks;
    }
  }, {
    key: "getTracks",
    value: function getTracks() {
      return Object.values(this.tracks);
    }
  }, {
    key: "getVideoTracks",
    value: function getVideoTracks() {
      return this.getTracks().filter(function (e) {
        return e.type === F.VIDEO;
      });
    }
  }, {
    key: "getRemoteVideoTracks",
    value: function getRemoteVideoTracks() {
      return this.getTracks().filter(function (e) {
        return e instanceof ve;
      });
    }
  }, {
    key: "getAudioTracks",
    value: function getAudioTracks() {
      return this.getTracks().filter(function (e) {
        return e.type === F.AUDIO;
      });
    }
  }, {
    key: "getPeerTracks",
    value: function getPeerTracks(e) {
      var t = e ? this.peers[e] : void 0,
        i = [];
      return (t == null ? void 0 : t.videoTrack) && i.push(t.videoTrack), (t == null ? void 0 : t.audioTrack) && i.push(t.audioTrack), i.concat((t == null ? void 0 : t.auxiliaryTracks) || []);
    }
  }, {
    key: "getLocalPeerTracks",
    value: function getLocalPeerTracks() {
      return this.getPeerTracks(this.localPeerId);
    }
  }, {
    key: "getTrackById",
    value: function getTrackById(e) {
      var r, s;
      var t = this.tracks[e];
      if (t) return t;
      var i = this.getLocalPeer();
      if (i) {
        if ((r = i.audioTrack) == null ? void 0 : r.isPublishedTrackId(e)) return i.audioTrack;
        if ((s = i.videoTrack) == null ? void 0 : s.isPublishedTrackId(e)) return i.videoTrack;
      }
    }
  }, {
    key: "getPeerByTrackId",
    value: function getPeerByTrackId(e) {
      var t = this.tracks[e];
      return t.peerId ? this.peers[t.peerId] : void 0;
    }
  }, {
    key: "getSpeakers",
    value: function getSpeakers() {
      return this.speakers;
    }
  }, {
    key: "getSpeakerPeers",
    value: function getSpeakerPeers() {
      return this.speakers.map(function (e) {
        return e.peer;
      });
    }
  }, {
    key: "getUserAgent",
    value: function getUserAgent() {
      return this.userAgent;
    }
  }, {
    key: "createAndSetUserAgent",
    value: function createAndSetUserAgent(e) {
      this.userAgent = Le(this.env, e);
    }
  }, {
    key: "setRoom",
    value: function setRoom(e) {
      this.room = e;
    }
  }, {
    key: "setKnownRoles",
    value: function setKnownRoles(e) {
      var i, r;
      if (this.knownRoles = e.known_roles, this.roleDetailsArrived = !0, !this.simulcastEnabled) return;
      var t = (i = this.knownRoles[e.name]) == null ? void 0 : i.publishParams;
      this.videoLayers = this.convertSimulcastLayers((r = t.simulcast) == null ? void 0 : r.video), this.updatePeersPolicy();
    }
  }, {
    key: "hasRoleDetailsArrived",
    value: function hasRoleDetailsArrived() {
      return this.roleDetailsArrived;
    }
  }, {
    key: "setConfig",
    value: function setConfig(e) {
      var t, i, r;
      if (Q.rememberDevices(Boolean(e.rememberDeviceSelection)), e.rememberDeviceSelection) {
        var s = Q.getSelection();
        s && (e.settings || (e.settings = {}), ((t = s.audioInput) == null ? void 0 : t.deviceId) && (e.settings.audioInputDeviceId = e.settings.audioInputDeviceId || s.audioInput.deviceId), ((i = s.audioOutput) == null ? void 0 : i.deviceId) && (e.settings.audioOutputDeviceId = e.settings.audioOutputDeviceId || s.audioOutput.deviceId), ((r = s.videoInput) == null ? void 0 : r.deviceId) && (e.settings.videoDeviceId = e.settings.videoDeviceId || s.videoInput.deviceId));
      }
      this.config = e, this.setEnv();
    }
  }, {
    key: "addPeer",
    value: function addPeer(e) {
      this.peers[e.peerId] = e, e.isLocal && (this.localPeerId = e.peerId);
    }
  }, {
    key: "addTrack",
    value: function addTrack(e) {
      this.tracks[e.trackId] = e;
    }
  }, {
    key: "getTrackState",
    value: function getTrackState(e) {
      return this.peerTrackStates[e];
    }
  }, {
    key: "setTrackState",
    value: function setTrackState(e) {
      this.peerTrackStates[e.trackInfo.track_id] = e;
    }
  }, {
    key: "removePeer",
    value: function removePeer(e) {
      this.localPeerId === e && (this.localPeerId = void 0), delete this.peers[e];
    }
  }, {
    key: "removeTrack",
    value: function removeTrack(e) {
      delete this.tracks[e];
    }
  }, {
    key: "updateSpeakers",
    value: function updateSpeakers(e) {
      this.speakers = e;
    }
  }, {
    key: "updateAudioOutputVolume",
    value: function updateAudioOutputVolume(e) {
      return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee99() {
        var _iterator8, _step8, _t3;
        return _regeneratorRuntime().wrap(function _callee99$(_context100) {
          while (1) switch (_context100.prev = _context100.next) {
            case 0:
              _iterator8 = _createForOfIteratorHelper(this.getAudioTracks());
              _context100.prev = 1;
              _iterator8.s();
            case 3:
              if ((_step8 = _iterator8.n()).done) {
                _context100.next = 9;
                break;
              }
              _t3 = _step8.value;
              _context100.next = 7;
              return _t3.setVolume(e);
            case 7:
              _context100.next = 3;
              break;
            case 9:
              _context100.next = 14;
              break;
            case 11:
              _context100.prev = 11;
              _context100.t0 = _context100["catch"](1);
              _iterator8.e(_context100.t0);
            case 14:
              _context100.prev = 14;
              _iterator8.f();
              return _context100.finish(14);
            case 17:
            case "end":
              return _context100.stop();
          }
        }, _callee99, this, [[1, 11, 14, 17]]);
      }));
    }
  }, {
    key: "updateAudioOutputDevice",
    value: function updateAudioOutputDevice(e) {
      return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee100() {
        var t;
        return _regeneratorRuntime().wrap(function _callee100$(_context101) {
          while (1) switch (_context101.prev = _context101.next) {
            case 0:
              t = [];
              this.getAudioTracks().forEach(function (i) {
                t.push(i.setOutputDevice(e));
              });
              _context101.next = 4;
              return Promise.all(t);
            case 4:
            case "end":
              return _context101.stop();
          }
        }, _callee100, this);
      }));
    }
  }, {
    key: "getSimulcastLayers",
    value: function getSimulcastLayers(e) {
      var t;
      return this.simulcastEnabled ? e === "screen" ? [] : ((t = this.videoLayers) == null ? void 0 : t.layers) || [] : [];
    }
  }, {
    key: "convertSimulcastLayers",
    value: function convertSimulcastLayers(e) {
      if (!!e) return L(v({}, e), {
        layers: (e.layers || []).map(function (t) {
          return L(v({}, t), {
            maxBitrate: t.maxBitrate * 1e3
          });
        })
      });
    }
  }, {
    key: "getSimulcastDefinitionsForPeer",
    value: function getSimulcastDefinitionsForPeer(e, t) {
      var d, l, h;
      if ([!e || !e.role, t === "screen", !this.simulcastEnabled].some(function (u) {
        return !!u;
      })) return [];
      var i = this.getPolicyForRole(e.role.name).publishParams,
        r,
        s,
        n;
      return t === "regular" ? (r = (d = i.simulcast) == null ? void 0 : d.video, s = i.video.width, n = i.video.height) : t === "screen" && (r = (l = i.simulcast) == null ? void 0 : l.screen, s = i.screen.width, n = i.screen.height), ((h = r == null ? void 0 : r.layers) == null ? void 0 : h.map(function (u) {
        var S = Pt[u.rid],
          g = {
            width: s / u.scaleResolutionDownBy,
            height: n / u.scaleResolutionDownBy
          };
        return {
          layer: S,
          resolution: g
        };
      })) || [];
    }
  }, {
    key: "getErrorListener",
    value: function getErrorListener() {
      return this.errorListener;
    }
  }, {
    key: "cleanUp",
    value: function cleanUp() {
      var e = this.getTracks();
      var _iterator9 = _createForOfIteratorHelper(e),
        _step9;
      try {
        for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
          var _t4 = _step9.value;
          _t4.cleanup();
        }
      } catch (err) {
        _iterator9.e(err);
      } finally {
        _iterator9.f();
      }
      this.room = void 0, this.config = void 0, this.localPeerId = void 0, this.roleDetailsArrived = !1;
    }
  }, {
    key: "setErrorListener",
    value: function setErrorListener(e) {
      this.errorListener = e;
    }
  }, {
    key: "updatePeersPolicy",
    value: function updatePeersPolicy() {
      var _this38 = this;
      this.getPeers().forEach(function (e) {
        var t;
        if (!e.role) {
          (t = _this38.errorListener) == null || t.onError(m.GenericErrors.InvalidRole(p.VALIDATION, ""));
          return;
        }
        e.role = _this38.getPolicyForRole(e.role.name);
      });
    }
  }, {
    key: "setEnv",
    value: function setEnv() {
      var r;
      var t = ((r = this.config) == null ? void 0 : r.initEndpoint).split("https://")[1],
        i = W.PROD;
      t.startsWith(W.PROD) ? i = W.PROD : t.startsWith(W.QA) ? i = W.QA : t.startsWith(W.DEV) && (i = W.DEV), this.env = i, se.setEnv(i);
    }
  }]);
  return st;
}();
var _t = /*#__PURE__*/function () {
  function _t(e) {
    _classCallCheck(this, _t);
    this.store = e;
    this.bufferSize = it;
    this.TAG = "[AnalyticsEventsService]";
    this.transport = null;
    this.pendingEvents = [];
    this.level = We.INFO;
  }
  _createClass(_t, [{
    key: "setTransport",
    value: function setTransport(e) {
      this.transport = e;
    }
  }, {
    key: "reset",
    value: function reset() {
      this.transport = null, this.pendingEvents = [];
    }
  }, {
    key: "queue",
    value: function queue(e) {
      if (e.level >= this.level && (this.pendingEvents.push(e), this.pendingEvents.length > this.bufferSize)) {
        var _t5 = this.pendingEvents.shift();
        o.d(this.TAG, "Max buffer size reached", "Removed event to accommodate new events", _t5);
      }
      return this;
    }
  }, {
    key: "flushFailedClientEvents",
    value: function flushFailedClientEvents() {
      se.flushFailedEvents();
    }
  }, {
    key: "flush",
    value: function flush() {
      var e;
      try {
        for (; this.pendingEvents.length > 0;) {
          var _t6 = this.pendingEvents.shift();
          _t6 && (_t6.metadata.peer.peer_id = (e = this.store.getLocalPeer()) == null ? void 0 : e.peerId, _t6.metadata.userAgent = this.store.getUserAgent(), this.transport && this.transport.transportProvider.isConnected ? this.transport.sendEvent(_t6) : this.sendClientEventOnHTTP(_t6));
        }
      } catch (t) {
        o.w(this.TAG, "Flush Failed", t);
      }
    }
  }, {
    key: "sendClientEventOnHTTP",
    value: function sendClientEventOnHTTP(e) {
      var r, s, n, d;
      var t = this.store.getRoom(),
        i = this.store.getLocalPeer();
      e.metadata.token = (r = this.store.getConfig()) == null ? void 0 : r.authToken, e.metadata.peer = {
        session_id: t.sessionId,
        room_id: t.id,
        room_name: t.name,
        template_id: t.templateId,
        joined_at: (s = t.joinedAt) == null ? void 0 : s.getTime(),
        session_started_at: (n = t.startedAt) == null ? void 0 : n.getTime(),
        role: (d = i == null ? void 0 : i.role) == null ? void 0 : d.name,
        user_name: i == null ? void 0 : i.name,
        user_data: i == null ? void 0 : i.metadata
      }, se.sendEvent(e);
    }
  }]);
  return _t;
}();
import { v4 as yr } from "uuid";
var Bi = {
    autoplayFailed: void 0,
    initialized: !1,
    autoplayCheckPromise: void 0
  },
  Mr = 3,
  at = /*#__PURE__*/function () {
    function at(e, t, i) {
      var _this39 = this;
      _classCallCheck(this, at);
      this.store = e;
      this.deviceManager = t;
      this.eventBus = i;
      this.autoPausedTracks = new Set();
      this.TAG = "[AudioSinkManager]:";
      this.volume = 100;
      this.state = v({}, Bi);
      this.retryCountMapping = new Map();
      this.handleAudioPaused = function (e) {
        return c(_this39, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee101() {
          var s, i, r;
          return _regeneratorRuntime().wrap(function _callee101$(_context102) {
            while (1) switch (_context102.prev = _context102.next) {
              case 0:
                i = (s = e.target.srcObject) == null ? void 0 : s.getAudioTracks()[0];
                if (i == null ? void 0 : i.enabled) {
                  _context102.next = 3;
                  break;
                }
                return _context102.abrupt("return");
              case 3:
                o.d(this.TAG, "Audio Paused", e.target.id);
                r = this.store.getTrackById(e.target.id);
                _context102.t0 = r;
                if (!_context102.t0) {
                  _context102.next = 14;
                  break;
                }
                if (!ui()) {
                  _context102.next = 13;
                  break;
                }
                _context102.next = 10;
                return $(500);
              case 10:
                this.playAudioFor(r);
                _context102.next = 14;
                break;
              case 13:
                this.autoPausedTracks.add(r);
              case 14:
              case "end":
                return _context102.stop();
            }
          }, _callee101, this);
        }));
      };
      this.handleTrackUpdate = function (_ref12) {
        var e = _ref12.track;
        o.d(_this39.TAG, "Track updated", "".concat(e));
      };
      this.handleTrackAdd = function (r) {
        return c(_this39, [r], function (_ref13) {
          var _this40 = this;
          var e = _ref13.track,
            t = _ref13.peer,
            _ref13$callListener = _ref13.callListener,
            i = _ref13$callListener === void 0 ? !0 : _ref13$callListener;
          return /*#__PURE__*/_regeneratorRuntime().mark(function _callee102() {
            var n, d, l, s;
            return _regeneratorRuntime().wrap(function _callee102$(_context103) {
              while (1) switch (_context103.prev = _context103.next) {
                case 0:
                  if (!((n = _this40.retryCountMapping.get(e.trackId)) != null ? n : 0 > Mr)) {
                    _context103.next = 2;
                    break;
                  }
                  return _context103.abrupt("return");
                case 2:
                  s = document.createElement("audio");
                  s.style.display = "none";
                  s.id = e.trackId;
                  s.addEventListener("pause", _this40.handleAudioPaused);
                  s.onerror = function () {
                    var u, S;
                    o.e(_this40.TAG, "error on audio element", s.error);
                    var h = m.TracksErrors.AudioPlaybackError("Audio playback error for track - ".concat(e.trackId));
                    _this40.eventBus.analytics.publish(H.audioPlaybackError(h)), ((u = s == null ? void 0 : s.error) == null ? void 0 : u.code) === MediaError.MEDIA_ERR_DECODE && (_this40.removeAudioElement(s, e), _this40.retryCountMapping.set(e.trackId, ((S = _this40.retryCountMapping.get(e.trackId)) != null ? S : 0) + 1), _this40.handleTrackAdd({
                      track: e,
                      peer: t,
                      callListener: !1
                    }));
                  };
                  e.setAudioElement(s);
                  e.setVolume(_this40.volume);
                  o.d(_this40.TAG, "Audio track added", "".concat(e));
                  _context103.next = 12;
                  return _this40.init();
                case 12:
                  (d = _this40.audioSink) == null || d.append(s);
                  _context103.t0 = _this40.outputDevice;
                  if (!_context103.t0) {
                    _context103.next = 17;
                    break;
                  }
                  _context103.next = 17;
                  return e.setOutputDevice(_this40.outputDevice);
                case 17:
                  s.srcObject = new MediaStream([e.nativeTrack]);
                  i && ((l = _this40.listener) == null || l.onTrackUpdate(D.TRACK_ADDED, e, t));
                  _context103.next = 21;
                  return _this40.handleAutoplayError(e);
                case 21:
                case "end":
                  return _context103.stop();
              }
            }, _callee102);
          })();
        });
      };
      this.handleAutoplayError = function (e) {
        return c(_this39, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee103() {
          var _this41 = this;
          return _regeneratorRuntime().wrap(function _callee103$(_context104) {
            while (1) switch (_context104.prev = _context104.next) {
              case 0:
                _context104.t0 = this.state.autoplayFailed === void 0;
                if (!_context104.t0) {
                  _context104.next = 5;
                  break;
                }
                this.state.autoplayCheckPromise || (this.state.autoplayCheckPromise = new Promise(function (t) {
                  _this41.playAudioFor(e).then(t);
                }));
                _context104.next = 5;
                return this.state.autoplayCheckPromise;
              case 5:
                if (!this.state.autoplayFailed) {
                  _context104.next = 8;
                  break;
                }
                this.autoPausedTracks.add(e);
                return _context104.abrupt("return");
              case 8:
                _context104.next = 10;
                return this.playAudioFor(e);
              case 10:
              case "end":
                return _context104.stop();
            }
          }, _callee103, this);
        }));
      };
      this.handleAudioDeviceChange = function (e) {
        e.error || !e.selection || e.type === "video" || _this39.unpauseAudioTracks();
      };
      this.handleTrackRemove = function (e) {
        _this39.autoPausedTracks.delete(e);
        var t = document.getElementById(e.trackId);
        t && _this39.removeAudioElement(t, e), _this39.audioSink && _this39.audioSink.childElementCount === 0 && (_this39.state.autoplayCheckPromise = void 0, _this39.state.autoplayFailed = void 0), o.d(_this39.TAG, "Audio track removed", "".concat(e));
      };
      this.unpauseAudioTracks = function () {
        return c(_this39, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee104() {
          var _this42 = this;
          var e;
          return _regeneratorRuntime().wrap(function _callee104$(_context105) {
            while (1) switch (_context105.prev = _context105.next) {
              case 0:
                e = [];
                this.autoPausedTracks.forEach(function (t) {
                  e.push(_this42.playAudioFor(t));
                });
                _context105.next = 4;
                return Promise.all(e);
              case 4:
              case "end":
                return _context105.stop();
            }
          }, _callee104, this);
        }));
      };
      this.removeAudioElement = function (e, t) {
        e && (e.removeEventListener("pause", _this39.handleAudioPaused), e.srcObject = null, e.remove(), t.setAudioElement(null));
      };
      this.eventBus.audioTrackAdded.subscribe(this.handleTrackAdd), this.eventBus.audioTrackRemoved.subscribe(this.handleTrackRemove), this.eventBus.audioTrackUpdate.subscribe(this.handleTrackUpdate), this.eventBus.deviceChange.subscribe(this.handleAudioDeviceChange);
    }
    _createClass(at, [{
      key: "setListener",
      value: function setListener(e) {
        this.listener = e;
      }
    }, {
      key: "getVolume",
      value: function getVolume() {
        return this.volume;
      }
    }, {
      key: "setVolume",
      value: function setVolume(e) {
        return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee105() {
          return _regeneratorRuntime().wrap(function _callee105$(_context106) {
            while (1) switch (_context106.prev = _context106.next) {
              case 0:
                _context106.next = 2;
                return this.store.updateAudioOutputVolume(e);
              case 2:
                this.volume = e;
              case 3:
              case "end":
                return _context106.stop();
            }
          }, _callee105, this);
        }));
      }
    }, {
      key: "unblockAutoplay",
      value: function unblockAutoplay() {
        return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee106() {
          return _regeneratorRuntime().wrap(function _callee106$(_context107) {
            while (1) switch (_context107.prev = _context107.next) {
              case 0:
                this.autoPausedTracks.size > 0 && this.unpauseAudioTracks();
              case 1:
              case "end":
                return _context107.stop();
            }
          }, _callee106, this);
        }));
      }
    }, {
      key: "init",
      value: function init(e) {
        if (this.state.initialized) return;
        this.state.initialized = !0;
        var t = document.createElement("div");
        t.id = "HMS-SDK-audio-sink-".concat(yr()), (e && document.getElementById(e) || document.body).append(t), this.audioSink = t;
      }
    }, {
      key: "cleanUp",
      value: function cleanUp() {
        var e;
        (e = this.audioSink) == null || e.remove(), this.audioSink = void 0, this.retryCountMapping.clear(), this.eventBus.audioTrackAdded.unsubscribe(this.handleTrackAdd), this.eventBus.audioTrackRemoved.unsubscribe(this.handleTrackRemove), this.eventBus.audioTrackUpdate.unsubscribe(this.handleTrackUpdate), this.eventBus.deviceChange.unsubscribe(this.handleAudioDeviceChange), this.autoPausedTracks = new Set(), this.state = v({}, Bi);
      }
    }, {
      key: "playAudioFor",
      value: function playAudioFor(e) {
        return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee107() {
          var t, _r7, s;
          return _regeneratorRuntime().wrap(function _callee107$(_context108) {
            while (1) switch (_context108.prev = _context108.next) {
              case 0:
                t = e.getAudioElement();
                if (t) {
                  _context108.next = 4;
                  break;
                }
                o.w(this.TAG, "No audio element found on track", e.trackId);
                return _context108.abrupt("return");
              case 4:
                _context108.prev = 4;
                _context108.next = 7;
                return t.play();
              case 7:
                this.state.autoplayFailed = !1;
                this.autoPausedTracks.delete(e);
                o.d(this.TAG, "Played track", "".concat(e));
                _context108.next = 17;
                break;
              case 12:
                _context108.prev = 12;
                _context108.t0 = _context108["catch"](4);
                this.autoPausedTracks.add(e), o.e(this.TAG, "Failed to play track", "".concat(e), _context108.t0);
                _r7 = _context108.t0;
                if (!this.state.autoplayFailed && _r7.name === "NotAllowedError") {
                  this.state.autoplayFailed = !0;
                  s = m.TracksErrors.AutoplayBlocked(p.AUTOPLAY, "");
                  s.addNativeError(_r7), this.eventBus.analytics.publish(H.autoplayError()), this.eventBus.autoplayError.publish(s);
                }
              case 17:
              case "end":
                return _context108.stop();
            }
          }, _callee107, this, [[4, 12]]);
        }));
      }
    }, {
      key: "outputDevice",
      get: function get() {
        return this.deviceManager.outputDevice;
      }
    }]);
    return at;
  }();
var nt = /*#__PURE__*/function () {
  function nt(e, t) {
    var _this43 = this;
    _classCallCheck(this, nt);
    this.store = e;
    this.eventBus = t;
    this.audioInput = [];
    this.audioOutput = [];
    this.videoInput = [];
    this.hasWebcamPermission = !1;
    this.hasMicrophonePermission = !1;
    this.TAG = "[Device Manager]:";
    this.initialized = !1;
    this.videoInputChanged = !1;
    this.audioInputChanged = !1;
    this.updateOutputDevice = function (e) {
      return c(_this43, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee108() {
        var t;
        return _regeneratorRuntime().wrap(function _callee108$(_context109) {
          while (1) switch (_context109.prev = _context109.next) {
            case 0:
              t = this.audioOutput.find(function (i) {
                return i.deviceId === e;
              });
              _context109.t0 = t;
              if (!_context109.t0) {
                _context109.next = 7;
                break;
              }
              this.outputDevice = t;
              _context109.next = 6;
              return this.store.updateAudioOutputDevice(t);
            case 6:
              Q.updateSelection("audioOutput", {
                deviceId: t.deviceId,
                groupId: t.groupId
              });
            case 7:
              return _context109.abrupt("return", t);
            case 8:
            case "end":
              return _context109.stop();
          }
        }, _callee108, this);
      }));
    };
    this.getCurrentSelection = function () {
      var n, d;
      var e = _this43.store.getLocalPeer(),
        t = _this43.createIdentifier((n = e == null ? void 0 : e.audioTrack) == null ? void 0 : n.getMediaTrackSettings()),
        i = _this43.createIdentifier((d = e == null ? void 0 : e.videoTrack) == null ? void 0 : d.getMediaTrackSettings()),
        r = _this43.audioInput.find(function (l) {
          return _this43.createIdentifier(l) === t;
        }),
        s = _this43.videoInput.find(function (l) {
          return _this43.createIdentifier(l) === i;
        });
      return {
        audioInput: r,
        videoInput: s,
        audioOutput: _this43.outputDevice
      };
    };
    this.computeChange = function (e, t) {
      return e.length !== t.length ? !0 : t.some(function (i) {
        return !e.includes(_this43.createIdentifier(i));
      });
    };
    this.enumerateDevices = function () {
      return c(_this43, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee109() {
        var _this44 = this;
        var _e4, _t7, _i6;
        return _regeneratorRuntime().wrap(function _callee109$(_context110) {
          while (1) switch (_context110.prev = _context110.next) {
            case 0:
              _context110.prev = 0;
              _context110.next = 3;
              return navigator.mediaDevices.enumerateDevices();
            case 3:
              _e4 = _context110.sent;
              _t7 = this.videoInput.map(this.createIdentifier);
              _i6 = this.audioInput.map(this.createIdentifier);
              this.audioInput = [], this.audioOutput = [], this.videoInput = [], _e4.forEach(function (r) {
                r.kind === "audioinput" && r.label ? (_this44.hasMicrophonePermission = !0, _this44.audioInput.push(r)) : r.kind === "audiooutput" ? _this44.audioOutput.push(r) : r.kind === "videoinput" && r.label && (_this44.hasWebcamPermission = !0, _this44.videoInput.push(r));
              }), this.videoInputChanged = this.computeChange(_t7, this.videoInput), this.audioInputChanged = this.computeChange(_i6, this.audioInput), Q.setDevices({
                videoInput: _toConsumableArray(this.videoInput),
                audioInput: _toConsumableArray(this.audioInput),
                audioOutput: _toConsumableArray(this.audioOutput)
              }), this.logDevices("Enumerate Devices");
              _context110.next = 12;
              break;
            case 9:
              _context110.prev = 9;
              _context110.t0 = _context110["catch"](0);
              o.e(this.TAG, "Failed enumerating devices", _context110.t0);
            case 12:
            case "end":
              return _context110.stop();
          }
        }, _callee109, this, [[0, 9]]);
      }));
    };
    this.handleDeviceChange = Mi(function () {
      return c(_this43, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee110() {
        var e;
        return _regeneratorRuntime().wrap(function _callee110$(_context111) {
          while (1) switch (_context111.prev = _context111.next) {
            case 0:
              _context111.next = 2;
              return this.enumerateDevices();
            case 2:
              this.logDevices("After Device Change");
              e = this.store.getLocalPeer();
              _context111.next = 6;
              return this.setOutputDevice(!0);
            case 6:
              _context111.next = 8;
              return this.handleAudioInputDeviceChange(e == null ? void 0 : e.audioTrack);
            case 8:
              _context111.next = 10;
              return this.handleVideoInputDeviceChange(e == null ? void 0 : e.videoTrack);
            case 10:
              this.eventBus.analytics.publish(H.deviceChange({
                selection: this.getCurrentSelection(),
                type: "change",
                devices: this.getDevices()
              }));
            case 11:
            case "end":
              return _context111.stop();
          }
        }, _callee110, this);
      }));
    }, 500).bind(this);
    this.handleAudioInputDeviceChange = function (e) {
      return c(_this43, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee111() {
        var t, i, r;
        return _regeneratorRuntime().wrap(function _callee111$(_context112) {
          while (1) switch (_context112.prev = _context112.next) {
            case 0:
              if (e) {
                _context112.next = 3;
                break;
              }
              o.d(this.TAG, "No Audio track on local peer");
              return _context112.abrupt("return");
            case 3:
              if (this.audioInputChanged) {
                _context112.next = 6;
                break;
              }
              o.d(this.TAG, "No Change in AudioInput Device");
              return _context112.abrupt("return");
            case 6:
              t = this.getNewAudioInputDevice();
              if (!(!t || !t.deviceId)) {
                _context112.next = 10;
                break;
              }
              this.eventBus.analytics.publish(H.deviceChange({
                selection: {
                  audioInput: t
                },
                error: new Error("Audio device not found"),
                devices: this.getDevices(),
                type: "audioInput"
              })), o.w(this.TAG, "Audio device not found");
              return _context112.abrupt("return");
            case 10:
              i = e.settings, r = new z().codec(i.codec).maxBitrate(i.maxBitrate).deviceId(t.deviceId).build();
              _context112.prev = 11;
              _context112.next = 14;
              return e.setSettings(r, !0);
            case 14:
              this.eventBus.deviceChange.publish({
                devices: this.getDevices(),
                selection: t,
                type: "audioInput"
              });
              this.logDevices("Audio Device Change Success");
              _context112.next = 21;
              break;
            case 18:
              _context112.prev = 18;
              _context112.t0 = _context112["catch"](11);
              o.e(this.TAG, "[Audio Device Change]", _context112.t0), this.eventBus.analytics.publish(H.deviceChange({
                selection: {
                  audioInput: t
                },
                devices: this.getDevices(),
                type: "audioInput",
                error: _context112.t0
              })), this.eventBus.deviceChange.publish({
                error: _context112.t0,
                selection: t,
                type: "audioInput",
                devices: this.getDevices()
              });
            case 21:
            case "end":
              return _context112.stop();
          }
        }, _callee111, this, [[11, 18]]);
      }));
    };
    this.handleVideoInputDeviceChange = function (e) {
      return c(_this43, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee112() {
        var t, i, r;
        return _regeneratorRuntime().wrap(function _callee112$(_context113) {
          while (1) switch (_context113.prev = _context113.next) {
            case 0:
              if (e) {
                _context113.next = 3;
                break;
              }
              o.d(this.TAG, "No video track on local peer");
              return _context113.abrupt("return");
            case 3:
              if (this.videoInputChanged) {
                _context113.next = 6;
                break;
              }
              o.d(this.TAG, "No Change in VideoInput Device");
              return _context113.abrupt("return");
            case 6:
              t = this.videoInput[0];
              if (!(!t || !t.deviceId)) {
                _context113.next = 10;
                break;
              }
              this.eventBus.analytics.publish(H.deviceChange({
                selection: {
                  videoInput: t
                },
                error: new Error("Video device not found"),
                devices: this.getDevices(),
                type: "video"
              })), o.w(this.TAG, "Video device not found");
              return _context113.abrupt("return");
            case 10:
              i = e.settings, r = new J().codec(i.codec).maxBitrate(i.maxBitrate).maxFramerate(i.maxFramerate).setWidth(i.width).setHeight(i.height).deviceId(t.deviceId).build();
              _context113.prev = 11;
              _context113.next = 14;
              return e.setSettings(r, !0);
            case 14:
              this.eventBus.deviceChange.publish({
                devices: this.getDevices(),
                selection: t,
                type: "video"
              });
              this.logDevices("Video Device Change Success");
              _context113.next = 21;
              break;
            case 18:
              _context113.prev = 18;
              _context113.t0 = _context113["catch"](11);
              o.e(this.TAG, "[Video Device Change]", _context113.t0), this.eventBus.analytics.publish(H.deviceChange({
                selection: {
                  videoInput: t
                },
                devices: this.getDevices(),
                type: "video",
                error: _context113.t0
              })), this.eventBus.deviceChange.publish({
                error: _context113.t0,
                type: "video",
                selection: t,
                devices: this.getDevices()
              });
            case 21:
            case "end":
              return _context113.stop();
          }
        }, _callee112, this, [[11, 18]]);
      }));
    };
    var i = function i(_ref14) {
      var r = _ref14.enabled,
        s = _ref14.track;
      return r && s.source === "regular";
    };
    this.eventBus.localVideoEnabled.waitFor(i).then(function () {
      return c(_this43, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee113() {
        return _regeneratorRuntime().wrap(function _callee113$(_context114) {
          while (1) switch (_context114.prev = _context114.next) {
            case 0:
              _context114.next = 2;
              return this.enumerateDevices();
            case 2:
              this.videoInputChanged && this.eventBus.deviceChange.publish({
                devices: this.getDevices()
              });
            case 3:
            case "end":
              return _context114.stop();
          }
        }, _callee113, this);
      }));
    }), this.eventBus.localAudioEnabled.waitFor(i).then(function () {
      return c(_this43, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee114() {
        return _regeneratorRuntime().wrap(function _callee114$(_context115) {
          while (1) switch (_context115.prev = _context115.next) {
            case 0:
              _context115.next = 2;
              return this.enumerateDevices();
            case 2:
              this.audioInputChanged && this.eventBus.deviceChange.publish({
                devices: this.getDevices()
              });
            case 3:
            case "end":
              return _context115.stop();
          }
        }, _callee114, this);
      }));
    });
  }
  _createClass(nt, [{
    key: "init",
    value: function init() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
      return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee115() {
        return _regeneratorRuntime().wrap(function _callee115$(_context116) {
          while (1) switch (_context116.prev = _context116.next) {
            case 0:
              _context116.t0 = this.initialized && !e;
              if (_context116.t0) {
                _context116.next = 11;
                break;
              }
              !this.initialized && navigator.mediaDevices.addEventListener("devicechange", this.handleDeviceChange);
              this.initialized = !0;
              _context116.next = 6;
              return this.enumerateDevices();
            case 6:
              this.logDevices("Init");
              _context116.next = 9;
              return this.setOutputDevice();
            case 9:
              this.eventBus.deviceChange.publish({
                devices: this.getDevices()
              });
              this.eventBus.analytics.publish(H.deviceChange({
                selection: this.getCurrentSelection(),
                type: "list",
                devices: this.getDevices()
              }));
            case 11:
            case "end":
              return _context116.stop();
          }
        }, _callee115, this);
      }));
    }
  }, {
    key: "getDevices",
    value: function getDevices() {
      return {
        audioInput: this.audioInput,
        audioOutput: this.audioOutput,
        videoInput: this.videoInput
      };
    }
  }, {
    key: "cleanUp",
    value: function cleanUp() {
      this.initialized = !1, this.audioInput = [], this.audioOutput = [], this.videoInput = [], this.outputDevice = void 0, navigator.mediaDevices.removeEventListener("devicechange", this.handleDeviceChange);
    }
  }, {
    key: "createIdentifier",
    value: function createIdentifier(e) {
      return e ? "".concat(e.deviceId).concat(e.groupId) : "";
    }
  }, {
    key: "getNewAudioInputDevice",
    value: function getNewAudioInputDevice() {
      var e = this.audioInput.find(function (t) {
        return t.deviceId === "default";
      });
      return e ? this.audioInput.find(function (i) {
        return i.deviceId !== "default" && e.label.includes(i.label);
      }) : this.audioInput[0];
    }
  }, {
    key: "setOutputDevice",
    value: function setOutputDevice() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
      return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee116() {
        var _this45 = this;
        var t, i;
        return _regeneratorRuntime().wrap(function _callee116$(_context117) {
          while (1) switch (_context117.prev = _context117.next) {
            case 0:
              t = this.getNewAudioInputDevice(), i = this.createIdentifier(this.outputDevice);
              this.outputDevice = this.getAudioOutputDeviceMatchingInput(t);
              this.outputDevice || (this.outputDevice = this.audioOutput.find(function (r) {
                return _this45.createIdentifier(r) === i;
              }), this.outputDevice || (this.outputDevice = this.audioOutput.find(function (r) {
                return r.deviceId === "default";
              }) || this.audioOutput[0]));
              _context117.next = 5;
              return this.store.updateAudioOutputDevice(this.outputDevice);
            case 5:
              e && i !== this.createIdentifier(this.outputDevice) && (this.eventBus.analytics.publish(H.deviceChange({
                selection: {
                  audioOutput: this.outputDevice
                },
                devices: this.getDevices(),
                type: "audioOutput"
              })), this.eventBus.deviceChange.publish({
                selection: this.outputDevice,
                type: "audioOutput",
                devices: this.getDevices()
              }));
            case 6:
            case "end":
              return _context117.stop();
          }
        }, _callee116, this);
      }));
    }
  }, {
    key: "getAudioOutputDeviceMatchingInput",
    value: function getAudioOutputDeviceMatchingInput(e) {
      var r, s;
      var t = ((s = (r = this.store.getConfig()) == null ? void 0 : r.settings) == null ? void 0 : s.speakerAutoSelectionBlacklist) || [];
      if (t === "all") return;
      var i = (e == null ? void 0 : e.label.toLowerCase()) || "";
      if (!t.some(function (n) {
        return i.includes(n.toLowerCase());
      }) && (e == null ? void 0 : e.groupId)) return this.audioOutput.find(function (n) {
        return e.deviceId !== "default" && n.label === e.label;
      });
    }
  }, {
    key: "logDevices",
    value: function logDevices() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
      o.d(this.TAG, e, JSON.stringify({
        videoInput: _toConsumableArray(this.videoInput),
        audioInput: _toConsumableArray(this.audioInput),
        audioOutput: _toConsumableArray(this.audioOutput),
        selected: this.getCurrentSelection()
      }, null, 4));
    }
  }]);
  return nt;
}();
var ot = /*#__PURE__*/function () {
  function ot(e, t) {
    _classCallCheck(this, ot);
    this.deviceManager = e;
    this.audioSinkManager = t;
  }
  _createClass(ot, [{
    key: "getVolume",
    value: function getVolume() {
      return this.audioSinkManager.getVolume();
    }
  }, {
    key: "setVolume",
    value: function setVolume(e) {
      if (e < 0 || e > 100) throw Error("Please pass a valid number between 0-100");
      this.audioSinkManager.setVolume(e);
    }
  }, {
    key: "getDevice",
    value: function getDevice() {
      return this.deviceManager.outputDevice;
    }
  }, {
    key: "setDevice",
    value: function setDevice(e) {
      return this.deviceManager.updateOutputDevice(e);
    }
  }, {
    key: "unblockAutoplay",
    value: function unblockAutoplay() {
      return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee117() {
        return _regeneratorRuntime().wrap(function _callee117$(_context118) {
          while (1) switch (_context118.prev = _context118.next) {
            case 0:
              _context118.next = 2;
              return this.audioSinkManager.unblockAutoplay();
            case 2:
              _context118.next = 4;
              return le.resumeContext();
            case 4:
            case "end":
              return _context118.stop();
          }
        }, _callee117, this);
      }));
    }
  }]);
  return ot;
}();
import { EventEmitter2 as Ar } from "eventemitter2";
var B = function B(e, t) {
  var _this46 = this;
  _classCallCheck(this, B);
  this.eventName = e;
  this.eventEmitter = t;
  this.publish = function (e) {
    _this46.eventEmitter.emit(_this46.eventName, e);
  };
  this.subscribe = function (e) {
    _this46.eventEmitter.on(_this46.eventName, e);
  };
  this.subscribeOnce = function (e) {
    _this46.eventEmitter.once(_this46.eventName, e);
  };
  this.unsubscribe = function (e) {
    _this46.eventEmitter.off(_this46.eventName, e);
  };
  this.waitFor = function (e) {
    return _this46.eventEmitter.waitFor(_this46.eventName, {
      filter: e
    });
  };
  this.removeAllListeners = function () {
    _this46.eventEmitter.removeAllListeners(_this46.eventName);
  };
};
var Dt = function Dt() {
  _classCallCheck(this, Dt);
  this.eventEmitter = new Ar();
  this.deviceChange = new B(V.DEVICE_CHANGE, this.eventEmitter);
  this.localAudioEnabled = new B(V.LOCAL_AUDIO_ENABLED, this.eventEmitter);
  this.localVideoEnabled = new B(V.LOCAL_VIDEO_ENABLED, this.eventEmitter);
  this.statsUpdate = new B(V.STATS_UPDATE, this.eventEmitter);
  this.trackDegraded = new B(V.TRACK_DEGRADED, this.eventEmitter);
  this.trackRestored = new B(V.TRACK_RESTORED, this.eventEmitter);
  this.trackAudioLevelUpdate = new B(V.TRACK_AUDIO_LEVEL_UPDATE, this.eventEmitter);
  this.audioPluginFailed = new B(V.AUDIO_PLUGIN_FAILED, this.eventEmitter);
  this.localAudioSilence = new B(V.LOCAL_AUDIO_SILENCE, this.eventEmitter);
  this.analytics = new B(V.ANALYTICS, this.eventEmitter);
  this.policyChange = new B(V.POLICY_CHANGE, this.eventEmitter);
  this.localRoleUpdate = new B(V.LOCAL_ROLE_UPDATE, this.eventEmitter);
  this.audioTrackUpdate = new B(V.AUDIO_TRACK_UPDATE, this.eventEmitter);
  this.audioTrackAdded = new B(V.AUDIO_TRACK_ADDED, this.eventEmitter);
  this.audioTrackRemoved = new B(V.AUDIO_TRACK_REMOVED, this.eventEmitter);
  this.autoplayError = new B(V.AUTOPLAY_ERROR, this.eventEmitter);
  this.leave = new B(V.LEAVE, this.eventEmitter);
};
var Nt = /*#__PURE__*/function () {
  function Nt(e, t, i) {
    _classCallCheck(this, Nt);
    this.store = e;
    this.listener = t;
    this.audioListener = i;
  }
  _createClass(Nt, [{
    key: "handleActiveSpeakers",
    value: function handleActiveSpeakers(e) {
      var _this47 = this;
      var s, n, d;
      var t = e["speaker-list"],
        i = t.map(function (l) {
          return {
            audioLevel: l.level,
            peer: _this47.store.getPeerById(l.peer_id),
            track: _this47.store.getTrackById(l.track_id)
          };
        });
      (s = this.audioListener) == null || s.onAudioLevelUpdate(i), this.store.updateSpeakers(i);
      var r = t[0];
      if (r) {
        var l = this.store.getPeerById(r.peer_id);
        (n = this.listener) == null || n.onPeerUpdate(q.BECAME_DOMINANT_SPEAKER, l);
      } else (d = this.listener) == null || d.onPeerUpdate(q.RESIGNED_DOMINANT_SPEAKER, null);
    }
  }]);
  return Nt;
}();
var A;
(function (y) {
  y.ROOM_STATE = "room-state", y.PEER_JOIN = "on-peer-join", y.PEER_LEAVE = "on-peer-leave", y.PEER_LIST = "peer-list", y.TRACK_METADATA_ADD = "on-track-add", y.TRACK_UPDATE = "on-track-update", y.CHANGE_TRACK_MUTE_STATE_UPDATE = "on-change-track-mute-state-request", y.ACTIVE_SPEAKERS = "active-speakers", y.CONNECTION_QUALITY = "on-connection-quality-update", y.SFU_STATS = "sfu-stats", y.ON_SFU_TRACK_LAYER_UPDATE = "on-track-layer-update", y.BROADCAST = "on-broadcast", y.ROLE_CHANGE = "on-role-change", y.POLICY_CHANGE = "on-policy-change", y.ROLE_CHANGE_REQUEST = "on-role-change-request", y.TRACK_UPDATE_REQUEST = "on-track-update-request", y.PEER_UPDATE = "on-peer-update", y.PEER_LEAVE_REQUEST = "on-peer-leave-request", y.UNSUPPORTED = "unsupported", y.RTMP_START = "on-rtmp-start", y.RTMP_STOP = "on-rtmp-stop", y.RECORDING_START = "on-record-start", y.RECORDING_STOP = "on-record-stop", y.HLS_START = "on-hls-start", y.HLS_STOP = "on-hls-stop";
})(A || (A = {}));
var Ot = /*#__PURE__*/function () {
  function Ot(e, t) {
    _classCallCheck(this, Ot);
    this.store = e;
    this.listener = t;
    this.TAG = "[BroadcastManager]";
  }
  _createClass(Ot, [{
    key: "handleNotification",
    value: function handleNotification(e, t) {
      e === A.BROADCAST && this.handleBroadcast(t);
    }
  }, {
    key: "handleBroadcast",
    value: function handleBroadcast(e) {
      var h;
      var t = e.peer,
        i = e.info,
        r = e.roles,
        s = this.getSender(t),
        n = e.private ? this.store.getLocalPeer() : void 0,
        d = [];
      if (r == null ? void 0 : r.length) {
        var u = this.store.getKnownRoles();
        var _iterator10 = _createForOfIteratorHelper(r),
          _step10;
        try {
          for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
            var _S = _step10.value;
            u[_S] && d.push(u[_S]);
          }
        } catch (err) {
          _iterator10.e(err);
        } finally {
          _iterator10.f();
        }
      }
      var l = new Ee(L(v({}, i), {
        sender: s,
        recipientRoles: d,
        recipientPeer: n,
        time: new Date(e.timestamp)
      }));
      o.d(this.TAG, "Received Message from sender=".concat(t == null ? void 0 : t.peer_id, ": ").concat(l)), (h = this.listener) == null || h.onMessageReceived(l);
    }
  }, {
    key: "getSender",
    value: function getSender(e) {
      var t = e ? this.store.getPeerById(e.peer_id) : void 0;
      return !t && e && (t = new oe({
        peerId: e.peer_id,
        name: e.info.name,
        isLocal: !1,
        customerUserId: e.info.user_id,
        metadata: e.info.data
      })), t;
    }
  }]);
  return Ot;
}();
var xt = /*#__PURE__*/function () {
  function xt(e) {
    _classCallCheck(this, xt);
    this.listener = e;
  }
  _createClass(xt, [{
    key: "handleQualityUpdate",
    value: function handleQualityUpdate(e) {
      var r;
      var i = e.peers.map(function (s) {
        return {
          peerID: s.peer_id,
          downlinkQuality: s.downlink_score
        };
      });
      (r = this.listener) == null || r.onConnectionQualityUpdate(i);
    }
  }]);
  return xt;
}();
var Ft = /*#__PURE__*/function () {
  function Ft(e, t, i, r) {
    var _this48 = this;
    _classCallCheck(this, Ft);
    this.store = e;
    this.peerManager = t;
    this.trackManager = i;
    this.listener = r;
    this.TAG = "[PeerListManager]";
    this.handleInitialPeerList = function (e) {
      var t = Object.values(e.peers);
      _this48.peerManager.handlePeerList(t);
    };
    this.handleReconnectPeerList = function (e) {
      _this48.handleRepeatedPeerList(e.peers);
    };
    this.handlePreviewRoomState = function (e) {
      if (!_this48.store.hasRoleDetailsArrived()) return;
      var t = e.peers;
      if (t == null) {
        e.peer_count === 0 && _this48.handleRepeatedPeerList({});
        return;
      }
      Object.keys(t).forEach(function (i) {
        t[i].tracks = {}, t[i].is_from_room_state = !0;
      }), _this48.handleRepeatedPeerList(t);
    };
    this.handleRepeatedPeerList = function (e) {
      var t = _this48.store.getRemotePeers(),
        i = Object.values(e),
        r = t.filter(function (s) {
          return !e[s.peerId];
        });
      r.length > 0 && o.d(_this48.TAG, "".concat(r)), r.forEach(function (s) {
        var d;
        var n = {
          peer_id: s.peerId,
          role: ((d = s.role) == null ? void 0 : d.name) || "",
          info: {
            name: s.name,
            data: s.metadata || "",
            user_id: s.customerUserId || ""
          },
          tracks: {}
        };
        _this48.peerManager.handlePeerLeave(n);
      }), i.forEach(function (s) {
        var n = _this48.store.getPeerById(s.peer_id),
          d = Object.values(s.tracks);
        n ? (_this48.store.getPeerTracks(n.peerId).forEach(function (h) {
          var u;
          s.tracks[h.trackId] || (_this48.removePeerTrack(n, h.trackId), (u = _this48.listener) == null || u.onTrackUpdate(D.TRACK_REMOVED, h, n));
        }), d.forEach(function (h) {
          _this48.store.getTrackById(h.track_id) || _this48.store.setTrackState({
            peerId: n.peerId,
            trackInfo: h
          });
        }), _this48.trackManager.handleTrackUpdate({
          peer: {
            info: s.info,
            peer_id: s.peer_id
          },
          tracks: s.tracks
        }), _this48.peerManager.handlePeerUpdate(s)) : _this48.peerManager.handlePeerJoin(s);
      });
    };
  }
  _createClass(Ft, [{
    key: "handleNotification",
    value: function handleNotification(e, t, i) {
      if (e === A.PEER_LIST) {
        var _r8 = t;
        i ? (o.d(this.TAG, "RECONNECT_PEER_LIST event", JSON.stringify(_r8, null, 2)), this.handleReconnectPeerList(_r8)) : (o.d(this.TAG, "PEER_LIST event", JSON.stringify(_r8, null, 2)), this.handleInitialPeerList(_r8));
      } else if (e === A.ROOM_STATE) {
        var _r9 = t;
        this.handlePreviewRoomState(_r9);
      }
    }
  }, {
    key: "removePeerTrack",
    value: function removePeerTrack(e, t) {
      var i, r;
      if (o.d(this.TAG, "removing track - ".concat(t, " from ").concat(e)), ((i = e.audioTrack) == null ? void 0 : i.trackId) === t) e.audioTrack = void 0;else if (((r = e.videoTrack) == null ? void 0 : r.trackId) === t) e.videoTrack = void 0;else {
        var s = e.auxiliaryTracks.findIndex(function (n) {
          return n.trackId === t;
        });
        s >= 0 && e.auxiliaryTracks.splice(s, 1);
      }
    }
  }]);
  return Ft;
}();
var Y = function Y(a) {
  return a ? new Date(a) : void 0;
};
var Ut = /*#__PURE__*/function () {
  function Ut(e, t, i) {
    var _this49 = this;
    _classCallCheck(this, Ut);
    this.store = e;
    this.trackManager = t;
    this.listener = i;
    this.TAG = "[PeerManager]";
    this.handlePeerList = function (e) {
      var r, s;
      if (e.length === 0) {
        (r = _this49.listener) == null || r.onPeerUpdate(q.PEER_LIST, []);
        return;
      }
      var t = [],
        i = new Set(e.map(function (n) {
          return n.peer_id;
        }));
      _this49.store.getRemotePeers().forEach(function (_ref15) {
        var n = _ref15.peerId,
          d = _ref15.fromRoomState;
        !i.has(n) && d && _this49.store.removePeer(n);
      });
      var _iterator11 = _createForOfIteratorHelper(e),
        _step11;
      try {
        for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
          var _n = _step11.value;
          t.push(_this49.makePeer(_n));
        }
      } catch (err) {
        _iterator11.e(err);
      } finally {
        _iterator11.f();
      }
      (s = _this49.listener) == null || s.onPeerUpdate(q.PEER_LIST, t), _this49.trackManager.processPendingTracks();
    };
    this.handlePeerJoin = function (e) {
      var i;
      var t = _this49.makePeer(e);
      (i = _this49.listener) == null || i.onPeerUpdate(q.PEER_JOINED, t), _this49.trackManager.processPendingTracks();
    };
    this.handlePeerLeave = function (e) {
      var i, r, s, n;
      var t = _this49.store.getPeerById(e.peer_id);
      _this49.store.removePeer(e.peer_id), o.d(_this49.TAG, "PEER_LEAVE", e.peer_id, "remainingPeers=".concat(_this49.store.getPeers().length)), !!t && (t.audioTrack && ((i = _this49.listener) == null || i.onTrackUpdate(D.TRACK_REMOVED, t.audioTrack, t)), t.videoTrack && ((r = _this49.listener) == null || r.onTrackUpdate(D.TRACK_REMOVED, t.videoTrack, t)), (s = t.auxiliaryTracks) == null || s.forEach(function (d) {
        var l;
        (l = _this49.listener) == null || l.onTrackUpdate(D.TRACK_REMOVED, d, t);
      }), (n = _this49.listener) == null || n.onPeerUpdate(q.PEER_LEFT, t));
    };
  }
  _createClass(Ut, [{
    key: "handleNotification",
    value: function handleNotification(e, t) {
      switch (e) {
        case A.PEER_JOIN:
          {
            var _i7 = t;
            this.handlePeerJoin(_i7);
            break;
          }
        case A.PEER_LEAVE:
          {
            var _i8 = t;
            this.handlePeerLeave(_i8);
            break;
          }
        case A.PEER_UPDATE:
          this.handlePeerUpdate(t);
          break;
        default:
          break;
      }
    }
  }, {
    key: "handlePeerUpdate",
    value: function handlePeerUpdate(e) {
      var i;
      var t = this.store.getPeerById(e.peer_id);
      if (!!t) {
        if (t.role && t.role.name !== e.role) {
          var _r10 = this.store.getPolicyForRole(e.role);
          t.updateRole(_r10), (i = this.listener) == null || i.onPeerUpdate(q.ROLE_UPDATED, t);
        }
        this.handlePeerInfoUpdate(v({
          peer: t
        }, e.info));
      }
    }
  }, {
    key: "handlePeerInfoUpdate",
    value: function handlePeerInfoUpdate(_ref16) {
      var e = _ref16.peer,
        t = _ref16.name,
        i = _ref16.data;
      var r, s;
      !e || (t && e.name !== t && (e.updateName(t), (r = this.listener) == null || r.onPeerUpdate(q.NAME_UPDATED, e)), i && e.metadata !== i && (e.updateMetadata(i), (s = this.listener) == null || s.onPeerUpdate(q.METADATA_UPDATED, e)));
    }
  }, {
    key: "makePeer",
    value: function makePeer(e) {
      var t = this.store.getPeerById(e.peer_id);
      t || (t = new $e({
        peerId: e.peer_id,
        name: e.info.name,
        customerUserId: e.info.user_id,
        metadata: e.info.data,
        role: this.store.getPolicyForRole(e.role),
        joinedAt: Y(e.joined_at),
        fromRoomState: !!e.is_from_room_state
      }), this.store.addPeer(t), o.d(this.TAG, "adding to the peerList", "".concat(t)));
      for (var _i9 in e.tracks) this.store.setTrackState({
        peerId: e.peer_id,
        trackInfo: e.tracks[_i9]
      });
      return t;
    }
  }]);
  return Ut;
}();
var Bt = /*#__PURE__*/function () {
  function Bt(e, t) {
    _classCallCheck(this, Bt);
    this.store = e;
    this.eventBus = t;
  }
  _createClass(Bt, [{
    key: "handlePolicyChange",
    value: function handlePolicyChange(e) {
      var t = this.store.getLocalPeer();
      if (t && !t.role) {
        var _i10 = e.known_roles[e.name];
        t.updateRole(_i10);
      }
      if (this.store.setKnownRoles(e), this.store.getRoom().templateId = e.template_id, (t == null ? void 0 : t.role) && t.role.name !== e.name) {
        var _i11 = this.store.getPolicyForRole(e.name),
          _r11 = t.role;
        t.updateRole(_i11), this.eventBus.localRoleUpdate.publish({
          oldRole: _r11,
          newRole: _i11
        });
      }
      this.eventBus.policyChange.publish(e);
    }
  }]);
  return Bt;
}();
var Gt = /*#__PURE__*/function () {
  function Gt(e, t) {
    _classCallCheck(this, Gt);
    this.store = e;
    this.listener = t;
  }
  _createClass(Gt, [{
    key: "handleNotification",
    value: function handleNotification(e, t) {
      switch (e) {
        case A.ROLE_CHANGE_REQUEST:
          this.handleRoleChangeRequest(t);
          break;
        case A.TRACK_UPDATE_REQUEST:
          this.handleTrackUpdateRequest(t);
          break;
        case A.CHANGE_TRACK_MUTE_STATE_UPDATE:
          this.handleChangeTrackStateRequest(t);
          break;
        default:
          return;
      }
    }
  }, {
    key: "handleRoleChangeRequest",
    value: function handleRoleChangeRequest(e) {
      var i;
      var t = {
        requestedBy: e.requested_by ? this.store.getPeerById(e.requested_by) : void 0,
        role: this.store.getPolicyForRole(e.role),
        token: e.token
      };
      (i = this.listener) == null || i.onRoleChangeRequest(t);
    }
  }, {
    key: "handleTrackUpdateRequest",
    value: function handleTrackUpdateRequest(e) {
      var _this50 = this;
      var t = e.requested_by,
        i = e.track_id,
        r = e.mute,
        s = t ? this.store.getPeerById(t) : void 0,
        n = this.store.getLocalPeerTracks().find(function (l) {
          return l.publishedTrackId === i;
        });
      if (!n) return;
      var d = function d() {
        var l;
        (l = _this50.listener) == null || l.onChangeTrackStateRequest({
          requestedBy: s,
          track: n,
          enabled: !r
        });
      };
      if (r) {
        if (n.enabled === !r) return;
        n.setEnabled(!r).then(d);
      } else d();
    }
  }, {
    key: "handleChangeTrackStateRequest",
    value: function handleChangeTrackStateRequest(e) {
      var _this51 = this;
      var h;
      var t = e.type,
        i = e.source,
        r = e.value,
        s = e.requested_by,
        n = s ? this.store.getPeerById(s) : void 0,
        d = !r,
        l = this.getTracksToBeUpdated({
          type: t,
          source: i,
          enabled: d
        });
      if (l.length !== 0) if (d) (h = this.listener) == null || h.onChangeMultiTrackStateRequest({
        requestedBy: n,
        tracks: l,
        type: t,
        source: i,
        enabled: !0
      });else {
        var u = [];
        var _iterator12 = _createForOfIteratorHelper(l),
          _step12;
        try {
          for (_iterator12.s(); !(_step12 = _iterator12.n()).done;) {
            var _S2 = _step12.value;
            u.push(_S2.setEnabled(!1));
          }
        } catch (err) {
          _iterator12.e(err);
        } finally {
          _iterator12.f();
        }
        Promise.all(u).then(function () {
          var S;
          (S = _this51.listener) == null || S.onChangeMultiTrackStateRequest({
            requestedBy: n,
            tracks: l,
            enabled: !1
          });
        });
      }
    }
  }, {
    key: "getTracksToBeUpdated",
    value: function getTracksToBeUpdated(_ref17) {
      var e = _ref17.type,
        t = _ref17.source,
        i = _ref17.enabled;
      var s = this.store.getLocalPeerTracks();
      return e && (s = s.filter(function (n) {
        return n.type === e;
      })), t && (s = s.filter(function (n) {
        return n.source === t;
      })), s.filter(function (n) {
        return n.enabled !== i;
      });
    }
  }]);
  return Gt;
}();
var Vt = /*#__PURE__*/function () {
  function Vt(e, t) {
    _classCallCheck(this, Vt);
    this.store = e;
    this.listener = t;
    this.TAG = "[RoomUpdateManager]";
  }
  _createClass(Vt, [{
    key: "handleNotification",
    value: function handleNotification(e, t) {
      switch (e) {
        case A.PEER_LIST:
          this.onRoomState(t.room);
          break;
        case A.RTMP_START:
          this.onRTMPStart(t);
          break;
        case A.RTMP_STOP:
          this.onRTMPStop(t);
          break;
        case A.RECORDING_START:
          this.onRecordingStart(t);
          break;
        case A.RECORDING_STOP:
          this.onRecordingStop(t);
          break;
        case A.ROOM_STATE:
          this.handlePreviewRoomState(t);
          break;
        default:
          this.onHLS(e, t);
          break;
      }
    }
  }, {
    key: "handlePreviewRoomState",
    value: function handlePreviewRoomState(e) {
      var t = e.room;
      this.onRoomState(t, e.peer_count);
    }
  }, {
    key: "onRoomState",
    value: function onRoomState(e, t) {
      var h, u, S;
      var i = e.recording,
        r = e.streaming,
        s = e.session_id,
        n = e.started_at,
        d = e.name,
        l = this.store.getRoom();
      l.peerCount = t, l.name = d, l.recording.server.running = !!(i == null ? void 0 : i.sfu.enabled), l.recording.browser.running = !!(i == null ? void 0 : i.browser.enabled), l.rtmp.running = !!((h = r == null ? void 0 : r.rtmp) == null ? void 0 : h.enabled), l.rtmp.startedAt = Y((u = r == null ? void 0 : r.rtmp) == null ? void 0 : u.started_at), l.recording.server.startedAt = Y(i == null ? void 0 : i.sfu.started_at), l.recording.browser.startedAt = Y(i == null ? void 0 : i.browser.started_at), l.recording.hls = this.getPeerListHLSRecording(i), l.hls = this.convertHls(r == null ? void 0 : r.hls), l.sessionId = s, l.startedAt = Y(n), (S = this.listener) == null || S.onRoomUpdate(ce.RECORDING_STATE_UPDATED, l);
    }
  }, {
    key: "onRTMPStart",
    value: function onRTMPStart(e) {
      var t;
      this.setRTMPStatus(!((t = e.error) == null ? void 0 : t.code), e);
    }
  }, {
    key: "onRTMPStop",
    value: function onRTMPStop(e) {
      this.setRTMPStatus(!1, e);
    }
  }, {
    key: "onRecordingStart",
    value: function onRecordingStart(e) {
      var t;
      this.setRecordingStatus(!((t = e.error) == null ? void 0 : t.code), e);
    }
  }, {
    key: "onRecordingStop",
    value: function onRecordingStop(e) {
      this.setRecordingStatus(!1, e);
    }
  }, {
    key: "onHLS",
    value: function onHLS(e, t) {
      var r, s;
      if (![A.HLS_START, A.HLS_STOP].includes(e)) return;
      var i = this.store.getRoom();
      t.enabled = e === A.HLS_START && !((r = t.error) == null ? void 0 : r.code), i.hls = this.convertHls(t), i.recording.hls = this.getHLSRecording(t), (s = this.listener) == null || s.onRoomUpdate(ce.HLS_STREAMING_STATE_UPDATED, i);
    }
  }, {
    key: "convertHls",
    value: function convertHls(e) {
      var i;
      var t = {
        running: !!(e == null ? void 0 : e.enabled),
        variants: [],
        error: this.toSdkError(e == null ? void 0 : e.error)
      };
      return (i = e == null ? void 0 : e.variants) == null || i.forEach(function (r) {
        t.variants.push({
          meetingURL: r.meeting_url,
          url: r.url,
          metadata: r.metadata,
          startedAt: Y(r.started_at)
        });
      }), t;
    }
  }, {
    key: "getHLSRecording",
    value: function getHLSRecording(e) {
      var i, r, s;
      var t = {
        running: !1
      };
      return (e == null ? void 0 : e.hls_recording) && (t = {
        running: !!(e == null ? void 0 : e.enabled),
        singleFilePerLayer: !!((i = e.hls_recording) == null ? void 0 : i.single_file_per_layer),
        hlsVod: !!((r = e.hls_recording) == null ? void 0 : r.hls_vod),
        startedAt: Y((s = e == null ? void 0 : e.variants) == null ? void 0 : s[0].started_at),
        error: this.toSdkError(e.error)
      }), t;
    }
  }, {
    key: "getPeerListHLSRecording",
    value: function getPeerListHLSRecording(e) {
      var i, r;
      var t = e == null ? void 0 : e.hls;
      return {
        running: !!(t == null ? void 0 : t.enabled),
        startedAt: Y(t == null ? void 0 : t.started_at),
        singleFilePerLayer: !!((i = t == null ? void 0 : t.config) == null ? void 0 : i.single_file_per_layer),
        hlsVod: !!((r = t == null ? void 0 : t.config) == null ? void 0 : r.hls_vod)
      };
    }
  }, {
    key: "setRecordingStatus",
    value: function setRecordingStatus(e, t) {
      var s;
      var i = this.store.getRoom(),
        r;
      t.type === "sfu" ? (i.recording.server = {
        running: e,
        startedAt: e ? Y(t.started_at) : void 0,
        error: this.toSdkError(t.error)
      }, r = ce.SERVER_RECORDING_STATE_UPDATED) : (i.recording.browser = {
        running: e,
        startedAt: e ? Y(t.started_at) : void 0,
        error: this.toSdkError(t.error)
      }, r = ce.BROWSER_RECORDING_STATE_UPDATED), (s = this.listener) == null || s.onRoomUpdate(r, i);
    }
  }, {
    key: "setRTMPStatus",
    value: function setRTMPStatus(e, t) {
      var r;
      var i = this.store.getRoom();
      i.rtmp = {
        running: e,
        startedAt: e ? Y(t.started_at) : void 0,
        error: this.toSdkError(t.error)
      }, (r = this.listener) == null || r.onRoomUpdate(ce.RTMP_STREAMING_STATE_UPDATED, i);
    }
  }, {
    key: "toSdkError",
    value: function toSdkError(e) {
      if (!(e == null ? void 0 : e.code)) return;
      var t = e.message || "error in streaming/recording",
        i = new T(e.code, "ServerErrors", p.NONE, t, t);
      return o.e(this.TAG, "error in streaming/recording", i), i;
    }
  }]);
  return Vt;
}();
var $t = /*#__PURE__*/function () {
  function $t(e, t, i) {
    var _this52 = this;
    _classCallCheck(this, $t);
    this.store = e;
    this.eventBus = t;
    this.listener = i;
    this.TAG = "[TrackManager]";
    this.tracksToProcess = new Map();
    this.handleTrackAdd = function (e) {
      o.d(_this52.TAG, "ONTRACKADD", "".concat(e)), _this52.store.addTrack(e), _this52.tracksToProcess.set(e.trackId, e), _this52.processPendingTracks();
    };
    this.handleTrackRemove = function (e) {
      var r;
      o.d(_this52.TAG, "ONTRACKREMOVE", "".concat(e));
      var t = _this52.store.getTrackState(e.trackId);
      if (!t) return;
      e.type === F.AUDIO && _this52.eventBus.audioTrackRemoved.publish(e), _this52.store.removeTrack(e.trackId);
      var i = _this52.store.getPeerById(t.peerId);
      !i || (_this52.removePeerTracks(i, e), (r = _this52.listener) == null || r.onTrackUpdate(D.TRACK_REMOVED, e, i));
    };
    this.handleTrackLayerUpdate = function (e) {
      for (var _t8 in e.tracks) {
        var _i12 = e.tracks[_t8],
          _r12 = _this52.store.getTrackById(_t8);
        !_r12 || !_this52.store.getPeerByTrackId(_t8) || _r12 instanceof ve && _this52.setLayer(_r12, _i12);
      }
    };
    this.handleTrackUpdate = function (e) {
      var i, r;
      var t = _this52.store.getPeerById(e.peer.peer_id);
      if (!t) {
        o.d(_this52.TAG, "Track Update ignored - Peer not added to store");
        return;
      }
      for (var s in e.tracks) {
        var _n2 = Object.assign({}, (i = _this52.store.getTrackState(s)) == null ? void 0 : i.trackInfo),
          _d2 = e.tracks[s],
          l = _this52.store.getTrackById(s);
        if (_this52.store.setTrackState({
          peerId: e.peer.peer_id,
          trackInfo: v(v({}, _n2), _d2)
        }), !l || _this52.tracksToProcess.has(s)) _this52.processPendingTracks();else {
          l.setEnabled(!_d2.mute);
          var h = _this52.processTrackUpdate(l, _n2, _d2);
          h && ((r = _this52.listener) == null || r.onTrackUpdate(h, l, t));
        }
      }
    };
  }
  _createClass($t, [{
    key: "handleTrackMetadataAdd",
    value: function handleTrackMetadataAdd(e) {
      o.d(this.TAG, "TRACK_METADATA_ADD", JSON.stringify(e, null, 2));
      for (var _t9 in e.tracks) this.store.setTrackState({
        peerId: e.peer.peer_id,
        trackInfo: e.tracks[_t9]
      });
      this.processPendingTracks();
    }
  }, {
    key: "processPendingTracks",
    value: function processPendingTracks() {
      var _this53 = this;
      new Map(this.tracksToProcess).forEach(function (t) {
        var s;
        var i = _this53.store.getTrackState(t.trackId);
        if (!i) {
          o.d(_this53.TAG, "TrackState not added to store", "peerId - ".concat(t.peerId), "trackId -".concat(t.trackId));
          return;
        }
        var r = _this53.store.getPeerById(i.peerId);
        if (!r) {
          o.d(_this53.TAG, "Peer not added to store, peerId", i.peerId);
          return;
        }
        t.source = i.trackInfo.source, t.peerId = r.peerId, t.logIdentifier = r.name, t.setEnabled(!i.trackInfo.mute), _this53.addAudioTrack(r, t), _this53.addVideoTrack(r, t), t.type === F.AUDIO ? _this53.eventBus.audioTrackAdded.publish({
          track: t,
          peer: r
        }) : (s = _this53.listener) == null || s.onTrackUpdate(D.TRACK_ADDED, t, r), _this53.tracksToProcess.delete(t.trackId);
      });
    }
  }, {
    key: "setLayer",
    value: function setLayer(e, t) {
      var s, n;
      var i = this.store.getPeerByTrackId(e.trackId);
      if (!i) return;
      e.setLayerFromServer(t) ? (s = this.listener) == null || s.onTrackUpdate(D.TRACK_DEGRADED, e, i) : (n = this.listener) == null || n.onTrackUpdate(D.TRACK_RESTORED, e, i);
    }
  }, {
    key: "removePeerTracks",
    value: function removePeerTracks(e, t) {
      var r, s;
      var i = e.auxiliaryTracks.indexOf(t);
      i > -1 ? e.auxiliaryTracks.splice(i, 1) : t.type === F.AUDIO && ((r = e.audioTrack) == null ? void 0 : r.trackId) === t.trackId ? e.audioTrack = void 0 : t.type === F.VIDEO && ((s = e.videoTrack) == null ? void 0 : s.trackId) === t.trackId && (e.videoTrack = void 0);
    }
  }, {
    key: "addAudioTrack",
    value: function addAudioTrack(e, t) {
      t.type === F.AUDIO && (!e.audioTrack && t.source === "regular" ? e.audioTrack = t : e.auxiliaryTracks.push(t));
    }
  }, {
    key: "addVideoTrack",
    value: function addVideoTrack(e, t) {
      if (t.type !== F.VIDEO) return;
      var i = t,
        r = this.store.getSimulcastDefinitionsForPeer(e, i.source);
      i.setSimulcastDefinitons(r), !e.videoTrack && t.source === "regular" ? e.videoTrack = i : e.auxiliaryTracks.push(i);
    }
  }, {
    key: "processTrackUpdate",
    value: function processTrackUpdate(e, t, i) {
      var r;
      return t.mute !== i.mute ? (r = i.mute ? D.TRACK_MUTED : D.TRACK_UNMUTED, e.type === F.AUDIO && this.eventBus.audioTrackUpdate.publish({
        track: e,
        enabled: !i.mute
      })) : t.description !== i.description && (r = D.TRACK_DESCRIPTION_CHANGED), r;
    }
  }]);
  return $t;
}();
var ct = /*#__PURE__*/function () {
  function ct(e, t, i, r, s) {
    var _this54 = this;
    _classCallCheck(this, ct);
    this.store = e;
    this.listener = i;
    this.audioListener = r;
    this.connectionQualityListener = s;
    this.TAG = "[HMSNotificationManager]";
    this.hasConsistentRoomStateArrived = !1;
    this.ignoreNotification = function (e) {
      if (e === A.PEER_LIST) _this54.hasConsistentRoomStateArrived = !0;else if (e === A.ROOM_STATE) return _this54.hasConsistentRoomStateArrived;
      return !1;
    };
    this.handleTrackAdd = function (e) {
      _this54.trackManager.handleTrackAdd(e);
    };
    this.handleTrackRemove = function (e) {
      _this54.trackManager.handleTrackRemove(e);
    };
    this.updateLocalPeer = function (_ref18) {
      var e = _ref18.name,
        t = _ref18.metadata;
      var i = _this54.store.getLocalPeer();
      _this54.peerManager.handlePeerInfoUpdate({
        peer: i,
        name: e,
        data: t
      });
    };
    this.trackManager = new $t(this.store, t, this.listener), this.peerManager = new Ut(this.store, this.trackManager, this.listener), this.peerListManager = new Ft(this.store, this.peerManager, this.trackManager, this.listener), this.broadcastManager = new Ot(this.store, this.listener), this.policyChangeManager = new Bt(this.store, t), this.requestManager = new Gt(this.store, this.listener), this.activeSpeakerManager = new Nt(this.store, this.listener, this.audioListener), this.connectionQualityManager = new xt(this.connectionQualityListener), this.roomUpdateManager = new Vt(this.store, this.listener);
  }
  _createClass(ct, [{
    key: "setListener",
    value: function setListener(e) {
      this.listener = e, this.trackManager.listener = e, this.peerManager.listener = e, this.peerListManager.listener = e, this.broadcastManager.listener = e, this.requestManager.listener = e, this.activeSpeakerManager.listener = e, this.roomUpdateManager.listener = e;
    }
  }, {
    key: "setAudioListener",
    value: function setAudioListener(e) {
      this.audioListener = e, this.activeSpeakerManager.audioListener = e;
    }
  }, {
    key: "setConnectionQualityListener",
    value: function setConnectionQualityListener(e) {
      this.connectionQualityListener = e, this.connectionQualityManager.listener = e;
    }
  }, {
    key: "handleNotification",
    value: function handleNotification(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
      var s, n;
      var i = e.method,
        r = e.params;
      [A.ACTIVE_SPEAKERS, A.SFU_STATS, A.CONNECTION_QUALITY, void 0].includes(i) || o.d(this.TAG, "Received notification - ".concat(i), {
        notification: r
      }), i === A.SFU_STATS && ((s = window.HMS) == null ? void 0 : s.ON_SFU_STATS) && typeof ((n = window.HMS) == null ? void 0 : n.ON_SFU_STATS) == "function" && window.HMS.ON_SFU_STATS(e.params), !this.ignoreNotification(i) && (this.roomUpdateManager.handleNotification(i, r), this.peerManager.handleNotification(i, r), this.requestManager.handleNotification(i, r), this.peerListManager.handleNotification(i, r, t), this.broadcastManager.handleNotification(i, r), this.handleIsolatedMethods(i, r));
    }
  }, {
    key: "handleIsolatedMethods",
    value: function handleIsolatedMethods(e, t) {
      switch (e) {
        case A.TRACK_METADATA_ADD:
          {
            this.trackManager.handleTrackMetadataAdd(t);
            break;
          }
        case A.TRACK_UPDATE:
          {
            this.trackManager.handleTrackUpdate(t);
            break;
          }
        case A.ON_SFU_TRACK_LAYER_UPDATE:
          {
            this.trackManager.handleTrackLayerUpdate(t);
            break;
          }
        case A.ACTIVE_SPEAKERS:
          this.activeSpeakerManager.handleActiveSpeakers(t);
          break;
        case A.CONNECTION_QUALITY:
          this.connectionQualityManager.handleQualityUpdate(t);
          break;
        case A.POLICY_CHANGE:
          this.policyChangeManager.handlePolicyChange(t);
          break;
        default:
          break;
      }
    }
  }]);
  return ct;
}();
var dt = function dt(e) {
  _classCallCheck(this, dt);
  this.type = e.type, this.source = e.source || "regular", this.description = "", e instanceof ge ? (this.mute = !e.enabled, this.track_id = e.publishedTrackId, this.stream_id = e.stream.id) : (this.mute = e.mute, this.track_id = e.track_id, this.stream_id = e.stream_id);
};
var Ue = /*#__PURE__*/function () {
  function Ue(e) {
    _classCallCheck(this, Ue);
    this.TAG = "[AudioContextManager]";
    this.audioContext = new AudioContext(), this.source = this.audioContext.createMediaElementSource(e), this.source.connect(this.audioContext.destination);
  }
  _createClass(Ue, [{
    key: "resumeContext",
    value: function resumeContext() {
      this.audioContext.state === "suspended" && (o.d(this.TAG, "AudioContext is resumed"), this.audioContext.resume());
    }
  }, {
    key: "getAudioTrack",
    value: function getAudioTrack() {
      return this.destinationNode && this.source.disconnect(this.destinationNode), this.destinationNode = this.audioContext.createMediaStreamDestination(), this.source.connect(this.destinationNode), this.destinationNode.stream.getAudioTracks()[0];
    }
  }, {
    key: "cleanup",
    value: function cleanup() {
      this.audioContext.state !== "closed" && this.audioContext.close();
    }
  }]);
  return Ue;
}();
import { EventEmitter2 as Pr } from "eventemitter2";
var fe = /*#__PURE__*/function (_Pr) {
  _inherits(fe, _Pr);
  function fe() {
    _classCallCheck(this, fe);
    return _possibleConstructorReturn(this, _getPrototypeOf(fe).apply(this, arguments));
  }
  _createClass(fe, [{
    key: "on",
    value: function on(e, t) {
      return _get(_getPrototypeOf(fe.prototype), "on", this).call(this, e, t);
    }
  }, {
    key: "off",
    value: function off(e, t) {
      return _get(_getPrototypeOf(fe.prototype), "off", this).call(this, e, t);
    }
  }, {
    key: "emit",
    value: function emit(e, t) {
      return _get(_getPrototypeOf(fe.prototype), "emit", this).call(this, e, t);
    }
  }, {
    key: "listeners",
    value: function listeners(e) {
      return _get(_getPrototypeOf(fe.prototype), "listeners", this).call(this, e);
    }
  }]);
  return fe;
}(Pr);
var Wt = /*#__PURE__*/function (_fe) {
  _inherits(Wt, _fe);
  function Wt() {
    var _this55;
    _classCallCheck(this, Wt);
    _this55 = _possibleConstructorReturn(this, _getPrototypeOf(Wt).apply(this, arguments));
    _this55.audioElement = null;
    _this55.TAG = "[PlaylistAudioManager]";
    _this55.seeked = !1;
    return _this55;
  }
  _createClass(Wt, [{
    key: "play",
    value: function play(e) {
      return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee119() {
        var _this56 = this;
        return _regeneratorRuntime().wrap(function _callee119$(_context120) {
          while (1) switch (_context120.prev = _context120.next) {
            case 0:
              return _context120.abrupt("return", (this.audioElement = this.getAudioElement(), new Promise(function (t, i) {
                _this56.audioElement = _this56.getAudioElement(), _this56.audioElement.src = e, _this56.seeked = !1, _this56.audioElement.onerror = function () {
                  var r = "Error loading ".concat(e);
                  o.e(_this56.TAG, r), _this56.stop(), i(r);
                }, _this56.audioElement.oncanplaythrough = function () {
                  return c(_this56, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee118() {
                    var _r13;
                    return _regeneratorRuntime().wrap(function _callee118$(_context119) {
                      while (1) switch (_context119.prev = _context119.next) {
                        case 0:
                          _context119.prev = 0;
                          if (this.audioElement) {
                            _context119.next = 3;
                            break;
                          }
                          return _context119.abrupt("return");
                        case 3:
                          if (!(this.audioContextManager.resumeContext(), this.track)) {
                            _context119.next = 13;
                            break;
                          }
                          if (!this.seeked) {
                            _context119.next = 8;
                            break;
                          }
                          this.seeked = !1;
                          _context119.next = 11;
                          break;
                        case 8:
                          _context119.next = 10;
                          return this.audioElement.play();
                        case 10:
                          t([this.track]);
                        case 11:
                          _context119.next = 17;
                          break;
                        case 13:
                          _context119.next = 15;
                          return this.audioElement.play();
                        case 15:
                          _r13 = this.audioContextManager.getAudioTrack();
                          this.track = _r13, t([_r13]);
                        case 17:
                          _context119.next = 22;
                          break;
                        case 19:
                          _context119.prev = 19;
                          _context119.t0 = _context119["catch"](0);
                          o.e(this.TAG, "Error playing audio", e, _context119.t0.message), i(_context119.t0);
                        case 22:
                        case "end":
                          return _context119.stop();
                      }
                    }, _callee118, this, [[0, 19]]);
                  }));
                }, _this56.audioElement.onseeked = function () {
                  _this56.seeked = !0;
                };
              })));
            case 1:
            case "end":
              return _context120.stop();
          }
        }, _callee119, this);
      }));
    }
  }, {
    key: "getTracks",
    value: function getTracks() {
      return this.track ? [this.track.id] : [];
    }
  }, {
    key: "getElement",
    value: function getElement() {
      return this.audioElement;
    }
  }, {
    key: "stop",
    value: function stop() {
      var e, t, i;
      (e = this.audioElement) == null || e.pause(), (t = this.audioElement) == null || t.removeAttribute("src"), this.audioElement = null, (i = this.audioContextManager) == null || i.cleanup(), this.track = void 0;
    }
  }, {
    key: "getAudioElement",
    value: function getAudioElement() {
      var _this57 = this;
      if (this.audioElement) return this.audioElement;
      var e = document.createElement("audio");
      return e.crossOrigin = "anonymous", e.addEventListener("timeupdate", function (t) {
        return _this57.emit("progress", t);
      }), e.addEventListener("ended", function () {
        _this57.emit("ended", null);
      }), this.audioContextManager = new Ue(e), e;
    }
  }]);
  return Wt;
}(fe);
var Kt = /*#__PURE__*/function (_fe2) {
  _inherits(Kt, _fe2);
  function Kt() {
    var _this58;
    _classCallCheck(this, Kt);
    _this58 = _possibleConstructorReturn(this, _getPrototypeOf(Kt).apply(this, arguments));
    _this58.TAG = "[PlaylistVideoManager]";
    _this58.videoElement = null;
    _this58.canvasContext = null;
    _this58.tracks = [];
    _this58.DEFAUL_FPS = 24;
    _this58.seeked = !1;
    _this58.drawImage = function () {
      var e, t, i;
      _this58.videoElement && !_this58.videoElement.paused && !_this58.videoElement.ended && ((i = _this58.canvasContext) == null || i.drawImage(_this58.videoElement, 0, 0, (e = _this58.canvas) == null ? void 0 : e.width, (t = _this58.canvas) == null ? void 0 : t.height), _this58.timer = setTimeout(function () {
        _this58.drawImage();
      }, 1e3 / _this58.DEFAUL_FPS));
    };
    return _this58;
  }
  _createClass(Kt, [{
    key: "play",
    value: function play(e) {
      var _this59 = this;
      return this.videoElement = this.getVideoElement(), this.createCanvas(), new Promise(function (t, i) {
        _this59.videoElement = _this59.getVideoElement(), _this59.videoElement.src = e, _this59.seeked = !1, _this59.videoElement.onerror = function () {
          var r = "Error loading ".concat(e);
          o.e(_this59.TAG, r), _this59.stop(), i(r);
        }, _this59.videoElement.oncanplaythrough = function () {
          return c(_this59, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee120() {
            var _this60 = this;
            var r, s, n, _d3, l;
            return _regeneratorRuntime().wrap(function _callee120$(_context121) {
              while (1) switch (_context121.prev = _context121.next) {
                case 0:
                  _context121.prev = 0;
                  if (this.videoElement) {
                    _context121.next = 3;
                    break;
                  }
                  return _context121.abrupt("return");
                case 3:
                  if (!(this.canvas.width = this.videoElement.videoWidth, this.canvas.height = this.videoElement.videoHeight, this.tracks.length === 0)) {
                    _context121.next = 17;
                    break;
                  }
                  this.clearCanvasAndTracks();
                  _d3 = this.canvas.captureStream();
                  if (_d3) {
                    _context121.next = 9;
                    break;
                  }
                  o.e(this.TAG, "Browser does not support captureStream");
                  return _context121.abrupt("return");
                case 9:
                  this.videoElement.onplay = this.drawImage;
                  this.audioContextManager.resumeContext();
                  _context121.next = 13;
                  return this.videoElement.play();
                case 13:
                  l = this.audioContextManager.getAudioTrack();
                  _d3.addTrack(l), _d3.getTracks().forEach(function (h) {
                    _this60.tracks.push(h);
                  }), t(this.tracks);
                  _context121.next = 24;
                  break;
                case 17:
                  if (!this.seeked) {
                    _context121.next = 21;
                    break;
                  }
                  this.seeked = !1, (n = this.canvasContext) == null || n.drawImage(this.videoElement, 0, 0, (r = this.canvas) == null ? void 0 : r.width, (s = this.canvas) == null ? void 0 : s.height);
                  _context121.next = 24;
                  break;
                case 21:
                  _context121.next = 23;
                  return this.videoElement.play();
                case 23:
                  t(this.tracks);
                case 24:
                  _context121.next = 29;
                  break;
                case 26:
                  _context121.prev = 26;
                  _context121.t0 = _context121["catch"](0);
                  o.e(this.TAG, "Error playing video", e, _context121.t0.message), i(_context121.t0);
                case 29:
                case "end":
                  return _context121.stop();
              }
            }, _callee120, this, [[0, 26]]);
          }));
        }, _this59.videoElement.onseeked = function () {
          _this59.seeked = !0;
        };
      });
    }
  }, {
    key: "getTracks",
    value: function getTracks() {
      return this.tracks.map(function (e) {
        return e.id;
      });
    }
  }, {
    key: "getElement",
    value: function getElement() {
      return this.videoElement;
    }
  }, {
    key: "stop",
    value: function stop() {
      var e, t, i;
      (e = this.videoElement) == null || e.pause(), (t = this.videoElement) == null || t.removeAttribute("src"), this.videoElement = null, (i = this.audioContextManager) == null || i.cleanup(), this.clearCanvasAndTracks();
    }
  }, {
    key: "clearCanvasAndTracks",
    value: function clearCanvasAndTracks() {
      var e;
      this.tracks = [], (e = this.canvasContext) == null || e.clearRect(0, 0, this.canvas.width, this.canvas.height), clearTimeout(this.timer);
    }
  }, {
    key: "getVideoElement",
    value: function getVideoElement() {
      var _this61 = this;
      if (this.videoElement) return this.videoElement;
      var e = document.createElement("video");
      return e.crossOrigin = "anonymous", e.addEventListener("timeupdate", function (t) {
        return _this61.emit("progress", t);
      }), e.addEventListener("ended", function () {
        _this61.emit("ended", null);
      }), this.audioContextManager = new Ue(e), e;
    }
  }, {
    key: "createCanvas",
    value: function createCanvas() {
      this.canvas || (this.canvas = document.createElement("canvas"), this.canvasContext = this.canvas.getContext("2d"));
    }
  }]);
  return Kt;
}(fe);
var lt = {
    audio: {
      list: [],
      currentIndex: -1,
      isAutoplayOn: !0
    },
    video: {
      list: [],
      currentIndex: -1,
      isAutoplayOn: !0
    }
  },
  ut = /*#__PURE__*/function (_fe3) {
    _inherits(ut, _fe3);
    function ut(e, t) {
      var _this62;
      _classCallCheck(this, ut);
      _this62 = _possibleConstructorReturn(this, _getPrototypeOf(ut).call(this));
      _this62.sdk = e;
      _this62.eventBus = t;
      _this62.state = {
        audio: v({}, lt.audio),
        video: v({}, lt.video)
      };
      _this62.TAG = "[PlaylistManager]";
      _this62.handlePausePlaylist = function (i) {
        return c(_assertThisInitialized(_assertThisInitialized(_this62)), [i], function (_ref19) {
          var _this63 = this;
          var e = _ref19.enabled,
            t = _ref19.track;
          return /*#__PURE__*/_regeneratorRuntime().mark(function _callee121() {
            var s, r;
            return _regeneratorRuntime().wrap(function _callee121$(_context122) {
              while (1) switch (_context122.prev = _context122.next) {
                case 0:
                  if (!e) {
                    _context122.next = 2;
                    break;
                  }
                  return _context122.abrupt("return");
                case 2:
                  t.source === "audioplaylist" && (r = b.audio), t.source === "videoplaylist" && (r = b.video), !!r && ((s = _this63.getElement(r)) == null || s.pause());
                case 3:
                case "end":
                  return _context122.stop();
              }
            }, _callee121);
          })();
        });
      };
      _this62.addTrack = function (e, t) {
        return c(_assertThisInitialized(_assertThisInitialized(_this62)), null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee122() {
          return _regeneratorRuntime().wrap(function _callee122$(_context123) {
            while (1) switch (_context123.prev = _context123.next) {
              case 0:
                _context123.next = 2;
                return this.sdk.addTrack(e, t);
              case 2:
                o.d(this.TAG, "Playlist track added", Je(e));
              case 3:
              case "end":
                return _context123.stop();
            }
          }, _callee122, this);
        }));
      };
      _this62.removeTrack = function (e) {
        return c(_assertThisInitialized(_assertThisInitialized(_this62)), null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee123() {
          return _regeneratorRuntime().wrap(function _callee123$(_context124) {
            while (1) switch (_context124.prev = _context124.next) {
              case 0:
                _context124.next = 2;
                return this.sdk.removeTrack(e, !0);
              case 2:
                o.d(this.TAG, "Playlist track removed", e);
              case 3:
              case "end":
                return _context124.stop();
            }
          }, _callee123, this);
        }));
      };
      _this62.audioManager = new Wt(), _this62.videoManager = new Kt(), _this62.addListeners();
      return _this62;
    }
    _createClass(ut, [{
      key: "getList",
      value: function getList() {
        var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : b.audio;
        return this.state[e].list;
      }
    }, {
      key: "setList",
      value: function setList(e) {
        var _this64 = this;
        if (!e || e.length === 0) {
          o.w(this.TAG, "Please pass in a list of HMSPlaylistItem's");
          return;
        }
        e.forEach(function (t) {
          _this64.state[t.type].list.includes(t) || _this64.state[t.type].list.push(t);
        });
      }
    }, {
      key: "clearList",
      value: function clearList(e) {
        return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee124() {
          return _regeneratorRuntime().wrap(function _callee124$(_context125) {
            while (1) switch (_context125.prev = _context125.next) {
              case 0:
                _context125.t0 = this.isPlaying(e);
                if (!_context125.t0) {
                  _context125.next = 4;
                  break;
                }
                _context125.next = 4;
                return this.stop(e);
              case 4:
                this.state[e].list = [];
              case 5:
              case "end":
                return _context125.stop();
            }
          }, _callee124, this);
        }));
      }
    }, {
      key: "removeItem",
      value: function removeItem(e, t) {
        return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee125() {
          var _this$state$t, i, r, s;
          return _regeneratorRuntime().wrap(function _callee125$(_context126) {
            while (1) switch (_context126.prev = _context126.next) {
              case 0:
                _this$state$t = this.state[t], i = _this$state$t.list, r = _this$state$t.currentIndex, s = i.findIndex(function (n) {
                  return e === n.id;
                });
                if (!(s > -1)) {
                  _context126.next = 10;
                  break;
                }
                _context126.t1 = r === s && this.isPlaying(t);
                if (!_context126.t1) {
                  _context126.next = 6;
                  break;
                }
                _context126.next = 6;
                return this.stop(t);
              case 6:
                i.splice(s, 1);
                _context126.t0 = !0;
                _context126.next = 11;
                break;
              case 10:
                _context126.t0 = !1;
              case 11:
                return _context126.abrupt("return", _context126.t0);
              case 12:
              case "end":
                return _context126.stop();
            }
          }, _callee125, this);
        }));
      }
    }, {
      key: "seek",
      value: function seek(e) {
        var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : b.audio;
        var i = this.state[t].currentIndex;
        if (i === -1) throw m.PlaylistErrors.NoEntryToPlay(p.PLAYLIST, "No item is currently playing");
        var r = this.getElement(t);
        if (r) {
          var s = Math.max(r.currentTime + e, 0);
          r.currentTime = Math.min(s, r.duration);
        }
      }
    }, {
      key: "seekTo",
      value: function seekTo(e) {
        var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : b.audio;
        var i = this.state[t].currentIndex;
        if (i === -1) throw m.PlaylistErrors.NoEntryToPlay(p.PLAYLIST, "No item is currently playing");
        if (e < 0) throw Error("value cannot be negative");
        var r = this.getElement(t);
        r && (r.currentTime = Math.min(e, r.duration));
      }
    }, {
      key: "setVolume",
      value: function setVolume(e) {
        var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : b.audio;
        if (e < 0 || e > 100) throw Error("Please pass a valid number between 0-100");
        var i = this.getElement(t);
        i && (i.volume = e * .01);
      }
    }, {
      key: "getVolume",
      value: function getVolume() {
        var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : b.audio;
        var t = this.getElement(e);
        return t ? t.volume * 100 : 0;
      }
    }, {
      key: "getCurrentTime",
      value: function getCurrentTime() {
        var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : b.audio;
        var t = this.getElement(e);
        return (t == null ? void 0 : t.currentTime) || 0;
      }
    }, {
      key: "getCurrentIndex",
      value: function getCurrentIndex() {
        var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : b.audio;
        return this.state[e].currentIndex;
      }
    }, {
      key: "getCurrentProgress",
      value: function getCurrentProgress() {
        var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : b.audio;
        var n;
        var _this$state$e = this.state[e],
          t = _this$state$e.list,
          i = _this$state$e.currentIndex,
          r = (n = t[i]) == null ? void 0 : n.url,
          s = this.getElement(e);
        return !r || !s ? 0 : Math.floor(100 * (s.currentTime / s.duration));
      }
    }, {
      key: "getCurrentSelection",
      value: function getCurrentSelection() {
        var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : b.audio;
        var _this$state$e2 = this.state[e],
          t = _this$state$e2.list,
          i = _this$state$e2.currentIndex;
        if (i !== -1) return t[i];
      }
    }, {
      key: "isPlaying",
      value: function isPlaying() {
        var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : b.audio;
        var t = this.getElement(e);
        return !!t && !t.paused;
      }
    }, {
      key: "setIsAutoplayOn",
      value: function setIsAutoplayOn() {
        var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : b.audio;
        var t = arguments.length > 1 ? arguments[1] : undefined;
        this.state[e].isAutoplayOn = t;
      }
    }, {
      key: "getPlaybackRate",
      value: function getPlaybackRate() {
        var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : b.audio;
        var t = this.getElement(e);
        return t ? t.playbackRate : 1;
      }
    }, {
      key: "setPlaybackRate",
      value: function setPlaybackRate() {
        var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : b.audio;
        var t = arguments.length > 1 ? arguments[1] : undefined;
        if (t < .25 || t > 2) throw Error("Please pass a value between 0.25 and 2.0");
        var i = this.getElement(e);
        i && (i.playbackRate = t);
      }
    }, {
      key: "setEnabled",
      value: function setEnabled(r, s) {
        return c(this, arguments, function (e, _ref20) {
          var _this65 = this;
          var t = _ref20.id,
            _ref20$type = _ref20.type,
            i = _ref20$type === void 0 ? b.audio : _ref20$type;
          return /*#__PURE__*/_regeneratorRuntime().mark(function _callee126() {
            var d, l;
            return _regeneratorRuntime().wrap(function _callee126$(_context127) {
              while (1) switch (_context127.prev = _context127.next) {
                case 0:
                  d = _this65.state[i].list.findIndex(function (h) {
                    return h.id === t;
                  });
                  if (!(!t || d === -1)) {
                    _context127.next = 4;
                    break;
                  }
                  o.w(_this65.TAG, "Pass a valid id");
                  return _context127.abrupt("return");
                case 4:
                  l = _this65.state[i].list[d].url;
                  if (!e) {
                    _context127.next = 10;
                    break;
                  }
                  _context127.next = 8;
                  return _this65.play(l, i);
                case 8:
                  _context127.next = 12;
                  break;
                case 10:
                  _context127.next = 12;
                  return _this65.pause(l, i);
                case 12:
                  _this65.state[i].currentIndex = d;
                  _this65.setDuration(i);
                case 14:
                case "end":
                  return _context127.stop();
              }
            }, _callee126);
          })();
        });
      }
    }, {
      key: "playNext",
      value: function playNext() {
        return c(this, arguments, function () {
          var _this66 = this;
          var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : b.audio;
          return /*#__PURE__*/_regeneratorRuntime().mark(function _callee127() {
            var _this66$state$e, t, i;
            return _regeneratorRuntime().wrap(function _callee127$(_context128) {
              while (1) switch (_context128.prev = _context128.next) {
                case 0:
                  _this66$state$e = _this66.state[e], t = _this66$state$e.list, i = _this66$state$e.currentIndex;
                  if (!(i >= t.length - 1)) {
                    _context128.next = 3;
                    break;
                  }
                  throw m.PlaylistErrors.NoEntryToPlay(p.PLAYLIST, "Reached end of playlist");
                case 3:
                  _context128.next = 5;
                  return _this66.play(t[i + 1].url, e);
                case 5:
                  _this66.state[e].currentIndex = i + 1;
                  _this66.setDuration(e);
                case 7:
                case "end":
                  return _context128.stop();
              }
            }, _callee127);
          })();
        });
      }
    }, {
      key: "playPrevious",
      value: function playPrevious() {
        return c(this, arguments, function () {
          var _this67 = this;
          var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : b.audio;
          return /*#__PURE__*/_regeneratorRuntime().mark(function _callee128() {
            var _this67$state$e, t, i;
            return _regeneratorRuntime().wrap(function _callee128$(_context129) {
              while (1) switch (_context129.prev = _context129.next) {
                case 0:
                  _this67$state$e = _this67.state[e], t = _this67$state$e.list, i = _this67$state$e.currentIndex;
                  if (!(i <= 0)) {
                    _context129.next = 3;
                    break;
                  }
                  throw m.PlaylistErrors.NoEntryToPlay(p.PLAYLIST, "Reached start of playlist");
                case 3:
                  _context129.next = 5;
                  return _this67.play(t[i - 1].url, e);
                case 5:
                  _this67.state[e].currentIndex = i - 1;
                  _this67.setDuration(e);
                case 7:
                case "end":
                  return _context129.stop();
              }
            }, _callee128);
          })();
        });
      }
    }, {
      key: "stop",
      value: function stop() {
        return c(this, arguments, function () {
          var _this68 = this;
          var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : b.audio;
          return /*#__PURE__*/_regeneratorRuntime().mark(function _callee129() {
            var i, t;
            return _regeneratorRuntime().wrap(function _callee129$(_context130) {
              while (1) switch (_context130.prev = _context130.next) {
                case 0:
                  t = e === b.audio ? _this68.audioManager : _this68.videoManager;
                  (i = t.getElement()) == null || i.pause();
                  _context130.next = 4;
                  return _this68.removeTracks(e);
                case 4:
                  t.stop();
                  _this68.state[e].currentIndex = -1;
                case 6:
                case "end":
                  return _context130.stop();
              }
            }, _callee129);
          })();
        });
      }
    }, {
      key: "cleanup",
      value: function cleanup() {
        this.state = {
          audio: v({}, lt.audio),
          video: v({}, lt.video)
        }, this.eventBus.localAudioEnabled.unsubscribe(this.handlePausePlaylist), this.eventBus.localVideoEnabled.unsubscribe(this.handlePausePlaylist), this.audioManager.stop(), this.videoManager.stop();
      }
    }, {
      key: "onProgress",
      value: function onProgress(e) {
        var _this69 = this;
        this.videoManager.on("progress", function () {
          try {
            e({
              type: b.video,
              progress: _this69.getCurrentProgress(b.video)
            });
          } catch (t) {
            o.e(_this69.TAG, "Error in onProgress callback");
          }
        }), this.audioManager.on("progress", function () {
          try {
            e({
              type: b.audio,
              progress: _this69.getCurrentProgress(b.audio)
            });
          } catch (t) {
            o.e(_this69.TAG, "Error in onProgress callback");
          }
        });
      }
    }, {
      key: "onNewTrackStart",
      value: function onNewTrackStart(e) {
        this.on("newTrackStart", e);
      }
    }, {
      key: "onPlaylistEnded",
      value: function onPlaylistEnded(e) {
        this.on("playlistEnded", e);
      }
    }, {
      key: "onCurrentTrackEnded",
      value: function onCurrentTrackEnded(e) {
        this.on("currentTrackEnded", e);
      }
    }, {
      key: "getElement",
      value: function getElement() {
        var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : b.audio;
        return e === b.audio ? this.audioManager.getElement() : this.videoManager.getElement();
      }
    }, {
      key: "removeTracks",
      value: function removeTracks() {
        return c(this, arguments, function () {
          var _this70 = this;
          var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : b.audio;
          return /*#__PURE__*/_regeneratorRuntime().mark(function _callee130() {
            var i, _iterator13, _step13, _r14;
            return _regeneratorRuntime().wrap(function _callee130$(_context131) {
              while (1) switch (_context131.prev = _context131.next) {
                case 0:
                  i = (e === b.audio ? _this70.audioManager : _this70.videoManager).getTracks();
                  _iterator13 = _createForOfIteratorHelper(i);
                  _context131.prev = 2;
                  _iterator13.s();
                case 4:
                  if ((_step13 = _iterator13.n()).done) {
                    _context131.next = 10;
                    break;
                  }
                  _r14 = _step13.value;
                  _context131.next = 8;
                  return _this70.removeTrack(_r14);
                case 8:
                  _context131.next = 4;
                  break;
                case 10:
                  _context131.next = 15;
                  break;
                case 12:
                  _context131.prev = 12;
                  _context131.t0 = _context131["catch"](2);
                  _iterator13.e(_context131.t0);
                case 15:
                  _context131.prev = 15;
                  _iterator13.f();
                  return _context131.finish(15);
                case 18:
                case "end":
                  return _context131.stop();
              }
            }, _callee130, null, [[2, 12, 15, 18]]);
          })();
        });
      }
    }, {
      key: "play",
      value: function play(i) {
        return c(this, arguments, function (e) {
          var _this71 = this;
          var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : b.audio;
          return /*#__PURE__*/_regeneratorRuntime().mark(function _callee131() {
            var r, s, _n3, _iterator14, _step14, _d4;
            return _regeneratorRuntime().wrap(function _callee131$(_context132) {
              while (1) switch (_context132.prev = _context132.next) {
                case 0:
                  r = t === b.audio ? _this71.audioManager : _this71.videoManager, s = r.getElement();
                  if (!_this71.isItemCurrentlyPlaying(e, t)) {
                    _context132.next = 4;
                    break;
                  }
                  o.w(_this71.TAG, "The ".concat(t, " is currently playing"));
                  return _context132.abrupt("return");
                case 4:
                  if (!(s == null ? void 0 : s.src.includes(e))) {
                    _context132.next = 9;
                    break;
                  }
                  _context132.next = 7;
                  return s.play();
                case 7:
                  _context132.next = 30;
                  break;
                case 9:
                  s == null || s.pause();
                  _context132.next = 12;
                  return r.play(e);
                case 12:
                  _n3 = _context132.sent;
                  _iterator14 = _createForOfIteratorHelper(_n3);
                  _context132.prev = 14;
                  _iterator14.s();
                case 16:
                  if ((_step14 = _iterator14.n()).done) {
                    _context132.next = 22;
                    break;
                  }
                  _d4 = _step14.value;
                  _context132.next = 20;
                  return _this71.addTrack(_d4, t === b.audio ? "audioplaylist" : "videoplaylist");
                case 20:
                  _context132.next = 16;
                  break;
                case 22:
                  _context132.next = 27;
                  break;
                case 24:
                  _context132.prev = 24;
                  _context132.t0 = _context132["catch"](14);
                  _iterator14.e(_context132.t0);
                case 27:
                  _context132.prev = 27;
                  _iterator14.f();
                  return _context132.finish(27);
                case 30:
                case "end":
                  return _context132.stop();
              }
            }, _callee131, null, [[14, 24, 27, 30]]);
          })();
        });
      }
    }, {
      key: "isItemCurrentlyPlaying",
      value: function isItemCurrentlyPlaying(e, t) {
        var i = this.getElement(t);
        return !!(i && !i.paused && i.src.includes(e));
      }
    }, {
      key: "setDuration",
      value: function setDuration() {
        var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : b.audio;
        var t = this.getElement(e),
          _this$state$e3 = this.state[e],
          i = _this$state$e3.list,
          r = _this$state$e3.currentIndex;
        i[r] && (i[r].duration = (t == null ? void 0 : t.duration) || 0), this.emit("newTrackStart", i[r]);
      }
    }, {
      key: "pause",
      value: function pause(i) {
        return c(this, arguments, function (e) {
          var _this72 = this;
          var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : b.audio;
          return /*#__PURE__*/_regeneratorRuntime().mark(function _callee132() {
            var r;
            return _regeneratorRuntime().wrap(function _callee132$(_context133) {
              while (1) switch (_context133.prev = _context133.next) {
                case 0:
                  r = _this72.getElement(t);
                  r && !r.paused && r.src.includes(e) ? (r.pause(), o.d(_this72.TAG, "paused url", e)) : o.w(_this72.TAG, "The passed in url is not currently playing");
                case 2:
                case "end":
                  return _context133.stop();
              }
            }, _callee132);
          })();
        });
      }
    }, {
      key: "addListeners",
      value: function addListeners() {
        var _this73 = this;
        this.audioManager.on("ended", function () {
          return _this73.handleEnded(b.audio);
        }), this.videoManager.on("ended", function () {
          return _this73.handleEnded(b.video);
        }), this.eventBus.localAudioEnabled.subscribe(this.handlePausePlaylist), this.eventBus.localVideoEnabled.subscribe(this.handlePausePlaylist);
      }
    }, {
      key: "handleEnded",
      value: function handleEnded() {
        return c(this, arguments, function () {
          var _this74 = this;
          var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : b.audio;
          return /*#__PURE__*/_regeneratorRuntime().mark(function _callee133() {
            var _this74$state$e, t, i, r;
            return _regeneratorRuntime().wrap(function _callee133$(_context134) {
              while (1) switch (_context134.prev = _context134.next) {
                case 0:
                  _this74$state$e = _this74.state[e], t = _this74$state$e.list, i = _this74$state$e.currentIndex, r = _this74$state$e.isAutoplayOn;
                  if (!(i === t.length - 1)) {
                    _context134.next = 7;
                    break;
                  }
                  _context134.next = 4;
                  return _this74.stop(e);
                case 4:
                  _this74.emit("playlistEnded", e);
                  _context134.next = 13;
                  break;
                case 7:
                  if (!r) {
                    _context134.next = 11;
                    break;
                  }
                  _this74.playNext(e);
                  _context134.next = 13;
                  break;
                case 11:
                  _context134.next = 13;
                  return _this74.pause(t[i].url, e);
                case 13:
                  _this74.emit("currentTrackEnded", t[i]);
                case 14:
                case "end":
                  return _context134.stop();
              }
            }, _callee133);
          })();
        });
      }
    }]);
    return ut;
  }(fe);
var qt = function qt(e, t) {
  var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
  var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "";
  var s = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : "https://prod-init.100ms.live/init";
  var n = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : !1;
  _classCallCheck(this, qt);
  this.authToken = e;
  this.peerId = t;
  this.peerName = i;
  this.data = r;
  this.endpoint = s;
  this.autoSubscribeVideo = n;
};
var C;
(function (s) {
  s[s.ConnectFailed = 0] = "ConnectFailed", s[s.SignalDisconnect = 1] = "SignalDisconnect", s[s.JoinWSMessageFailed = 2] = "JoinWSMessageFailed", s[s.PublishIceConnectionFailed = 3] = "PublishIceConnectionFailed", s[s.SubscribeIceConnectionFailed = 4] = "SubscribeIceConnectionFailed";
})(C || (C = {}));
var Gi = (_Gi = {}, _defineProperty(_Gi, 0, []), _defineProperty(_Gi, 1, []), _defineProperty(_Gi, 2, [1]), _defineProperty(_Gi, 3, [1]), _defineProperty(_Gi, 4, [1]), _Gi);
var R;
(function (d) {
  d.Disconnected = "Disconnected", d.Connecting = "Connecting", d.Joined = "Joined", d.Preview = "Preview", d.Failed = "Failed", d.Reconnecting = "Reconnecting", d.Leaving = "Leaving";
})(R || (R = {}));
var jt = function jt(e) {
  var _this75 = this;
  _classCallCheck(this, jt);
  this.promise = new Promise(function (t, i) {
    _this75.resolve = t, _this75.reject = i, e(t, i);
  });
};
var Jt = /*#__PURE__*/function () {
  function Jt(e, t) {
    _classCallCheck(this, Jt);
    this.onStateChange = e;
    this.sendEvent = t;
    this.TAG = "[RetryScheduler]";
    this.inProgress = new Map();
    this.retryTaskIds = [];
  }
  _createClass(Jt, [{
    key: "schedule",
    value: function schedule(d) {
      return c(this, arguments, function (_ref21) {
        var _this76 = this;
        var e = _ref21.category,
          t = _ref21.error,
          i = _ref21.task,
          r = _ref21.originalState,
          _ref21$maxFailedRetri = _ref21.maxFailedRetries,
          s = _ref21$maxFailedRetri === void 0 ? xe : _ref21$maxFailedRetri,
          _ref21$changeState = _ref21.changeState,
          n = _ref21$changeState === void 0 ? !0 : _ref21$changeState;
        return /*#__PURE__*/_regeneratorRuntime().mark(function _callee134() {
          return _regeneratorRuntime().wrap(function _callee134$(_context135) {
            while (1) switch (_context135.prev = _context135.next) {
              case 0:
                _context135.next = 2;
                return _this76.scheduleTask({
                  category: e,
                  error: t,
                  changeState: n,
                  task: i,
                  originalState: r,
                  maxFailedRetries: s
                });
              case 2:
              case "end":
                return _context135.stop();
            }
          }, _callee134);
        })();
      });
    }
  }, {
    key: "reset",
    value: function reset() {
      this.retryTaskIds.forEach(function (e) {
        return clearTimeout(e);
      }), this.retryTaskIds = [], this.inProgress.clear();
    }
  }, {
    key: "isTaskInProgress",
    value: function isTaskInProgress(e) {
      return !!this.inProgress.get(e);
    }
  }, {
    key: "scheduleTask",
    value: function scheduleTask(l) {
      return c(this, arguments, function (_ref22) {
        var _this77 = this;
        var e = _ref22.category,
          t = _ref22.error,
          i = _ref22.changeState,
          r = _ref22.task,
          s = _ref22.originalState,
          _ref22$maxFailedRetri = _ref22.maxFailedRetries,
          n = _ref22$maxFailedRetri === void 0 ? xe : _ref22$maxFailedRetri,
          _ref22$failedRetryCou = _ref22.failedRetryCount,
          d = _ref22$failedRetryCou === void 0 ? 0 : _ref22$failedRetryCou;
        return /*#__PURE__*/_regeneratorRuntime().mark(function _callee135() {
          var E, N, h, u, _E, _N, O, S, g, _E2;
          return _regeneratorRuntime().wrap(function _callee135$(_context136) {
            while (1) switch (_context136.prev = _context136.next) {
              case 0:
                if (!(o.d(_this77.TAG, "schedule: ", {
                  category: C[e],
                  error: t
                }), d === 0)) {
                  _context136.next = 9;
                  break;
                }
                E = _this77.inProgress.get(e);
                if (!E) {
                  _context136.next = 7;
                  break;
                }
                o.d(_this77.TAG, "schedule: Already a task for ".concat(C[e], " scheduled, waiting for its completion"));
                _context136.next = 6;
                return E.promise;
              case 6:
                return _context136.abrupt("return");
              case 7:
                N = new jt(function (O, I) {});
                _this77.inProgress.set(e, N), _this77.sendEvent(t, e);
              case 9:
                h = !1, u = Gi[e];
                _context136.t0 = _regeneratorRuntime().keys(u);
              case 11:
                if ((_context136.t1 = _context136.t0()).done) {
                  _context136.next = 30;
                  break;
                }
                _E = _context136.t1.value;
                _N = u[parseInt(_E)];
                _context136.prev = 14;
                O = _this77.inProgress.get(_N);
                _context136.t2 = O;
                if (!_context136.t2) {
                  _context136.next = 22;
                  break;
                }
                o.d(_this77.TAG, "schedule: Suspending retry task of ".concat(C[e], ", waiting for ").concat(C[_N], " to recover"));
                _context136.next = 21;
                return O.promise;
              case 21:
                o.d(_this77.TAG, "schedule: Resuming retry task ".concat(C[e], " as it's dependency ").concat(C[_N], " is recovered"));
              case 22:
                _context136.next = 28;
                break;
              case 24:
                _context136.prev = 24;
                _context136.t3 = _context136["catch"](14);
                o.d(_this77.TAG, "schedule: Stopping retry task of ".concat(C[e], " as it's dependency ").concat(C[_N], " failed to recover")), h = !0;
                return _context136.abrupt("break", 30);
              case 28:
                _context136.next = 11;
                break;
              case 30:
                if (!(d >= n || h)) {
                  _context136.next = 37;
                  break;
                }
                if (!(t.description += ". [".concat(C[e], "] Could not recover after ").concat(d, " tries"), h && (t.description += " Could not recover all of it's required dependencies - [".concat(u.map(function (E) {
                  return C[E];
                }).toString(), "]")), t.isTerminal = !0, _this77.inProgress.delete(e), _this77.sendEvent(t, e), _this77.reset(), i)) {
                  _context136.next = 35;
                  break;
                }
                _this77.onStateChange(R.Failed, t);
                _context136.next = 36;
                break;
              case 35:
                throw t;
              case 36:
                return _context136.abrupt("return");
              case 37:
                i && _this77.onStateChange(R.Reconnecting, t);
                S = _this77.getDelayForRetryCount(e, d);
                o.i(_this77.TAG, "schedule: [".concat(C[e], "] [failedRetryCount=").concat(d, "] Scheduling retry task in ").concat(S, "ms"));
                _context136.prev = 40;
                _context136.next = 43;
                return _this77.setTimeoutPromise(r, S);
              case 43:
                g = _context136.sent;
                _context136.next = 49;
                break;
              case 46:
                _context136.prev = 46;
                _context136.t4 = _context136["catch"](40);
                g = !1, o.w(_this77.TAG, "[".concat(C[e], "] Un-caught exception ").concat(_context136.t4.name, " in retry-task, initiating retry"), _context136.t4);
              case 49:
                if (!g) {
                  _context136.next = 54;
                  break;
                }
                _E2 = _this77.inProgress.get(e);
                _this77.inProgress.delete(e), _E2 == null || _E2.resolve(d), i && _this77.inProgress.size === 0 && _this77.onStateChange(s), o.i(_this77.TAG, "schedule: [".concat(C[e], "] [failedRetryCount=").concat(d, "] Recovered \u267B\uFE0F"));
                _context136.next = 56;
                break;
              case 54:
                _context136.next = 56;
                return _this77.scheduleTask({
                  category: e,
                  error: t,
                  changeState: i,
                  task: r,
                  originalState: s,
                  maxFailedRetries: n,
                  failedRetryCount: d + 1
                });
              case 56:
              case "end":
                return _context136.stop();
            }
          }, _callee135, null, [[14, 24], [40, 46]]);
        })();
      });
    }
  }, {
    key: "getBaseDelayForTask",
    value: function getBaseDelayForTask(e, t) {
      return e === C.JoinWSMessageFailed ? 2 : Math.pow(2, t);
    }
  }, {
    key: "getDelayForRetryCount",
    value: function getDelayForRetryCount(e, t) {
      var i = this.getBaseDelayForTask(e, t),
        r = e === C.JoinWSMessageFailed ? Math.random() * 2 : Math.random();
      return Math.round(Math.min(i + r, bi) * 1e3);
    }
  }, {
    key: "setTimeoutPromise",
    value: function setTimeoutPromise(e, t) {
      return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee137() {
        var _this78 = this;
        return _regeneratorRuntime().wrap(function _callee137$(_context138) {
          while (1) switch (_context138.prev = _context138.next) {
            case 0:
              return _context138.abrupt("return", new Promise(function (i, r) {
                var s = window.setTimeout(function () {
                  return c(_this78, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee136() {
                    var _n4;
                    return _regeneratorRuntime().wrap(function _callee136$(_context137) {
                      while (1) switch (_context137.prev = _context137.next) {
                        case 0:
                          _context137.prev = 0;
                          _context137.next = 3;
                          return e();
                        case 3:
                          _n4 = _context137.sent;
                          _n4 && this.retryTaskIds.splice(this.retryTaskIds.indexOf(s), 1), i(_n4);
                          _context137.next = 10;
                          break;
                        case 7:
                          _context137.prev = 7;
                          _context137.t0 = _context137["catch"](0);
                          r(_context137.t0);
                        case 10:
                        case "end":
                          return _context137.stop();
                      }
                    }, _callee136, this, [[0, 7]]);
                  }));
                }, t);
                _this78.retryTaskIds.push(s);
              }));
            case 1:
            case "end":
              return _context138.stop();
          }
        }, _callee137);
      }));
    }
  }]);
  return Jt;
}();
var Qt = /*#__PURE__*/function (_Se) {
  _inherits(Qt, _Se);
  function Qt() {
    var _this79;
    _classCallCheck(this, Qt);
    _this79 = _possibleConstructorReturn(this, _getPrototypeOf(Qt).call(this, it));
    _this79.localStorage = new te("hms-analytics");
    _this79.localStorage.clear(), _this79.initLocalStorageQueue();
    return _this79;
  }
  _createClass(Qt, [{
    key: "enqueue",
    value: function enqueue(e) {
      _get(_getPrototypeOf(Qt.prototype), "enqueue", this).call(this, e), this.localStorage.set(this.storage);
    }
  }, {
    key: "dequeue",
    value: function dequeue() {
      var e = _get(_getPrototypeOf(Qt.prototype), "dequeue", this).call(this);
      return this.localStorage.set(this.storage), e;
    }
  }, {
    key: "initLocalStorageQueue",
    value: function initLocalStorageQueue() {
      var _this80 = this;
      var e;
      (e = this.localStorage.get()) == null || e.forEach(function (t) {
        var i = new x(t);
        _get(_getPrototypeOf(Qt.prototype), "enqueue", _this80).call(_this80, i);
      });
    }
  }]);
  return Qt;
}(Se);
var Yt = /*#__PURE__*/function () {
  function Yt() {
    _classCallCheck(this, Yt);
    this.TAG = "[AnalyticsTransport]";
  }
  _createClass(Yt, [{
    key: "sendEvent",
    value: function sendEvent(e) {
      try {
        this.sendSingleEvent(e), this.flushFailedEvents();
      } catch (t) {
        o.w(this.TAG, "sendEvent failed", t);
      }
    }
  }, {
    key: "flushFailedEvents",
    value: function flushFailedEvents(e) {
      var t;
      try {
        for (o.d(this.TAG, "Flushing failed events", this.failedEvents); this.failedEvents.size() > 0;) {
          var _i13 = this.failedEvents.dequeue();
          _i13 && (((t = _i13.metadata) == null ? void 0 : t.peer.peer_id) === e || !_i13.metadata.peer.peer_id ? this.sendSingleEvent(_i13) : se.sendEvent(_i13));
        }
      } catch (i) {
        o.w(this.TAG, "flushFailedEvents failed", i);
      }
    }
  }, {
    key: "sendSingleEvent",
    value: function sendSingleEvent(e) {
      try {
        this.transportProvider.sendEvent(e), o.d(this.TAG, "Sent event", e.name, e);
      } catch (t) {
        throw o.w(this.TAG, "".concat(this.transportProvider.TAG, ".sendEvent failed, adding to local storage events"), {
          event: e,
          error: t
        }), this.failedEvents.enqueue(e), t;
      }
    }
  }]);
  return Yt;
}();
var zt = /*#__PURE__*/function (_Yt) {
  _inherits(zt, _Yt);
  function zt(e) {
    var _this81;
    _classCallCheck(this, zt);
    _this81 = _possibleConstructorReturn(this, _getPrototypeOf(zt).call(this));
    _this81.transportProvider = e;
    _this81.failedEvents = new Qt();
    return _this81;
  }
  return zt;
}(Yt);
var G;
(function (t) {
  t[t.Publish = 0] = "Publish", t[t.Subscribe = 1] = "Subscribe";
})(G || (G = {}));
import { parse as qi, write as Ir } from "sdp-transform";
var Vi = "[VALIDATIONS]";
function ae(a) {
  return a != null;
}
var Zt = function Zt() {
    if (!ae(RTCPeerConnection)) {
      var a = m.GenericErrors.MissingRTCPeerConnection();
      throw o.e(Vi, a), a;
    }
  },
  Xt = function Xt() {
    if (!ae(navigator.mediaDevices)) {
      var a = m.GenericErrors.MissingMediaDevices();
      throw o.e(Vi, a), a;
    }
  };
function $i(a, e) {
  var r;
  var t = qi(a.sdp);
  if (!((r = t.origin) == null ? void 0 : r.username.startsWith("mozilla"))) return a;
  var i = e ? Array.from(e.values()) : [];
  return t.media.forEach(function (s) {
    var l, h, u;
    var n = (l = s.msid) == null ? void 0 : l.split(" ")[0],
      d = (h = i.find(function (S) {
        return S.type === s.type && S.stream_id === n;
      })) == null ? void 0 : h.track_id;
    d && (s.msid = (u = s.msid) == null ? void 0 : u.replace(/\s(.+)/, " ".concat(d)));
  }), {
    type: a.type,
    sdp: Ir(t)
  };
}
function Wi(a, e) {
  var s;
  if (!(a == null ? void 0 : a.sdp) || !e) return;
  var i = qi(a.sdp).media.find(function (n) {
    return ae(n.mid) && parseInt(n.mid) === parseInt(e);
  });
  return (s = i == null ? void 0 : i.msid) == null ? void 0 : s.split(" ")[1];
}
function Ki(a) {
  return a.sdp.includes("usedtx=1") ? a : {
    type: a.type,
    sdp: a.sdp.replace("useinbandfec=1", "useinbandfec=1;usedtx=1")
  };
}
var he = "[HMSConnection]",
  we = /*#__PURE__*/function () {
    function we(e, t) {
      _classCallCheck(this, we);
      this.candidates = new Array();
      this.role = e, this.signal = t;
    }
    _createClass(we, [{
      key: "addTransceiver",
      value: function addTransceiver(e, t) {
        return this.nativeConnection.addTransceiver(e, t);
      }
    }, {
      key: "createOffer",
      value: function createOffer(e, t) {
        return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee138() {
          var _i14;
          return _regeneratorRuntime().wrap(function _callee138$(_context139) {
            while (1) switch (_context139.prev = _context139.next) {
              case 0:
                _context139.prev = 0;
                _context139.next = 3;
                return this.nativeConnection.createOffer(t);
              case 3:
                _i14 = _context139.sent;
                return _context139.abrupt("return", (o.d(he, "[role=".concat(this.role, "] createOffer offer=").concat(JSON.stringify(_i14, null, 1))), Ki($i(_i14, e))));
              case 7:
                _context139.prev = 7;
                _context139.t0 = _context139["catch"](0);
                throw m.WebrtcErrors.CreateOfferFailed(this.action, _context139.t0.message);
              case 10:
              case "end":
                return _context139.stop();
            }
          }, _callee138, this, [[0, 7]]);
        }));
      }
    }, {
      key: "createAnswer",
      value: function createAnswer() {
        var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : void 0;
        return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee139() {
          var _t10;
          return _regeneratorRuntime().wrap(function _callee139$(_context140) {
            while (1) switch (_context140.prev = _context140.next) {
              case 0:
                _context140.prev = 0;
                _context140.next = 3;
                return this.nativeConnection.createAnswer(e);
              case 3:
                _t10 = _context140.sent;
                return _context140.abrupt("return", (o.d(he, "[role=".concat(this.role, "] createAnswer answer=").concat(JSON.stringify(_t10, null, 1))), _t10));
              case 7:
                _context140.prev = 7;
                _context140.t0 = _context140["catch"](0);
                throw m.WebrtcErrors.CreateAnswerFailed(this.action, _context140.t0.message);
              case 10:
              case "end":
                return _context140.stop();
            }
          }, _callee139, this, [[0, 7]]);
        }));
      }
    }, {
      key: "setLocalDescription",
      value: function setLocalDescription(e) {
        return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee140() {
          return _regeneratorRuntime().wrap(function _callee140$(_context141) {
            while (1) switch (_context141.prev = _context141.next) {
              case 0:
                _context141.prev = 0;
                o.d(he, "[role=".concat(this.role, "] setLocalDescription description=").concat(JSON.stringify(e, null, 1)));
                _context141.next = 4;
                return this.nativeConnection.setLocalDescription(e);
              case 4:
                _context141.next = 9;
                break;
              case 6:
                _context141.prev = 6;
                _context141.t0 = _context141["catch"](0);
                throw m.WebrtcErrors.SetLocalDescriptionFailed(this.action, _context141.t0.message);
              case 9:
              case "end":
                return _context141.stop();
            }
          }, _callee140, this, [[0, 6]]);
        }));
      }
    }, {
      key: "setRemoteDescription",
      value: function setRemoteDescription(e) {
        return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee141() {
          return _regeneratorRuntime().wrap(function _callee141$(_context142) {
            while (1) switch (_context142.prev = _context142.next) {
              case 0:
                _context142.prev = 0;
                o.d(he, "[role=".concat(this.role, "] setRemoteDescription description=").concat(JSON.stringify(e, null, 1)));
                _context142.next = 4;
                return this.nativeConnection.setRemoteDescription(e);
              case 4:
                _context142.next = 9;
                break;
              case 6:
                _context142.prev = 6;
                _context142.t0 = _context142["catch"](0);
                throw m.WebrtcErrors.SetRemoteDescriptionFailed(this.action, _context142.t0.message);
              case 9:
              case "end":
                return _context142.stop();
            }
          }, _callee141, this, [[0, 6]]);
        }));
      }
    }, {
      key: "addIceCandidate",
      value: function addIceCandidate(e) {
        return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee142() {
          return _regeneratorRuntime().wrap(function _callee142$(_context143) {
            while (1) switch (_context143.prev = _context143.next) {
              case 0:
                o.d(he, "[role=".concat(this.role, "] addIceCandidate candidate=").concat(JSON.stringify(e, null, 1)));
                _context143.next = 3;
                return this.nativeConnection.addIceCandidate(e);
              case 3:
              case "end":
                return _context143.stop();
            }
          }, _callee142, this);
        }));
      }
    }, {
      key: "getSenders",
      value: function getSenders() {
        return this.nativeConnection.getSenders();
      }
    }, {
      key: "logSelectedIceCandidatePairs",
      value: function logSelectedIceCandidatePairs() {
        var _this82 = this;
        try {
          (this.role === G.Publish ? this.getSenders() : this.getReceivers()).forEach(function (t) {
            var r;
            var i = (r = t.track) == null ? void 0 : r.kind;
            if (t.transport) {
              var s = t.transport.iceTransport,
                _n5 = function _n5() {
                  typeof s.getSelectedCandidatePair == "function" && (_this82.selectedCandidatePair = s.getSelectedCandidatePair(), o.d(he, "".concat(G[_this82.role], " connection"), "selected ".concat(i || "unknown", " candidate pair"), JSON.stringify(_this82.selectedCandidatePair, null, 2)));
                };
              typeof s.onselectedcandidatepairchange == "function" && (s.onselectedcandidatepairchange = _n5), _n5();
            }
          });
        } catch (e) {
          o.w(he, "Error in logging selected ice candidate pair for ".concat(G[this.role], " connection"), e);
        }
      }
    }, {
      key: "removeTrack",
      value: function removeTrack(e) {
        this.nativeConnection.signalingState !== "closed" && this.nativeConnection.removeTrack(e);
      }
    }, {
      key: "setMaxBitrateAndFramerate",
      value: function setMaxBitrateAndFramerate(e) {
        return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee143() {
          var t, i, r, s;
          return _regeneratorRuntime().wrap(function _callee143$(_context144) {
            while (1) switch (_context144.prev = _context144.next) {
              case 0:
                t = e.settings.maxBitrate, i = e instanceof Z && e.settings.maxFramerate, r = this.getSenders().find(function (s) {
                  var n;
                  return ((n = s == null ? void 0 : s.track) == null ? void 0 : n.id) === e.getTrackIDBeingSent();
                });
                if (!r) {
                  _context144.next = 8;
                  break;
                }
                s = r.getParameters();
                s.encodings.length > 0 && (t && (s.encodings[0].maxBitrate = t * 1e3), i && (s.encodings[0].maxFramerate = i));
                _context144.next = 6;
                return r.setParameters(s);
              case 6:
                _context144.next = 9;
                break;
              case 8:
                o.w(he, "no sender found to setMaxBitrate for track - ".concat(e.trackId, ", sentTrackId - ").concat(e.getTrackIDBeingSent()));
              case 9:
              case "end":
                return _context144.stop();
            }
          }, _callee143, this);
        }));
      }
    }, {
      key: "getStats",
      value: function getStats() {
        return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee144() {
          return _regeneratorRuntime().wrap(function _callee144$(_context145) {
            while (1) switch (_context145.prev = _context145.next) {
              case 0:
                _context145.next = 2;
                return this.nativeConnection.getStats();
              case 2:
                return _context145.abrupt("return", _context145.sent);
              case 3:
              case "end":
                return _context145.stop();
            }
          }, _callee144, this);
        }));
      }
    }, {
      key: "close",
      value: function close() {
        return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee145() {
          return _regeneratorRuntime().wrap(function _callee145$(_context146) {
            while (1) switch (_context146.prev = _context146.next) {
              case 0:
                this.nativeConnection.close();
              case 1:
              case "end":
                return _context146.stop();
            }
          }, _callee145, this);
        }));
      }
    }, {
      key: "getReceivers",
      value: function getReceivers() {
        return this.nativeConnection.getReceivers();
      }
    }, {
      key: "iceConnectionState",
      get: function get() {
        return this.nativeConnection.iceConnectionState;
      }
    }, {
      key: "connectionState",
      get: function get() {
        return this.nativeConnection.connectionState;
      }
    }, {
      key: "action",
      get: function get() {
        return this.role === G.Publish ? p.PUBLISH : p.SUBSCRIBE;
      }
    }, {
      key: "remoteDescription",
      get: function get() {
        return this.nativeConnection.remoteDescription;
      }
    }]);
    return we;
  }();
var ht = /*#__PURE__*/function (_we) {
  _inherits(ht, _we);
  function ht(e, t, i, r) {
    var _this83;
    _classCallCheck(this, ht);
    _this83 = _possibleConstructorReturn(this, _getPrototypeOf(ht).call(this, G.Publish, e));
    _this83.TAG = "[HMSPublishConnection]";
    _this83.observer = i, _this83.transport = r, _this83.nativeConnection = new RTCPeerConnection(t), _this83.nativeConnection.createDataChannel(tt, {
      protocol: "SCTP"
    }), _this83.nativeConnection.onicecandidate = function (_ref23) {
      var s = _ref23.candidate;
      s && e.trickle(_this83.role, s);
    }, _this83.nativeConnection.oniceconnectionstatechange = function () {
      _this83.observer.onIceConnectionChange(_this83.nativeConnection.iceConnectionState);
    }, _this83.nativeConnection.onconnectionstatechange = function () {
      _this83.observer.onConnectionStateChange(_this83.nativeConnection.connectionState);
    };
    return _this83;
  }
  _createClass(ht, [{
    key: "initAfterJoin",
    value: function initAfterJoin() {
      var _this84 = this;
      this.nativeConnection.onnegotiationneeded = function () {
        return c(_this84, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee146() {
          return _regeneratorRuntime().wrap(function _callee146$(_context147) {
            while (1) switch (_context147.prev = _context147.next) {
              case 0:
                o.d(this.TAG, "onnegotiationneeded");
                _context147.next = 3;
                return this.observer.onRenegotiationNeeded();
              case 3:
              case "end":
                return _context147.stop();
            }
          }, _callee146, this);
        }));
      };
    }
  }, {
    key: "trackUpdate",
    value: function trackUpdate(e) {
      this.transport.trackUpdate(e);
    }
  }]);
  return ht;
}(we);
import br from "eventemitter2";
import { v4 as Cr } from "uuid";
var pt = /*#__PURE__*/function () {
  function pt(e, t) {
    var _this85 = this;
    var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
    _classCallCheck(this, pt);
    this.TAG = "[HMSDataChannel]";
    this.nativeChannel = e, this.observer = t, this.metadata = i, e.onmessage = function (r) {
      _this85.observer.onMessage(r.data);
    };
  }
  _createClass(pt, [{
    key: "send",
    value: function send(e) {
      o.d(this.TAG, "[".concat(this.metadata, "] Sending [size=").concat(e.length, "] message=").concat(e)), this.nativeChannel.send(e);
    }
  }, {
    key: "close",
    value: function close() {
      this.nativeChannel.close();
    }
  }, {
    key: "id",
    get: function get() {
      return this.nativeChannel.id;
    }
  }, {
    key: "label",
    get: function get() {
      return this.nativeChannel.label;
    }
  }, {
    key: "readyState",
    get: function get() {
      return this.nativeChannel.readyState;
    }
  }]);
  return pt;
}();
var mt = /*#__PURE__*/function (_we2) {
  _inherits(mt, _we2);
  function mt(e, t, i) {
    var _this86;
    _classCallCheck(this, mt);
    _this86 = _possibleConstructorReturn(this, _getPrototypeOf(mt).call(this, G.Subscribe, e));
    _this86.TAG = "[HMSSubscribeConnection]";
    _this86.remoteStreams = new Map();
    _this86.MAX_RETRIES = 3;
    _this86.pendingMessageQueue = [];
    _this86.eventEmitter = new br({
      maxListeners: 15
    });
    _this86.handlePendingApiMessages = function () {
      _this86.eventEmitter.emit("open", !0), _this86.pendingMessageQueue.length > 0 && (o.d(_this86.TAG, "Found pending message queue, sending messages"), _this86.pendingMessageQueue.forEach(function (e) {
        return _this86.sendOverApiDataChannel(e);
      }), _this86.pendingMessageQueue.length = 0);
    };
    _this86.sendMessage = function (e, t) {
      return c(_assertThisInitialized(_assertThisInitialized(_this86)), null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee147() {
        var r, i, s, _n6, l;
        return _regeneratorRuntime().wrap(function _callee147$(_context148) {
          while (1) switch (_context148.prev = _context148.next) {
            case 0:
              _context148.t0 = ((r = this.apiChannel) == null ? void 0 : r.readyState) !== "open";
              if (!_context148.t0) {
                _context148.next = 4;
                break;
              }
              _context148.next = 4;
              return this.eventEmitter.waitFor("open");
            case 4:
              s = 0;
            case 5:
              if (!(s < this.MAX_RETRIES)) {
                _context148.next = 26;
                break;
              }
              this.apiChannel.send(e);
              _context148.next = 9;
              return this.waitForResponse(t);
            case 9:
              i = _context148.sent;
              _n6 = i.error;
              if (!_n6) {
                _context148.next = 22;
                break;
              }
              if (!(_n6.code === 404)) {
                _context148.next = 15;
                break;
              }
              o.d(this.TAG, "Track not found ".concat(t), {
                request: e,
                try: s + 1,
                error: _n6
              });
              return _context148.abrupt("break", 26);
            case 15:
              if (!(o.e(this.TAG, "Failed sending ".concat(t), {
                request: e,
                try: s + 1,
                error: _n6
              }), !(_n6.code / 100 == 5 || _n6.code === 429))) {
                _context148.next = 17;
                break;
              }
              throw Error("code=".concat(_n6.code, ", message=").concat(_n6.message));
            case 17:
              l = (2 + Math.random() * 2) * 1e3;
              _context148.next = 20;
              return $(l);
            case 20:
              _context148.next = 23;
              break;
            case 22:
              return _context148.abrupt("break", 26);
            case 23:
              s++;
              _context148.next = 5;
              break;
            case 26:
              return _context148.abrupt("return", i);
            case 27:
            case "end":
              return _context148.stop();
          }
        }, _callee147, this);
      }));
    };
    _this86.waitForResponse = function (e) {
      return c(_assertThisInitialized(_assertThisInitialized(_this86)), null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee148() {
        var t, i;
        return _regeneratorRuntime().wrap(function _callee148$(_context149) {
          while (1) switch (_context149.prev = _context149.next) {
            case 0:
              _context149.next = 2;
              return this.eventEmitter.waitFor("message", function (r) {
                return r.includes(e);
              });
            case 2:
              t = _context149.sent;
              i = JSON.parse(t[0]);
              return _context149.abrupt("return", (o.d(this.TAG, "response for ".concat(e, " -"), JSON.stringify(i, null, 2)), i));
            case 5:
            case "end":
              return _context149.stop();
          }
        }, _callee148, this);
      }));
    };
    _this86.observer = i, _this86.nativeConnection = new RTCPeerConnection(t), _this86.initNativeConnectionCallbacks();
    return _this86;
  }
  _createClass(mt, [{
    key: "initNativeConnectionCallbacks",
    value: function initNativeConnectionCallbacks() {
      var _this87 = this;
      this.nativeConnection.oniceconnectionstatechange = function () {
        _this87.observer.onIceConnectionChange(_this87.nativeConnection.iceConnectionState);
      }, this.nativeConnection.onconnectionstatechange = function () {
        _this87.observer.onConnectionStateChange(_this87.nativeConnection.connectionState);
      }, this.nativeConnection.ondatachannel = function (e) {
        e.channel.label === tt && (_this87.apiChannel = new pt(e.channel, {
          onMessage: function onMessage(t) {
            _this87.eventEmitter.emit("message", t), _this87.observer.onApiChannelMessage(t);
          }
        }, "role=".concat(_this87.role)), e.channel.onopen = _this87.handlePendingApiMessages);
      }, this.nativeConnection.onicecandidate = function (e) {
        e.candidate !== null && _this87.signal.trickle(_this87.role, e.candidate);
      }, this.nativeConnection.ontrack = function (e) {
        var l;
        var t = e.streams[0],
          i = t.id;
        if (!_this87.remoteStreams.has(i)) {
          var h = new Pe(t, _this87);
          _this87.remoteStreams.set(i, h), t.onremovetrack = function (u) {
            var S = h.tracks.findIndex(function (g) {
              return g.nativeTrack.id === u.track.id;
            });
            if (S >= 0) {
              var g = h.tracks[S];
              _this87.observer.onTrackRemove(g), h.tracks.splice(S, 1), h.tracks.length === 0 && _this87.remoteStreams.delete(i);
            }
          };
        }
        var r = _this87.remoteStreams.get(i),
          s = e.track.kind === "audio" ? Rt : ve,
          n = new s(r, e.track),
          d = Wi(_this87.remoteDescription, (l = e.transceiver) == null ? void 0 : l.mid);
        d && n.setSdpTrackId(d), r.tracks.push(n), _this87.observer.onTrackAdd(n);
      };
    }
  }, {
    key: "sendOverApiDataChannel",
    value: function sendOverApiDataChannel(e) {
      this.apiChannel && this.apiChannel.readyState === "open" ? this.apiChannel.send(e) : (o.w(this.TAG, "API Data channel not ".concat(this.apiChannel ? "open" : "present", ", queueing"), e), this.pendingMessageQueue.push(e));
    }
  }, {
    key: "sendOverApiDataChannelWithResponse",
    value: function sendOverApiDataChannelWithResponse(e, t) {
      return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee149() {
        var i, r;
        return _regeneratorRuntime().wrap(function _callee149$(_context150) {
          while (1) switch (_context150.prev = _context150.next) {
            case 0:
              i = Cr(), r = JSON.stringify(v({
                id: t || i,
                jsonrpc: "2.0"
              }, e));
              return _context150.abrupt("return", this.sendMessage(r, i));
            case 2:
            case "end":
              return _context150.stop();
          }
        }, _callee149, this);
      }));
    }
  }, {
    key: "close",
    value: function close() {
      var _this88 = this;
      var e = function e(t) {
        return _get(_getPrototypeOf(mt.prototype), t, _this88);
      };
      return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee150() {
        var i;
        return _regeneratorRuntime().wrap(function _callee150$(_context151) {
          while (1) switch (_context151.prev = _context151.next) {
            case 0:
              _context151.next = 2;
              return e("close").call(this);
            case 2:
              (i = this.apiChannel) == null || i.close();
            case 3:
            case "end":
              return _context151.stop();
          }
        }, _callee150, this);
      }));
    }
  }]);
  return mt;
}(we);
var ji = function ji(a, e, t, i) {
    return c(void 0, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee151() {
      var n, r, s, _d5, l, h;
      return _regeneratorRuntime().wrap(function _callee151$(_context152) {
        while (1) switch (_context152.prev = _context152.next) {
          case 0:
            s = {};
            if (!e.stream.hasSender(e)) {
              _context152.next = 14;
              break;
            }
            _context152.prev = 2;
            _context152.next = 5;
            return (n = a.publish) == null ? void 0 : n.call(a, e.getTrackBeingSent());
          case 5:
            r = _context152.sent;
            _d5 = {}, l = {}, h = {};
            r == null || r.forEach(function (u) {
              switch (u.type) {
                case "outbound-rtp":
                  l[u.id] = u;
                  break;
                case "remote-inbound-rtp":
                  h[u.ssrc] = u;
                  break;
                case "codec":
                  _d5[u.id] = u.mimeType;
                  break;
                default:
                  break;
              }
            }), Object.keys(v({}, l)).forEach(function (u) {
              var I;
              var S = (I = l[u]) == null ? void 0 : I.codecId,
                g = S ? _d5[S] : void 0,
                E;
              g && (E = g.substring(g.indexOf("/") + 1));
              var N = l[u],
                O = h[N.ssrc];
              s[u] = L(v({}, N), {
                bitrate: ii("bytesSent", N, i == null ? void 0 : i[u]),
                packetsLost: O == null ? void 0 : O.packetsLost,
                jitter: O == null ? void 0 : O.jitter,
                roundTripTime: O == null ? void 0 : O.roundTripTime,
                totalRoundTripTime: O == null ? void 0 : O.totalRoundTripTime,
                peerName: t,
                peerID: e.peerId,
                codec: E
              });
            });
            _context152.next = 13;
            break;
          case 10:
            _context152.prev = 10;
            _context152.t0 = _context152["catch"](2);
            o.w("[HMSWebrtcStats]", "Error in getting local track stats", e, _context152.t0, _context152.t0.name);
          case 13:
            return _context152.abrupt("return", s);
          case 14:
          case "end":
            return _context152.stop();
        }
      }, _callee151, null, [[2, 10]]);
    }));
  },
  Ji = function Ji(a, e, t, i) {
    return c(void 0, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee152() {
      var l, r, s, n, d;
      return _regeneratorRuntime().wrap(function _callee152$(_context153) {
        while (1) switch (_context153.prev = _context153.next) {
          case 0:
            _context153.prev = 0;
            _context153.next = 3;
            return (l = a.subscribe) == null ? void 0 : l.call(a, e.nativeTrack);
          case 3:
            r = _context153.sent;
            _context153.next = 9;
            break;
          case 6:
            _context153.prev = 6;
            _context153.t0 = _context153["catch"](0);
            o.w("[HMSWebrtcStats]", "Error in getting remote track stats", e, _context153.t0);
          case 9:
            s = Rr(r), n = ii("bytesReceived", s, i), d = ri("packetsLost", s, i);
            return _context153.abrupt("return", ((s == null ? void 0 : s.remote) && Object.assign(s.remote, {
              packetsLostRate: ri("packetsLost", s.remote, i == null ? void 0 : i.remote)
            }), s && Object.assign(s, {
              bitrate: n,
              packetsLostRate: d,
              peerId: e.peerId,
              peerName: t,
              codec: s.codec
            })));
          case 11:
          case "end":
            return _context153.stop();
        }
      }, _callee152, null, [[0, 6]]);
    }));
  },
  Rr = function Rr(a) {
    var e,
      t,
      i = {};
    a == null || a.forEach(function (n) {
      switch (n.type) {
        case "inbound-rtp":
          e = n;
          break;
        case "outbound-rtp":
          e = n;
          break;
        case "remote-inbound-rtp":
          t = n;
          break;
        case "codec":
          i[n.id] = n.mimeType;
          break;
        default:
          break;
      }
    });
    var r = (e == null ? void 0 : e.codecId) ? i[e.codecId] : void 0,
      s;
    return r && (s = r.substring(r.indexOf("/") + 1)), e && Object.assign(e, {
      remote: t,
      codec: s
    });
  },
  ei = function ei(a, e, t) {
    var i = wr(e),
      r = ii(a === "publish" ? "bytesSent" : "bytesReceived", i, t && t[a]);
    return i && Object.assign(i, {
      bitrate: r
    });
  },
  wr = function wr(a) {
    var e;
    return a.forEach(function (t) {
      t.type === "transport" && (e = a.get(t.selectedCandidatePairId));
    }), e || a.forEach(function (t) {
      t.type === "candidate-pair" && t.selected && (e = t);
    }), e;
  },
  Qi = function Qi(a) {
    var e = {
      packetsLost: 0,
      jitter: 0
    };
    return a == null || a.forEach(function (t) {
      t.packetsLost && (e.packetsLost += t.packetsLost), t.jitter > e.jitter && (e.jitter = t.jitter);
    }), e;
  },
  ti = function ti(a, e) {
    return Array.from(new Set(a.concat(e)));
  },
  ii = function ii(a, e, t) {
    return ri(a, e, t) * 8;
  },
  ri = function ri(a, e, t) {
    var i = e && e[a],
      r = t ? t[a] : null;
    return [e, t, ae(i), ae(r)].every(function (n) {
      return !!n;
    }) ? si(i, r, e == null ? void 0 : e.timestamp, t == null ? void 0 : t.timestamp) * 1e3 : 0;
  },
  si = function si(a, e, t, i) {
    return ae(a) && ae(e) && t && i ? (a - e) / (t - i) : 0;
  };
var gt = /*#__PURE__*/function () {
  function gt(e, t) {
    _classCallCheck(this, gt);
    this.getStats = e;
    this.store = t;
    this.TAG = "[HMSWebrtcStats]";
    this.peerStats = {};
    this.remoteTrackStats = {};
    this.localTrackStats = {};
    var i;
    this.localPeerID = (i = this.store.getLocalPeer()) == null ? void 0 : i.peerId;
  }
  _createClass(gt, [{
    key: "getLocalPeerStats",
    value: function getLocalPeerStats() {
      return this.peerStats[this.localPeerID];
    }
  }, {
    key: "getRemoteTrackStats",
    value: function getRemoteTrackStats(e) {
      return this.remoteTrackStats[e];
    }
  }, {
    key: "getLocalTrackStats",
    value: function getLocalTrackStats() {
      return this.localTrackStats;
    }
  }, {
    key: "updateStats",
    value: function updateStats() {
      return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee153() {
        return _regeneratorRuntime().wrap(function _callee153$(_context154) {
          while (1) switch (_context154.prev = _context154.next) {
            case 0:
              _context154.next = 2;
              return this.updateLocalPeerStats();
            case 2:
              _context154.next = 4;
              return this.updateLocalTrackStats();
            case 4:
              _context154.next = 6;
              return this.updateRemoteTrackStats();
            case 6:
            case "end":
              return _context154.stop();
          }
        }, _callee153, this);
      }));
    }
  }, {
    key: "updateLocalPeerStats",
    value: function updateLocalPeerStats() {
      return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee154() {
        var u, S, g, E, N, O, e, t, i, r, s, _Qi, n, d, l, h;
        return _regeneratorRuntime().wrap(function _callee154$(_context155) {
          while (1) switch (_context155.prev = _context155.next) {
            case 0:
              e = this.getLocalPeerStats();
              _context155.prev = 1;
              _context155.next = 4;
              return (S = (u = this.getStats).publish) == null ? void 0 : S.call(u);
            case 4:
              t = _context155.sent;
              _context155.next = 10;
              break;
            case 7:
              _context155.prev = 7;
              _context155.t0 = _context155["catch"](1);
              o.w(this.TAG, "Error in getting publish stats", _context155.t0);
            case 10:
              i = t && ei("publish", t, e);
              _context155.prev = 11;
              _context155.next = 14;
              return (E = (g = this.getStats).subscribe) == null ? void 0 : E.call(g);
            case 14:
              r = _context155.sent;
              _context155.next = 20;
              break;
            case 17:
              _context155.prev = 17;
              _context155.t1 = _context155["catch"](11);
              o.w(this.TAG, "Error in getting subscribe stats", _context155.t1);
            case 20:
              s = r && ei("subscribe", r, e), _Qi = Qi(r), n = _Qi.packetsLost, d = _Qi.jitter, l = si(n, (N = e == null ? void 0 : e.subscribe) == null ? void 0 : N.packetsLost, s == null ? void 0 : s.timestamp, (O = e == null ? void 0 : e.subscribe) == null ? void 0 : O.timestamp), h = s && Object.assign(s, {
                packetsLostRate: l,
                jitter: d,
                packetsLost: n
              });
              this.peerStats[this.localPeerID] = {
                publish: i,
                subscribe: h
              };
            case 22:
            case "end":
              return _context155.stop();
          }
        }, _callee154, this, [[1, 7], [11, 17]]);
      }));
    }
  }, {
    key: "updateRemoteTrackStats",
    value: function updateRemoteTrackStats() {
      return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee155() {
        var _this89 = this;
        var i, e, t, _iterator15, _step15, _r15, s, _n7, _d6, l;
        return _regeneratorRuntime().wrap(function _callee155$(_context156) {
          while (1) switch (_context156.prev = _context156.next) {
            case 0:
              e = this.store.getTracksMap(), t = ti(Object.keys(this.remoteTrackStats), Object.keys(e)).filter(function (r) {
                return e[r] && e[r].peerId !== _this89.localPeerID;
              });
              _iterator15 = _createForOfIteratorHelper(t);
              _context156.prev = 2;
              _iterator15.s();
            case 4:
              if ((_step15 = _iterator15.n()).done) {
                _context156.next = 19;
                break;
              }
              _r15 = _step15.value;
              s = e[_r15];
              if (!s) {
                _context156.next = 16;
                break;
              }
              _n7 = s.peerId && ((i = this.store.getPeerById(s.peerId)) == null ? void 0 : i.name);
              _d6 = this.getRemoteTrackStats(s.trackId);
              _context156.next = 12;
              return Ji(this.getStats, s, _n7, _d6);
            case 12:
              l = _context156.sent;
              l && (this.remoteTrackStats[_r15] = l);
              _context156.next = 17;
              break;
            case 16:
              delete this.remoteTrackStats[_r15];
            case 17:
              _context156.next = 4;
              break;
            case 19:
              _context156.next = 24;
              break;
            case 21:
              _context156.prev = 21;
              _context156.t0 = _context156["catch"](2);
              _iterator15.e(_context156.t0);
            case 24:
              _context156.prev = 24;
              _iterator15.f();
              return _context156.finish(24);
            case 27:
            case "end":
              return _context156.stop();
          }
        }, _callee155, this, [[2, 21, 24, 27]]);
      }));
    }
  }, {
    key: "updateLocalTrackStats",
    value: function updateLocalTrackStats() {
      return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee156() {
        var i, e, t, _iterator16, _step16, _r16, s, _n8, _d7;
        return _regeneratorRuntime().wrap(function _callee156$(_context157) {
          while (1) switch (_context157.prev = _context157.next) {
            case 0:
              e = this.store.getLocalPeerTracks().reduce(function (r, s) {
                return r[s.getTrackIDBeingSent()] = s, r;
              }, {}), t = ti(Object.keys(this.localTrackStats), Object.keys(e));
              _iterator16 = _createForOfIteratorHelper(t);
              _context157.prev = 2;
              _iterator16.s();
            case 4:
              if ((_step16 = _iterator16.n()).done) {
                _context157.next = 18;
                break;
              }
              _r16 = _step16.value;
              s = e[_r16];
              if (!s) {
                _context157.next = 15;
                break;
              }
              _n8 = (i = this.store.getLocalPeer()) == null ? void 0 : i.name;
              _context157.next = 11;
              return ji(this.getStats, s, _n8, this.localTrackStats[_r16]);
            case 11:
              _d7 = _context157.sent;
              _d7 && (this.localTrackStats[_r16] = _d7);
              _context157.next = 16;
              break;
            case 15:
              delete this.localTrackStats[_r16];
            case 16:
              _context157.next = 4;
              break;
            case 18:
              _context157.next = 23;
              break;
            case 20:
              _context157.prev = 20;
              _context157.t0 = _context157["catch"](2);
              _iterator16.e(_context157.t0);
            case 23:
              _context157.prev = 23;
              _iterator16.f();
              return _context157.finish(23);
            case 26:
            case "end":
              return _context157.stop();
          }
        }, _callee156, this, [[2, 20, 23, 26]]);
      }));
    }
  }]);
  return gt;
}();
var St = /*#__PURE__*/function () {
  function St(e, t, i, r) {
    var _this90 = this;
    _classCallCheck(this, St);
    this.store = e;
    this.eventBus = t;
    this.publishConnection = i;
    this.subscribeConnection = r;
    this.TAG = "[HMSWebrtcInternals]";
    this.interval = Li;
    this.isMonitored = !1;
    this.handleStatsUpdate = function () {
      return c(_this90, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee157() {
        var e;
        return _regeneratorRuntime().wrap(function _callee157$(_context158) {
          while (1) switch (_context158.prev = _context158.next) {
            case 0:
              _context158.next = 2;
              return (e = this.hmsStats) == null ? void 0 : e.updateStats();
            case 2:
              this.eventBus.statsUpdate.publish(this.hmsStats);
            case 3:
            case "end":
              return _context158.stop();
          }
        }, _callee157, this);
      }));
    };
  }
  _createClass(St, [{
    key: "getPublishPeerConnection",
    value: function getPublishPeerConnection() {
      return this.publishConnection;
    }
  }, {
    key: "getSubscribePeerConnection",
    value: function getSubscribePeerConnection() {
      return this.subscribeConnection;
    }
  }, {
    key: "getCurrentStats",
    value: function getCurrentStats() {
      return this.hmsStats;
    }
  }, {
    key: "onStatsChange",
    value: function onStatsChange(e) {
      var _this91 = this;
      return this.eventBus.statsUpdate.subscribe(e), function () {
        _this91.eventBus.statsUpdate.unsubscribe(e);
      };
    }
  }, {
    key: "setPeerConnections",
    value: function setPeerConnections(_ref24) {
      var e = _ref24.publish,
        t = _ref24.subscribe;
      var i, r;
      this.publishConnection = e, this.subscribeConnection = t, this.hmsStats = new gt({
        publish: (i = this.publishConnection) == null ? void 0 : i.getStats.bind(this.publishConnection),
        subscribe: (r = this.subscribeConnection) == null ? void 0 : r.getStats.bind(this.subscribeConnection)
      }, this.store);
    }
  }, {
    key: "start",
    value: function start() {
      return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee158() {
        var _this92 = this;
        return _regeneratorRuntime().wrap(function _callee158$(_context159) {
          while (1) switch (_context159.prev = _context159.next) {
            case 0:
              if (!this.isMonitored) {
                _context159.next = 3;
                break;
              }
              o.d(this.TAG, "Already started");
              return _context159.abrupt("return");
            case 3:
              this.stop(), this.isMonitored = !0, o.d(this.TAG, "Starting Webrtc Stats Monitor"), this.startLoop().then(function () {
                return o.d(_this92.TAG, "Stopping Webrtc Stats Monitor");
              }).catch(function (e) {
                return o.e(_this92.TAG, e.message);
              });
            case 4:
            case "end":
              return _context159.stop();
          }
        }, _callee158, this);
      }));
    }
  }, {
    key: "stop",
    value: function stop() {
      this.isMonitored = !1;
    }
  }, {
    key: "startLoop",
    value: function startLoop() {
      return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee159() {
        return _regeneratorRuntime().wrap(function _callee159$(_context160) {
          while (1) switch (_context160.prev = _context160.next) {
            case 0:
              if (!this.isMonitored) {
                _context160.next = 7;
                break;
              }
              _context160.next = 3;
              return this.handleStatsUpdate();
            case 3:
              _context160.next = 5;
              return $(this.interval);
            case 5:
              _context160.next = 0;
              break;
            case 7:
            case "end":
              return _context160.stop();
          }
        }, _callee159, this);
      }));
    }
  }, {
    key: "cleanUp",
    value: function cleanUp() {
      this.stop(), this.eventBus.statsUpdate.removeAllListeners();
    }
  }]);
  return St;
}();
var ai = "[InitService]",
  vt = /*#__PURE__*/function () {
    function vt() {
      _classCallCheck(this, vt);
    }
    _createClass(vt, null, [{
      key: "handleError",
      value: function handleError(e, t) {
        switch (e.status) {
          case 404:
            throw m.InitAPIErrors.EndpointUnreachable(p.INIT, t.message || e.statusText);
          case 200:
            break;
          default:
            throw m.InitAPIErrors.ServerErrors(t.code || e.status, p.INIT, t.message || (e == null ? void 0 : e.statusText));
        }
      }
    }, {
      key: "fetchInitConfig",
      value: function fetchInitConfig(n) {
        return c(this, arguments, function (_ref25) {
          var _this93 = this;
          var e = _ref25.token,
            t = _ref25.peerId,
            i = _ref25.userAgent,
            _ref25$initEndpoint = _ref25.initEndpoint,
            r = _ref25$initEndpoint === void 0 ? "https://prod-init.100ms.live" : _ref25$initEndpoint,
            _ref25$region = _ref25.region,
            s = _ref25$region === void 0 ? "" : _ref25$region;
          return /*#__PURE__*/_regeneratorRuntime().mark(function _callee160() {
            var d, l, h, _h;
            return _regeneratorRuntime().wrap(function _callee160$(_context161) {
              while (1) switch (_context161.prev = _context161.next) {
                case 0:
                  o.d(ai, "fetchInitConfig: initEndpoint=".concat(r, " token=").concat(e, " peerId=").concat(t, " region=").concat(s, " "));
                  d = Hr(r, t, i, s);
                  _context161.prev = 2;
                  _context161.next = 5;
                  return fetch(d, {
                    headers: {
                      Authorization: "Bearer ".concat(e)
                    }
                  });
                case 5:
                  l = _context161.sent;
                  _context161.next = 8;
                  return l.json();
                case 8:
                  h = _context161.sent;
                  return _context161.abrupt("return", (_this93.handleError(l, h), o.d(ai, "config is ".concat(JSON.stringify(h, null, 2))), Lr(h)));
                case 12:
                  _context161.prev = 12;
                  _context161.t0 = _context161["catch"](2);
                  _h = _context161.t0;
                  throw ["Failed to fetch", "NetworkError"].some(function (u) {
                    return _h.message.includes(u);
                  }) ? m.InitAPIErrors.EndpointUnreachable(p.INIT, _h.message) : _h;
                case 16:
                case "end":
                  return _context161.stop();
              }
            }, _callee160, null, [[2, 12]]);
          })();
        });
      }
    }]);
    return vt;
  }();
function Hr(a, e, t, i) {
  try {
    var _r17 = new URL("/init", a);
    return i && i.trim().length > 0 && _r17.searchParams.set("region", i.trim()), _r17.searchParams.set("peer_id", e), _r17.searchParams.set("user_agent_v2", t), _r17.toString();
  } catch (r) {
    var s = r;
    throw o.e(ai, s.name, s.message), s;
  }
}
function Lr(a) {
  var e;
  return L(v({}, a), {
    rtcConfiguration: L(v({}, a.rtcConfiguration), {
      iceServers: (e = a.rtcConfiguration) == null ? void 0 : e.ice_servers
    })
  });
}
var ne;
(function (i) {
  i.FLAG_SERVER_SUB_DEGRADATION = "subscribeDegradation", i.FLAG_SERVER_SIMULCAST = "simulcast", i.FLAG_NON_WEBRTC_DISABLE_OFFER = "nonWebRTCDisableOffer";
})(ne || (ne = {}));
import { v4 as _r } from "uuid";
var w;
(function (k) {
  k.JOIN = "join", k.OFFER = "offer", k.ANSWER = "answer", k.TRICKLE = "trickle", k.TRACK_UPDATE = "track-update", k.BROADCAST = "broadcast", k.ANALYTICS = "analytics", k.SERVER_ERROR = "on-error", k.SERVER_WARNING = "on-warning", k.SDK_NOTIFICATION = "sdk-notification", k.LEAVE = "leave", k.END_ROOM = "end-room", k.PING = "ping", k.ROLE_CHANGE_REQUEST = "role-change-request", k.ROLE_CHANGE = "role-change", k.TRACK_UPDATE_REQUEST = "track-update-request", k.PEER_LEAVE_REQUEST = "peer-leave-request", k.CHANGE_TRACK_MUTE_STATE_REQUEST = "change-track-mute-state-request", k.START_RTMP_OR_RECORDING_REQUEST = "rtmp-start", k.STOP_RTMP_AND_RECORDING_REQUEST = "rtmp-stop", k.UPDATE_PEER_METADATA = "peer-update", k.START_HLS_STREAMING = "hls-start", k.STOP_HLS_STREAMING = "hls-stop", k.HLS_TIMED_METADATA = "hls-timed-metadata", k.SET_METADATA = "set-metadata", k.GET_METADATA = "get-metadata";
})(w || (w = {}));
function ni(a) {
  switch (a) {
    case w.JOIN:
      return p.JOIN;
    case w.OFFER:
      return p.PUBLISH;
    case w.ANSWER:
      return p.SUBSCRIBE;
    case w.TRACK_UPDATE:
      return p.TRACK;
    default:
      return p.NONE;
  }
}
var Tt = /*#__PURE__*/function () {
  function Tt(e) {
    var _this94 = this;
    _classCallCheck(this, Tt);
    this.TAG = "[SIGNAL]: ";
    this.pongResponseTimes = new Se(wi);
    this.isJoinCompleted = !1;
    this.pendingTrickle = [];
    this.socket = null;
    this.callbacks = new Map();
    this._isConnected = !1;
    this.id = 0;
    this.onCloseHandler = function () {};
    this.offlineListener = function () {
      o.d(_this94.TAG, "Window network offline"), _this94.setIsConnected(!1, "Window network offline");
    };
    this.onlineListener = function () {
      o.d(_this94.TAG, "Window network online"), _this94.observer.onNetworkOnline();
    };
    this.observer = e, window.addEventListener("offline", this.offlineListener), window.addEventListener("online", this.onlineListener), this.onMessageHandler = this.onMessageHandler.bind(this);
  }
  _createClass(Tt, [{
    key: "setIsConnected",
    value: function setIsConnected(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
      o.d(this.TAG, "isConnected set id: ".concat(this.id, ", oldValue: ").concat(this._isConnected, ", newValue: ").concat(e)), this._isConnected !== e && (this._isConnected && !e ? (this._isConnected = e, this.rejectPendingCalls(t), this.observer.onOffline(t)) : !this._isConnected && e && (this._isConnected = e, this.observer.onOnline()));
    }
  }, {
    key: "getPongResponseTimes",
    value: function getPongResponseTimes() {
      return this.pongResponseTimes.toList();
    }
  }, {
    key: "internalCall",
    value: function internalCall(e, t) {
      return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee161() {
        var _this95 = this;
        var s, i, r, _d8;
        return _regeneratorRuntime().wrap(function _callee161$(_context162) {
          while (1) switch (_context162.prev = _context162.next) {
            case 0:
              i = _r(), r = {
                method: e,
                params: t,
                id: i,
                jsonrpc: "2.0"
              };
              (s = this.socket) == null || s.send(JSON.stringify(r));
              _context162.prev = 2;
              _context162.next = 5;
              return new Promise(function (d, l) {
                _this95.callbacks.set(i, {
                  resolve: d,
                  reject: l,
                  metadata: {
                    method: e
                  }
                });
              });
            case 5:
              return _context162.abrupt("return", _context162.sent);
            case 8:
              _context162.prev = 8;
              _context162.t0 = _context162["catch"](2);
              if (!(_context162.t0 instanceof T)) {
                _context162.next = 12;
                break;
              }
              throw _context162.t0;
            case 12:
              _d8 = _context162.t0;
              throw m.WebsocketMethodErrors.ServerErrors(Number(_d8.code), ni(e), _d8.message);
            case 14:
            case "end":
              return _context162.stop();
          }
        }, _callee161, this, [[2, 8]]);
      }));
    }
  }, {
    key: "notify",
    value: function notify(e, t) {
      var r, s;
      var i = {
        method: e,
        params: t
      };
      ((r = this.socket) == null ? void 0 : r.readyState) === WebSocket.OPEN && ((s = this.socket) == null || s.send(JSON.stringify(i)));
    }
  }, {
    key: "open",
    value: function open(e) {
      var _this96 = this;
      return new Promise(function (t, i) {
        var r = !1;
        _this96.socket && (_this96.socket.close(), _this96.socket.removeEventListener("close", _this96.onCloseHandler), _this96.socket.removeEventListener("message", _this96.onMessageHandler)), _this96.socket = new WebSocket(e);
        var s = function s(d) {
          o.e(_this96.TAG, "Error from websocket", d), r = !0, i(m.WebSocketConnectionErrors.FailedToConnect(p.JOIN, "Error opening websocket connection - ".concat(d)));
        };
        _this96.onCloseHandler = function (d) {
          o.e("Websocket closed code=".concat(d.code)), r ? _this96.setIsConnected(!1, "code: ".concat(d.code).concat(d.code !== 1e3 ? ", unexpected websocket close" : "")) : (r = !0, i(m.WebSocketConnectionErrors.AbnormalClose(p.JOIN, "Error opening websocket connection - websocket closed unexpectedly with code=".concat(d.code))));
        }, _this96.socket.addEventListener("error", s);
        var n = function n() {
          var d, l;
          r = !0, t(), _this96.setIsConnected(!0), _this96.id++, (d = _this96.socket) == null || d.removeEventListener("open", n), (l = _this96.socket) == null || l.removeEventListener("error", s), _this96.pingPongLoop(_this96.id);
        };
        _this96.socket.addEventListener("open", n), _this96.socket.addEventListener("close", _this96.onCloseHandler), _this96.socket.addEventListener("message", _this96.onMessageHandler);
      });
    }
  }, {
    key: "close",
    value: function close() {
      return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee162() {
        return _regeneratorRuntime().wrap(function _callee162$(_context163) {
          while (1) switch (_context163.prev = _context163.next) {
            case 0:
              window.removeEventListener("offline", this.offlineListener), window.removeEventListener("online", this.onlineListener), this.socket ? (this.socket.close(1e3, "Normal Close"), this.setIsConnected(!1, "code: 1000, normal websocket close"), this.socket.removeEventListener("close", this.onCloseHandler), this.socket.removeEventListener("message", this.onMessageHandler)) : this.setIsConnected(!1, "websocket not connected yet");
            case 1:
            case "end":
              return _context163.stop();
          }
        }, _callee162, this);
      }));
    }
  }, {
    key: "join",
    value: function join(e, t, i, r, s, n) {
      return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee163() {
        var _this97 = this;
        var d, l;
        return _regeneratorRuntime().wrap(function _callee163$(_context164) {
          while (1) switch (_context164.prev = _context164.next) {
            case 0:
              if (this.isConnected) {
                _context164.next = 2;
                break;
              }
              throw m.WebSocketConnectionErrors.WebSocketConnectionLost(p.JOIN, "Failed to send join over WS connection");
            case 2:
              d = {
                name: e,
                disableVidAutoSub: i,
                data: t,
                offer: n,
                server_sub_degrade: r,
                simulcast: s
              };
              _context164.next = 5;
              return this.internalCall(w.JOIN, d);
            case 5:
              l = _context164.sent;
              return _context164.abrupt("return", (this.isJoinCompleted = !0, this.pendingTrickle.forEach(function (_ref26) {
                var h = _ref26.target,
                  u = _ref26.candidate;
                return _this97.trickle(h, u);
              }), this.pendingTrickle.length = 0, o.d(this.TAG, "join: response=".concat(JSON.stringify(l, null, 1))), l));
            case 7:
            case "end":
              return _context164.stop();
          }
        }, _callee163, this);
      }));
    }
  }, {
    key: "trickle",
    value: function trickle(e, t) {
      this.isJoinCompleted ? this.notify(w.TRICKLE, {
        target: e,
        candidate: t
      }) : this.pendingTrickle.push({
        target: e,
        candidate: t
      });
    }
  }, {
    key: "offer",
    value: function offer(e, t) {
      return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee164() {
        return _regeneratorRuntime().wrap(function _callee164$(_context165) {
          while (1) switch (_context165.prev = _context165.next) {
            case 0:
              _context165.next = 2;
              return this.call(w.OFFER, {
                desc: e,
                tracks: Object.fromEntries(t)
              });
            case 2:
              return _context165.abrupt("return", _context165.sent);
            case 3:
            case "end":
              return _context165.stop();
          }
        }, _callee164, this);
      }));
    }
  }, {
    key: "answer",
    value: function answer(e) {
      this.notify(w.ANSWER, {
        desc: e
      });
    }
  }, {
    key: "trackUpdate",
    value: function trackUpdate(e) {
      this.notify(w.TRACK_UPDATE, {
        version: "1.0",
        tracks: Object.fromEntries(e)
      });
    }
  }, {
    key: "broadcast",
    value: function broadcast(e) {
      return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee165() {
        return _regeneratorRuntime().wrap(function _callee165$(_context166) {
          while (1) switch (_context166.prev = _context166.next) {
            case 0:
              _context166.next = 2;
              return this.call(w.BROADCAST, v({
                version: "1.0"
              }, e.toSignalParams()));
            case 2:
              return _context166.abrupt("return", _context166.sent);
            case 3:
            case "end":
              return _context166.stop();
          }
        }, _callee165, this);
      }));
    }
  }, {
    key: "leave",
    value: function leave() {
      this.notify(w.LEAVE, {
        version: "1.0"
      });
    }
  }, {
    key: "endRoom",
    value: function endRoom(e, t) {
      return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee166() {
        return _regeneratorRuntime().wrap(function _callee166$(_context167) {
          while (1) switch (_context167.prev = _context167.next) {
            case 0:
              _context167.next = 2;
              return this.call(w.END_ROOM, {
                lock: e,
                reason: t
              });
            case 2:
            case "end":
              return _context167.stop();
          }
        }, _callee166, this);
      }));
    }
  }, {
    key: "sendEvent",
    value: function sendEvent(e) {
      if (!this.isConnected) throw Error("".concat(this.TAG, " not connected. Could not send event ").concat(e));
      this.notify(w.ANALYTICS, e.toSignalParams());
    }
  }, {
    key: "ping",
    value: function ping(e) {
      var t = Date.now(),
        i = new Promise(function (s) {
          setTimeout(function () {
            s(Date.now() - t);
          }, e + 1);
        }),
        r = this.internalCall(w.PING, {
          timestamp: t
        }).then(function () {
          return Date.now() - t;
        }).catch(function () {
          return Date.now() - t;
        });
      return Promise.race([i, r]);
    }
  }, {
    key: "requestRoleChange",
    value: function requestRoleChange(e) {
      return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee167() {
        return _regeneratorRuntime().wrap(function _callee167$(_context168) {
          while (1) switch (_context168.prev = _context168.next) {
            case 0:
              _context168.next = 2;
              return this.call(w.ROLE_CHANGE_REQUEST, e);
            case 2:
            case "end":
              return _context168.stop();
          }
        }, _callee167, this);
      }));
    }
  }, {
    key: "requestBulkRoleChange",
    value: function requestBulkRoleChange(e) {
      return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee168() {
        return _regeneratorRuntime().wrap(function _callee168$(_context169) {
          while (1) switch (_context169.prev = _context169.next) {
            case 0:
              _context169.next = 2;
              return this.call(w.ROLE_CHANGE_REQUEST, e);
            case 2:
            case "end":
              return _context169.stop();
          }
        }, _callee168, this);
      }));
    }
  }, {
    key: "acceptRoleChangeRequest",
    value: function acceptRoleChangeRequest(e) {
      return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee169() {
        return _regeneratorRuntime().wrap(function _callee169$(_context170) {
          while (1) switch (_context170.prev = _context170.next) {
            case 0:
              _context170.next = 2;
              return this.call(w.ROLE_CHANGE, e);
            case 2:
            case "end":
              return _context170.stop();
          }
        }, _callee169, this);
      }));
    }
  }, {
    key: "requestTrackStateChange",
    value: function requestTrackStateChange(e) {
      return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee170() {
        return _regeneratorRuntime().wrap(function _callee170$(_context171) {
          while (1) switch (_context171.prev = _context171.next) {
            case 0:
              _context171.next = 2;
              return this.call(w.TRACK_UPDATE_REQUEST, e);
            case 2:
            case "end":
              return _context171.stop();
          }
        }, _callee170, this);
      }));
    }
  }, {
    key: "requestMultiTrackStateChange",
    value: function requestMultiTrackStateChange(e) {
      return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee171() {
        return _regeneratorRuntime().wrap(function _callee171$(_context172) {
          while (1) switch (_context172.prev = _context172.next) {
            case 0:
              _context172.next = 2;
              return this.call(w.CHANGE_TRACK_MUTE_STATE_REQUEST, e);
            case 2:
            case "end":
              return _context172.stop();
          }
        }, _callee171, this);
      }));
    }
  }, {
    key: "removePeer",
    value: function removePeer(e) {
      return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee172() {
        return _regeneratorRuntime().wrap(function _callee172$(_context173) {
          while (1) switch (_context173.prev = _context173.next) {
            case 0:
              _context173.next = 2;
              return this.call(w.PEER_LEAVE_REQUEST, e);
            case 2:
            case "end":
              return _context173.stop();
          }
        }, _callee172, this);
      }));
    }
  }, {
    key: "startRTMPOrRecording",
    value: function startRTMPOrRecording(e) {
      return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee173() {
        return _regeneratorRuntime().wrap(function _callee173$(_context174) {
          while (1) switch (_context174.prev = _context174.next) {
            case 0:
              _context174.next = 2;
              return this.call(w.START_RTMP_OR_RECORDING_REQUEST, v({
                version: "1.0"
              }, e));
            case 2:
            case "end":
              return _context174.stop();
          }
        }, _callee173, this);
      }));
    }
  }, {
    key: "stopRTMPAndRecording",
    value: function stopRTMPAndRecording() {
      return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee174() {
        return _regeneratorRuntime().wrap(function _callee174$(_context175) {
          while (1) switch (_context175.prev = _context175.next) {
            case 0:
              _context175.next = 2;
              return this.call(w.STOP_RTMP_AND_RECORDING_REQUEST, {
                version: "1.0"
              });
            case 2:
            case "end":
              return _context175.stop();
          }
        }, _callee174, this);
      }));
    }
  }, {
    key: "startHLSStreaming",
    value: function startHLSStreaming(e) {
      return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee175() {
        return _regeneratorRuntime().wrap(function _callee175$(_context176) {
          while (1) switch (_context176.prev = _context176.next) {
            case 0:
              _context176.next = 2;
              return this.call(w.START_HLS_STREAMING, v({
                version: "1.0"
              }, e));
            case 2:
            case "end":
              return _context176.stop();
          }
        }, _callee175, this);
      }));
    }
  }, {
    key: "stopHLSStreaming",
    value: function stopHLSStreaming(e) {
      return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee176() {
        return _regeneratorRuntime().wrap(function _callee176$(_context177) {
          while (1) switch (_context177.prev = _context177.next) {
            case 0:
              _context177.next = 2;
              return this.call(w.STOP_HLS_STREAMING, v({
                version: "1.0"
              }, e));
            case 2:
            case "end":
              return _context177.stop();
          }
        }, _callee176, this);
      }));
    }
  }, {
    key: "sendHLSTimedMetadata",
    value: function sendHLSTimedMetadata(e) {
      return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee177() {
        return _regeneratorRuntime().wrap(function _callee177$(_context178) {
          while (1) switch (_context178.prev = _context178.next) {
            case 0:
              _context178.next = 2;
              return this.call(w.HLS_TIMED_METADATA, v({
                version: "1.0"
              }, e));
            case 2:
            case "end":
              return _context178.stop();
          }
        }, _callee177, this);
      }));
    }
  }, {
    key: "updatePeer",
    value: function updatePeer(e) {
      return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee178() {
        return _regeneratorRuntime().wrap(function _callee178$(_context179) {
          while (1) switch (_context179.prev = _context179.next) {
            case 0:
              _context179.next = 2;
              return this.call(w.UPDATE_PEER_METADATA, v({
                version: "1.0"
              }, e));
            case 2:
            case "end":
              return _context179.stop();
          }
        }, _callee178, this);
      }));
    }
  }, {
    key: "setSessionMetadata",
    value: function setSessionMetadata(e) {
      return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee179() {
        return _regeneratorRuntime().wrap(function _callee179$(_context180) {
          while (1) switch (_context180.prev = _context180.next) {
            case 0:
              _context180.next = 2;
              return this.call(w.SET_METADATA, v({
                version: "1.0"
              }, e));
            case 2:
            case "end":
              return _context180.stop();
          }
        }, _callee179, this);
      }));
    }
  }, {
    key: "getSessionMetadata",
    value: function getSessionMetadata() {
      return this.call(w.GET_METADATA, {
        version: "1.0"
      });
    }
  }, {
    key: "onMessageHandler",
    value: function onMessageHandler(e) {
      var t = e.data,
        i = JSON.parse(t);
      if (i.id) this.handleResponseWithId(i);else if (i.method) this.handleResponseWithMethod(i);else throw Error("WebSocket message has no 'method' or 'id' field, message=".concat(i));
    }
  }, {
    key: "handleResponseWithId",
    value: function handleResponseWithId(e) {
      var t = e,
        i = t.id;
      if (this.callbacks.has(i)) {
        var _r18 = this.callbacks.get(i);
        this.callbacks.delete(i), t.result ? _r18.resolve(t.result) : _r18.reject(t.error);
      } else this.observer.onNotification(t);
    }
  }, {
    key: "handleResponseWithMethod",
    value: function handleResponseWithMethod(e) {
      switch (e.method) {
        case w.OFFER:
          this.observer.onOffer(e.params);
          break;
        case w.TRICKLE:
          this.observer.onTrickle(e.params);
          break;
        case w.SERVER_ERROR:
          this.observer.onServerError(m.WebsocketMethodErrors.ServerErrors(Number(e.params.code), p.NONE, e.params.message));
          break;
        case w.SERVER_WARNING:
          o.w(this.TAG, e.params);
          break;
        default:
          this.observer.onNotification(e);
          break;
      }
    }
  }, {
    key: "rejectPendingCalls",
    value: function rejectPendingCalls() {
      var _this98 = this;
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
      this.callbacks.forEach(function (t, i) {
        var r, s, n, d;
        ((r = t.metadata) == null ? void 0 : r.method) !== w.PING && (o.e(_this98.TAG, "rejecting pending callback ".concat((s = t.metadata) == null ? void 0 : s.method, ", id=").concat(i)), t.reject(m.WebSocketConnectionErrors.WebSocketConnectionLost(((n = t.metadata) == null ? void 0 : n.method) ? ni((d = t.metadata) == null ? void 0 : d.method) : p.RECONNECT_SIGNAL, e)), _this98.callbacks.delete(i));
      });
    }
  }, {
    key: "pingPongLoop",
    value: function pingPongLoop(e) {
      return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee180() {
        var _this99 = this;
        var i, r, t, s;
        return _regeneratorRuntime().wrap(function _callee180$(_context181) {
          while (1) switch (_context181.prev = _context181.next) {
            case 0:
              t = ((i = window.HMS) == null ? void 0 : i.PING_TIMEOUT) || Ci;
              if (!this.isConnected) {
                _context181.next = 6;
                break;
              }
              _context181.next = 4;
              return this.ping(t);
            case 4:
              s = _context181.sent;
              this.pongResponseTimes.enqueue(s), s > t ? (o.d(this.TAG, "Pong timeout ".concat(e, ", pageHidden=").concat(pi())), this.id === e && this.setIsConnected(!1, "ping pong failure")) : setTimeout(function () {
                return _this99.pingPongLoop(e);
              }, ((r = window.HMS) == null ? void 0 : r.PING_INTERVAL) || Ri);
            case 6:
            case "end":
              return _context181.stop();
          }
        }, _callee180, this);
      }));
    }
  }, {
    key: "call",
    value: function call(e, t) {
      return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee181() {
        var i, r, s, l;
        return _regeneratorRuntime().wrap(function _callee181$(_context182) {
          while (1) switch (_context182.prev = _context182.next) {
            case 0:
              i = 3, r = m.WebsocketMethodErrors.ServerErrors(500, e, "Default ".concat(e, " error"));
              s = 0;
            case 2:
              if (!(s < i)) {
                _context182.next = 20;
                break;
              }
              _context182.prev = 3;
              o.d(this.TAG, "Try number ".concat(s + 1, " sending ").concat(e), t);
              _context182.next = 7;
              return this.internalCall(e, t);
            case 7:
              return _context182.abrupt("return", _context182.sent);
            case 10:
              _context182.prev = 10;
              _context182.t0 = _context182["catch"](3);
              if (!(r = _context182.t0, o.e(this.TAG, "Failed sending ".concat(e), {
                method: e,
                try: s + 1,
                params: t,
                error: r
              }), !(parseInt("".concat(r.code / 100)) === 5 || r.code === 429))) {
                _context182.next = 14;
                break;
              }
              return _context182.abrupt("break", 20);
            case 14:
              l = (2 + Math.random() * 2) * 1e3;
              _context182.next = 17;
              return $(l);
            case 17:
              s++;
              _context182.next = 2;
              break;
            case 20:
              throw o.e("Sending ".concat(e, " over WS failed after ").concat(i, " retries"), {
                method: e,
                params: t,
                error: r
              }), r;
            case 21:
            case "end":
              return _context182.stop();
          }
        }, _callee181, this, [[3, 10]]);
      }));
    }
  }, {
    key: "isConnected",
    get: function get() {
      return this._isConnected;
    }
  }]);
  return Tt;
}();
var Yi = function Yi() {
  if (!X || typeof navigator.connection == "undefined") return;
  var a = navigator.connection;
  return {
    downlink: a.downlink,
    downlinkMax: a.downlinkMax,
    effectiveType: a.effectiveType,
    rtt: a.rtt,
    saveData: a.saveData,
    type: a.type
  };
};
var P = "[HMSTransport]:",
  ft = /*#__PURE__*/function () {
    function ft(e, t, i, r, s, n) {
      var _this100 = this;
      _classCallCheck(this, ft);
      this.observer = e;
      this.deviceManager = t;
      this.store = i;
      this.eventBus = r;
      this.analyticsEventsService = s;
      this.analyticsTimer = n;
      this.state = R.Disconnected;
      this.trackStates = new Map();
      this.publishConnection = null;
      this.subscribeConnection = null;
      this.maxSubscribeBitrate = 0;
      this.joinRetryCount = 0;
      this.callbacks = new Map();
      this.signalObserver = {
        onOffer: function onOffer(e) {
          return c(_this100, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee182() {
            var _iterator17, _step17, _i15, _t11, _i16;
            return _regeneratorRuntime().wrap(function _callee182$(_context183) {
              while (1) switch (_context183.prev = _context183.next) {
                case 0:
                  _context183.prev = 0;
                  if (this.subscribeConnection) {
                    _context183.next = 3;
                    break;
                  }
                  return _context183.abrupt("return");
                case 3:
                  _context183.next = 5;
                  return this.subscribeConnection.setRemoteDescription(e);
                case 5:
                  o.d(P, "[SUBSCRIBE] Adding ".concat(this.subscribeConnection.candidates.length, " ice-candidates"), this.subscribeConnection.candidates);
                  _iterator17 = _createForOfIteratorHelper(this.subscribeConnection.candidates);
                  _context183.prev = 7;
                  _iterator17.s();
                case 9:
                  if ((_step17 = _iterator17.n()).done) {
                    _context183.next = 15;
                    break;
                  }
                  _i15 = _step17.value;
                  _context183.next = 13;
                  return this.subscribeConnection.addIceCandidate(_i15);
                case 13:
                  _context183.next = 9;
                  break;
                case 15:
                  _context183.next = 20;
                  break;
                case 17:
                  _context183.prev = 17;
                  _context183.t0 = _context183["catch"](7);
                  _iterator17.e(_context183.t0);
                case 20:
                  _context183.prev = 20;
                  _iterator17.f();
                  return _context183.finish(20);
                case 23:
                  this.subscribeConnection.candidates.length = 0;
                  _context183.next = 26;
                  return this.subscribeConnection.createAnswer();
                case 26:
                  _t11 = _context183.sent;
                  _context183.next = 29;
                  return this.subscribeConnection.setLocalDescription(_t11);
                case 29:
                  this.signal.answer(_t11);
                  o.d(P, "[role=SUBSCRIBE] onOffer renegotiation DONE \u2705");
                  _context183.next = 37;
                  break;
                case 33:
                  _context183.prev = 33;
                  _context183.t1 = _context183["catch"](0);
                  o.d(P, "[role=SUBSCRIBE] onOffer renegotiation FAILED \u274C", _context183.t1), this.state = R.Failed;
                  _context183.t1 instanceof T ? _i16 = _context183.t1 : _i16 = m.GenericErrors.Unknown(p.PUBLISH, _context183.t1.message), this.observer.onFailure(_i16), this.eventBus.analytics.publish(H.subscribeFail(_i16));
                case 37:
                case "end":
                  return _context183.stop();
              }
            }, _callee182, this, [[0, 33], [7, 17, 20, 23]]);
          }));
        },
        onTrickle: function onTrickle(e) {
          return c(_this100, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee183() {
            var t;
            return _regeneratorRuntime().wrap(function _callee183$(_context184) {
              while (1) switch (_context184.prev = _context184.next) {
                case 0:
                  t = e.target === G.Publish ? this.publishConnection : this.subscribeConnection;
                  if (!(t == null ? void 0 : t.remoteDescription)) {
                    _context184.next = 6;
                    break;
                  }
                  _context184.next = 4;
                  return t.addIceCandidate(e.candidate);
                case 4:
                  _context184.next = 7;
                  break;
                case 6:
                  t == null || t.candidates.push(e.candidate);
                case 7:
                case "end":
                  return _context184.stop();
              }
            }, _callee183, this);
          }));
        },
        onNotification: function onNotification(e) {
          return _this100.observer.onNotification(e);
        },
        onServerError: function onServerError(e) {
          return c(_this100, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee184() {
            return _regeneratorRuntime().wrap(function _callee184$(_context185) {
              while (1) switch (_context185.prev = _context185.next) {
                case 0:
                  _context185.next = 2;
                  return this.observer.onStateChange(R.Failed, e);
                case 2:
                case "end":
                  return _context185.stop();
              }
            }, _callee184, this);
          }));
        },
        onFailure: function onFailure(e) {
          _this100.joinParameters && _this100.retryScheduler.schedule({
            category: C.SignalDisconnect,
            error: e,
            task: _this100.retrySignalDisconnectTask,
            originalState: _this100.state
          });
        },
        onOffline: function onOffline(e) {
          return c(_this100, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee185() {
            return _regeneratorRuntime().wrap(function _callee185$(_context186) {
              while (1) switch (_context186.prev = _context186.next) {
                case 0:
                  o.d(P, "socket offline", R[this.state]);
                  try {
                    this.state !== R.Leaving && this.joinParameters && this.retryScheduler.schedule({
                      category: C.SignalDisconnect,
                      error: m.WebSocketConnectionErrors.WebSocketConnectionLost(p.RECONNECT_SIGNAL, e),
                      task: this.retrySignalDisconnectTask,
                      originalState: this.state
                    });
                  } catch (t) {
                    console.error(t);
                  }
                case 2:
                case "end":
                  return _context186.stop();
              }
            }, _callee185, this);
          }));
        },
        onOnline: function onOnline() {
          var e;
          o.d(P, "socket online", R[_this100.state]), _this100.analyticsSignalTransport.flushFailedEvents((e = _this100.store.getLocalPeer()) == null ? void 0 : e.peerId);
        },
        onNetworkOnline: function onNetworkOnline() {
          _this100.analyticsEventsService.flushFailedClientEvents();
        }
      };
      this.signal = new Tt(this.signalObserver);
      this.analyticsSignalTransport = new zt(this.signal);
      this.publishConnectionObserver = {
        onRenegotiationNeeded: function onRenegotiationNeeded() {
          return c(_this100, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee186() {
            return _regeneratorRuntime().wrap(function _callee186$(_context187) {
              while (1) switch (_context187.prev = _context187.next) {
                case 0:
                  _context187.next = 2;
                  return this.performPublishRenegotiation();
                case 2:
                case "end":
                  return _context187.stop();
              }
            }, _callee186, this);
          }));
        },
        onIceConnectionChange: function onIceConnectionChange(e) {
          return c(_this100, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee187() {
            return _regeneratorRuntime().wrap(function _callee187$(_context188) {
              while (1) switch (_context188.prev = _context188.next) {
                case 0:
                  (e === "disconnected" ? o.w.bind(o) : o.d.bind(o))(P, "Publish ice connection state change: ".concat(e));
                case 1:
                case "end":
                  return _context188.stop();
              }
            }, _callee187);
          }));
        },
        onConnectionStateChange: function onConnectionStateChange(e) {
          return c(_this100, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee188() {
            var _this101 = this;
            var i, r, s, n, d;
            return _regeneratorRuntime().wrap(function _callee188$(_context189) {
              while (1) switch (_context189.prev = _context189.next) {
                case 0:
                  (e === "disconnected" ? o.w.bind(o) : o.d.bind(o))(P, "Publish connection state change: ".concat(e));
                  e === "connected" && ((i = this.publishConnection) == null || i.logSelectedIceCandidatePairs());
                  e === "disconnected" && setTimeout(function () {
                    var l, h, u, S, g;
                    ((l = _this101.publishConnection) == null ? void 0 : l.connectionState) === "disconnected" && _this101.handleIceConnectionFailure(G.Publish, m.WebrtcErrors.ICEDisconnected(p.PUBLISH, "local candidate - ".concat((u = (h = _this101.publishConnection) == null ? void 0 : h.selectedCandidatePair) == null ? void 0 : u.local.candidate, "; remote candidate - ").concat((g = (S = _this101.publishConnection) == null ? void 0 : S.selectedCandidatePair) == null ? void 0 : g.remote.candidate)));
                  }, Ht);
                  _context189.t0 = e === "failed";
                  if (!_context189.t0) {
                    _context189.next = 7;
                    break;
                  }
                  _context189.next = 7;
                  return this.handleIceConnectionFailure(G.Publish, m.WebrtcErrors.ICEFailure(p.PUBLISH, "local candidate - ".concat((s = (r = this.publishConnection) == null ? void 0 : r.selectedCandidatePair) == null ? void 0 : s.local.candidate, "; remote candidate - ").concat((d = (n = this.publishConnection) == null ? void 0 : n.selectedCandidatePair) == null ? void 0 : d.remote.candidate)));
                case 7:
                case "end":
                  return _context189.stop();
              }
            }, _callee188, this);
          }));
        }
      };
      this.subscribeConnectionObserver = {
        onApiChannelMessage: function onApiChannelMessage(e) {
          _this100.observer.onNotification(JSON.parse(e));
        },
        onTrackAdd: function onTrackAdd(e) {
          o.d(P, "[Subscribe] onTrackAdd", "".concat(e)), _this100.observer.onTrackAdd(e);
        },
        onTrackRemove: function onTrackRemove(e) {
          o.d(P, "[Subscribe] onTrackRemove", "".concat(e)), _this100.observer.onTrackRemove(e);
        },
        onIceConnectionChange: function onIceConnectionChange(e) {
          return c(_this100, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee189() {
            var _i17;
            return _regeneratorRuntime().wrap(function _callee189$(_context190) {
              while (1) switch (_context190.prev = _context190.next) {
                case 0:
                  if ((e === "disconnected" ? o.w.bind(o) : o.d.bind(o))(P, "Subscribe ice connection state change: ".concat(e)), e === "connected") {
                    _i17 = this.callbacks.get(Re);
                    this.callbacks.delete(Re), _i17 && _i17.promise.resolve(!0);
                  }
                case 1:
                case "end":
                  return _context190.stop();
              }
            }, _callee189, this);
          }));
        },
        onConnectionStateChange: function onConnectionStateChange(e) {
          return c(_this100, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee190() {
            var _this102 = this;
            var i, r, s, n;
            return _regeneratorRuntime().wrap(function _callee190$(_context191) {
              while (1) switch (_context191.prev = _context191.next) {
                case 0:
                  (e === "disconnected" ? o.w.bind(o) : o.d.bind(o))(P, "Subscribe connection state change: ".concat(e));
                  _context191.t0 = e === "failed";
                  if (!_context191.t0) {
                    _context191.next = 5;
                    break;
                  }
                  _context191.next = 5;
                  return this.handleIceConnectionFailure(G.Subscribe, m.WebrtcErrors.ICEFailure(p.SUBSCRIBE, "local candidate - ".concat((r = (i = this.subscribeConnection) == null ? void 0 : i.selectedCandidatePair) == null ? void 0 : r.local.candidate, "; remote candidate - ").concat((n = (s = this.subscribeConnection) == null ? void 0 : s.selectedCandidatePair) == null ? void 0 : n.remote.candidate)));
                case 5:
                  e === "disconnected" && setTimeout(function () {
                    var d, l, h, u, S;
                    ((d = _this102.subscribeConnection) == null ? void 0 : d.connectionState) === "disconnected" && _this102.handleIceConnectionFailure(G.Subscribe, m.WebrtcErrors.ICEDisconnected(p.SUBSCRIBE, "local candidate - ".concat((h = (l = _this102.subscribeConnection) == null ? void 0 : l.selectedCandidatePair) == null ? void 0 : h.local.candidate, "; remote candidate - ").concat((S = (u = _this102.subscribeConnection) == null ? void 0 : u.selectedCandidatePair) == null ? void 0 : S.remote.candidate)));
                  }, Ht);
                  e === "connected" && this.handleSubscribeConnectionConnected();
                case 7:
                case "end":
                  return _context191.stop();
              }
            }, _callee190, this);
          }));
        }
      };
      this.handleLocalRoleUpdate = function (i) {
        return c(_this100, [i], function (_ref27) {
          var _this103 = this;
          var e = _ref27.oldRole,
            t = _ref27.newRole;
          return /*#__PURE__*/_regeneratorRuntime().mark(function _callee191() {
            return _regeneratorRuntime().wrap(function _callee191$(_context192) {
              while (1) switch (_context192.prev = _context192.next) {
                case 0:
                  _context192.t0 = !(!_this103.doesRoleNeedWebRTC(e) && _this103.doesRoleNeedWebRTC(t));
                  if (_context192.t0) {
                    _context192.next = 6;
                    break;
                  }
                  o.i(P, "Local peer role updated to webrtc role, creating PeerConnections and performing inital publish negotiation \u23F3");
                  _this103.createPeerConnections();
                  _context192.next = 6;
                  return _this103.negotiateOnFirstPublish();
                case 6:
                case "end":
                  return _context192.stop();
              }
            }, _callee191);
          })();
        });
      };
      this.retryPublishIceFailedTask = function () {
        return c(_this100, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee192() {
          var _this104 = this;
          var _e5;
          return _regeneratorRuntime().wrap(function _callee192$(_context193) {
            while (1) switch (_context193.prev = _context193.next) {
              case 0:
                if (!this.publishConnection) {
                  _context193.next = 6;
                  break;
                }
                _e5 = new Promise(function (t, i) {
                  _this104.callbacks.set(Ce, {
                    promise: {
                      resolve: t,
                      reject: i
                    },
                    action: p.RESTART_ICE,
                    extra: {}
                  });
                });
                _context193.next = 4;
                return this.performPublishRenegotiation({
                  iceRestart: this.publishConnection.connectionState !== "connected"
                });
              case 4:
                _context193.next = 6;
                return _e5;
              case 6:
                return _context193.abrupt("return", !0);
              case 7:
              case "end":
                return _context193.stop();
            }
          }, _callee192, this);
        }));
      };
      this.retrySubscribeIceFailedTask = function () {
        return c(_this100, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee193() {
          var _this105 = this;
          var _e6, _t12;
          return _regeneratorRuntime().wrap(function _callee193$(_context194) {
            while (1) switch (_context194.prev = _context194.next) {
              case 0:
                if (!(this.subscribeConnection && this.subscribeConnection.connectionState !== "connected")) {
                  _context194.next = 3;
                  break;
                }
                _e6 = new Promise(function (i, r) {
                  _this105.callbacks.set(Re, {
                    promise: {
                      resolve: i,
                      reject: r
                    },
                    action: p.RESTART_ICE,
                    extra: {}
                  });
                }), _t12 = new Promise(function (i) {
                  setTimeout(i, Hi, !1);
                });
                return _context194.abrupt("return", Promise.race([_e6, _t12]));
              case 3:
                return _context194.abrupt("return", !0);
              case 4:
              case "end":
                return _context194.stop();
            }
          }, _callee193, this);
        }));
      };
      this.retrySignalDisconnectTask = function () {
        return c(_this100, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee194() {
          var e;
          return _regeneratorRuntime().wrap(function _callee194$(_context195) {
            while (1) switch (_context195.prev = _context195.next) {
              case 0:
                if (!(o.d(P, "retrySignalDisconnectTask", {
                  signalConnected: this.signal.isConnected
                }), !this.signal.isConnected)) {
                  _context195.next = 8;
                  break;
                }
                _context195.prev = 1;
                _context195.next = 4;
                return this.internalConnect(this.joinParameters.authToken, this.joinParameters.endpoint, this.joinParameters.peerId);
              case 4:
                _context195.next = 8;
                break;
              case 6:
                _context195.prev = 6;
                _context195.t0 = _context195["catch"](1);
              case 8:
                if (!this.store.getRoom().joinedAt) {
                  _context195.next = 17;
                  break;
                }
                _context195.t2 = this.signal.isConnected;
                if (!_context195.t2) {
                  _context195.next = 14;
                  break;
                }
                _context195.next = 13;
                return this.retryPublishIceFailedTask();
              case 13:
                _context195.t2 = _context195.sent;
              case 14:
                _context195.t1 = _context195.t2;
                _context195.next = 18;
                break;
              case 17:
                _context195.t1 = this.signal.isConnected;
              case 18:
                e = _context195.t1;
                return _context195.abrupt("return", (this.signal.trackUpdate(this.trackStates), e));
              case 20:
              case "end":
                return _context195.stop();
            }
          }, _callee194, this, [[1, 6]]);
        }));
      };
      var l, h;
      this.webrtcInternals = new St(this.store, this.eventBus, (l = this.publishConnection) == null ? void 0 : l.nativeConnection, (h = this.subscribeConnection) == null ? void 0 : h.nativeConnection);
      var d = function d(u, S) {
        return c(_this100, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee195() {
          return _regeneratorRuntime().wrap(function _callee195$(_context196) {
            while (1) switch (_context196.prev = _context196.next) {
              case 0:
                _context196.t0 = u !== this.state;
                if (!_context196.t0) {
                  _context196.next = 5;
                  break;
                }
                this.state = u;
                _context196.next = 5;
                return this.observer.onStateChange(this.state, S);
              case 5:
              case "end":
                return _context196.stop();
            }
          }, _callee195, this);
        }));
      };
      this.retryScheduler = new Jt(d, this.sendErrorAnalyticsEvent.bind(this)), this.eventBus.statsUpdate.subscribe(function (u) {
        var g, E;
        var S = ((E = (g = u.getLocalPeerStats()) == null ? void 0 : g.subscribe) == null ? void 0 : E.bitrate) || 0;
        _this100.maxSubscribeBitrate = Math.max(_this100.maxSubscribeBitrate, S);
      });
    }
    _createClass(ft, [{
      key: "getWebrtcInternals",
      value: function getWebrtcInternals() {
        return this.webrtcInternals;
      }
    }, {
      key: "isFlagEnabled",
      value: function isFlagEnabled(e) {
        var r;
        var t = (r = this.initConfig) == null ? void 0 : r.config;
        return ((t == null ? void 0 : t.enabledFlags) || []).includes(e);
      }
    }, {
      key: "preview",
      value: function preview(e, t, i, r) {
        var s = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : !1;
        return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee196() {
          var n;
          return _regeneratorRuntime().wrap(function _callee196$(_context197) {
            while (1) switch (_context197.prev = _context197.next) {
              case 0:
                _context197.next = 2;
                return this.connect(e, t, i, r, s);
              case 2:
                n = _context197.sent;
                return _context197.abrupt("return", (this.state = R.Preview, this.observer.onStateChange(this.state), n));
              case 4:
              case "end":
                return _context197.stop();
            }
          }, _callee196, this);
        }));
      }
    }, {
      key: "join",
      value: function join(e, t, i, r) {
        var s = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : !1;
        return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee197() {
          var _d9;
          return _regeneratorRuntime().wrap(function _callee197$(_context198) {
            while (1) switch (_context198.prev = _context198.next) {
              case 0:
                o.d(P, "join: started \u23F0");
                _context198.prev = 1;
                _context198.t0 = !this.signal.isConnected || !this.initConfig;
                if (!_context198.t0) {
                  _context198.next = 6;
                  break;
                }
                _context198.next = 6;
                return this.connect(e, r, t, i, s);
              case 6:
                this.validateNotDisconnected("connect");
                _context198.t1 = this.initConfig;
                if (!_context198.t1) {
                  _context198.next = 16;
                  break;
                }
                _context198.next = 11;
                return this.waitForLocalRoleAvailability();
              case 11:
                _context198.next = 13;
                return this.createConnectionsAndNegotiateJoin(i, s);
              case 13:
                _context198.next = 15;
                return this.initRtcStatsMonitor();
              case 15:
                o.d(P, "\u2705 join: Negotiated over PUBLISH connection");
              case 16:
                _context198.next = 26;
                break;
              case 18:
                _context198.prev = 18;
                _context198.t2 = _context198["catch"](1);
                o.e(P, "join: failed \u274C [token=".concat(e, "]"), _context198.t2), this.state = R.Failed;
                _d9 = _context198.t2;
                _d9.isTerminal = _d9.isTerminal || _d9.code === 500;
                _context198.next = 25;
                return this.observer.onStateChange(this.state, _d9);
              case 25:
                throw _d9;
              case 26:
                o.i(P, "\u2705 join: successful"), this.state = R.Joined, this.observer.onStateChange(this.state);
              case 27:
              case "end":
                return _context198.stop();
            }
          }, _callee197, this, [[1, 18]]);
        }));
      }
    }, {
      key: "connect",
      value: function connect(e, t, i, r) {
        var s = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : !1;
        return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee199() {
          var _this106 = this;
          var l;
          return _regeneratorRuntime().wrap(function _callee199$(_context200) {
            while (1) switch (_context200.prev = _context200.next) {
              case 0:
                this.setTransportStateForConnect(), this.joinParameters = new qt(e, i, r.name, r.metaData, t, s);
                _context200.prev = 1;
                _context200.next = 4;
                return this.internalConnect(e, t, i);
              case 4:
                return _context200.abrupt("return", _context200.sent);
              case 7:
                _context200.prev = 7;
                _context200.t0 = _context200["catch"](1);
                if (!(_context200.t0 instanceof T && ([f.WebSocketConnectionErrors.WEBSOCKET_CONNECTION_LOST, f.WebSocketConnectionErrors.FAILED_TO_CONNECT, f.WebSocketConnectionErrors.ABNORMAL_CLOSE, f.InitAPIErrors.ENDPOINT_UNREACHABLE].includes(_context200.t0.code) || _context200.t0.code.toString().startsWith("5") || _context200.t0.code.toString().startsWith("429")))) {
                  _context200.next = 15;
                  break;
                }
                l = function l() {
                  return c(_this106, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee198() {
                    return _regeneratorRuntime().wrap(function _callee198$(_context199) {
                      while (1) switch (_context199.prev = _context199.next) {
                        case 0:
                          _context199.next = 2;
                          return this.internalConnect(e, t, i);
                        case 2:
                          return _context199.abrupt("return", Boolean(this.initConfig && this.initConfig.endpoint));
                        case 3:
                        case "end":
                          return _context199.stop();
                      }
                    }, _callee198, this);
                  }));
                };
                _context200.next = 13;
                return this.retryScheduler.schedule({
                  category: C.ConnectFailed,
                  error: _context200.t0,
                  task: l,
                  originalState: this.state,
                  maxFailedRetries: xe,
                  changeState: !1
                });
              case 13:
                _context200.next = 16;
                break;
              case 15:
                throw _context200.t0;
              case 16:
              case "end":
                return _context200.stop();
            }
          }, _callee199, this, [[1, 7]]);
        }));
      }
    }, {
      key: "leave",
      value: function leave(e) {
        return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee200() {
          var t, i, r;
          return _regeneratorRuntime().wrap(function _callee200$(_context201) {
            while (1) switch (_context201.prev = _context201.next) {
              case 0:
                this.retryScheduler.reset(), this.joinParameters = void 0, o.d(P, "leaving in transport");
                _context201.prev = 1;
                this.state = R.Leaving;
                (t = this.webrtcInternals) == null || t.cleanUp();
                _context201.next = 6;
                return (i = this.publishConnection) == null ? void 0 : i.close();
              case 6:
                _context201.next = 8;
                return (r = this.subscribeConnection) == null ? void 0 : r.close();
              case 8:
                if (!e) {
                  _context201.next = 10;
                  break;
                }
                try {
                  this.signal.leave(), o.d(P, "signal leave done");
                } catch (s) {
                  o.w(P, "failed to send leave on websocket to server", s);
                }
              case 10:
                this.analyticsEventsService.flushFailedClientEvents();
                this.analyticsEventsService.reset();
                _context201.next = 14;
                return this.signal.close();
              case 14:
                _context201.next = 19;
                break;
              case 16:
                _context201.prev = 16;
                _context201.t0 = _context201["catch"](1);
                this.eventBus.analytics.publish(H.disconnect(_context201.t0)), o.e(P, "leave: FAILED \u274C", _context201.t0);
              case 19:
                _context201.prev = 19;
                this.state = R.Disconnected, this.observer.onStateChange(this.state);
                return _context201.finish(19);
              case 22:
              case "end":
                return _context201.stop();
            }
          }, _callee200, this, [[1, 16, 19, 22]]);
        }));
      }
    }, {
      key: "publish",
      value: function publish(e) {
        return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee201() {
          var _iterator18, _step18, _t13;
          return _regeneratorRuntime().wrap(function _callee201$(_context202) {
            while (1) switch (_context202.prev = _context202.next) {
              case 0:
                _iterator18 = _createForOfIteratorHelper(e);
                _context202.prev = 1;
                _iterator18.s();
              case 3:
                if ((_step18 = _iterator18.n()).done) {
                  _context202.next = 15;
                  break;
                }
                _t13 = _step18.value;
                _context202.prev = 5;
                _context202.next = 8;
                return this.publishTrack(_t13);
              case 8:
                _context202.next = 13;
                break;
              case 10:
                _context202.prev = 10;
                _context202.t0 = _context202["catch"](5);
                this.eventBus.analytics.publish(H.publish({
                  devices: this.deviceManager.getDevices(),
                  error: _context202.t0
                }));
              case 13:
                _context202.next = 3;
                break;
              case 15:
                _context202.next = 20;
                break;
              case 17:
                _context202.prev = 17;
                _context202.t1 = _context202["catch"](1);
                _iterator18.e(_context202.t1);
              case 20:
                _context202.prev = 20;
                _iterator18.f();
                return _context202.finish(20);
              case 23:
              case "end":
                return _context202.stop();
            }
          }, _callee201, this, [[1, 17, 20, 23], [5, 10]]);
        }));
      }
    }, {
      key: "unpublish",
      value: function unpublish(e) {
        return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee202() {
          var _iterator19, _step19, _t14;
          return _regeneratorRuntime().wrap(function _callee202$(_context203) {
            while (1) switch (_context203.prev = _context203.next) {
              case 0:
                _iterator19 = _createForOfIteratorHelper(e);
                _context203.prev = 1;
                _iterator19.s();
              case 3:
                if ((_step19 = _iterator19.n()).done) {
                  _context203.next = 9;
                  break;
                }
                _t14 = _step19.value;
                _context203.next = 7;
                return this.unpublishTrack(_t14);
              case 7:
                _context203.next = 3;
                break;
              case 9:
                _context203.next = 14;
                break;
              case 11:
                _context203.prev = 11;
                _context203.t0 = _context203["catch"](1);
                _iterator19.e(_context203.t0);
              case 14:
                _context203.prev = 14;
                _iterator19.f();
                return _context203.finish(14);
              case 17:
              case "end":
                return _context203.stop();
            }
          }, _callee202, this, [[1, 11, 14, 17]]);
        }));
      }
    }, {
      key: "sendMessage",
      value: function sendMessage(e) {
        return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee203() {
          return _regeneratorRuntime().wrap(function _callee203$(_context204) {
            while (1) switch (_context204.prev = _context204.next) {
              case 0:
                _context204.next = 2;
                return this.signal.broadcast(e);
              case 2:
                return _context204.abrupt("return", _context204.sent);
              case 3:
              case "end":
                return _context204.stop();
            }
          }, _callee203, this);
        }));
      }
    }, {
      key: "trackUpdate",
      value: function trackUpdate(e) {
        var i = Array.from(this.trackStates.values()).find(function (r) {
          return e.type === r.type && e.source === r.source;
        });
        if (i) {
          var _r19 = new dt(L(v({}, i), {
            mute: !e.enabled
          }));
          this.trackStates.set(i.track_id, _r19), o.d(P, "Track Update", this.trackStates, e), this.signal.trackUpdate(new Map([[i.track_id, _r19]]));
        }
      }
    }, {
      key: "changeRole",
      value: function changeRole(e, t) {
        var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
        return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee204() {
          return _regeneratorRuntime().wrap(function _callee204$(_context205) {
            while (1) switch (_context205.prev = _context205.next) {
              case 0:
                _context205.next = 2;
                return this.signal.requestRoleChange({
                  requested_for: e.peerId,
                  role: t,
                  force: i
                });
              case 2:
              case "end":
                return _context205.stop();
            }
          }, _callee204, this);
        }));
      }
    }, {
      key: "changeRoleOfPeer",
      value: function changeRoleOfPeer(e, t, i) {
        return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee205() {
          return _regeneratorRuntime().wrap(function _callee205$(_context206) {
            while (1) switch (_context206.prev = _context206.next) {
              case 0:
                _context206.next = 2;
                return this.signal.requestRoleChange({
                  requested_for: e.peerId,
                  role: t,
                  force: i
                });
              case 2:
              case "end":
                return _context206.stop();
            }
          }, _callee205, this);
        }));
      }
    }, {
      key: "changeRoleOfPeersWithRoles",
      value: function changeRoleOfPeersWithRoles(e, t) {
        return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee206() {
          return _regeneratorRuntime().wrap(function _callee206$(_context207) {
            while (1) switch (_context207.prev = _context207.next) {
              case 0:
                _context207.next = 2;
                return this.signal.requestBulkRoleChange({
                  roles: e.map(function (i) {
                    return i.name;
                  }),
                  role: t,
                  force: !0
                });
              case 2:
              case "end":
                return _context207.stop();
            }
          }, _callee206, this);
        }));
      }
    }, {
      key: "acceptRoleChange",
      value: function acceptRoleChange(e) {
        return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee207() {
          var t;
          return _regeneratorRuntime().wrap(function _callee207$(_context208) {
            while (1) switch (_context208.prev = _context208.next) {
              case 0:
                _context208.next = 2;
                return this.signal.acceptRoleChangeRequest({
                  requested_by: (t = e.requestedBy) == null ? void 0 : t.peerId,
                  role: e.role.name,
                  token: e.token
                });
              case 2:
              case "end":
                return _context208.stop();
            }
          }, _callee207, this);
        }));
      }
    }, {
      key: "endRoom",
      value: function endRoom(e, t) {
        return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee208() {
          return _regeneratorRuntime().wrap(function _callee208$(_context209) {
            while (1) switch (_context209.prev = _context209.next) {
              case 0:
                _context209.next = 2;
                return this.signal.endRoom(e, t);
              case 2:
              case "end":
                return _context209.stop();
            }
          }, _callee208, this);
        }));
      }
    }, {
      key: "removePeer",
      value: function removePeer(e, t) {
        return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee209() {
          return _regeneratorRuntime().wrap(function _callee209$(_context210) {
            while (1) switch (_context210.prev = _context210.next) {
              case 0:
                _context210.next = 2;
                return this.signal.removePeer({
                  requested_for: e,
                  reason: t
                });
              case 2:
              case "end":
                return _context210.stop();
            }
          }, _callee209, this);
        }));
      }
    }, {
      key: "startRTMPOrRecording",
      value: function startRTMPOrRecording(e) {
        return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee210() {
          var i, t;
          return _regeneratorRuntime().wrap(function _callee210$(_context211) {
            while (1) switch (_context211.prev = _context211.next) {
              case 0:
                t = {
                  meeting_url: e.meetingURL,
                  record: e.record
                };
                ((i = e.rtmpURLs) == null ? void 0 : i.length) && (t.rtmp_urls = e.rtmpURLs);
                e.resolution && (t.resolution = e.resolution);
                _context211.next = 5;
                return this.signal.startRTMPOrRecording(t);
              case 5:
              case "end":
                return _context211.stop();
            }
          }, _callee210, this);
        }));
      }
    }, {
      key: "stopRTMPOrRecording",
      value: function stopRTMPOrRecording() {
        return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee211() {
          return _regeneratorRuntime().wrap(function _callee211$(_context212) {
            while (1) switch (_context212.prev = _context212.next) {
              case 0:
                _context212.next = 2;
                return this.signal.stopRTMPAndRecording();
              case 2:
              case "end":
                return _context212.stop();
            }
          }, _callee211, this);
        }));
      }
    }, {
      key: "startHLSStreaming",
      value: function startHLSStreaming(e) {
        return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee212() {
          var t;
          return _regeneratorRuntime().wrap(function _callee212$(_context213) {
            while (1) switch (_context213.prev = _context213.next) {
              case 0:
                t = {};
                e && e.variants && e.variants.length > 0 && (t.variants = e.variants.map(function (i) {
                  var r = {
                    meeting_url: i.meetingURL
                  };
                  return i.metadata && (r.metadata = i.metadata), r;
                }));
                (e == null ? void 0 : e.recording) && (t.hls_recording = {
                  single_file_per_layer: e.recording.singleFilePerLayer,
                  hls_vod: e.recording.hlsVod
                });
                _context213.next = 5;
                return this.signal.startHLSStreaming(t);
              case 5:
              case "end":
                return _context213.stop();
            }
          }, _callee212, this);
        }));
      }
    }, {
      key: "stopHLSStreaming",
      value: function stopHLSStreaming(e) {
        return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee213() {
          var t, _i18;
          return _regeneratorRuntime().wrap(function _callee213$(_context214) {
            while (1) switch (_context214.prev = _context214.next) {
              case 0:
                if (!e) {
                  _context214.next = 4;
                  break;
                }
                _i18 = {
                  variants: (t = e == null ? void 0 : e.variants) == null ? void 0 : t.map(function (r) {
                    var s = {
                      meeting_url: r.meetingURL
                    };
                    return r.metadata && (s.metadata = r.metadata), s;
                  })
                };
                _context214.next = 4;
                return this.signal.stopHLSStreaming(_i18);
              case 4:
                _context214.next = 6;
                return this.signal.stopHLSStreaming();
              case 6:
              case "end":
                return _context214.stop();
            }
          }, _callee213, this);
        }));
      }
    }, {
      key: "sendHLSTimedMetadata",
      value: function sendHLSTimedMetadata(e) {
        return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee214() {
          var _t15;
          return _regeneratorRuntime().wrap(function _callee214$(_context215) {
            while (1) switch (_context215.prev = _context215.next) {
              case 0:
                if (!(e.length > 0)) {
                  _context215.next = 4;
                  break;
                }
                _t15 = {
                  metadata_objs: e
                };
                _context215.next = 4;
                return this.signal.sendHLSTimedMetadata(_t15);
              case 4:
              case "end":
                return _context215.stop();
            }
          }, _callee214, this);
        }));
      }
    }, {
      key: "changeName",
      value: function changeName(e) {
        return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee215() {
          var t;
          return _regeneratorRuntime().wrap(function _callee215$(_context216) {
            while (1) switch (_context216.prev = _context216.next) {
              case 0:
                t = this.store.getLocalPeer();
                _context216.t0 = t && t.name !== e;
                if (!_context216.t0) {
                  _context216.next = 5;
                  break;
                }
                _context216.next = 5;
                return this.signal.updatePeer({
                  name: e
                });
              case 5:
              case "end":
                return _context216.stop();
            }
          }, _callee215, this);
        }));
      }
    }, {
      key: "changeMetadata",
      value: function changeMetadata(e) {
        return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee216() {
          return _regeneratorRuntime().wrap(function _callee216$(_context217) {
            while (1) switch (_context217.prev = _context217.next) {
              case 0:
                _context217.next = 2;
                return this.signal.updatePeer({
                  data: e
                });
              case 2:
              case "end":
                return _context217.stop();
            }
          }, _callee216, this);
        }));
      }
    }, {
      key: "getSessionMetadata",
      value: function getSessionMetadata() {
        return this.signal.getSessionMetadata();
      }
    }, {
      key: "setSessionMetadata",
      value: function setSessionMetadata(e) {
        return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee217() {
          return _regeneratorRuntime().wrap(function _callee217$(_context218) {
            while (1) switch (_context218.prev = _context218.next) {
              case 0:
                _context218.next = 2;
                return this.signal.setSessionMetadata({
                  data: e
                });
              case 2:
              case "end":
                return _context218.stop();
            }
          }, _callee217, this);
        }));
      }
    }, {
      key: "changeTrackState",
      value: function changeTrackState(e) {
        return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee218() {
          return _regeneratorRuntime().wrap(function _callee218$(_context219) {
            while (1) switch (_context219.prev = _context219.next) {
              case 0:
                _context219.next = 2;
                return this.signal.requestTrackStateChange(e);
              case 2:
              case "end":
                return _context219.stop();
            }
          }, _callee218, this);
        }));
      }
    }, {
      key: "changeMultiTrackState",
      value: function changeMultiTrackState(e) {
        return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee219() {
          return _regeneratorRuntime().wrap(function _callee219$(_context220) {
            while (1) switch (_context220.prev = _context220.next) {
              case 0:
                _context220.next = 2;
                return this.signal.requestMultiTrackStateChange(e);
              case 2:
              case "end":
                return _context220.stop();
            }
          }, _callee219, this);
        }));
      }
    }, {
      key: "publishTrack",
      value: function publishTrack(e) {
        return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee220() {
          var _this107 = this;
          var t, i, r;
          return _regeneratorRuntime().wrap(function _callee220$(_context221) {
            while (1) switch (_context221.prev = _context221.next) {
              case 0:
                e.publishedTrackId = e.getTrackIDBeingSent(), o.d(P, "\u23F3 publishTrack: trackId=".concat(e.trackId, ", toPublishTrackId=").concat(e.publishedTrackId), "".concat(e)), this.trackStates.set(e.publishedTrackId, new dt(e));
                t = new Promise(function (s, n) {
                  _this107.callbacks.set(Ce, {
                    promise: {
                      resolve: s,
                      reject: n
                    },
                    action: p.PUBLISH,
                    extra: {}
                  });
                }), i = e.stream;
                i.setConnection(this.publishConnection);
                r = this.store.getSimulcastLayers(e.source);
                i.addTransceiver(e, r);
                o.time("publish-".concat(e.trackId, "-").concat(e.type));
                _context221.next = 8;
                return t;
              case 8:
                o.timeEnd("publish-".concat(e.trackId, "-").concat(e.type));
                this.store.addTrack(e);
                _context221.next = 12;
                return i.setMaxBitrateAndFramerate(e).then(function () {
                  o.d(P, "Setting maxBitrate=".concat(e.settings.maxBitrate, " kpbs").concat(e instanceof Z ? " and maxFramerate=".concat(e.settings.maxFramerate) : "", " for ").concat(e.source, " ").concat(e.type, " ").concat(e.trackId));
                }).catch(function (s) {
                  return o.w(P, "Failed setting maxBitrate and maxFramerate", s);
                });
              case 12:
                e.isPublished = !0;
                o.d(P, "\u2705 publishTrack: trackId=".concat(e.trackId), "".concat(e), this.callbacks);
              case 14:
              case "end":
                return _context221.stop();
            }
          }, _callee220, this);
        }));
      }
    }, {
      key: "unpublishTrack",
      value: function unpublishTrack(e) {
        return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee221() {
          var _this108 = this;
          var s, t;
          return _regeneratorRuntime().wrap(function _callee221$(_context222) {
            while (1) switch (_context222.prev = _context222.next) {
              case 0:
                if (o.d(P, "\u23F3 unpublishTrack: trackId=".concat(e.trackId), "".concat(e)), e.publishedTrackId && this.trackStates.has(e.publishedTrackId)) this.trackStates.delete(e.publishedTrackId);else {
                  s = Array.from(this.trackStates.values()).find(function (n) {
                    return e.type === n.type && e.source === n.source;
                  });
                  s && this.trackStates.delete(s.track_id);
                }
                t = new Promise(function (r, s) {
                  _this108.callbacks.set(Ce, {
                    promise: {
                      resolve: r,
                      reject: s
                    },
                    action: p.UNPUBLISH,
                    extra: {}
                  });
                });
                e.stream.removeSender(e);
                _context222.next = 5;
                return t;
              case 5:
                _context222.next = 7;
                return e.cleanup();
              case 7:
                this.store.removeTrack(e.trackId);
                o.d(P, "\u2705 unpublishTrack: trackId=".concat(e.trackId), this.callbacks);
              case 9:
              case "end":
                return _context222.stop();
            }
          }, _callee221, this);
        }));
      }
    }, {
      key: "waitForLocalRoleAvailability",
      value: function waitForLocalRoleAvailability() {
        var _this109 = this;
        if (!this.store.hasRoleDetailsArrived()) return new Promise(function (e) {
          _this109.eventBus.policyChange.subscribeOnce(function () {
            return e();
          });
        });
      }
    }, {
      key: "createConnectionsAndNegotiateJoin",
      value: function createConnectionsAndNegotiateJoin(e) {
        var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
        return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee222() {
          var i;
          return _regeneratorRuntime().wrap(function _callee222$(_context223) {
            while (1) switch (_context223.prev = _context223.next) {
              case 0:
                i = this.doesLocalPeerNeedWebRTC();
                i && this.createPeerConnections();
                this.analyticsTimer.start(M.JOIN_RESPONSE);
                _context223.next = 5;
                return this.negotiateJoinWithRetry({
                  name: e.name,
                  data: e.metaData,
                  autoSubscribeVideo: t,
                  isWebRTC: i
                });
              case 5:
                this.analyticsTimer.end(M.JOIN_RESPONSE);
              case 6:
              case "end":
                return _context223.stop();
            }
          }, _callee222, this);
        }));
      }
    }, {
      key: "createPeerConnections",
      value: function createPeerConnections() {
        this.initConfig && (this.publishConnection || (this.publishConnection = new ht(this.signal, this.initConfig.rtcConfiguration, this.publishConnectionObserver, this)), this.subscribeConnection || (this.subscribeConnection = new mt(this.signal, this.initConfig.rtcConfiguration, this.subscribeConnectionObserver)));
      }
    }, {
      key: "negotiateJoinWithRetry",
      value: function negotiateJoinWithRetry(s) {
        return c(this, arguments, function (_ref28) {
          var _this110 = this;
          var e = _ref28.name,
            t = _ref28.data,
            i = _ref28.autoSubscribeVideo,
            _ref28$isWebRTC = _ref28.isWebRTC,
            r = _ref28$isWebRTC === void 0 ? !0 : _ref28$isWebRTC;
          return /*#__PURE__*/_regeneratorRuntime().mark(function _callee224() {
            var _d10, h;
            return _regeneratorRuntime().wrap(function _callee224$(_context225) {
              while (1) switch (_context225.prev = _context225.next) {
                case 0:
                  _context225.prev = 0;
                  _context225.next = 3;
                  return _this110.negotiateJoin({
                    name: e,
                    data: t,
                    autoSubscribeVideo: i,
                    isWebRTC: r
                  });
                case 3:
                  _context225.next = 17;
                  break;
                case 5:
                  _context225.prev = 5;
                  _context225.t0 = _context225["catch"](0);
                  o.e(P, "Join negotiation failed \u274C", _context225.t0);
                  _d10 = _context225.t0 instanceof T ? _context225.t0 : m.WebsocketMethodErrors.ServerErrors(500, p.JOIN, "Websocket join error - ".concat(_context225.t0.message));
                  if (!(parseInt("".concat(_d10.code / 100)) === 5 || [f.WebSocketConnectionErrors.WEBSOCKET_CONNECTION_LOST, 429].includes(_d10.code))) {
                    _context225.next = 16;
                    break;
                  }
                  _this110.joinRetryCount = 0, _d10.isTerminal = !1;
                  h = function h() {
                    return c(_this110, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee223() {
                      return _regeneratorRuntime().wrap(function _callee223$(_context224) {
                        while (1) switch (_context224.prev = _context224.next) {
                          case 0:
                            this.joinRetryCount++;
                            _context224.next = 3;
                            return this.negotiateJoin({
                              name: e,
                              data: t,
                              autoSubscribeVideo: i,
                              isWebRTC: r
                            });
                          case 3:
                            return _context224.abrupt("return", _context224.sent);
                          case 4:
                          case "end":
                            return _context224.stop();
                        }
                      }, _callee223, this);
                    }));
                  };
                  _context225.next = 14;
                  return _this110.retryScheduler.schedule({
                    category: C.JoinWSMessageFailed,
                    error: _d10,
                    task: h,
                    originalState: R.Joined,
                    maxFailedRetries: 3,
                    changeState: !1
                  });
                case 14:
                  _context225.next = 17;
                  break;
                case 16:
                  throw _context225.t0;
                case 17:
                case "end":
                  return _context225.stop();
              }
            }, _callee224, null, [[0, 5]]);
          })();
        });
      }
    }, {
      key: "negotiateJoin",
      value: function negotiateJoin(s) {
        return c(this, arguments, function (_ref29) {
          var _this111 = this;
          var e = _ref29.name,
            t = _ref29.data,
            i = _ref29.autoSubscribeVideo,
            _ref29$isWebRTC = _ref29.isWebRTC,
            r = _ref29$isWebRTC === void 0 ? !0 : _ref29$isWebRTC;
          return /*#__PURE__*/_regeneratorRuntime().mark(function _callee225() {
            return _regeneratorRuntime().wrap(function _callee225$(_context226) {
              while (1) switch (_context226.prev = _context226.next) {
                case 0:
                  if (!r) {
                    _context226.next = 6;
                    break;
                  }
                  _context226.next = 3;
                  return _this111.negotiateJoinWebRTC({
                    name: e,
                    data: t,
                    autoSubscribeVideo: i
                  });
                case 3:
                  _context226.t0 = _context226.sent;
                  _context226.next = 9;
                  break;
                case 6:
                  _context226.next = 8;
                  return _this111.negotiateJoinNonWebRTC({
                    name: e,
                    data: t,
                    autoSubscribeVideo: i
                  });
                case 8:
                  _context226.t0 = _context226.sent;
                case 9:
                  return _context226.abrupt("return", _context226.t0);
                case 10:
                case "end":
                  return _context226.stop();
              }
            }, _callee225);
          })();
        });
      }
    }, {
      key: "negotiateJoinWebRTC",
      value: function negotiateJoinWebRTC(r) {
        return c(this, arguments, function (_ref30) {
          var _this112 = this;
          var e = _ref30.name,
            t = _ref30.data,
            i = _ref30.autoSubscribeVideo;
          return /*#__PURE__*/_regeneratorRuntime().mark(function _callee226() {
            var s, n, d, l, _iterator20, _step20, h;
            return _regeneratorRuntime().wrap(function _callee226$(_context227) {
              while (1) switch (_context227.prev = _context227.next) {
                case 0:
                  if (!(o.d(P, "\u23F3 join: Negotiating over PUBLISH connection"), !_this112.publishConnection)) {
                    _context227.next = 2;
                    break;
                  }
                  return _context227.abrupt("return", (o.e(P, "Publish peer connection not found, cannot negotiate"), !1));
                case 2:
                  _context227.next = 4;
                  return _this112.publishConnection.createOffer();
                case 4:
                  s = _context227.sent;
                  _context227.next = 7;
                  return _this112.publishConnection.setLocalDescription(s);
                case 7:
                  n = _this112.isFlagEnabled(ne.FLAG_SERVER_SUB_DEGRADATION);
                  d = _this112.isFlagEnabled(ne.FLAG_SERVER_SIMULCAST);
                  _context227.next = 11;
                  return _this112.signal.join(e, t, !i, n, d, s);
                case 11:
                  l = _context227.sent;
                  _context227.next = 14;
                  return _this112.publishConnection.setRemoteDescription(l);
                case 14:
                  _iterator20 = _createForOfIteratorHelper(_this112.publishConnection.candidates);
                  _context227.prev = 15;
                  _iterator20.s();
                case 17:
                  if ((_step20 = _iterator20.n()).done) {
                    _context227.next = 23;
                    break;
                  }
                  h = _step20.value;
                  _context227.next = 21;
                  return _this112.publishConnection.addIceCandidate(h);
                case 21:
                  _context227.next = 17;
                  break;
                case 23:
                  _context227.next = 28;
                  break;
                case 25:
                  _context227.prev = 25;
                  _context227.t0 = _context227["catch"](15);
                  _iterator20.e(_context227.t0);
                case 28:
                  _context227.prev = 28;
                  _iterator20.f();
                  return _context227.finish(28);
                case 31:
                  return _context227.abrupt("return", (_this112.publishConnection.initAfterJoin(), !!l));
                case 32:
                case "end":
                  return _context227.stop();
              }
            }, _callee226, null, [[15, 25, 28, 31]]);
          })();
        });
      }
    }, {
      key: "negotiateJoinNonWebRTC",
      value: function negotiateJoinNonWebRTC(r) {
        return c(this, arguments, function (_ref31) {
          var _this113 = this;
          var e = _ref31.name,
            t = _ref31.data,
            i = _ref31.autoSubscribeVideo;
          return /*#__PURE__*/_regeneratorRuntime().mark(function _callee227() {
            var s, n;
            return _regeneratorRuntime().wrap(function _callee227$(_context228) {
              while (1) switch (_context228.prev = _context228.next) {
                case 0:
                  o.d(P, "\u23F3 join: Negotiating Non-WebRTC");
                  s = _this113.isFlagEnabled(ne.FLAG_SERVER_SUB_DEGRADATION), n = _this113.isFlagEnabled(ne.FLAG_SERVER_SIMULCAST);
                  _context228.next = 4;
                  return _this113.signal.join(e, t, !i, s, n);
                case 4:
                  return _context228.abrupt("return", !!_context228.sent);
                case 5:
                case "end":
                  return _context228.stop();
              }
            }, _callee227);
          })();
        });
      }
    }, {
      key: "negotiateOnFirstPublish",
      value: function negotiateOnFirstPublish() {
        return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee228() {
          var e, t, _iterator21, _step21, _i19;
          return _regeneratorRuntime().wrap(function _callee228$(_context229) {
            while (1) switch (_context229.prev = _context229.next) {
              case 0:
                if (!(o.d(P, "\u23F3 Negotiating offer over PUBLISH connection"), !this.publishConnection)) {
                  _context229.next = 2;
                  break;
                }
                return _context229.abrupt("return", (o.e(P, "Publish peer connection not found, cannot negotiate"), !1));
              case 2:
                _context229.next = 4;
                return this.publishConnection.createOffer(this.trackStates);
              case 4:
                e = _context229.sent;
                _context229.next = 7;
                return this.publishConnection.setLocalDescription(e);
              case 7:
                _context229.next = 9;
                return this.signal.offer(e, this.trackStates);
              case 9:
                t = _context229.sent;
                _context229.next = 12;
                return this.publishConnection.setRemoteDescription(t);
              case 12:
                _iterator21 = _createForOfIteratorHelper(this.publishConnection.candidates);
                _context229.prev = 13;
                _iterator21.s();
              case 15:
                if ((_step21 = _iterator21.n()).done) {
                  _context229.next = 21;
                  break;
                }
                _i19 = _step21.value;
                _context229.next = 19;
                return this.publishConnection.addIceCandidate(_i19);
              case 19:
                _context229.next = 15;
                break;
              case 21:
                _context229.next = 26;
                break;
              case 23:
                _context229.prev = 23;
                _context229.t0 = _context229["catch"](13);
                _iterator21.e(_context229.t0);
              case 26:
                _context229.prev = 26;
                _iterator21.f();
                return _context229.finish(26);
              case 29:
                return _context229.abrupt("return", (this.publishConnection.initAfterJoin(), !!t));
              case 30:
              case "end":
                return _context229.stop();
            }
          }, _callee228, this, [[13, 23, 26, 29]]);
        }));
      }
    }, {
      key: "performPublishRenegotiation",
      value: function performPublishRenegotiation(e) {
        return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee229() {
          var t, _i20, _r20, _r21;
          return _regeneratorRuntime().wrap(function _callee229$(_context230) {
            while (1) switch (_context230.prev = _context230.next) {
              case 0:
                o.d(P, "\u23F3 [role=PUBLISH] onRenegotiationNeeded START", this.trackStates);
                t = this.callbacks.get(Ce);
                if (!t) {
                  _context230.next = 27;
                  break;
                }
                if (this.publishConnection) {
                  _context230.next = 6;
                  break;
                }
                o.e(P, "Publish peer connection not found, cannot renegotiate");
                return _context230.abrupt("return");
              case 6:
                _context230.prev = 6;
                _context230.next = 9;
                return this.publishConnection.createOffer(this.trackStates, e);
              case 9:
                _i20 = _context230.sent;
                _context230.next = 12;
                return this.publishConnection.setLocalDescription(_i20);
              case 12:
                o.time("renegotiation-offer-exchange");
                _context230.next = 15;
                return this.signal.offer(_i20, this.trackStates);
              case 15:
                _r20 = _context230.sent;
                this.callbacks.delete(Ce);
                o.timeEnd("renegotiation-offer-exchange");
                _context230.next = 20;
                return this.publishConnection.setRemoteDescription(_r20);
              case 20:
                t.promise.resolve(!0);
                o.d(P, "[role=PUBLISH] onRenegotiationNeeded DONE \u2705");
                _context230.next = 27;
                break;
              case 24:
                _context230.prev = 24;
                _context230.t0 = _context230["catch"](6);
                _context230.t0 instanceof T ? _r21 = _context230.t0 : _r21 = m.GenericErrors.Unknown(p.PUBLISH, _context230.t0.message), t.promise.reject(_r21), o.d(P, "[role=PUBLISH] onRenegotiationNeeded FAILED \u274C");
              case 27:
              case "end":
                return _context230.stop();
            }
          }, _callee229, this, [[6, 24]]);
        }));
      }
    }, {
      key: "handleIceConnectionFailure",
      value: function handleIceConnectionFailure(e, t) {
        return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee230() {
          return _regeneratorRuntime().wrap(function _callee230$(_context231) {
            while (1) switch (_context231.prev = _context231.next) {
              case 0:
                this.retryScheduler.isTaskInProgress(G.Publish ? C.PublishIceConnectionFailed : C.SubscribeIceConnectionFailed) || (e === G.Publish ? this.retryScheduler.schedule({
                  category: C.PublishIceConnectionFailed,
                  error: t,
                  task: this.retryPublishIceFailedTask,
                  originalState: R.Joined
                }) : this.retryScheduler.schedule({
                  category: C.SubscribeIceConnectionFailed,
                  error: t,
                  task: this.retrySubscribeIceFailedTask,
                  originalState: R.Joined,
                  maxFailedRetries: 1
                }));
              case 1:
              case "end":
                return _context231.stop();
            }
          }, _callee230, this);
        }));
      }
    }, {
      key: "internalConnect",
      value: function internalConnect(e, t, i) {
        return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee231() {
          var r;
          return _regeneratorRuntime().wrap(function _callee231$(_context232) {
            while (1) switch (_context232.prev = _context232.next) {
              case 0:
                o.d(P, "connect: started \u23F0");
                r = new Date();
                _context232.prev = 2;
                this.analyticsTimer.start(M.INIT);
                _context232.next = 6;
                return vt.fetchInitConfig({
                  token: e,
                  peerId: i,
                  userAgent: this.store.getUserAgent(),
                  initEndpoint: t
                });
              case 6:
                this.initConfig = _context232.sent;
                this.analyticsTimer.end(M.INIT);
                se.setWebsocketEndpoint(this.initConfig.endpoint);
                this.validateNotDisconnected("post init");
                _context232.next = 12;
                return this.openSignal(e, i);
              case 12:
                this.store.setSimulcastEnabled(this.isFlagEnabled(ne.FLAG_SERVER_SIMULCAST));
                o.d(P, "Adding Analytics Transport: JsonRpcSignal");
                this.analyticsEventsService.setTransport(this.analyticsSignalTransport);
                this.analyticsEventsService.flush();
                return _context232.abrupt("return", this.initConfig);
              case 19:
                _context232.prev = 19;
                _context232.t0 = _context232["catch"](2);
                throw this.state !== R.Reconnecting && this.eventBus.analytics.publish(H.connect(_context232.t0, this.getAdditionalAnalyticsProperties(), r, new Date(), t)), o.d(P, "\u274C internal connect: failed", _context232.t0), _context232.t0;
              case 22:
              case "end":
                return _context232.stop();
            }
          }, _callee231, this, [[2, 19]]);
        }));
      }
    }, {
      key: "validateNotDisconnected",
      value: function validateNotDisconnected(e) {
        if (this.state === R.Disconnected) throw o.w(P, "aborting join as transport state is disconnected"), m.GenericErrors.ValidationFailed("leave called before join could complete - stage=".concat(e));
      }
    }, {
      key: "openSignal",
      value: function openSignal(e, t) {
        return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee232() {
          var i;
          return _regeneratorRuntime().wrap(function _callee232$(_context233) {
            while (1) switch (_context233.prev = _context233.next) {
              case 0:
                if (this.initConfig) {
                  _context233.next = 2;
                  break;
                }
                throw m.InitAPIErrors.InitConfigNotAvailable(p.INIT, "Init Config not found");
              case 2:
                o.d(P, "\u23F3 internal connect: connecting to ws endpoint", this.initConfig.endpoint);
                i = new URL(this.initConfig.endpoint);
                i.searchParams.set("peer", t);
                i.searchParams.set("token", e);
                i.searchParams.set("user_agent_v2", this.store.getUserAgent());
                this.endpoint = i.toString();
                this.analyticsTimer.start(M.WEBSOCKET_CONNECT);
                _context233.next = 11;
                return this.signal.open(this.endpoint);
              case 11:
                this.analyticsTimer.end(M.WEBSOCKET_CONNECT);
                this.analyticsTimer.start(M.ON_POLICY_CHANGE);
                this.analyticsTimer.start(M.ROOM_STATE);
                o.d(P, "\u2705 internal connect: connected to ws endpoint");
              case 15:
              case "end":
                return _context233.stop();
            }
          }, _callee232, this);
        }));
      }
    }, {
      key: "initRtcStatsMonitor",
      value: function initRtcStatsMonitor() {
        return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee233() {
          var e, t, i;
          return _regeneratorRuntime().wrap(function _callee233$(_context234) {
            while (1) switch (_context234.prev = _context234.next) {
              case 0:
                (i = this.webrtcInternals) == null || i.setPeerConnections({
                  publish: (e = this.publishConnection) == null ? void 0 : e.nativeConnection,
                  subscribe: (t = this.subscribeConnection) == null ? void 0 : t.nativeConnection
                });
              case 1:
              case "end":
                return _context234.stop();
            }
          }, _callee233, this);
        }));
      }
    }, {
      key: "doesRoleNeedWebRTC",
      value: function doesRoleNeedWebRTC(e) {
        var r, s;
        if (!this.isFlagEnabled(ne.FLAG_NON_WEBRTC_DISABLE_OFFER)) return !0;
        var t = Boolean(e.publishParams.allowed && ((r = e.publishParams.allowed) == null ? void 0 : r.length) > 0),
          i = Boolean(e.subscribeParams.subscribeToRoles && ((s = e.subscribeParams.subscribeToRoles) == null ? void 0 : s.length) > 0);
        return t || i;
      }
    }, {
      key: "doesLocalPeerNeedWebRTC",
      value: function doesLocalPeerNeedWebRTC() {
        var t;
        var e = (t = this.store.getLocalPeer()) == null ? void 0 : t.role;
        return e ? this.doesRoleNeedWebRTC(e) : !0;
      }
    }, {
      key: "handleSubscribeConnectionConnected",
      value: function handleSubscribeConnectionConnected() {
        var t;
        (t = this.subscribeConnection) == null || t.logSelectedIceCandidatePairs();
        var e = this.callbacks.get(Re);
        this.callbacks.delete(Re), e && e.promise.resolve(!0);
      }
    }, {
      key: "setTransportStateForConnect",
      value: function setTransportStateForConnect() {
        if (this.state === R.Failed && (this.state = R.Disconnected), this.state !== R.Disconnected && this.state !== R.Reconnecting) throw m.WebsocketMethodErrors.AlreadyJoined(p.JOIN, "Cannot join a meeting in ".concat(this.state, " state"));
        this.state === R.Disconnected && (this.state = R.Connecting, this.observer.onStateChange(this.state));
      }
    }, {
      key: "sendErrorAnalyticsEvent",
      value: function sendErrorAnalyticsEvent(e, t) {
        var i = this.getAdditionalAnalyticsProperties(),
          r;
        switch (t) {
          case C.ConnectFailed:
            r = H.connect(e, i);
            break;
          case C.SignalDisconnect:
            r = H.disconnect(e, i);
            break;
          case C.JoinWSMessageFailed:
            r = H.join({
              error: e,
              time: this.analyticsTimer.getTimeTaken(M.JOIN),
              init_response_time: this.analyticsTimer.getTimeTaken(M.INIT),
              ws_connect_time: this.analyticsTimer.getTimeTaken(M.WEBSOCKET_CONNECT),
              on_policy_change_time: this.analyticsTimer.getTimeTaken(M.ON_POLICY_CHANGE),
              local_audio_track_time: this.analyticsTimer.getTimeTaken(M.LOCAL_AUDIO_TRACK),
              local_video_track_time: this.analyticsTimer.getTimeTaken(M.LOCAL_VIDEO_TRACK),
              retries_join: this.joinRetryCount
            });
            break;
          case C.PublishIceConnectionFailed:
            r = H.publish({
              error: e
            });
            break;
          case C.SubscribeIceConnectionFailed:
            r = H.subscribeFail(e);
            break;
        }
        this.eventBus.analytics.publish(r);
      }
    }, {
      key: "getAdditionalAnalyticsProperties",
      value: function getAdditionalAnalyticsProperties() {
        var n, d, l, h, u, S, g, E;
        var e = Yi(),
          t = typeof document != "undefined" && document.hidden,
          i = this.store.getRemoteVideoTracks().filter(function (N) {
            return N.degraded;
          }).length,
          r = (h = (l = (d = (n = this.getWebrtcInternals()) == null ? void 0 : n.getCurrentStats()) == null ? void 0 : d.getLocalPeerStats()) == null ? void 0 : l.publish) == null ? void 0 : h.bitrate,
          s = (E = (g = (S = (u = this.getWebrtcInternals()) == null ? void 0 : u.getCurrentStats()) == null ? void 0 : S.getLocalPeerStats()) == null ? void 0 : g.subscribe) == null ? void 0 : E.bitrate;
        return {
          network_info: e,
          document_hidden: t,
          num_degraded_tracks: i,
          bitrate: {
            publish: r,
            subscribe: s
          },
          max_sub_bitrate: this.maxSubscribeBitrate,
          recent_pong_response_times: this.signal.getPongResponseTimes(),
          transport_state: this.state
        };
      }
    }]);
    return ft;
  }();
function Et(a) {
  if (!a || a.length === 0) throw m.InitAPIErrors.InvalidTokenFormat(p.INIT, "Token cannot be an empty string or undefined or null");
  var e = a.split(".");
  if (e.length !== 3) throw m.InitAPIErrors.InvalidTokenFormat(p.INIT, "Expected 3 '.' separate fields - header, payload and signature respectively");
  var t = atob(e[1]);
  try {
    var _i21 = JSON.parse(t);
    return {
      roomId: _i21.room_id,
      userId: _i21.user_id,
      role: _i21.role
    };
  } catch (i) {
    throw m.InitAPIErrors.InvalidTokenFormat(p.INIT, "couldn't parse to json - ".concat(i.message));
  }
}
var zi = {
    isAudioMuted: !1,
    isVideoMuted: !1,
    audioInputDeviceId: "default",
    audioOutputDeviceId: "default",
    videoDeviceId: "default"
  },
  Zi = {
    published: !1,
    isInitialised: !1,
    isReconnecting: !1,
    isPreviewInProgress: !1,
    isJoinInProgress: !1,
    deviceManagersInitialised: !1
  },
  Dr = /*#__PURE__*/function () {
    function Dr() {
      var _this114 = this;
      _classCallCheck(this, Dr);
      this.TAG = "[HMSSdk]:";
      this.transportState = R.Disconnected;
      this.analyticsTimer = new At();
      this.sdkState = v({}, Zi);
      this.handleAutoplayError = function (e) {
        var t, i;
        (i = (t = _this114.errorListener) == null ? void 0 : t.onError) == null || i.call(t, e);
      };
      this.observer = {
        onNotification: function onNotification(e) {
          if (e.method === A.PEER_LEAVE_REQUEST) {
            _this114.handlePeerLeaveRequest(e.params);
            return;
          }
          switch (e.method) {
            case A.POLICY_CHANGE:
              _this114.analyticsTimer.end(M.ON_POLICY_CHANGE);
              break;
            case A.PEER_LIST:
              _this114.analyticsTimer.end(M.PEER_LIST);
              break;
            case A.ROOM_STATE:
              _this114.analyticsTimer.end(M.ROOM_STATE);
              break;
            default:
          }
          _this114.notificationManager.handleNotification(e, _this114.sdkState.isReconnecting);
        },
        onTrackAdd: function onTrackAdd(e) {
          _this114.notificationManager.handleTrackAdd(e);
        },
        onTrackRemove: function onTrackRemove(e) {
          _this114.notificationManager.handleTrackRemove(e);
        },
        onFailure: function onFailure(e) {
          var t;
          (t = _this114.errorListener) == null || t.onError(e);
        },
        onStateChange: function onStateChange(e, t) {
          return c(_this114, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee235() {
            var _this115 = this;
            var r, s, i;
            return _regeneratorRuntime().wrap(function _callee235$(_context236) {
              while (1) switch (_context236.prev = _context236.next) {
                case 0:
                  i = function i(n) {
                    return c(_this115, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee234() {
                      var d, l;
                      return _regeneratorRuntime().wrap(function _callee234$(_context235) {
                        while (1) switch (_context235.prev = _context235.next) {
                          case 0:
                            _context235.next = 2;
                            return this.internalLeave(!0, n);
                          case 2:
                            !this.sdkState.isPreviewInProgress && !this.sdkState.isJoinInProgress && ((l = (d = this.errorListener) == null ? void 0 : d.onError) == null || l.call(d, n));
                            this.sdkState.isReconnecting = !1;
                          case 4:
                          case "end":
                            return _context235.stop();
                        }
                      }, _callee234, this);
                    }));
                  };
                  _context236.t0 = e;
                  _context236.next = _context236.t0 === R.Preview ? 4 : _context236.t0 === R.Joined ? 4 : _context236.t0 === R.Failed ? 6 : _context236.t0 === R.Reconnecting ? 9 : 11;
                  break;
                case 4:
                  this.transportState === R.Reconnecting && ((r = this.listener) == null || r.onReconnected());
                  return _context236.abrupt("break", 11);
                case 6:
                  _context236.next = 8;
                  return i(t);
                case 8:
                  return _context236.abrupt("break", 11);
                case 9:
                  this.sdkState.isReconnecting = !0, (s = this.listener) == null || s.onReconnecting(t);
                  return _context236.abrupt("break", 11);
                case 11:
                  this.transportState = e, o.d(this.TAG, "Transport State Change", this.transportState);
                case 12:
                case "end":
                  return _context236.stop();
              }
            }, _callee235, this);
          }));
        }
      };
      this.handlePeerLeaveRequest = function (e) {
        var r;
        var t = e.requested_by ? _this114.store.getPeerById(e.requested_by) : void 0,
          i = {
            roomEnded: e.room_end,
            reason: e.reason,
            requestedBy: t
          };
        (r = _this114.listener) == null || r.onRemovedFromRoom(i), _this114.internalLeave(!1);
      };
      this.handleDeviceChange = function (e) {
        var t, i, r, s, n, d;
        if (o.d(_this114.TAG, "Device Change event", e), (i = (t = _this114.deviceChangeListener) == null ? void 0 : t.onDeviceChange) == null || i.call(t, e), e.error && e.type) {
          var l = e.type.includes("audio") ? (r = _this114.localPeer) == null ? void 0 : r.audioTrack : (s = _this114.localPeer) == null ? void 0 : s.videoTrack;
          (n = _this114.errorListener) == null || n.onError(e.error), [f.TracksErrors.CANT_ACCESS_CAPTURE_DEVICE, f.TracksErrors.DEVICE_IN_USE, f.TracksErrors.DEVICE_NOT_AVAILABLE].includes(e.error.code) && l && (l.setEnabled(!1), (d = _this114.listener) == null || d.onTrackUpdate(D.TRACK_MUTED, l, _this114.localPeer));
        }
      };
      this.handleAudioPluginError = function (e) {
        var t;
        o.e(_this114.TAG, "Audio Plugin Error event", e), (t = _this114.errorListener) == null || t.onError(e);
      };
      this.handleLocalRoleUpdate = function (i) {
        return c(_this114, [i], function (_ref32) {
          var _this116 = this;
          var e = _ref32.oldRole,
            t = _ref32.newRole;
          return /*#__PURE__*/_regeneratorRuntime().mark(function _callee236() {
            var r;
            return _regeneratorRuntime().wrap(function _callee236$(_context237) {
              while (1) switch (_context237.prev = _context237.next) {
                case 0:
                  _context237.next = 2;
                  return _this116.transport.handleLocalRoleUpdate({
                    oldRole: e,
                    newRole: t
                  });
                case 2:
                  _context237.next = 4;
                  return (r = _this116.roleChangeManager) == null ? void 0 : r.handleLocalPeerRoleUpdate({
                    oldRole: e,
                    newRole: t
                  });
                case 4:
                case "end":
                  return _context237.stop();
              }
            }, _callee236);
          })();
        });
      };
      this.sendAudioPresenceFailed = function () {
        var e = m.TracksErrors.NoAudioDetected(p.PREVIEW);
        o.w(_this114.TAG, "Audio Presence Failure", _this114.transportState, e);
      };
      this.sendJoinAnalyticsEvent = function () {
        var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
        var t = arguments.length > 1 ? arguments[1] : undefined;
        _this114.eventBus.analytics.publish(H.join(L(v({
          error: t
        }, _this114.analyticsTimer.getTimes()), {
          time: _this114.analyticsTimer.getTimeTaken(M.JOIN),
          is_preview_called: e
        })));
      };
      this.sendPreviewAnalyticsEvent = function (e) {
        _this114.eventBus.analytics.publish(H.preview(L(v({
          error: e
        }, _this114.analyticsTimer.getTimes(M.ROOM_STATE)), {
          time: _this114.analyticsTimer.getTimeTaken(M.PREVIEW)
        })));
      };
      this.sendAnalyticsEvent = function (e) {
        _this114.analyticsEventsService.queue(e).flush();
      };
    }
    _createClass(Dr, [{
      key: "initStoreAndManagers",
      value: function initStoreAndManagers() {
        if (this.sdkState.isInitialised) {
          this.notificationManager.setListener(this.listener), this.audioSinkManager.setListener(this.listener);
          return;
        }
        this.sdkState.isInitialised = !0, this.store = new st(), this.eventBus = new Dt(), this.networkTestManager = new Lt(this.eventBus, this.listener), this.playlistManager = new ut(this, this.eventBus), this.notificationManager = new ct(this.store, this.eventBus, this.listener, this.audioListener), this.deviceManager = new nt(this.store, this.eventBus), this.audioSinkManager = new at(this.store, this.deviceManager, this.eventBus), this.audioOutput = new ot(this.deviceManager, this.audioSinkManager), this.audioSinkManager.setListener(this.listener), this.eventBus.autoplayError.subscribe(this.handleAutoplayError), this.localTrackManager = new ue(this.store, this.observer, this.deviceManager, this.eventBus, this.analyticsTimer), this.analyticsEventsService = new _t(this.store), this.transport = new ft(this.observer, this.deviceManager, this.store, this.eventBus, this.analyticsEventsService, this.analyticsTimer), this.eventBus.analytics.subscribe(this.sendAnalyticsEvent), this.eventBus.deviceChange.subscribe(this.handleDeviceChange), this.eventBus.audioPluginFailed.subscribe(this.handleAudioPluginError);
      }
    }, {
      key: "validateJoined",
      value: function validateJoined(e) {
        if (!this.localPeer) throw m.GenericErrors.NotConnected(p.VALIDATION, "Not connected - ".concat(e));
      }
    }, {
      key: "refreshDevices",
      value: function refreshDevices() {
        return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee237() {
          return _regeneratorRuntime().wrap(function _callee237$(_context238) {
            while (1) switch (_context238.prev = _context238.next) {
              case 0:
                this.validateJoined("refreshDevices");
                _context238.next = 3;
                return this.deviceManager.init(!0);
              case 3:
              case "end":
                return _context238.stop();
            }
          }, _callee237, this);
        }));
      }
    }, {
      key: "getWebrtcInternals",
      value: function getWebrtcInternals() {
        var e;
        return (e = this.transport) == null ? void 0 : e.getWebrtcInternals();
      }
    }, {
      key: "getPlaylistManager",
      value: function getPlaylistManager() {
        return this.playlistManager;
      }
    }, {
      key: "getRecordingState",
      value: function getRecordingState() {
        var e;
        return (e = this.store.getRoom()) == null ? void 0 : e.recording;
      }
    }, {
      key: "getRTMPState",
      value: function getRTMPState() {
        var e;
        return (e = this.store.getRoom()) == null ? void 0 : e.rtmp;
      }
    }, {
      key: "getHLSState",
      value: function getHLSState() {
        var e;
        return (e = this.store.getRoom()) == null ? void 0 : e.hls;
      }
    }, {
      key: "preview",
      value: function preview(e, t) {
        return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee240() {
          var _this117 = this;
          var i, r, s;
          return _regeneratorRuntime().wrap(function _callee240$(_context241) {
            while (1) switch (_context241.prev = _context241.next) {
              case 0:
                if (!(Xt(), Zt(), this.sdkState.isPreviewInProgress)) {
                  _context241.next = 2;
                  break;
                }
                return _context241.abrupt("return", Promise.reject(m.GenericErrors.PreviewAlreadyInProgress(p.PREVIEW, "Preview already called")));
              case 2:
                this.analyticsTimer.start(M.PREVIEW), this.setUpPreview(e, t), e.alwaysRequestPermissions && this.localTrackManager.requestPermissions().then(function () {
                  return c(_this117, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee238() {
                    return _regeneratorRuntime().wrap(function _callee238$(_context239) {
                      while (1) switch (_context239.prev = _context239.next) {
                        case 0:
                          _context239.next = 2;
                          return this.initDeviceManagers();
                        case 2:
                        case "end":
                          return _context239.stop();
                      }
                    }, _callee238, this);
                  }));
                });
                i = !1, r = !1, s = setTimeout(function () {
                  var n, d;
                  (!i || !r) && ((d = (n = _this117.listener) == null ? void 0 : n.onNetworkQuality) == null || d.call(n, -1));
                }, 3e3);
                return _context241.abrupt("return", new Promise(function (n, d) {
                  var l = function l() {
                      return c(_this117, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee239() {
                        var _this118 = this;
                        var S, g, u;
                        return _regeneratorRuntime().wrap(function _callee239$(_context240) {
                          while (1) switch (_context240.prev = _context240.next) {
                            case 0:
                              if (this.localPeer) {
                                g = e.asRole && this.store.getPolicyForRole(e.asRole);
                                this.localPeer.asRole = g || this.localPeer.role;
                              }
                              _context240.next = 3;
                              return this.localTrackManager.getTracksToPublish(e.settings || zi);
                            case 3:
                              u = _context240.sent;
                              u.forEach(function (g) {
                                return _this118.setLocalPeerTrack(g);
                              });
                              ((S = this.localPeer) == null ? void 0 : S.audioTrack) && this.initPreviewTrackAudioLevelMonitor();
                              _context240.next = 8;
                              return this.initDeviceManagers();
                            case 8:
                              this.sdkState.isPreviewInProgress = !1;
                              this.analyticsTimer.end(M.PREVIEW);
                              t.onPreview(this.store.getRoom(), u);
                              this.sendPreviewAnalyticsEvent();
                              n();
                            case 13:
                            case "end":
                              return _context240.stop();
                          }
                        }, _callee239, this);
                      }));
                    },
                    h = function h(u) {
                      var S;
                      _this117.analyticsTimer.end(M.PREVIEW), u && ((S = _this117.errorListener) == null || S.onError(u)), _this117.sendPreviewAnalyticsEvent(u), _this117.sdkState.isPreviewInProgress = !1, d(u);
                    };
                  _this117.eventBus.policyChange.subscribeOnce(l), _this117.eventBus.leave.subscribeOnce(h), _this117.transport.preview(e.authToken, e.initEndpoint, _this117.localPeer.peerId, {
                    name: e.userName,
                    metaData: e.metaData || ""
                  }, e.autoVideoSubscribe).then(function (u) {
                    var S;
                    i = !0, clearTimeout(s), u && e.captureNetworkQualityInPreview && _this117.networkTestManager.start((S = u.config) == null ? void 0 : S.networkHealth).then(function () {
                      r = !0;
                    });
                  }).catch(h);
                }));
              case 5:
              case "end":
                return _context241.stop();
            }
          }, _callee240, this);
        }));
      }
    }, {
      key: "join",
      value: function join(e, t) {
        return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee241() {
          var l, h, u, S, g, E, i, _Et, r, s, n, d;
          return _regeneratorRuntime().wrap(function _callee241$(_context242) {
            while (1) switch (_context242.prev = _context242.next) {
              case 0:
                if (!(Xt(), Zt(), this.sdkState.isPreviewInProgress)) {
                  _context242.next = 2;
                  break;
                }
                throw m.GenericErrors.NotReady(p.JOIN, "Preview is in progress, can't join");
              case 2:
                this.analyticsTimer.start(M.JOIN), this.sdkState.isJoinInProgress = !0;
                i = this.transportState === R.Preview, _Et = Et(e.authToken), r = _Et.roomId, s = _Et.userId, n = _Et.role, d = ((h = (l = this.localPeer) == null ? void 0 : l.asRole) == null ? void 0 : h.name) || ((S = (u = this.localPeer) == null ? void 0 : u.role) == null ? void 0 : S.name);
                (g = this.networkTestManager) == null || g.stop(), this.listener = t, this.commonSetup(e, r, t), this.removeDevicesFromConfig(e), this.store.setConfig(e), this.store.createAndSetUserAgent(this.frameworkInfo), le.resumeContext(), this.localPeer ? (this.localPeer.name = e.userName, this.localPeer.role = this.store.getPolicyForRole(n), this.localPeer.customerUserId = s, this.localPeer.metadata = e.metaData, delete this.localPeer.asRole) : this.createAndAddLocalPeerToStore(e, n, s), this.roleChangeManager = new rt(this.store, this.transport, this.getAndPublishTracks.bind(this), this.removeTrack.bind(this), this.listener), this.eventBus.localRoleUpdate.subscribe(this.handleLocalRoleUpdate), o.d(this.TAG, "SDK Store", this.store), o.d(this.TAG, "\u23F3 Joining room ".concat(r)), o.time("join-room-".concat(r));
                _context242.prev = 5;
                _context242.next = 8;
                return this.transport.join(e.authToken, this.localPeer.peerId, {
                  name: e.userName,
                  metaData: e.metaData
                }, e.initEndpoint, e.autoVideoSubscribe);
              case 8:
                o.d(this.TAG, "\u2705 Joined room ".concat(r));
                this.analyticsTimer.start(M.PEER_LIST);
                _context242.next = 12;
                return this.notifyJoin();
              case 12:
                this.sdkState.isJoinInProgress = !1;
                this.sendJoinAnalyticsEvent(i);
                _context242.next = 16;
                return this.publish(e.settings || zi, d);
              case 16:
                _context242.next = 21;
                break;
              case 18:
                _context242.prev = 18;
                _context242.t0 = _context242["catch"](5);
                throw this.analyticsTimer.end(M.JOIN), this.sdkState.isJoinInProgress = !1, (E = this.listener) == null || E.onError(_context242.t0), this.sendJoinAnalyticsEvent(i, _context242.t0), o.e(this.TAG, "Unable to join room", _context242.t0), _context242.t0;
              case 21:
                o.timeEnd("join-room-".concat(r));
              case 22:
              case "end":
                return _context242.stop();
            }
          }, _callee241, this, [[5, 18]]);
        }));
      }
    }, {
      key: "stringifyMetadata",
      value: function stringifyMetadata(e) {
        e.metaData && typeof e.metaData != "string" ? e.metaData = JSON.stringify(e.metaData) : e.metaData || (e.metaData = "");
      }
    }, {
      key: "cleanUp",
      value: function cleanUp() {
        var e, t;
        this.cleanDeviceManagers(), this.eventBus.analytics.unsubscribe(this.sendAnalyticsEvent), this.analyticsTimer.cleanUp(), Q.cleanup(), this.playlistManager.cleanup(), o.cleanUp(), this.sdkState = v({}, Zi), this.localPeer && ((e = this.localPeer.audioTrack) == null || e.cleanup(), this.localPeer.audioTrack = void 0, (t = this.localPeer.videoTrack) == null || t.cleanup(), this.localPeer.videoTrack = void 0), this.store.cleanUp(), this.listener = void 0, this.roleChangeManager && this.eventBus.localRoleUpdate.unsubscribe(this.handleLocalRoleUpdate);
      }
    }, {
      key: "leave",
      value: function leave(e) {
        return this.internalLeave(e);
      }
    }, {
      key: "internalLeave",
      value: function internalLeave() {
        var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !0;
        var t = arguments.length > 1 ? arguments[1] : undefined;
        return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee242() {
          var r, s, i, _n9;
          return _regeneratorRuntime().wrap(function _callee242$(_context243) {
            while (1) switch (_context243.prev = _context243.next) {
              case 0:
                i = this.store.getRoom();
                if (!i) {
                  _context243.next = 10;
                  break;
                }
                _n9 = i.id;
                (r = this.networkTestManager) == null || r.stop();
                this.eventBus.leave.publish(t);
                o.d(this.TAG, "\u23F3 Leaving room ".concat(_n9));
                _context243.next = 8;
                return (s = this.transport) == null ? void 0 : s.leave(e);
              case 8:
                this.cleanUp();
                o.d(this.TAG, "\u2705 Left room ".concat(_n9));
              case 10:
              case "end":
                return _context243.stop();
            }
          }, _callee242, this);
        }));
      }
    }, {
      key: "getLocalPeer",
      value: function getLocalPeer() {
        return this.store.getLocalPeer();
      }
    }, {
      key: "getPeers",
      value: function getPeers() {
        var e = this.store.getPeers();
        return e.length < 50 && o.d(this.TAG, "Got peers(".concat(e.length, ")"), e.toString()), e;
      }
    }, {
      key: "getAudioOutput",
      value: function getAudioOutput() {
        return this.audioOutput;
      }
    }, {
      key: "sendMessage",
      value: function sendMessage(e, t) {
        this.sendMessageInternal({
          message: t,
          type: e
        });
      }
    }, {
      key: "sendBroadcastMessage",
      value: function sendBroadcastMessage(e, t) {
        return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee243() {
          return _regeneratorRuntime().wrap(function _callee243$(_context244) {
            while (1) switch (_context244.prev = _context244.next) {
              case 0:
                _context244.next = 2;
                return this.sendMessageInternal({
                  message: e,
                  type: t
                });
              case 2:
                return _context244.abrupt("return", _context244.sent);
              case 3:
              case "end":
                return _context244.stop();
            }
          }, _callee243, this);
        }));
      }
    }, {
      key: "sendGroupMessage",
      value: function sendGroupMessage(e, t, i) {
        return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee244() {
          var r;
          return _regeneratorRuntime().wrap(function _callee244$(_context245) {
            while (1) switch (_context245.prev = _context245.next) {
              case 0:
                r = this.store.getKnownRoles();
                if (!((t.filter(function (n) {
                  return r[n.name];
                }) || []).length === 0)) {
                  _context245.next = 3;
                  break;
                }
                throw m.GenericErrors.ValidationFailed("No valid role is present", t);
              case 3:
                _context245.next = 5;
                return this.sendMessageInternal({
                  message: e,
                  recipientRoles: t,
                  type: i
                });
              case 5:
                return _context245.abrupt("return", _context245.sent);
              case 6:
              case "end":
                return _context245.stop();
            }
          }, _callee244, this);
        }));
      }
    }, {
      key: "sendDirectMessage",
      value: function sendDirectMessage(e, t, i) {
        return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee245() {
          var s;
          return _regeneratorRuntime().wrap(function _callee245$(_context246) {
            while (1) switch (_context246.prev = _context246.next) {
              case 0:
                if (this.store.getPeerById(t.peerId)) {
                  _context246.next = 2;
                  break;
                }
                throw m.GenericErrors.ValidationFailed("Invalid peer - peer not present in the room", t);
              case 2:
                if (!(((s = this.localPeer) == null ? void 0 : s.peerId) === t.peerId)) {
                  _context246.next = 4;
                  break;
                }
                throw m.GenericErrors.ValidationFailed("Cannot send message to self");
              case 4:
                _context246.next = 6;
                return this.sendMessageInternal({
                  message: e,
                  recipientPeer: t,
                  type: i
                });
              case 6:
                return _context246.abrupt("return", _context246.sent);
              case 7:
              case "end":
                return _context246.stop();
            }
          }, _callee245, this);
        }));
      }
    }, {
      key: "sendMessageInternal",
      value: function sendMessageInternal(s) {
        return c(this, arguments, function (_ref33) {
          var _this119 = this;
          var e = _ref33.recipientRoles,
            t = _ref33.recipientPeer,
            _ref33$type = _ref33.type,
            i = _ref33$type === void 0 ? "chat" : _ref33$type,
            r = _ref33.message;
          return /*#__PURE__*/_regeneratorRuntime().mark(function _callee246() {
            var n, d;
            return _regeneratorRuntime().wrap(function _callee246$(_context247) {
              while (1) switch (_context247.prev = _context247.next) {
                case 0:
                  if (!(r.replace(/\u200b/g, " ").trim() === "")) {
                    _context247.next = 2;
                    break;
                  }
                  throw o.w(_this119.TAG, "sendMessage", "Ignoring empty message send"), m.GenericErrors.ValidationFailed("Empty message not allowed");
                case 2:
                  n = new Ee({
                    sender: _this119.localPeer,
                    type: i,
                    message: r,
                    recipientPeer: t,
                    recipientRoles: e,
                    time: new Date()
                  });
                  o.d(_this119.TAG, "Sending Message: ", n);
                  _context247.next = 6;
                  return _this119.transport.sendMessage(n);
                case 6:
                  d = _context247.sent;
                  return _context247.abrupt("return", (n.time = new Date(d.timestamp), n));
                case 8:
                case "end":
                  return _context247.stop();
              }
            }, _callee246);
          })();
        });
      }
    }, {
      key: "startScreenShare",
      value: function startScreenShare(e, t) {
        return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee247() {
          var _this120 = this;
          var d, l, h, i, r, n;
          return _regeneratorRuntime().wrap(function _callee247$(_context248) {
            while (1) switch (_context248.prev = _context248.next) {
              case 0:
                i = this.store.getPublishParams();
                if (i) {
                  _context248.next = 3;
                  break;
                }
                return _context248.abrupt("return");
              case 3:
                r = i.allowed;
                if (r && r.includes("screen")) {
                  _context248.next = 7;
                  break;
                }
                o.e(this.TAG, "Role ".concat((d = this.localPeer) == null ? void 0 : d.role, " cannot share screen"));
                return _context248.abrupt("return");
              case 7:
                if (!((h = (l = this.localPeer) == null ? void 0 : l.auxiliaryTracks) == null ? void 0 : h.find(function (u) {
                  return u.source === "screen";
                }))) {
                  _context248.next = 9;
                  break;
                }
                throw Error("Cannot share multiple screens");
              case 9:
                _context248.next = 11;
                return this.getScreenshareTracks(e, t);
              case 11:
                n = _context248.sent;
                if (this.localPeer) {
                  _context248.next = 15;
                  break;
                }
                o.d(this.TAG, "Screenshared when not connected"), n.forEach(function (u) {
                  u.cleanup();
                });
                return _context248.abrupt("return");
              case 15:
                _context248.next = 17;
                return this.transport.publish(n);
              case 17:
                n.forEach(function (u) {
                  var S, g, E;
                  u.peerId = (S = _this120.localPeer) == null ? void 0 : S.peerId, (g = _this120.localPeer) == null || g.auxiliaryTracks.push(u), (E = _this120.listener) == null || E.onTrackUpdate(D.TRACK_ADDED, u, _this120.localPeer);
                });
              case 18:
              case "end":
                return _context248.stop();
            }
          }, _callee247, this);
        }));
      }
    }, {
      key: "stopEndedScreenshare",
      value: function stopEndedScreenshare(e) {
        return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee248() {
          return _regeneratorRuntime().wrap(function _callee248$(_context249) {
            while (1) switch (_context249.prev = _context249.next) {
              case 0:
                o.d(this.TAG, "\u2705 Screenshare ended natively");
                _context249.next = 3;
                return this.stopScreenShare();
              case 3:
                e();
              case 4:
              case "end":
                return _context249.stop();
            }
          }, _callee248, this);
        }));
      }
    }, {
      key: "stopScreenShare",
      value: function stopScreenShare() {
        return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee249() {
          var t, e, _iterator22, _step22, _i22;
          return _regeneratorRuntime().wrap(function _callee249$(_context250) {
            while (1) switch (_context250.prev = _context250.next) {
              case 0:
                o.d(this.TAG, "\u2705 Screenshare ended from app");
                e = (t = this.localPeer) == null ? void 0 : t.auxiliaryTracks.filter(function (i) {
                  return i.source === "screen";
                });
                if (!e) {
                  _context250.next = 20;
                  break;
                }
                _iterator22 = _createForOfIteratorHelper(e);
                _context250.prev = 4;
                _iterator22.s();
              case 6:
                if ((_step22 = _iterator22.n()).done) {
                  _context250.next = 12;
                  break;
                }
                _i22 = _step22.value;
                _context250.next = 10;
                return this.removeTrack(_i22.trackId);
              case 10:
                _context250.next = 6;
                break;
              case 12:
                _context250.next = 17;
                break;
              case 14:
                _context250.prev = 14;
                _context250.t0 = _context250["catch"](4);
                _iterator22.e(_context250.t0);
              case 17:
                _context250.prev = 17;
                _iterator22.f();
                return _context250.finish(17);
              case 20:
              case "end":
                return _context250.stop();
            }
          }, _callee249, this, [[4, 14, 17, 20]]);
        }));
      }
    }, {
      key: "addTrack",
      value: function addTrack(e) {
        var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "regular";
        return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee250() {
          var h, u, S, g, r, s, n, d, l;
          return _regeneratorRuntime().wrap(function _callee250$(_context251) {
            while (1) switch (_context251.prev = _context251.next) {
              case 0:
                if (e) {
                  _context251.next = 3;
                  break;
                }
                o.w(this.TAG, "Please pass a valid MediaStreamTrack");
                return _context251.abrupt("return");
              case 3:
                if (this.localPeer) {
                  _context251.next = 5;
                  break;
                }
                throw m.GenericErrors.NotConnected(p.VALIDATION, "No local peer present, cannot addTrack");
              case 5:
                if (!this.localPeer.auxiliaryTracks.find(function (E) {
                  return E.trackId === e.id;
                })) {
                  _context251.next = 7;
                  break;
                }
                return _context251.abrupt("return");
              case 7:
                r = e.kind, s = new MediaStream([e]), n = new Te(s), d = r === "audio" ? Ie : Z, l = new d(n, e, t, this.eventBus);
                this.setPlaylistSettings({
                  track: e,
                  hmsTrack: l,
                  source: t
                });
                _context251.next = 11;
                return (h = this.transport) == null ? void 0 : h.publish([l]);
              case 11:
                l.peerId = (u = this.localPeer) == null ? void 0 : u.peerId;
                (S = this.localPeer) == null || S.auxiliaryTracks.push(l);
                (g = this.listener) == null || g.onTrackUpdate(D.TRACK_ADDED, l, this.localPeer);
              case 14:
              case "end":
                return _context251.stop();
            }
          }, _callee250, this);
        }));
      }
    }, {
      key: "removeTrack",
      value: function removeTrack(e) {
        var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
        return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee251() {
          var r, i, s;
          return _regeneratorRuntime().wrap(function _callee251$(_context252) {
            while (1) switch (_context252.prev = _context252.next) {
              case 0:
                if (this.localPeer) {
                  _context252.next = 2;
                  break;
                }
                throw m.GenericErrors.NotConnected(p.VALIDATION, "No local peer present, cannot removeTrack");
              case 2:
                i = this.localPeer.auxiliaryTracks.findIndex(function (s) {
                  return s.trackId === e;
                });
                if (!(i > -1)) {
                  _context252.next = 17;
                  break;
                }
                s = this.localPeer.auxiliaryTracks[i];
                if (!s.isPublished) {
                  _context252.next = 10;
                  break;
                }
                _context252.next = 8;
                return this.transport.unpublish([s]);
              case 8:
                _context252.next = 12;
                break;
              case 10:
                _context252.next = 12;
                return s.cleanup();
              case 12:
                t || this.stopPlaylist(s);
                this.localPeer.auxiliaryTracks.splice(i, 1);
                (r = this.listener) == null || r.onTrackUpdate(D.TRACK_REMOVED, s, this.localPeer);
                _context252.next = 18;
                break;
              case 17:
                o.w(this.TAG, "No track found for ".concat(e));
              case 18:
              case "end":
                return _context252.stop();
            }
          }, _callee251, this);
        }));
      }
    }, {
      key: "setAnalyticsLevel",
      value: function setAnalyticsLevel(e) {
        this.analyticsEventsService.level = e;
      }
    }, {
      key: "setLogLevel",
      value: function setLogLevel(e) {
        o.level = e;
      }
    }, {
      key: "addAudioListener",
      value: function addAudioListener(e) {
        this.audioListener = e, this.notificationManager.setAudioListener(e);
      }
    }, {
      key: "addConnectionQualityListener",
      value: function addConnectionQualityListener(e) {
        this.notificationManager.setConnectionQualityListener(e);
      }
    }, {
      key: "changeRole",
      value: function changeRole(e, t) {
        var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
        return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee252() {
          var r;
          return _regeneratorRuntime().wrap(function _callee252$(_context253) {
            while (1) switch (_context253.prev = _context253.next) {
              case 0:
                _context253.t0 = !e.role || e.role.name === t;
                if (_context253.t0) {
                  _context253.next = 4;
                  break;
                }
                _context253.next = 4;
                return (r = this.transport) == null ? void 0 : r.changeRoleOfPeer(e, t, i);
              case 4:
              case "end":
                return _context253.stop();
            }
          }, _callee252, this);
        }));
      }
    }, {
      key: "changeRoleOfPeer",
      value: function changeRoleOfPeer(e, t) {
        var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
        return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee253() {
          var r;
          return _regeneratorRuntime().wrap(function _callee253$(_context254) {
            while (1) switch (_context254.prev = _context254.next) {
              case 0:
                _context254.t0 = !e.role || e.role.name === t;
                if (_context254.t0) {
                  _context254.next = 4;
                  break;
                }
                _context254.next = 4;
                return (r = this.transport) == null ? void 0 : r.changeRoleOfPeer(e, t, i);
              case 4:
              case "end":
                return _context254.stop();
            }
          }, _callee253, this);
        }));
      }
    }, {
      key: "changeRoleOfPeersWithRoles",
      value: function changeRoleOfPeersWithRoles(e, t) {
        return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee254() {
          var i;
          return _regeneratorRuntime().wrap(function _callee254$(_context255) {
            while (1) switch (_context255.prev = _context255.next) {
              case 0:
                _context255.t0 = e.length <= 0 || !t;
                if (_context255.t0) {
                  _context255.next = 4;
                  break;
                }
                _context255.next = 4;
                return (i = this.transport) == null ? void 0 : i.changeRoleOfPeersWithRoles(e, t);
              case 4:
              case "end":
                return _context255.stop();
            }
          }, _callee254, this);
        }));
      }
    }, {
      key: "acceptChangeRole",
      value: function acceptChangeRole(e) {
        return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee255() {
          var t;
          return _regeneratorRuntime().wrap(function _callee255$(_context256) {
            while (1) switch (_context256.prev = _context256.next) {
              case 0:
                _context256.next = 2;
                return (t = this.transport) == null ? void 0 : t.acceptRoleChange(e);
              case 2:
              case "end":
                return _context256.stop();
            }
          }, _callee255, this);
        }));
      }
    }, {
      key: "endRoom",
      value: function endRoom(e, t) {
        return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee256() {
          var i;
          return _regeneratorRuntime().wrap(function _callee256$(_context257) {
            while (1) switch (_context257.prev = _context257.next) {
              case 0:
                if (this.localPeer) {
                  _context257.next = 2;
                  break;
                }
                throw m.GenericErrors.NotConnected(p.VALIDATION, "No local peer present, cannot end room");
              case 2:
                _context257.next = 4;
                return (i = this.transport) == null ? void 0 : i.endRoom(e, t);
              case 4:
                _context257.next = 6;
                return this.leave();
              case 6:
              case "end":
                return _context257.stop();
            }
          }, _callee256, this);
        }));
      }
    }, {
      key: "removePeer",
      value: function removePeer(e, t) {
        return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee257() {
          var i;
          return _regeneratorRuntime().wrap(function _callee257$(_context258) {
            while (1) switch (_context258.prev = _context258.next) {
              case 0:
                if (this.localPeer) {
                  _context258.next = 2;
                  break;
                }
                throw m.GenericErrors.NotConnected(p.VALIDATION, "No local peer present, cannot remove peer");
              case 2:
                if (this.store.getPeerById(e.peerId)) {
                  _context258.next = 4;
                  break;
                }
                throw m.GenericErrors.ValidationFailed("Invalid peer, given peer not present in room", e);
              case 4:
                _context258.next = 6;
                return (i = this.transport) == null ? void 0 : i.removePeer(e.peerId, t);
              case 6:
              case "end":
                return _context258.stop();
            }
          }, _callee257, this);
        }));
      }
    }, {
      key: "startRTMPOrRecording",
      value: function startRTMPOrRecording(e) {
        return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee258() {
          var t;
          return _regeneratorRuntime().wrap(function _callee258$(_context259) {
            while (1) switch (_context259.prev = _context259.next) {
              case 0:
                if (this.localPeer) {
                  _context259.next = 2;
                  break;
                }
                throw m.GenericErrors.NotConnected(p.VALIDATION, "No local peer present, cannot start streaming or recording");
              case 2:
                _context259.next = 4;
                return (t = this.transport) == null ? void 0 : t.startRTMPOrRecording(e);
              case 4:
              case "end":
                return _context259.stop();
            }
          }, _callee258, this);
        }));
      }
    }, {
      key: "stopRTMPAndRecording",
      value: function stopRTMPAndRecording() {
        return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee259() {
          var e;
          return _regeneratorRuntime().wrap(function _callee259$(_context260) {
            while (1) switch (_context260.prev = _context260.next) {
              case 0:
                if (this.localPeer) {
                  _context260.next = 2;
                  break;
                }
                throw m.GenericErrors.NotConnected(p.VALIDATION, "No local peer present, cannot stop streaming or recording");
              case 2:
                _context260.next = 4;
                return (e = this.transport) == null ? void 0 : e.stopRTMPOrRecording();
              case 4:
              case "end":
                return _context260.stop();
            }
          }, _callee259, this);
        }));
      }
    }, {
      key: "startHLSStreaming",
      value: function startHLSStreaming(e) {
        return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee260() {
          var t;
          return _regeneratorRuntime().wrap(function _callee260$(_context261) {
            while (1) switch (_context261.prev = _context261.next) {
              case 0:
                if (this.localPeer) {
                  _context261.next = 2;
                  break;
                }
                throw m.GenericErrors.NotConnected(p.VALIDATION, "No local peer present, cannot start HLS streaming");
              case 2:
                _context261.next = 4;
                return (t = this.transport) == null ? void 0 : t.startHLSStreaming(e);
              case 4:
              case "end":
                return _context261.stop();
            }
          }, _callee260, this);
        }));
      }
    }, {
      key: "stopHLSStreaming",
      value: function stopHLSStreaming(e) {
        return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee261() {
          var t;
          return _regeneratorRuntime().wrap(function _callee261$(_context262) {
            while (1) switch (_context262.prev = _context262.next) {
              case 0:
                if (this.localPeer) {
                  _context262.next = 2;
                  break;
                }
                throw m.GenericErrors.NotConnected(p.VALIDATION, "No local peer present, cannot stop HLS streaming");
              case 2:
                _context262.next = 4;
                return (t = this.transport) == null ? void 0 : t.stopHLSStreaming(e);
              case 4:
              case "end":
                return _context262.stop();
            }
          }, _callee261, this);
        }));
      }
    }, {
      key: "sendHLSTimedMetadata",
      value: function sendHLSTimedMetadata(e) {
        return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee262() {
          var t;
          return _regeneratorRuntime().wrap(function _callee262$(_context263) {
            while (1) switch (_context263.prev = _context263.next) {
              case 0:
                this.validateJoined("sendHLSTimedMetadata");
                _context263.next = 3;
                return (t = this.transport) == null ? void 0 : t.sendHLSTimedMetadata(e);
              case 3:
              case "end":
                return _context263.stop();
            }
          }, _callee262, this);
        }));
      }
    }, {
      key: "changeName",
      value: function changeName(e) {
        return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee263() {
          var t;
          return _regeneratorRuntime().wrap(function _callee263$(_context264) {
            while (1) switch (_context264.prev = _context264.next) {
              case 0:
                this.validateJoined("changeName");
                _context264.next = 3;
                return (t = this.transport) == null ? void 0 : t.changeName(e);
              case 3:
                this.notificationManager.updateLocalPeer({
                  name: e
                });
              case 4:
              case "end":
                return _context264.stop();
            }
          }, _callee263, this);
        }));
      }
    }, {
      key: "changeMetadata",
      value: function changeMetadata(e) {
        return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee264() {
          var t;
          return _regeneratorRuntime().wrap(function _callee264$(_context265) {
            while (1) switch (_context265.prev = _context265.next) {
              case 0:
                this.validateJoined("changeMetadata");
                _context265.next = 3;
                return (t = this.transport) == null ? void 0 : t.changeMetadata(e);
              case 3:
                this.notificationManager.updateLocalPeer({
                  metadata: e
                });
              case 4:
              case "end":
                return _context265.stop();
            }
          }, _callee264, this);
        }));
      }
    }, {
      key: "setSessionMetadata",
      value: function setSessionMetadata(e) {
        return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee265() {
          return _regeneratorRuntime().wrap(function _callee265$(_context266) {
            while (1) switch (_context266.prev = _context266.next) {
              case 0:
                _context266.next = 2;
                return this.transport.setSessionMetadata(e);
              case 2:
              case "end":
                return _context266.stop();
            }
          }, _callee265, this);
        }));
      }
    }, {
      key: "getSessionMetadata",
      value: function getSessionMetadata() {
        return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee266() {
          return _regeneratorRuntime().wrap(function _callee266$(_context267) {
            while (1) switch (_context267.prev = _context267.next) {
              case 0:
                _context267.next = 2;
                return this.transport.getSessionMetadata();
              case 2:
                return _context267.abrupt("return", _context267.sent.data);
              case 3:
              case "end":
                return _context267.stop();
            }
          }, _callee266, this);
        }));
      }
    }, {
      key: "getRoles",
      value: function getRoles() {
        return Object.values(this.store.getKnownRoles());
      }
    }, {
      key: "changeTrackState",
      value: function changeTrackState(e, t) {
        return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee267() {
          var r, i;
          return _regeneratorRuntime().wrap(function _callee267$(_context268) {
            while (1) switch (_context268.prev = _context268.next) {
              case 0:
                if (!(e.type === F.VIDEO && e.source !== "regular")) {
                  _context268.next = 3;
                  break;
                }
                o.w(this.TAG, "Muting non-regular video tracks is currently not supported");
                return _context268.abrupt("return");
              case 3:
                if (!(e.enabled === t)) {
                  _context268.next = 6;
                  break;
                }
                o.w(this.TAG, "Aborting change track state, track already has enabled - ".concat(t), e);
                return _context268.abrupt("return");
              case 6:
                if (this.store.getTrackById(e.trackId)) {
                  _context268.next = 8;
                  break;
                }
                throw m.GenericErrors.ValidationFailed("No track found for change track state", e);
              case 8:
                i = this.store.getPeerByTrackId(e.trackId);
                if (i) {
                  _context268.next = 11;
                  break;
                }
                throw m.GenericErrors.ValidationFailed("No peer found for change track state", e);
              case 11:
                _context268.next = 13;
                return (r = this.transport) == null ? void 0 : r.changeTrackState({
                  requested_for: i.peerId,
                  track_id: e.trackId,
                  stream_id: e.stream.id,
                  mute: !t
                });
              case 13:
              case "end":
                return _context268.stop();
            }
          }, _callee267, this);
        }));
      }
    }, {
      key: "changeMultiTrackState",
      value: function changeMultiTrackState(e) {
        return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee268() {
          var n, t, i, r, s;
          return _regeneratorRuntime().wrap(function _callee268$(_context269) {
            while (1) switch (_context269.prev = _context269.next) {
              case 0:
                if (!(typeof e.enabled != "boolean")) {
                  _context269.next = 2;
                  break;
                }
                throw m.GenericErrors.ValidationFailed("Pass a boolean for enabled");
              case 2:
                t = e.enabled, i = e.roles, r = e.type, s = e.source;
                _context269.next = 5;
                return (n = this.transport) == null ? void 0 : n.changeMultiTrackState({
                  value: !t,
                  type: r,
                  source: s,
                  roles: i == null ? void 0 : i.map(function (d) {
                    return d == null ? void 0 : d.name;
                  })
                });
              case 5:
              case "end":
                return _context269.stop();
            }
          }, _callee268, this);
        }));
      }
    }, {
      key: "setFrameworkInfo",
      value: function setFrameworkInfo(e) {
        this.frameworkInfo = e;
      }
    }, {
      key: "publish",
      value: function publish(e, t) {
        return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee269() {
          var _this121 = this;
          var i, r, s, _n10;
          return _regeneratorRuntime().wrap(function _callee269$(_context270) {
            while (1) switch (_context270.prev = _context270.next) {
              case 0:
                if (![this.store.getPublishParams(), !this.sdkState.published, !me].every(function (n) {
                  return !!n;
                })) {
                  _context270.next = 4;
                  break;
                }
                _n10 = t && t !== ((r = (i = this.localPeer) == null ? void 0 : i.role) == null ? void 0 : r.name) ? function () {
                  var d;
                  return (d = _this121.roleChangeManager) == null ? void 0 : d.diffRolesAndPublishTracks({
                    oldRole: _this121.store.getPolicyForRole(t),
                    newRole: _this121.localPeer.role
                  });
                } : function () {
                  return _this121.getAndPublishTracks(e);
                };
                _context270.next = 4;
                return (s = _n10 == null ? void 0 : _n10()) == null ? void 0 : s.catch(function (d) {
                  var l;
                  o.e(_this121.TAG, "Error in publish", d), (l = _this121.listener) == null || l.onError(d);
                });
              case 4:
              case "end":
                return _context270.stop();
            }
          }, _callee269, this);
        }));
      }
    }, {
      key: "getAndPublishTracks",
      value: function getAndPublishTracks(e) {
        return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee270() {
          var i, r, t;
          return _regeneratorRuntime().wrap(function _callee270$(_context271) {
            while (1) switch (_context271.prev = _context271.next) {
              case 0:
                _context271.next = 2;
                return this.localTrackManager.getTracksToPublish(e);
              case 2:
                t = _context271.sent;
                _context271.next = 5;
                return this.setAndPublishTracks(t);
              case 5:
                (r = (i = this.localPeer) == null ? void 0 : i.audioTrack) == null || r.initAudioLevelMonitor();
                this.sdkState.published = !0;
              case 7:
              case "end":
                return _context271.stop();
            }
          }, _callee270, this);
        }));
      }
    }, {
      key: "setAndPublishTracks",
      value: function setAndPublishTracks(e) {
        return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee271() {
          var t, _iterator23, _step23, _i23;
          return _regeneratorRuntime().wrap(function _callee271$(_context272) {
            while (1) switch (_context272.prev = _context272.next) {
              case 0:
                _iterator23 = _createForOfIteratorHelper(e);
                _context272.prev = 1;
                _iterator23.s();
              case 3:
                if ((_step23 = _iterator23.n()).done) {
                  _context272.next = 11;
                  break;
                }
                _i23 = _step23.value;
                _context272.next = 7;
                return this.transport.publish([_i23]);
              case 7:
                this.setLocalPeerTrack(_i23);
                (t = this.listener) == null || t.onTrackUpdate(D.TRACK_ADDED, _i23, this.localPeer);
              case 9:
                _context272.next = 3;
                break;
              case 11:
                _context272.next = 16;
                break;
              case 13:
                _context272.prev = 13;
                _context272.t0 = _context272["catch"](1);
                _iterator23.e(_context272.t0);
              case 16:
                _context272.prev = 16;
                _iterator23.f();
                return _context272.finish(16);
              case 19:
                _context272.next = 21;
                return this.initDeviceManagers();
              case 21:
              case "end":
                return _context272.stop();
            }
          }, _callee271, this, [[1, 13, 16, 19]]);
        }));
      }
    }, {
      key: "setLocalPeerTrack",
      value: function setLocalPeerTrack(e) {
        var t;
        switch (e.peerId = (t = this.localPeer) == null ? void 0 : t.peerId, e.type) {
          case F.AUDIO:
            this.localPeer.audioTrack = e;
            break;
          case F.VIDEO:
            this.localPeer.videoTrack = e;
            break;
        }
      }
    }, {
      key: "initDeviceManagers",
      value: function initDeviceManagers() {
        return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee272() {
          var e, t, i, r, s;
          return _regeneratorRuntime().wrap(function _callee272$(_context273) {
            while (1) switch (_context273.prev = _context273.next) {
              case 0:
                _context273.t0 = this.sdkState.deviceManagersInitialised;
                if (_context273.t0) {
                  _context273.next = 12;
                  break;
                }
                this.sdkState.deviceManagersInitialised = !0;
                _context273.next = 5;
                return this.deviceManager.init();
              case 5:
                _context273.next = 7;
                return this.deviceManager.updateOutputDevice((t = (e = this.store.getConfig()) == null ? void 0 : e.settings) == null ? void 0 : t.audioOutputDeviceId);
              case 7:
                _context273.t1 = _context273.sent;
                if (_context273.t1) {
                  _context273.next = 11;
                  break;
                }
                _context273.next = 11;
                return this.deviceManager.updateOutputDevice((r = (i = Q.getSelection()) == null ? void 0 : i.audioOutput) == null ? void 0 : r.deviceId);
              case 11:
                this.audioSinkManager.init((s = this.store.getConfig()) == null ? void 0 : s.audioSinkElementId);
              case 12:
              case "end":
                return _context273.stop();
            }
          }, _callee272, this);
        }));
      }
    }, {
      key: "cleanDeviceManagers",
      value: function cleanDeviceManagers() {
        this.eventBus.deviceChange.unsubscribe(this.handleDeviceChange), this.eventBus.audioPluginFailed.unsubscribe(this.handleAudioPluginError), this.eventBus.autoplayError.unsubscribe(this.handleAutoplayError), this.deviceManager.cleanUp(), this.audioSinkManager.cleanUp();
      }
    }, {
      key: "initPreviewTrackAudioLevelMonitor",
      value: function initPreviewTrackAudioLevelMonitor() {
        var _this122 = this;
        var t;
        var e = (t = this.localPeer) == null ? void 0 : t.audioTrack;
        e == null || e.initAudioLevelMonitor(), this.eventBus.trackAudioLevelUpdate.subscribe(function (i) {
          var s;
          var r = i && i.track.trackId === (e == null ? void 0 : e.trackId) ? [{
            audioLevel: i.audioLevel,
            peer: _this122.localPeer,
            track: e
          }] : [];
          _this122.store.updateSpeakers(r), (s = _this122.audioListener) == null || s.onAudioLevelUpdate(r);
        }), this.eventBus.localAudioSilence.subscribe(this.sendAudioPresenceFailed);
      }
    }, {
      key: "notifyJoin",
      value: function notifyJoin() {
        var _this123 = this;
        var i;
        var e = this.store.getLocalPeer(),
          t = this.store.getRoom();
        if (t.joinedAt = new Date(), e && (e.joinedAt = t.joinedAt), e == null ? void 0 : e.role) {
          this.analyticsTimer.end(M.JOIN), (i = this.listener) == null || i.onJoin(t);
          return;
        }
        return new Promise(function (r, s) {
          _this123.eventBus.policyChange.subscribeOnce(function () {
            var n;
            _this123.analyticsTimer.end(M.JOIN), (n = _this123.listener) == null || n.onJoin(t), r();
          }), _this123.eventBus.leave.subscribeOnce(function (n) {
            s(n);
          });
        });
      }
    }, {
      key: "setUpPreview",
      value: function setUpPreview(e, t) {
        this.listener = t, this.sdkState.isPreviewInProgress = !0;
        var _Et2 = Et(e.authToken),
          i = _Et2.roomId,
          r = _Et2.userId,
          s = _Et2.role;
        this.commonSetup(e, i, t), this.store.setConfig(e), this.store.createAndSetUserAgent(this.frameworkInfo), this.createAndAddLocalPeerToStore(e, s, r, e.asRole), o.d(this.TAG, "SDK Store", this.store);
      }
    }, {
      key: "setPlaylistSettings",
      value: function setPlaylistSettings(r) {
        return c(this, arguments, function (_ref34) {
          var e = _ref34.track,
            t = _ref34.hmsTrack,
            i = _ref34.source;
          return /*#__PURE__*/_regeneratorRuntime().mark(function _callee273() {
            var s, _e$getSettings, _n11, _d11;
            return _regeneratorRuntime().wrap(function _callee273$(_context274) {
              while (1) switch (_context274.prev = _context274.next) {
                case 0:
                  if (!(i === "videoplaylist")) {
                    _context274.next = 7;
                    break;
                  }
                  s = {};
                  if (e.kind === "audio") s.maxBitrate = 64;else {
                    s.maxBitrate = 1e3;
                    _e$getSettings = e.getSettings(), _n11 = _e$getSettings.width, _d11 = _e$getSettings.height;
                    s.width = _n11, s.height = _d11;
                  }
                  _context274.next = 5;
                  return t.setSettings(s);
                case 5:
                  _context274.next = 11;
                  break;
                case 7:
                  _context274.t0 = i === "audioplaylist";
                  if (!_context274.t0) {
                    _context274.next = 11;
                    break;
                  }
                  _context274.next = 11;
                  return t.setSettings({
                    maxBitrate: 64
                  });
                case 11:
                case "end":
                  return _context274.stop();
              }
            }, _callee273);
          })();
        });
      }
    }, {
      key: "createAndAddLocalPeerToStore",
      value: function createAndAddLocalPeerToStore(e, t, i, r) {
        var s = this.store.getPolicyForRole(t),
          n = r ? this.store.getPolicyForRole(r) : void 0,
          d = new Ve({
            name: e.userName || "",
            customerUserId: i,
            metadata: e.metaData || "",
            role: s,
            asRole: n || s
          });
        this.store.addPeer(d);
      }
    }, {
      key: "commonSetup",
      value: function commonSetup(e, t, i) {
        this.stringifyMetadata(e), e.initEndpoint || (e.initEndpoint = "https://prod-init.100ms.live"), this.errorListener = i, this.deviceChangeListener = i, this.initStoreAndManagers(), this.store.setErrorListener(this.errorListener), this.store.getRoom() || this.store.setRoom(new Ge(t, this.store));
      }
    }, {
      key: "removeDevicesFromConfig",
      value: function removeDevicesFromConfig(e) {
        this.store.getConfig() && e.settings && (delete e.settings.audioOutputDeviceId, delete e.settings.videoDeviceId, delete e.settings.audioInputDeviceId);
      }
    }, {
      key: "getScreenshareTracks",
      value: function getScreenshareTracks(e, t) {
        return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee274() {
          var _this124 = this;
          var _yield$this$localTrac, _yield$this$localTrac2, i, r, s, n;
          return _regeneratorRuntime().wrap(function _callee274$(_context275) {
            while (1) switch (_context275.prev = _context275.next) {
              case 0:
                _context275.next = 2;
                return this.localTrackManager.getLocalScreen(t);
              case 2:
                _yield$this$localTrac = _context275.sent;
                _yield$this$localTrac2 = _slicedToArray(_yield$this$localTrac, 2);
                i = _yield$this$localTrac2[0];
                r = _yield$this$localTrac2[1];
                s = function s() {
                  _this124.stopEndedScreenshare(e);
                };
                n = [];
                if (!(t == null ? void 0 : t.audioOnly)) {
                  _context275.next = 14;
                  break;
                }
                if (!(i.nativeTrack.stop(), !r)) {
                  _context275.next = 11;
                  break;
                }
                throw m.TracksErrors.NothingToReturn(p.TRACK, "Select share audio when sharing screen", "No audio found");
              case 11:
                n.push(r), r.nativeTrack.onended = s;
                _context275.next = 15;
                break;
              case 14:
                n.push(i), i.nativeTrack.onended = s, r && n.push(r);
              case 15:
                return _context275.abrupt("return", n);
              case 16:
              case "end":
                return _context275.stop();
            }
          }, _callee274, this);
        }));
      }
    }, {
      key: "stopPlaylist",
      value: function stopPlaylist(e) {
        e.source === "audioplaylist" ? this.playlistManager.stop(b.audio) : e.source === "videoplaylist" && this.playlistManager.stop(b.video);
      }
    }, {
      key: "localPeer",
      get: function get() {
        var e;
        return (e = this.store) == null ? void 0 : e.getLocalPeer();
      }
    }]);
    return Dr;
  }();
function Xp() {
  return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee275() {
    var a, e;
    return _regeneratorRuntime().wrap(function _callee275$(_context276) {
      while (1) switch (_context276.prev = _context276.next) {
        case 0:
          a = new J().build(), e = new z().build();
          _context276.prev = 1;
          _context276.next = 4;
          return Ye(e);
        case 4:
          _context276.sent.stop();
          _context276.next = 14;
          break;
        case 7:
          _context276.prev = 7;
          _context276.t0 = _context276["catch"](1);
          if (!Nr(_context276.t0)) {
            _context276.next = 14;
            break;
          }
          _context276.next = 12;
          return yi({
            audio: !1,
            video: !0
          });
        case 12:
          _context276.sent.getTracks().forEach(function (s) {
            return s.stop();
          });
          throw _context276.t0;
        case 14:
          _context276.next = 16;
          return ze(a);
        case 16:
          _context276.sent.stop();
          return _context276.abrupt("return", !1);
        case 18:
        case "end":
          return _context276.stop();
      }
    }, _callee275, null, [[1, 7]]);
  }));
}
function Nr(a) {
  return a instanceof T && a.action === p.TRACK;
}
o.i("adapter", "".concat(Xi.browserDetails.browser, " v").concat(Xi.browserDetails.version));
export { Ei as DeviceType, W as ENV, qe as HMSAudioCodec, le as HMSAudioContextHandler, It as HMSAudioPluginType, Qe as HMSAudioPluginsManager, De as HMSAudioTrack, T as HMSException, Ie as HMSLocalAudioTrack, Z as HMSLocalVideoTrack, U as HMSLogLevel, q as HMSPeerUpdate, b as HMSPlaylistType, re as HMSPluginUnsupportedTypes, Rt as HMSRemoteAudioTrack, ve as HMSRemoteVideoTrack, ce as HMSRoomUpdate, Dr as HMSSdk, j as HMSSimulcastLayer, ge as HMSTrack, F as HMSTrackType, D as HMSTrackUpdate, Ke as HMSVideoCodec, Oe as HMSVideoPluginCanvasContextType, be as HMSVideoPluginType, et as HMSVideoPluginsManager, Ne as HMSVideoTrack, St as HMSWebrtcInternals, gt as HMSWebrtcStats, hi as getAnalyticsDeviceId, mn as getLocalDevices, pn as getLocalScreen, yi as getLocalStream, X as isBrowser, yt as isIOS, ui as isMobile, me as isNode, pi as isPageHidden, $r as isSupported, pe as parsedUserAgent, Pt as simulcastMapping, Xp as validateDeviceAV };